
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("adhil", function(module, exports) {

$parcel$export(module.exports, "Side", () => $51f4ad1a1d4c86a3$export$80a00690bda7f17e);
$parcel$export(module.exports, "JSON_ID", () => $51f4ad1a1d4c86a3$export$d9f9f34e18094ffd);
$parcel$export(module.exports, "GapCursorSelection", () => $51f4ad1a1d4c86a3$export$7d98c58ca1423246);

var $kviC1 = parcelRequire("kviC1");

var $7T7aA = parcelRequire("7T7aA");

var $1gpr6 = parcelRequire("1gpr6");
var $51f4ad1a1d4c86a3$export$80a00690bda7f17e = /*#__PURE__*/ function(Side) {
    Side["LEFT"] = "left";
    Side["RIGHT"] = "right";
    return Side;
}({});
const $51f4ad1a1d4c86a3$export$d9f9f34e18094ffd = 'gapcursor';
class $51f4ad1a1d4c86a3$export$7d98c58ca1423246 extends (0, $7T7aA.Selection) {
    static valid($pos) {
        const { parent: parent, nodeBefore: nodeBefore, nodeAfter: nodeAfter } = $pos;
        const targetNode = (0, $1gpr6.isValidTargetNode)(nodeBefore) ? nodeBefore : (0, $1gpr6.isValidTargetNode)(nodeAfter) ? nodeAfter : null;
        if (!targetNode || parent.isTextblock) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const deflt = parent.contentMatchAt($pos.index()).defaultType;
        return deflt && deflt.isTextblock;
    }
    static findFrom($pos, dir, mustMove = false) {
        const side = dir === 1 ? "right" : "left";
        if (!mustMove && $51f4ad1a1d4c86a3$export$7d98c58ca1423246.valid($pos)) return new $51f4ad1a1d4c86a3$export$7d98c58ca1423246($pos, side);
        let pos = $pos.pos;
        // TODO: ED-5048 - Fix any, potential issue.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let next = null;
        // Scan up from this position
        for(let d = $pos.depth;; d--){
            const parent = $pos.node(d);
            if (side === "right" ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
                next = parent.maybeChild(side === "right" ? $pos.indexAfter(d) : $pos.index(d) - 1);
                break;
            } else if (d === 0) return null;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($51f4ad1a1d4c86a3$export$7d98c58ca1423246.valid($cur)) return new $51f4ad1a1d4c86a3$export$7d98c58ca1423246($cur, side);
        }
        // And then down into the next node
        for(;;){
            next = side === "right" ? next.firstChild : next.lastChild;
            if (next === null) break;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($51f4ad1a1d4c86a3$export$7d98c58ca1423246.valid($cur)) return new $51f4ad1a1d4c86a3$export$7d98c58ca1423246($cur, side);
        }
        return null;
    }
    static fromJSON(doc, json) {
        return new $51f4ad1a1d4c86a3$export$7d98c58ca1423246(doc.resolve(json.pos), json.side);
    }
    map(doc, mapping) {
        const $pos = doc.resolve(mapping.map(this.head));
        return $51f4ad1a1d4c86a3$export$7d98c58ca1423246.valid($pos) ? new $51f4ad1a1d4c86a3$export$7d98c58ca1423246($pos, this.side) : (0, $7T7aA.Selection).near($pos);
    }
    eq(other) {
        return other instanceof $51f4ad1a1d4c86a3$export$7d98c58ca1423246 && other.head === this.head;
    }
    content() {
        return (0, $kviC1.Slice).empty;
    }
    getBookmark() {
        return new $51f4ad1a1d4c86a3$export$afd2c0d75bc9ce6c(this.anchor);
    }
    toJSON() {
        return {
            pos: this.head,
            type: $51f4ad1a1d4c86a3$export$d9f9f34e18094ffd,
            side: this.side
        };
    }
    /**
   * Construct a GapCursorSelection
   * @param {ResolvedPos} $pos resolved position
   * @param {Side} side side where the gap cursor is drawn
   */ constructor($pos, side = "left"){
        super($pos, $pos), this.side = side;
        this.visible = false;
    }
}
(0, $7T7aA.Selection).jsonID($51f4ad1a1d4c86a3$export$d9f9f34e18094ffd, $51f4ad1a1d4c86a3$export$7d98c58ca1423246);
class $51f4ad1a1d4c86a3$export$afd2c0d75bc9ce6c {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    map(mapping) {
        return new $51f4ad1a1d4c86a3$export$afd2c0d75bc9ce6c(mapping.map(this.pos));
    }
    resolve(doc) {
        const $pos = doc.resolve(this.pos);
        return $51f4ad1a1d4c86a3$export$7d98c58ca1423246.valid($pos) ? new $51f4ad1a1d4c86a3$export$7d98c58ca1423246($pos) : (0, $7T7aA.Selection).near($pos);
    }
    constructor(pos){
        this.pos = pos;
    }
}

});
parcelRegister("1gpr6", function(module, exports) {

$parcel$export(module.exports, "isValidTargetNode", () => $27b8041df1cc92a4$export$b485b49b5e1715ef);

var $4Wd8f = parcelRequire("4Wd8f");
const $27b8041df1cc92a4$export$b485b49b5e1715ef = (node)=>{
    return !!node && !(0, $4Wd8f.isIgnored)(node);
};

});
parcelRegister("4Wd8f", function(module, exports) {

$parcel$export(module.exports, "isIgnored", () => $f3b25ae2912922b3$export$ac3f691269cd6d9b);
// we don't show gap cursor for those nodes
const $f3b25ae2912922b3$var$IGNORED_NODES = [
    'paragraph',
    'bulletList',
    'orderedList',
    'listItem',
    'taskItem',
    'decisionItem',
    'heading',
    'blockquote',
    'layoutColumn',
    'caption',
    'media',
    'extensionFrame'
];
const $f3b25ae2912922b3$export$ac3f691269cd6d9b = (node)=>{
    return !!node && $f3b25ae2912922b3$var$IGNORED_NODES.indexOf(node.type.name) !== -1;
};

});



parcelRegister("dSVmA", function(module, exports) {

$parcel$export(module.exports, "ErrorReporter", () => $9e998316eee14f1b$export$88da0ac32d9c271e);
class $9e998316eee14f1b$export$88da0ac32d9c271e {
    captureMessage(msg, tags) {
        if (this.handlerStorage) this.handlerStorage.captureMessage(msg, tags);
    }
    captureException(err, tags) {
        if (this.handlerStorage) this.handlerStorage.captureException(err, tags);
    }
    set handler(handler) {
        this.handlerStorage = handler;
    }
    constructor(){
        this.handlerStorage = null;
    }
}

});

parcelRegister("6tl2G", function(module, exports) {

$parcel$export(module.exports, "processRawValueWithoutValidation", () => $c8ab5aa71274e362$export$cafe23194e65f591);
$parcel$export(module.exports, "processRawValue", () => $c8ab5aa71274e362$export$f1a0a61081c3ed62);
$parcel$export(module.exports, "processRawFragmentValue", () => $c8ab5aa71274e362$export$89b7989c347e6a7b);

var $bQZGL = parcelRequire("bQZGL");
var $jl4n8 = parcelRequire("jl4n8");
var $eJNM0 = parcelRequire("eJNM0");
var $1LHXq = parcelRequire("1LHXq");
var $dDZcC = parcelRequire("dDZcC");
var $fjWka = parcelRequire("fjWka");
var $krPum = parcelRequire("krPum");

var $kviC1 = parcelRequire("kviC1");

var $dh538 = parcelRequire("dh538");

var $d925B = parcelRequire("d925B");

var $hpdQE = parcelRequire("hpdQE");

var $juTiU = parcelRequire("juTiU");

var $6aq5c = parcelRequire("6aq5c");
const $c8ab5aa71274e362$var$transformNestedTablesWithAnalytics = (node, dispatchAnalyticsEvent)=>{
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $dDZcC.transformNestedTablesIncomingDocument)(node);
        if (isTransformed && dispatchAnalyticsEvent) {
            dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
            return {
                transformedAdf: transformedAdf,
                isTransformed: isTransformed
            };
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to transform one or more nested tables in the document');
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform one or more nested tables' : undefined}`
            }
        });
    }
    return {
        transformedAdf: node,
        isTransformed: false
    };
};
function $c8ab5aa71274e362$export$cafe23194e65f591(schema, value, dispatchAnalyticsEvent) {
    if (!value) return;
    let node;
    if (typeof value === 'string') try {
        node = JSON.parse(value);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${value} isn't a valid JSON`);
        return;
    }
    else node = value;
    if ((0, $dh538.fg)('platform_editor_use_nested_table_pm_nodes')) {
        // Convert nested-table extensions into nested tables
        const { transformedAdf: transformedAdf } = $c8ab5aa71274e362$var$transformNestedTablesWithAnalytics(node, dispatchAnalyticsEvent);
        return (0, $kviC1.Node).fromJSON(schema, transformedAdf);
    } else return (0, $kviC1.Node).fromJSON(schema, node);
}
function $c8ab5aa71274e362$export$f1a0a61081c3ed62(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
    if (!value) return;
    let node;
    if (typeof value === 'string') try {
        if (contentTransformer) {
            const doc = contentTransformer.parse(value);
            node = doc.toJSON();
        } else node = JSON.parse(value);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${value} isn't a valid JSON`);
        return;
    }
    else node = value;
    if (Array.isArray(node)) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${node} is an array, but it must be an object.`);
        return;
    }
    try {
        // ProseMirror always require a child under doc
        if (node.type === 'doc') {
            if (Array.isArray(node.content) && node.content.length === 0) node.content.push({
                type: 'paragraph',
                content: []
            });
            // Just making sure doc is always valid
            if (!node.version) node.version = 1;
        }
        if (contentTransformer) return (0, $kviC1.Node).fromJSON(schema, node);
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        let { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $1LHXq.transformMediaLinkMarks)(node);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        // See: HOT-97965 https://product-fabric.atlassian.net/browse/ED-14400
        // We declared in code mark spec that links and marks should not co-exist on
        // text nodes. This util strips code marks from bad text nodes and preserves links.
        // Otherwise, prosemirror will try to repair the invalid document by stripping links
        // and preserving code marks during content changes.
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $krPum.transformTextLinkCodeMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).TEXT_LINK_MARK_TRANSFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        let discardedMarks = [];
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed, discardedMarks: discardedMarks } = (0, $bQZGL.transformDedupeMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).DEDUPE_MARKS_TRANSFORMED_V2,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                /** UGC WARNING
					 *
					 * DO NOT include the `mark` attributes inside, we map here to only
					 * extract the mark type as that is the only non-UGC safe information
					 * that we can add to event-attributes
					 *
					 */ discardedMarkTypes: discardedMarks.map((mark)=>mark.type)
            }
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $fjWka.transformNodesMissingContent)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).NODES_MISSING_CONTENT_TRANSFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $jl4n8.transformIndentationMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).INDENTATION_MARKS_TRANSFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $eJNM0.transformInvalidMediaContent)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).INVALID_MEDIA_CONTENT_TRANSFORMED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        if ((0, $dh538.fg)('platform_editor_use_nested_table_pm_nodes')) // Convert nested-table extensions into nested tables
        ({ transformedAdf: transformedAdf } = $c8ab5aa71274e362$var$transformNestedTablesWithAnalytics(transformedAdf, dispatchAnalyticsEvent));
        if (dispatchAnalyticsEvent) {
            const hasSingleColumnLayout = transformedAdf.content?.some((node)=>node && node.type === 'layoutSection' && node.content?.length === 1);
            if (hasSingleColumnLayout) dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).SINGLE_COL_LAYOUT_DETECTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
        }
        const entity = (0, $6aq5c.validateADFEntity)(schema, transformedAdf || node, dispatchAnalyticsEvent);
        const newEntity = $c8ab5aa71274e362$var$maySanitizePrivateContent(entity, providerFactory, sanitizePrivateContent);
        const parsedDoc = (0, $kviC1.Node).fromJSON(schema, newEntity);
        // throws an error if the document is invalid
        try {
            parsedDoc.check();
        } catch (err) {
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
            throw err;
        }
        if (dispatchAnalyticsEvent) (0, $juTiU.findAndTrackUnsupportedContentNodes)(parsedDoc, schema, dispatchAnalyticsEvent);
        return parsedDoc;
    } catch (e) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
        // eslint-disable-next-line no-console
        console.error(`Error processing document:\n${e instanceof Error ? e.message : String(e)}\n\n`, JSON.stringify(node));
        if ($c8ab5aa71274e362$var$isProseMirrorSchemaCheckError(e)) throw e;
        return;
    }
}
function $c8ab5aa71274e362$export$89b7989c347e6a7b(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
    if (!value) return;
    const adfEntities = value.map((item)=>$c8ab5aa71274e362$export$f1a0a61081c3ed62(schema, item, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent)).filter((item)=>Boolean(item));
    if (adfEntities.length === 0) return;
    return (0, $kviC1.Fragment).from(adfEntities);
}
function $c8ab5aa71274e362$var$isProseMirrorSchemaCheckError(error) {
    return error instanceof RangeError && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    (!!error.message.match(/^Invalid collection of marks for node/) || // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !!error.message.match(/^Invalid content for node/));
}
const $c8ab5aa71274e362$var$maySanitizePrivateContent = (entity, providerFactory, sanitizePrivateContent)=>{
    if (sanitizePrivateContent && providerFactory) return (0, $hpdQE.sanitizeNodeForPrivacy)(entity, providerFactory);
    return entity;
};

});
parcelRegister("bQZGL", function(module, exports) {

$parcel$export(module.exports, "transformDedupeMarks", () => $1c2816ef0c8b7188$export$af4e387303482581);

var $6jPem = parcelRequire("6jPem");
// This is the set of marks that we wont allow in duplicate to
// exist on a given node, regardless of their attributes. We do
// not include annotations here, because we do allow duplicate
// annotations as long as they have unique id attributes (valid scenario)
const $1c2816ef0c8b7188$var$markDuplicatesDisallowed = new Set([
    'strong',
    'underline',
    'textColor',
    'link',
    'em',
    'subsup',
    'strike',
    'backgroundColor'
]);
const $1c2816ef0c8b7188$var$maybeHasDisallowedDuplicateMarks = (node)=>{
    const markTypes = node.marks?.map((mark)=>mark.type)?.filter((markType)=>// For annotations, we are performing the same cheap check
        // for duplicates by type, without considering IDs, to quickly determine
        // whether there may be potential deduping targets.
        // In the actual deduping logic in maybeRemoveDisallowedDuplicateMarks,
        // we correctly/safely dedupe annotations by their unique IDs.
        $1c2816ef0c8b7188$var$markDuplicatesDisallowed.has(markType) || markType === 'annotation');
    if (!markTypes?.length) return false;
    return new Set(markTypes).size !== markTypes.length;
};
const $1c2816ef0c8b7188$var$maybeRemoveDisallowedDuplicateMarks = (node)=>{
    const quota = new Map();
    const annotationsQuota = new Map();
    const discardedMarks = [];
    $1c2816ef0c8b7188$var$markDuplicatesDisallowed.forEach((mark)=>{
        quota.set(mark, false);
    });
    if (!node.marks) return {
        discardedMarks: discardedMarks
    };
    const dedupedMarks = node.marks.filter((mark)=>{
        const markType = mark.type;
        if (markType === 'annotation') {
            const id = mark.attrs?.id;
            if (annotationsQuota.has(id)) {
                discardedMarks.push(mark);
                return false;
            } else {
                annotationsQuota.set(id, true);
                return true;
            }
        }
        if (quota.has(markType)) {
            if (!quota.get(markType)) {
                quota.set(markType, true);
                return true;
            } else {
                discardedMarks.push(mark);
                return false;
            }
        }
        return true;
    });
    return {
        node: {
            ...node,
            marks: dedupedMarks
        },
        discardedMarks: discardedMarks
    };
};
const $1c2816ef0c8b7188$export$af4e387303482581 = (adf)=>{
    let isTransformed = false;
    const discardedMarks = [];
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        text: (node)=>{
            if ($1c2816ef0c8b7188$var$maybeHasDisallowedDuplicateMarks(node)) {
                const result = $1c2816ef0c8b7188$var$maybeRemoveDisallowedDuplicateMarks(node);
                const resultDiscardedMarks = result.discardedMarks;
                if (resultDiscardedMarks.length) {
                    discardedMarks.push(...resultDiscardedMarks);
                    isTransformed = true;
                    return result.node;
                }
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed,
        discardedMarks: discardedMarks
    };
};

});

parcelRegister("jl4n8", function(module, exports) {

$parcel$export(module.exports, "transformIndentationMarks", () => $c7e8fda47c191e04$export$c06e4b521519af22);

var $6jPem = parcelRequire("6jPem");
const $c7e8fda47c191e04$var$hasChildHeadingWithIndentation = (node)=>node.content?.some((childNode)=>childNode?.type === 'heading' && childNode?.marks?.some((mark)=>mark.type === 'indentation')) ?? false;
const $c7e8fda47c191e04$var$removeIndentationFromHeadings = (node)=>{
    return {
        ...node,
        content: node.content?.map((childNode)=>{
            if (childNode?.type === 'heading') return {
                ...childNode,
                marks: childNode.marks?.filter((mark)=>mark.type !== 'indentation')
            };
            return childNode;
        })
    };
};
const $c7e8fda47c191e04$export$c06e4b521519af22 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        tableCell: (node)=>{
            if ($c7e8fda47c191e04$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $c7e8fda47c191e04$var$removeIndentationFromHeadings(node);
            }
        },
        tableHeader: (node)=>{
            if ($c7e8fda47c191e04$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $c7e8fda47c191e04$var$removeIndentationFromHeadings(node);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("eJNM0", function(module, exports) {

$parcel$export(module.exports, "transformInvalidMediaContent", () => $5b85afc4a4930f06$export$1c8c16d74c7a63bf);

var $6jPem = parcelRequire("6jPem");

var $hbEec = parcelRequire("hbEec");
const $5b85afc4a4930f06$var$getChildrenTypeCounts = (nodeContent, allowedTypes)=>{
    const childrenTypes = {};
    nodeContent.forEach((childNode, index)=>{
        if (!childNode?.type || !allowedTypes.includes(childNode.type)) return;
        if (!childrenTypes[childNode.type]) {
            childrenTypes[childNode.type] = 1;
            return;
        }
        childrenTypes[childNode.type]++;
    });
    return childrenTypes;
};
const $5b85afc4a4930f06$var$removeDuplicatedNodes = (type, content, predicate)=>{
    let maxIterations = 10;
    let childrenTypeCounts = $5b85afc4a4930f06$var$getChildrenTypeCounts(content, [
        type
    ])[type];
    let firstPredicateNodeIndex = content.findIndex(predicate);
    while(childrenTypeCounts > 1 && firstPredicateNodeIndex > -1 && maxIterations-- > 0){
        content.splice(firstPredicateNodeIndex, 1);
        firstPredicateNodeIndex = content.findIndex(predicate);
        childrenTypeCounts = $5b85afc4a4930f06$var$getChildrenTypeCounts(content, [
            type
        ])[type];
    }
};
/**
 * @param  {{[type:string]:number}} allowedTypes - array types allowed to deduplicate
 */ const $5b85afc4a4930f06$var$deduplicateMediaSingleChildren = (node, allowedTypes)=>{
    if (!node.content) return;
    const content = [
        ...node.content
    ];
    Object.keys(allowedTypes).forEach((type)=>{
        //prioritise removing empty nodes first
        $5b85afc4a4930f06$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type && (0, $hbEec.isEmpty)(node));
        //remove other remaining dupicates
        $5b85afc4a4930f06$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type);
    });
    return {
        ...node,
        content: content
    };
};
const $5b85afc4a4930f06$export$1c8c16d74c7a63bf = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node?.content?.length) return;
            const disallowedDuplicateTypes = [
                'media',
                'caption'
            ];
            const childrenTypes = $5b85afc4a4930f06$var$getChildrenTypeCounts(node.content, disallowedDuplicateTypes);
            if (Object.values(childrenTypes).some((occurences)=>occurences > 1)) {
                isTransformed = true;
                return $5b85afc4a4930f06$var$deduplicateMediaSingleChildren(node, childrenTypes);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});
parcelRegister("hbEec", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $5f601bcc1718fb0b$export$dd1bc94b04021eeb);
const $5f601bcc1718fb0b$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;

});


parcelRegister("fjWka", function(module, exports) {

$parcel$export(module.exports, "transformNodesMissingContent", () => $c977c2fbc5484638$export$652814b83c30d251);

var $6jPem = parcelRequire("6jPem");

var $eyfm5 = parcelRequire("eyfm5");
var $2FFuS = parcelRequire("2FFuS");
var $inmjk = parcelRequire("inmjk");
var $8WrQo = parcelRequire("8WrQo");

var $hbEec = parcelRequire("hbEec");
const $c977c2fbc5484638$var$getMaxColumnsCountForTable = (tableNode)=>{
    let colsInRow = 1;
    tableNode.content?.forEach((childNode)=>{
        if (childNode?.type === 'tableRow' && typeof childNode.content?.length === 'number' && childNode.content.length > colsInRow) colsInRow = childNode.content.length;
    });
    return colsInRow;
};
const $c977c2fbc5484638$var$createValidEmptyContent = (node)=>{
    switch(node.type){
        case 'tableCell':
            return [
                (0, $2FFuS.paragraph)()
            ];
        default:
            return [];
    }
};
const $c977c2fbc5484638$var$fixIfTableCellInvalidEmpty = (reportTransform)=>(node)=>{
        if ((0, $hbEec.isEmpty)(node)) {
            reportTransform();
            return {
                ...node,
                content: $c977c2fbc5484638$var$createValidEmptyContent(node)
            };
        }
    };
const $c977c2fbc5484638$var$hasNonListItemChildren = (node)=>node.content?.some((node)=>node?.type !== 'listItem');
const $c977c2fbc5484638$var$hasEmptyListItemChildren = (node)=>node.content?.some((childNode)=>childNode?.type === 'listItem' && !childNode.content?.length);
const $c977c2fbc5484638$var$tryCreateValidListItemWrappedChildren = (parentListNode)=>{
    return parentListNode.content?.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'listItem':
                if ((0, $hbEec.isEmpty)(childNode)) {
                    const result = (0, $eyfm5.listItem)([
                        (0, $2FFuS.paragraph)()
                    ]);
                    return result;
                }
                return childNode;
            case 'text':
                return (0, $eyfm5.listItem)([
                    (0, $2FFuS.paragraph)(childNode)
                ]);
            default:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return (0, $eyfm5.listItem)([
                    childNode
                ]);
        }
        return childNode;
    });
};
const $c977c2fbc5484638$var$fixIfListParentWithInvalidListItemChildren = (reportTransform)=>(node)=>{
        if ($c977c2fbc5484638$var$hasNonListItemChildren(node) || $c977c2fbc5484638$var$hasEmptyListItemChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $c977c2fbc5484638$var$tryCreateValidListItemWrappedChildren(node)
            };
        }
    };
const $c977c2fbc5484638$var$hasNonTableRowChildren = (node)=>node.content?.some((node)=>node?.type !== 'tableRow');
const $c977c2fbc5484638$var$tryCreateValidTableRowWrappedChildren = (parentTableNode)=>{
    const maxColsCount = $c977c2fbc5484638$var$getMaxColumnsCountForTable(parentTableNode);
    return parentTableNode.content?.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'text':
                return (0, $8WrQo.tableRow)([
                    (0, $inmjk.tableCell)({})((0, $2FFuS.paragraph)(childNode)),
                    ...new Array(maxColsCount - 1).fill((0, $inmjk.tableCell)({})((0, $2FFuS.paragraph)()))
                ]);
            case 'tableCell':
                return (0, $8WrQo.tableRow)([
                    childNode
                ]);
            case 'tableRow':
                if ((0, $hbEec.isEmpty)(childNode)) return (0, $8WrQo.tableRow)([
                    ...new Array(maxColsCount).fill((0, $inmjk.tableCell)({})((0, $2FFuS.paragraph)()))
                ]);
                return childNode;
            default:
                return childNode;
        }
        return childNode;
    });
};
const $c977c2fbc5484638$var$hasEmptyTableRowChildren = (node)=>node?.content?.some((node)=>node?.type === 'tableRow' && node?.content?.length === 0);
const $c977c2fbc5484638$var$fixIfTableParentWithInvalidTableRowChildren = (reportTransform)=>(node)=>{
        if ($c977c2fbc5484638$var$hasEmptyTableRowChildren(node) || $c977c2fbc5484638$var$hasNonTableRowChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $c977c2fbc5484638$var$tryCreateValidTableRowWrappedChildren(node)
            };
        }
    };
const $c977c2fbc5484638$var$removeMediaSingleWithNoContent = (reportTransform)=>(node)=>{
        if ((0, $hbEec.isEmpty)(node)) {
            reportTransform();
            return false;
        }
    };
const $c977c2fbc5484638$export$652814b83c30d251 = (adf)=>{
    let isTransformed = false;
    const reportTransform = ()=>{
        isTransformed = true;
    };
    let transformedAdf = (0, $6jPem.traverse)(adf, {
        tableCell: $c977c2fbc5484638$var$fixIfTableCellInvalidEmpty(reportTransform)
    });
    // Empty mediaSingle nodes get stripped from the document and so this transform
    // will create an empty listItem if the media node is in a list. Empty listItems
    // are invalid adf, so we need to transform the mediaSingle nodes first.
    transformedAdf = (0, $6jPem.traverse)(transformedAdf || adf, {
        mediaSingle: $c977c2fbc5484638$var$removeMediaSingleWithNoContent(reportTransform)
    });
    transformedAdf = (0, $6jPem.traverse)(transformedAdf || adf, {
        bulletList: $c977c2fbc5484638$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        orderedList: $c977c2fbc5484638$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        table: $c977c2fbc5484638$var$fixIfTableParentWithInvalidTableRowChildren(reportTransform)
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});
parcelRegister("eyfm5", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $6fd46c311db8d44c$export$76c7e83ecc9cdf05);
const $6fd46c311db8d44c$export$76c7e83ecc9cdf05 = (content)=>({
        type: 'listItem',
        content: content
    });

});

parcelRegister("2FFuS", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $a4fc62108e90d067$export$9c206ddddb32a9b);

var $enilC = parcelRequire("enilC");
const $a4fc62108e90d067$export$9c206ddddb32a9b = (...content)=>({
        type: 'paragraph',
        content: (0, $enilC.createTextNodes)(content)
    });

});
parcelRegister("enilC", function(module, exports) {

$parcel$export(module.exports, "createTextNodes", () => $b397a3d9dc60a40a$export$3a269a5941b62f04);

var $aoDcQ = parcelRequire("aoDcQ");
function $b397a3d9dc60a40a$export$3a269a5941b62f04(nodes) {
    return nodes.map($b397a3d9dc60a40a$export$72b9432ea0656b50);
}
function $b397a3d9dc60a40a$export$72b9432ea0656b50(str) {
    return typeof str === 'string' ? (0, $aoDcQ.text)(str) : str;
}

});
parcelRegister("aoDcQ", function(module, exports) {

$parcel$export(module.exports, "text", () => $cb8b1b1eb7a280a9$export$6f093cfa640b7166);
const $cb8b1b1eb7a280a9$export$6f093cfa640b7166 = (text)=>({
        type: 'text',
        text: text
    });

});



parcelRegister("inmjk", function(module, exports) {

$parcel$export(module.exports, "tableCell", () => $c51384942fa452cc$export$e1e720e5f4603e6a);
const $c51384942fa452cc$export$e1e720e5f4603e6a = (attrs)=>(...content)=>({
            type: 'tableCell',
            attrs: attrs,
            content: content
        });

});

parcelRegister("8WrQo", function(module, exports) {

$parcel$export(module.exports, "tableRow", () => $e620d19b8ea2ca65$export$ce666bf02318c957);
const $e620d19b8ea2ca65$export$ce666bf02318c957 = (content)=>({
        type: 'tableRow',
        content: content
    });

});


parcelRegister("krPum", function(module, exports) {

$parcel$export(module.exports, "transformTextLinkCodeMarks", () => $8fc0fe8ad0751ae2$export$3d531d2daf0e8a14);

var $6jPem = parcelRequire("6jPem");
const $8fc0fe8ad0751ae2$var$hasLinkAndCodeMarks = (node)=>{
    const marks = node.marks?.map((mark)=>mark.type);
    return marks?.includes('link') && marks?.includes('code');
};
const $8fc0fe8ad0751ae2$var$removeCodeMarks = (node)=>{
    if (node.marks) return {
        ...node,
        marks: node.marks.filter((mark)=>mark.type !== 'code')
    };
    return node;
};
const $8fc0fe8ad0751ae2$export$3d531d2daf0e8a14 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        text: (node)=>{
            if ($8fc0fe8ad0751ae2$var$hasLinkAndCodeMarks(node)) {
                isTransformed = true;
                return $8fc0fe8ad0751ae2$var$removeCodeMarks(node);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("hpdQE", function(module, exports) {

$parcel$export(module.exports, "sanitizeNodeForPrivacy", () => $5dc3e3095b1b3f43$export$8a32f625580e0a06);

var $6jPem = parcelRequire("6jPem");

var $bqMS3 = parcelRequire("bqMS3");
function $5dc3e3095b1b3f43$export$8a32f625580e0a06(json, providerFactory) {
    const mentionNames = new Map();
    let hasCacheableMentions = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedJSON = (0, $6jPem.traverse)(json, {
        mention: (node)=>{
            if (node.attrs && node.attrs.text) {
                hasCacheableMentions = true;
                // Remove @ prefix
                const text = node.attrs.text;
                const name = text.startsWith('@') ? text.slice(1) : text;
                mentionNames.set(node.attrs.id, name);
            }
            return {
                ...node,
                attrs: {
                    ...node.attrs,
                    text: ''
                }
            };
        }
    });
    if (hasCacheableMentions && providerFactory) {
        const handler = (_name, providerPromise)=>{
            if (providerPromise) providerPromise.then((provider)=>{
                if ((0, $bqMS3.isResolvingMentionProvider)(provider)) {
                    mentionNames.forEach((name, id)=>{
                        provider.cacheMentionName(id, name);
                    });
                    mentionNames.clear();
                    providerFactory.unsubscribe('mentionProvider', handler);
                }
            });
        };
        providerFactory.subscribe('mentionProvider', handler);
    }
    return sanitizedJSON;
}

});


parcelRegister("DoNsZ", function(module, exports) {

$parcel$export(module.exports, "darkPanelColors", () => $2d8620dcf810155b$export$804476272fbaff5e);
$parcel$export(module.exports, "PanelSharedCssClassName", () => $2d8620dcf810155b$export$6dd740b6c888e050);
$parcel$export(module.exports, "getPanelTypeBackgroundNoTokens", () => $2d8620dcf810155b$export$8099afddf1b1be78);
$parcel$export(module.exports, "panelSharedStyles", () => $2d8620dcf810155b$export$fc98407afe711ba8);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $kyLrk = parcelRequire("kyLrk");

var $6icEc = parcelRequire("6icEc");

var $aFUXX = parcelRequire("aFUXX");

var $aFUXX = parcelRequire("aFUXX");

var $8hpYf = parcelRequire("8hpYf");

var $dh538 = parcelRequire("dh538");
const $2d8620dcf810155b$var$lightPanelColors = {
    info: '#DEEBFF',
    note: '#EAE6FF',
    tip: '#E3FCEF',
    success: '#E3FCEF',
    warning: '#FFFAE6',
    error: '#FFEBE6'
};
const $2d8620dcf810155b$export$804476272fbaff5e = {
    // standard panels
    info: `#0C294F`,
    error: `#441C13`,
    warning: `#413001`,
    tip: `#052E21`,
    success: `#052E21`,
    note: `#282249`,
    // Reds
    R900: '#601D16',
    // Red Saturated
    R100S: `#FFEFEB`,
    R300S: `#FFB5A3`,
    R500S: `#FF6B47`,
    R800S: `#C4320E`,
    R1200S: `#441C13`,
    // Yellows
    Y900: '#533F04',
    // Yellow Saturated
    Y100S: `#FFF3D1`,
    Y300S: `#FFDC7A`,
    Y500S: `#FFC933`,
    Y800S: `#D8A003`,
    Y1200S: `#413001`,
    // Greens
    G900: '#164B35',
    // Green Saturated
    G100S: `#E3FCF0`,
    G300S: `#95EEC5`,
    G400S: `#60DCA8`,
    G900S: `#086848`,
    G1200S: `#052E21`,
    // Blues
    B900: '#09326C',
    // Saturated Blues
    B100S: '#E5F0FF',
    B300S: '#A3C9FF',
    B500S: '#4794FF',
    B800S: '#0055CC',
    B1200S: '#0C294F',
    // Purples
    P900: `#352C63`,
    // Purple Saturated
    P100S: `#EEEBFF`,
    P300S: `#CCC3FE`,
    P500S: `#A292F7`,
    P800S: `#5E49CA`,
    P1200S: `#282249`,
    // Teals
    T900: '#1D474C',
    // Teal Saturated
    T100S: `#DBFAFF`,
    T300S: `#78EBFC`,
    T400S: `#3AD6EE`,
    T900S: `#056270`,
    T1200S: `#0B3037`,
    // Dark Mode Alpha
    DarkGray: '#161A1D',
    Gray: '#2C333A',
    LightGray: '#5A6977',
    TextColor: '#D9DDE3'
};
const $2d8620dcf810155b$var$lightIconColor = {
    info: "var(--ds-icon-information, #1D7AFC)",
    note: "var(--ds-icon-discovery, #8270DB)",
    tip: "var(--ds-icon-success, #22A06B)",
    success: "var(--ds-icon-success, #22A06B)",
    warning: "var(--ds-icon-warning, #E56910)",
    error: "var(--ds-icon-danger, #C9372C)"
};
// New custom icons are a little smaller than predefined icons.
// To fix alignment issues with custom icons, vertical alignment is updated.
const $2d8620dcf810155b$var$panelEmojiSpriteVerticalAlignment = -(24 - (0, $aFUXX.akEditorCustomIconSize)) / 2;
const $2d8620dcf810155b$var$panelEmojiImageVerticalAlignment = $2d8620dcf810155b$var$panelEmojiSpriteVerticalAlignment - 1;
function $2d8620dcf810155b$export$9490e629452e7f9e(colorName, colorValue) {
    return `
  &[data-panel-color="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
    color: ${$2d8620dcf810155b$export$804476272fbaff5e.TextColor};
  }
  `;
}
const $2d8620dcf810155b$var$prefix = 'ak-editor-panel';
const $2d8620dcf810155b$export$6dd740b6c888e050 = {
    prefix: $2d8620dcf810155b$var$prefix,
    content: `${$2d8620dcf810155b$var$prefix}__content`,
    icon: `${$2d8620dcf810155b$var$prefix}__icon`,
    noIcon: `${$2d8620dcf810155b$var$prefix}__no-icon`
};
const $2d8620dcf810155b$export$b0ee08fae091706a = {
    infoPanel: `.${$2d8620dcf810155b$var$prefix}[data-panel-type=${(0, $kyLrk.PanelType).INFO}]`,
    notePanel: `.${$2d8620dcf810155b$var$prefix}[data-panel-type=${(0, $kyLrk.PanelType).NOTE}]`,
    warningPanel: `.${$2d8620dcf810155b$var$prefix}[data-panel-type=${(0, $kyLrk.PanelType).WARNING}]`,
    errorPanel: `.${$2d8620dcf810155b$var$prefix}[data-panel-type=${(0, $kyLrk.PanelType).ERROR}]`,
    successPanel: `.${$2d8620dcf810155b$var$prefix}[data-panel-type=${(0, $kyLrk.PanelType).SUCCESS}]`,
    noteButton: `button[aria-label="Note"]`,
    warningButton: `button[aria-label="Warning"]`,
    removeButton: `button[aria-label="Remove"]`,
    colorPalette: `[aria-label="Background color"]`,
    selectedColor: `[aria-label="Light green"]`,
    removeEmojiIcon: `[aria-label="Remove emoji"]`,
    emojiIcon: `[aria-label="editor-add-emoji"]`,
    selectedEmoji: `[aria-label=":grinning:"]`,
    addYourOwnEmoji: `#add-custom-emoji`,
    emojiNameInCustomEmoji: `[aria-label="Enter a name for the new emoji"]`,
    title: `#editor-title`,
    emojiPopup: `[aria-label="Popup"]`,
    searchEmoji: `[aria-label="Emoji name"]`,
    orangeWarningIcon: `[aria-label=":warning:"]`,
    yellowWarningIcon: `[aria-label=":warning:"]  span:nth-child(1)`,
    copyButton: `button[aria-label="Copy"]`
};
const $2d8620dcf810155b$var$getIconStyles = (panelType)=>{
    if ((0, $dh538.fg)('platform_editor_lcm_nested_panel_icon_fix')) return `
			.${$2d8620dcf810155b$export$6dd740b6c888e050.icon}[data-panel-type='${panelType}'] {
				color: ${$2d8620dcf810155b$var$lightIconColor[panelType]};
			}
		`;
    else return `
			.${$2d8620dcf810155b$export$6dd740b6c888e050.icon} {
				color: ${$2d8620dcf810155b$var$lightIconColor[panelType]};
			}
		`;
};
const $2d8620dcf810155b$export$8099afddf1b1be78 = (panelType)=>$2d8620dcf810155b$var$lightPanelColors[panelType] || 'none';
const $2d8620dcf810155b$export$dd3f0fd482ae7ccc = (panelType)=>(0, $6icEc.hexToEditorBackgroundPaletteColor)($2d8620dcf810155b$var$lightPanelColors[panelType]) || 'none';
const $2d8620dcf810155b$var$mainDynamicStyles = (panelType)=>{
    return `
    background-color: ${$2d8620dcf810155b$export$dd3f0fd482ae7ccc(panelType)};
    color: inherit;
  `;
};
const $2d8620dcf810155b$export$d707b378cb63679a = ()=>(0, $3jLHL.css)`
	border-radius: ${"var(--ds-border-radius, 3px)"};
	margin: ${0, $aFUXX.blockNodesVerticalMargin} 0 0;
	padding-top: ${"var(--ds-space-100, 8px)"};
	padding-right: ${"var(--ds-space-200, 16px)"};
	padding-bottom: ${"var(--ds-space-100, 8px)"};
	padding-left: ${"var(--ds-space-100, 8px)"};
	min-width: ${0, $aFUXX.akEditorTableCellMinWidth}px;
	display: flex;
	position: relative;
	align-items: normal;
	word-break: break-word;

	${$2d8620dcf810155b$var$mainDynamicStyles((0, $kyLrk.PanelType).INFO)}

	.${$2d8620dcf810155b$export$6dd740b6c888e050.icon} {
		flex-shrink: 0;
		height: ${"var(--ds-space-300, 24px)"};
		width: ${"var(--ds-space-300, 24px)"};
		box-sizing: content-box;
		padding-right: ${"var(--ds-space-100, 8px)"};
		text-align: center;
		user-select: none;
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
		margin-top: 0.1em;

		> span {
			vertical-align: middle;
			display: inline-flex;
		}

		.${0, $8hpYf.emojiSprite} {
			vertical-align: ${$2d8620dcf810155b$var$panelEmojiSpriteVerticalAlignment}px;
		}

		.${0, $8hpYf.emojiImage} {
			vertical-align: ${$2d8620dcf810155b$var$panelEmojiImageVerticalAlignment}px;

			/* Vertical align only works for inline-block elements in Firefox */
			@-moz-document url-prefix() {
				img {
					display: inline-block;
				}
			}
		}
	}

	.ak-editor-panel__content {
		margin: ${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"};
		flex: 1 0 0;
		/*
      https://ishadeed.com/article/min-max-css/#setting-min-width-to-zero-with-flexbox
      The default value for min-width is auto, which is computed to zero. When an element is a flex item, the value of min-width doesn’t compute to zero. The minimum size of a flex item is equal to the size of its contents.
    */
		min-width: 0;
	}

	/* support nested panel */
	${(0, $dh538.fg)('platform_editor_add_border_for_nested_panel') ? `.${$2d8620dcf810155b$export$6dd740b6c888e050.content} .${$2d8620dcf810155b$var$prefix} {
			border: 1px solid ${"var(--ds-border, #091E42)"};
		}` : ''}

	&[data-panel-type='${(0, $kyLrk.PanelType).INFO}'] {
		${$2d8620dcf810155b$var$getIconStyles((0, $kyLrk.PanelType).INFO)}
	}

	&[data-panel-type='${(0, $kyLrk.PanelType).NOTE}'] {
		${$2d8620dcf810155b$var$mainDynamicStyles((0, $kyLrk.PanelType).NOTE)}
		${$2d8620dcf810155b$var$getIconStyles((0, $kyLrk.PanelType).NOTE)}
	}

	&[data-panel-type='${(0, $kyLrk.PanelType).TIP}'] {
		${$2d8620dcf810155b$var$mainDynamicStyles((0, $kyLrk.PanelType).TIP)}
		${$2d8620dcf810155b$var$getIconStyles((0, $kyLrk.PanelType).TIP)}
	}

	&[data-panel-type='${(0, $kyLrk.PanelType).WARNING}'] {
		${$2d8620dcf810155b$var$mainDynamicStyles((0, $kyLrk.PanelType).WARNING)}
		${$2d8620dcf810155b$var$getIconStyles((0, $kyLrk.PanelType).WARNING)}
	}

	&[data-panel-type='${(0, $kyLrk.PanelType).ERROR}'] {
		${$2d8620dcf810155b$var$mainDynamicStyles((0, $kyLrk.PanelType).ERROR)}
		${$2d8620dcf810155b$var$getIconStyles((0, $kyLrk.PanelType).ERROR)}
	}

	&[data-panel-type='${(0, $kyLrk.PanelType).SUCCESS}'] {
		${$2d8620dcf810155b$var$mainDynamicStyles((0, $kyLrk.PanelType).SUCCESS)}
		${$2d8620dcf810155b$var$getIconStyles((0, $kyLrk.PanelType).SUCCESS)}
	}

	${(0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? `&.${$2d8620dcf810155b$export$6dd740b6c888e050.noIcon} {
			padding-right: ${"var(--ds-space-150, 12px)"};
			padding-left: ${"var(--ds-space-150, 12px)"};
		}` : ''}
`;
const $2d8620dcf810155b$export$fc98407afe711ba8 = ()=>(0, $3jLHL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.${$2d8620dcf810155b$export$6dd740b6c888e050.prefix}`]: $2d8620dcf810155b$export$d707b378cb63679a()
    });

});

parcelRegister("fDGbV", function(module, exports) {

$parcel$export(module.exports, "getDimensionsWithDefault", () => $fdb0bbe11c94f00f$export$36acad525b1fb57b);
const $fdb0bbe11c94f00f$export$36acad525b1fb57b = (dimensions = {
    width: '100%',
    height: '100%'
})=>{
    return {
        height: typeof dimensions.height === 'number' ? `${dimensions.height}px` : dimensions.height,
        width: typeof dimensions.width === 'number' ? `${dimensions.width}px` : dimensions.width
    };
};

});

parcelRegister("8jrlU", function(module, exports) {

$parcel$export(module.exports, "newFileExperienceClassName", () => $dba4e4fdcb4b1deb$export$c5ba918dbb0b00f3);
const $dba4e4fdcb4b1deb$export$c5ba918dbb0b00f3 = 'new-file-experience-wrapper';

});

parcelRegister("ieXGd", function(module, exports) {

$parcel$export(module.exports, "getSelectionStyles", () => $097d317d23b8bcc9$export$fb186b651805ffe4);
$parcel$export(module.exports, "hideNativeBrowserTextSelectionStyles", () => $097d317d23b8bcc9$export$a716852a0c5e54d5);

var $aFUXX = parcelRequire("aFUXX");

var $b38UX = parcelRequire("b38UX");
const $097d317d23b8bcc9$export$fb186b651805ffe4 = (selectionStyles)=>selectionStyles.map((selectionStyle)=>$097d317d23b8bcc9$var$getSelectionStyle(selectionStyle)).concat($097d317d23b8bcc9$export$a716852a0c5e54d5).join('\n');
const $097d317d23b8bcc9$export$a716852a0c5e54d5 = `
  ::selection,*::selection {
    background-color: transparent;
  }
  ::-moz-selection,*::-moz-selection {
    background-color: transparent;
  }
`;
const $097d317d23b8bcc9$var$getSelectionStyle = (style)=>{
    switch(style){
        case (0, $b38UX.SelectionStyle).Border:
            return `
        border: ${0, $aFUXX.akEditorSelectedBorder};

        // Fixes ED-15246: Trello card is visible through a border of a table border
        &::after {
          height: 100%;
          content: '\\00a0';
          background: ${0, $aFUXX.akEditorSelectedBorderColor};
          position: absolute;
          right: -1px;
          top: 0;
          bottom: 0;
          width: 1px;
          border: none;
          display: inline-block;
        }
      `;
        case (0, $b38UX.SelectionStyle).BoxShadow:
            return `
        box-shadow: ${0, $aFUXX.akEditorSelectedBoxShadow};
        border-color: transparent;
        `;
        case (0, $b38UX.SelectionStyle).Background:
            return `background-color: ${"var(--ds-background-selected, #E9F2FF)"};`;
        case (0, $b38UX.SelectionStyle).Blanket:
            return `
        position: relative;

        // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel
        // in Safari. Looks like it's caused by user-select: all in the emoji element
        -webkit-user-select: text;

        ::before {
          position: absolute;
          content: '';
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          pointer-events: none;
          z-index: ${0, $aFUXX.akEditorSmallZIndex};
          background-color: ${"var(--ds-blanket-selected, #388BFF14)"}
        }`;
        default:
            return '';
    }
};

});
parcelRegister("b38UX", function(module, exports) {

$parcel$export(module.exports, "SelectionStyle", () => $5e118ec333d708f7$export$80010201b36a8290);
/**
 * These are generic selection styles for all nodes
 * If you have custom behaviour needed for a node, add that in the plugin's styles
 * file in editor-core
 */ var $5e118ec333d708f7$export$80010201b36a8290 = /*#__PURE__*/ function(SelectionStyle) {
    SelectionStyle[SelectionStyle["Border"] = 0] = "Border";
    SelectionStyle[SelectionStyle["BoxShadow"] = 1] = "BoxShadow";
    SelectionStyle[SelectionStyle["Background"] = 2] = "Background";
    SelectionStyle[SelectionStyle["Blanket"] = 3] = "Blanket";
    return SelectionStyle;
}({});

});


parcelRegister("cDSVG", function(module, exports) {

$parcel$export(module.exports, "inlinePlayerClassName", () => $4bc6aca00a4d4c4d$export$70bc5d30fe886af);
$parcel$export(module.exports, "inlinePlayerWrapperStyles", () => $4bc6aca00a4d4c4d$export$bffd1a8ecf8d5d06);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $dTk3A = parcelRequire("dTk3A");

var $fDGbV = parcelRequire("fDGbV");

var $ieXGd = parcelRequire("ieXGd");
var $b38UX = parcelRequire("b38UX");
/*
 * Used to display the blue border around a selected card without
 * shrinking the image OR growing the card size
 */ const $4bc6aca00a4d4c4d$var$getSelectedBorderStyle = ({ selected: selected })=>`
    ${selected ? (0, $ieXGd.hideNativeBrowserTextSelectionStyles) : ''}

    &::after {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      box-sizing: border-box;
      pointer-events: none;
      ${0, $dTk3A.borderRadius}
      ${selected ? (0, $ieXGd.getSelectionStyles)([
        (0, $b38UX.SelectionStyle).Border
    ]) : ''}
    }
  `;
const $4bc6aca00a4d4c4d$export$70bc5d30fe886af = 'media-card-inline-player';
const $4bc6aca00a4d4c4d$export$bffd1a8ecf8d5d06 = ({ dimensions: dimensions, selected: selected })=>(0, $3jLHL.css)`
	width: ${(0, $fDGbV.getDimensionsWithDefault)(dimensions).width || '100%'};
	height: ${(0, $fDGbV.getDimensionsWithDefault)(dimensions).height || 'auto'};
	overflow: hidden;
	border-radius: ${(0, $dTk3A.borderRadius)()}px;
	position: relative;
	max-width: 100%;
	max-height: 100%;

	${$4bc6aca00a4d4c4d$var$getSelectedBorderStyle(selected)}

	video {
		width: 100%;
		height: 100%;
	}
`;
$4bc6aca00a4d4c4d$export$bffd1a8ecf8d5d06.displayName = 'InlinePlayerWrapper';

});

parcelRegister("b5IZN", function(module, exports) {

$parcel$export(module.exports, "CoreEditor", () => $f12bc0dec21ca30e$export$be7eaacc86ce4514);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $atveb = parcelRequire("atveb");

var $kyKWe = parcelRequire("kyKWe");

var $ffCOo = parcelRequire("ffCOo");

var $inPa6 = parcelRequire("inPa6");

var $d925B = parcelRequire("d925B");
var $ajtqX = parcelRequire("ajtqX");

var $2T4ch = parcelRequire("2T4ch");

var $lWghV = parcelRequire("lWghV");

var $dh538 = parcelRequire("dh538");

var $fswVK = parcelRequire("fswVK");

var $auTg8 = parcelRequire("auTg8");

var $6DQRK = parcelRequire("6DQRK");

var $7lreV = parcelRequire("7lreV");

var $75KVc = parcelRequire("75KVc");

var $eqcbK = parcelRequire("eqcbK");

var $blhF9 = parcelRequire("blhF9");

var $eilyC = parcelRequire("eilyC");

var $19Ub2 = parcelRequire("19Ub2");

var $1T1oM = parcelRequire("1T1oM");

var $amGDM = parcelRequire("amGDM");
/**
 * Editor wrapper that deals with the lifecycle logic of the editor
 * @param passedProps
 * @example
 */ function $f12bc0dec21ca30e$var$Editor(passedProps) {
    const propsRef = (0, $gwFzn.useRef)(passedProps);
    const props = (0, $19Ub2.default)(passedProps);
    (0, $gwFzn.useMemo)(()=>{
        propsRef.current = props;
    }, [
        props
    ]);
    const editorContext = (0, $auTg8.useEditorContext)();
    const editorActionsPlaceholderInstance = (0, $gwFzn.useMemo)(()=>new (0, $fswVK.default)(), []);
    const editorActions = editorContext.editorActions || editorActionsPlaceholderInstance;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleAnalyticsEvent = (0, $gwFzn.useCallback)((data)=>{
        (0, $ajtqX.fireAnalyticsEvent)(createAnalyticsEvent)(data);
    }, [
        createAnalyticsEvent
    ]);
    const getFeatureFlagsFromRef = (0, $gwFzn.useCallback)(()=>{
        return {
            ...(0, $6DQRK.createFeatureFlagsFromProps)(propsRef.current.featureFlags),
            useNativeCollabPlugin: Boolean(typeof propsRef.current.collabEdit?.useNativePlugin === 'boolean' ? !!propsRef.current.collabEdit?.useNativePlugin : false)
        };
    }, []);
    const onEditorCreated = (0, $gwFzn.useCallback)((instance)=>{
        const { contextIdentifierProvider: contextIdentifierProvider, onEditorReady: onEditorReady, featureFlags: featureFlags } = propsRef.current;
        editorActions._privateRegisterEditor(instance.view, instance.eventDispatcher, instance.transformer, getFeatureFlagsFromRef);
        if (onEditorReady) {
            (0, $2T4ch.startMeasure)((0, $7lreV.default).ON_EDITOR_READY_CALLBACK);
            onEditorReady(editorActions);
            (0, $2T4ch.stopMeasure)((0, $7lreV.default).ON_EDITOR_READY_CALLBACK, (0, $amGDM.default)((0, $d925B.ACTION).ON_EDITOR_READY_CALLBACK, {
                contextIdentifierProvider: contextIdentifierProvider,
                featureFlags: featureFlags
            }, createAnalyticsEvent));
        }
    }, [
        editorActions,
        createAnalyticsEvent,
        getFeatureFlagsFromRef,
        propsRef
    ]);
    const onEditorDestroyed = (0, $gwFzn.useCallback)((_instance)=>{
        const { onDestroy: onDestroy } = propsRef.current;
        editorActions._privateUnregisterEditor();
        if (onDestroy) onDestroy();
    }, [
        editorActions,
        propsRef
    ]);
    (0, $eilyC.default)(props, createAnalyticsEvent);
    const providerFactory = (0, $1T1oM.default)(props, editorActions, createAnalyticsEvent);
    const { onSave: onSaveFromProps } = props;
    const handleSave = (0, $gwFzn.useCallback)((view)=>{
        if (onSaveFromProps) onSaveFromProps(view);
    }, [
        onSaveFromProps
    ]);
    const isFullPageApperance = Boolean(props.appearance && [
        'full-page',
        'full-width'
    ].includes(props.appearance));
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, isFullPageApperance && (0, $dh538.fg)('platform_editor_fe--inp-metrics') ? /*#__PURE__*/ (0, $3jLHL.jsx)((0, $eqcbK.EditorINPMetrics), null) : null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $blhF9.EditorInternal), {
        props: props,
        handleAnalyticsEvent: handleAnalyticsEvent,
        createAnalyticsEvent: createAnalyticsEvent,
        preset: props.preset,
        handleSave: handleSave,
        editorActions: editorActions,
        onEditorCreated: onEditorCreated,
        onEditorDestroyed: onEditorDestroyed,
        providerFactory: providerFactory,
        AppearanceComponent: props.AppearanceComponent
    }));
}
const $f12bc0dec21ca30e$var$useMemoEditorFeatureFlags = (featureFlags)=>{
    const ffRef = (0, $gwFzn.useRef)(featureFlags);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($atveb)))(ffRef.current, featureFlags)) ffRef.current = featureFlags;
    return ffRef.current;
};
function $f12bc0dec21ca30e$export$be7eaacc86ce4514(props) {
    const editorSessionId = (0, $gwFzn.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))());
    const data = (0, $gwFzn.useMemo)(()=>{
        return {
            packageName: (0, $75KVc.name),
            packageVersion: (0, $75KVc.version),
            componentName: 'editorCore',
            appearance: (0, $lWghV.getAnalyticsAppearance)(props.appearance),
            editorSessionId: editorSessionId.current
        };
    }, [
        props.appearance
    ]);
    const memodEditorFeatureFlags = $f12bc0dec21ca30e$var$useMemoEditorFeatureFlags(props.featureFlags);
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $ffCOo.FabricEditorAnalyticsContext), {
        // @ts-expect-error Type 'string' is not assignable to type '"editorCore" | "renderer"'.
        data: data
    }, /*#__PURE__*/ (0, $3jLHL.jsx)($f12bc0dec21ca30e$var$Editor, {
        ...props,
        featureFlags: memodEditorFeatureFlags
    }));
}
$f12bc0dec21ca30e$export$be7eaacc86ce4514.propTypes = {
    minHeight: ({ appearance: appearance, minHeight: minHeight })=>{
        if (minHeight && appearance && ![
            'comment',
            'chromeless'
        ].includes(appearance)) return new Error('minHeight only supports editor appearance chromeless and comment for Editor');
        return null;
    }
};
var $f12bc0dec21ca30e$export$2e2bcd8739ae039 = $f12bc0dec21ca30e$export$be7eaacc86ce4514;

});
parcelRegister("ajtqX", function(module, exports) {

$parcel$export(module.exports, "editorAnalyticsChannel", () => $2ca897dc13b18654$export$1467dbbb3bb418c6);
$parcel$export(module.exports, "fireAnalyticsEvent", () => $2ca897dc13b18654$export$c7d191551feb734);

var $k7eoe = parcelRequire("k7eoe");

var $5sRXB = parcelRequire("5sRXB");
const $2ca897dc13b18654$export$1467dbbb3bb418c6 = (0, $k7eoe.FabricChannel).editor;
const $2ca897dc13b18654$export$c7d191551feb734 = (createAnalyticsEvent, options)=>({ payload: payload, channel: channel = $2ca897dc13b18654$export$1467dbbb3bb418c6 })=>{
        if (!createAnalyticsEvent) return;
        if (options?.immediate) {
            createAnalyticsEvent(payload)?.fire(channel);
            return;
        }
        const queue = (0, $5sRXB.AnalyticsQueue).get();
        queue.schedule(()=>createAnalyticsEvent(payload)?.fire(channel));
    };

});
parcelRegister("5sRXB", function(module, exports) {

$parcel$export(module.exports, "AnalyticsQueue", () => $59df087331ac03f0$export$b44c4ba8fe19bbc7);

var $csnse = parcelRequire("csnse");
var $59df087331ac03f0$var$_AnalyticsQueue;
class $59df087331ac03f0$export$b44c4ba8fe19bbc7 {
    request(fn) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (window.requestIdleCallback) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.requestIdleCallback(fn);
        else {
            const start = performance.now();
            setTimeout(()=>{
                fn({
                    didTimeout: false,
                    timeRemaining: ()=>Math.max(0, 50 - (performance.now() - start))
                });
            }, 0);
        }
    }
    pending() {
        // Defensive coding as navigator.scheduling.isInputPending is an experimental API
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (typeof window.navigator?.scheduling?.isInputPending === 'function') // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return window.navigator?.scheduling?.isInputPending() === true;
        return false;
    }
    process() {
        if (this.running) return;
        this.running = true;
        this.request((deadline)=>{
            while(deadline.timeRemaining() > 0 && this.tasks.length > 0 && !this.pending()){
                const task = this.tasks.shift();
                if (task) task();
            }
            this.running = false;
            if (this.tasks.length > 0) this.process();
        });
    }
    schedule(task) {
        this.tasks.push(task);
        this.process();
    }
    constructor(){
        this.tasks = [];
        this.running = false;
    }
}
$59df087331ac03f0$var$_AnalyticsQueue = $59df087331ac03f0$export$b44c4ba8fe19bbc7;
$59df087331ac03f0$export$b44c4ba8fe19bbc7.get = (0, $csnse.default)(()=>new $59df087331ac03f0$var$_AnalyticsQueue());

});


parcelRegister("fswVK", function(module, exports) {

$parcel$export(module.exports, "default", () => $982b9f7bd08d5545$export$2e2bcd8739ae039);

var $d925B = parcelRequire("d925B");

var $5vVM5 = parcelRequire("5vVM5");

var $6tl2G = parcelRequire("6tl2G");

var $lWghV = parcelRequire("lWghV");

var $kviC1 = parcelRequire("kviC1");

var $7T7aA = parcelRequire("7T7aA");

var $gWR1e = parcelRequire("gWR1e");

var $dh538 = parcelRequire("dh538");

var $g1Zdk = parcelRequire("g1Zdk");

var $bwgmA = parcelRequire("bwgmA");

var $6Pdx8 = parcelRequire("6Pdx8");

var $4oXlU = parcelRequire("4oXlU");

var $erkez = parcelRequire("erkez");

var $XtzgJ = parcelRequire("XtzgJ");
// Please, do not copy or use this kind of code below
// @ts-ignore
const $982b9f7bd08d5545$var$fakePluginKey = {
    key: 'nativeCollabProviderPlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['nativeCollabProviderPlugin$'];
    }
};
class $982b9f7bd08d5545$export$2e2bcd8739ae039 {
    static from(view, eventDispatcher, transformer) {
        const editorActions = new $982b9f7bd08d5545$export$2e2bcd8739ae039();
        editorActions._privateRegisterEditor(view, eventDispatcher, transformer);
        return editorActions;
    }
    //#region private
    // This method needs to be public for context based helper components.
    _privateGetEditorView() {
        return this.editorView;
    }
    _privateGetEventDispatcher() {
        return this.eventDispatcher;
    }
    getFeatureFlags() {
        return {};
    }
    // This method needs to be public for EditorContext component.
    _privateRegisterEditor(editorView, eventDispatcher, contentTransformer, getFeatureFlags = ()=>({})) {
        this.contentTransformer = contentTransformer;
        this.eventDispatcher = eventDispatcher;
        this.getFeatureFlags = getFeatureFlags;
        if (!this.editorView && editorView) {
            this.editorView = editorView;
            this.listeners.forEach((cb)=>cb(editorView, eventDispatcher));
        } else if (this.editorView !== editorView) throw new Error("Editor has already been registered! It's not allowed to re-register editor with the new Editor instance.");
        if (this.contentTransformer) this.contentEncode = this.contentTransformer.encode.bind(this.contentTransformer);
    }
    // This method needs to be public for EditorContext component.
    _privateUnregisterEditor() {
        this.editorView = undefined;
        this.contentTransformer = undefined;
        this.contentEncode = undefined;
        this.eventDispatcher = undefined;
        this.getFeatureFlags = ()=>({});
    }
    _privateSubscribe(cb) {
        // If editor is registered and somebody is trying to add a listener,
        // just call it first.
        if (this.editorView && this.eventDispatcher) cb(this.editorView, this.eventDispatcher);
        this.listeners.push(cb);
    }
    _privateUnsubscribe(cb) {
        this.listeners = this.listeners.filter((c)=>c !== cb);
    }
    //#endregion
    focus({ scrollIntoView: scrollIntoView } = {
        scrollIntoView: true
    }) {
        if (!this.editorView || this.editorView.hasFocus()) return false;
        this.editorView.focus();
        if ((0, $dh538.fg)('platform_editor_reduce_scroll_jump_on_editor_start')) {
            if (scrollIntoView ?? true) this.editorView.dispatch(this.editorView.state.tr.scrollIntoView());
        } else this.editorView.dispatch(this.editorView.state.tr.scrollIntoView());
        return true;
    }
    blur() {
        if (!this.editorView || !this.editorView.hasFocus()) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.editorView.dom.blur();
        return true;
    }
    clear() {
        if (!this.editorView) return false;
        const editorView = this.editorView;
        const { state: state } = editorView;
        const tr = editorView.state.tr.setSelection((0, $7T7aA.TextSelection).create(state.doc, 0, state.doc.nodeSize - 2)).deleteSelection();
        editorView.dispatch(tr);
        return true;
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * @deprecated This is deprecated and is no longer maintained.
   *
   * Use the `requestDocument` API from `editorAPI` (ie. `editorApi?.core?.actions.requestDocument( ... ))
   * it has inbuilt throttling and is designed for use with `ComposableEditor`.
   *
   * Docs on its usage are available from: https://atlaskit.atlassian.com/packages/editor/editor-core
   *
   * WARNING: this may be called repeatedly, async with care
   */ async getValue() {
        const { editorView: editorView } = this;
        if (!editorView) return;
        const doc = await (0, $g1Zdk.getEditorValueWithMedia)(editorView);
        const json = (0, $XtzgJ.toJSON)(doc);
        if (!this.contentEncode) return json;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const nodeSanitized = (0, $kviC1.Node).fromJSON(this.editorView.state.schema, json);
        try {
            return this.contentEncode(nodeSanitized);
        } catch (e) {
            this.dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).DOCUMENT_PROCESSING_ERROR,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
                }
            });
            throw e;
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * @deprecated - please use `getNodeWithPosByLocalId` found in the core plugin actions instead
   * @example 
    	const { editorApi, preset } = usePreset(...);
  	const extensionAPI = editorAPI?.extension?.actions?.api();
  	// Use nodeWithPos as desired
  	const nodeWithPos = extensionAPI.getNodeWithPosByLocalId(localId);
  	const node = nodeWithPos.node;
  	const nodePos = nodeWithPos.pos;
   */ getNodeByLocalId(id) {
        if (this.editorView?.state) {
            const nodes = (0, $erkez.findNodePosByLocalIds)(this.editorView?.state, [
                id
            ]);
            const node = nodes.length >= 1 ? nodes[0] : undefined;
            return node?.node;
        }
    }
    getNodeByFragmentLocalId(id) {
        if (this.editorView?.state) {
            const nodes = (0, $6Pdx8.findNodePosByFragmentLocalIds)(this.editorView?.state, [
                id
            ]);
            return nodes.length > 0 ? nodes[0].node : undefined;
        }
    }
    /**
   * This method will return the currently selected `Node` if the selection is a `Node`.
   * Otherwise, if the selection is textual or a non-selectable `Node` within another selectable `Node`, the closest selectable parent `Node` will be returned.
   */ getSelectedNode() {
        if (this.editorView?.state?.selection) {
            const { selection: selection } = this.editorView.state;
            if (selection instanceof (0, $7T7aA.NodeSelection)) return selection.node;
            return (0, $gWR1e.findParentNode)((node)=>Boolean(node.type.spec.selectable))(selection)?.node;
        }
    }
    isDocumentEmpty() {
        // Unlikely case when editorView has been destroyed before calling isDocumentEmpty,
        // we treat this case as if document was empty.
        if (!this.editorView) return true;
        return (0, $4oXlU.isEmptyDocument)(this.editorView.state.doc);
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * @deprecated - please use `replaceDocument` found in the core plugin actions instead
   * using this will reset your Editor State which could cause some things to break (like emojis)
   * @example - use the `replaceDocument` from the core plugin actions instead
   * ```ts
   * const { editorApi, preset } = usePreset(...);
  	// where you need it
  	editorApi?.core.actions.replaceDocument(value);
  	return <ComposableEditor preset={preset} ... />
   */ replaceDocument(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    rawValue, shouldScrollToBottom = true, // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /** @deprecated [ED-14158] shouldAddToHistory is not being used in this function */ shouldAddToHistory = true) {
        (0, $bwgmA.default)('EditorActions.replaceDocument', {
            shouldAddToHistory: shouldAddToHistory
        }, [
            {
                property: 'shouldAddToHistory',
                description: '[ED-14158] EditorActions.replaceDocument does not use the shouldAddToHistory arg',
                type: 'removed'
            }
        ]);
        if (!this.editorView || rawValue === undefined || rawValue === null) return false;
        if (this.eventDispatcher) this.eventDispatcher.emit('resetEditorState', {
            doc: rawValue,
            shouldScrollToBottom: shouldScrollToBottom
        });
        return true;
    }
    replaceSelection(rawValue, tryToReplace, position) {
        if (!this.editorView) return false;
        const { state: state } = this.editorView;
        if (!rawValue) {
            const tr = state.tr.deleteSelection().scrollIntoView();
            this.editorView.dispatch(tr);
            return true;
        }
        const { schema: schema } = state;
        const content = Array.isArray(rawValue) ? (0, $6tl2G.processRawFragmentValue)(schema, rawValue, undefined, undefined, undefined, this.dispatchAnalyticsEvent) : (0, $6tl2G.processRawValue)(schema, rawValue, undefined, undefined, undefined, this.dispatchAnalyticsEvent);
        if (!content) return false;
        // try to find a place in the document where to insert a node if its not allowed at the cursor position by schema
        this.editorView.dispatch((0, $gWR1e.safeInsert)(content, position, tryToReplace)(state.tr).scrollIntoView());
        return true;
    }
    appendText(text) {
        if (!this.editorView || !text) return false;
        const { state: state } = this.editorView;
        const lastChild = state.doc.lastChild;
        if (lastChild && lastChild.type !== state.schema.nodes.paragraph) return false;
        const tr = state.tr.insertText(text).scrollIntoView();
        this.editorView.dispatch(tr);
        return true;
    }
    constructor(){
        this.editorView = void 0;
        this.contentTransformer = void 0;
        this.contentEncode = void 0;
        this.eventDispatcher = void 0;
        this.listeners = [];
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $5vVM5.createDispatch)(this.eventDispatcher);
                dispatch((0, $lWghV.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        /**
     * If editor is using new collab service,
     * we want editor to call the collab provider to
     * retrieve the final acknowledged state of the
     * editor. The final acknowledged editor state
     * refers to the latest state of editor with confirmed
     * steps.
     */ this.getResolvedEditorState = async (reason)=>{
            const { useNativeCollabPlugin: useNativeCollabPlugin } = this.getFeatureFlags();
            if (!this.editorView) throw new Error('Called getResolvedEditorState before editorView is ready');
            if (!useNativeCollabPlugin) {
                const editorValue = await this.getValue();
                if (!editorValue) throw new Error('editorValue is undefined');
                return {
                    content: editorValue,
                    title: null,
                    stepVersion: -1
                };
            }
            const editorView = this.editorView;
            await (0, $g1Zdk.getEditorValueWithMedia)(editorView);
            const collabEditState = $982b9f7bd08d5545$var$fakePluginKey.getState(editorView.state);
            return collabEditState?.getFinalAcknowledgedState(reason);
        };
    }
}

});
parcelRegister("g1Zdk", function(module, exports) {

$parcel$export(module.exports, "getEditorValueWithMedia", () => $674469a067b8ad06$export$99c45752ffdaa598);
// Please, do not copy or use this kind of code below
// @ts-ignore
const $674469a067b8ad06$var$mediaPluginKey = {
    key: 'mediaPlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['mediaPlugin$'];
    }
};
async function $674469a067b8ad06$export$99c45752ffdaa598(editorView) {
    const mediaPluginState = editorView.state && $674469a067b8ad06$var$mediaPluginKey.getState(editorView.state);
    if (mediaPluginState && mediaPluginState.waitForMediaUpload) await mediaPluginState.waitForPendingTasks();
    return editorView.state.doc;
}

});

parcelRegister("bwgmA", function(module, exports) {

$parcel$export(module.exports, "default", () => $24808638338110d5$export$2e2bcd8739ae039);
function $24808638338110d5$var$deprecationWarnings(className, props, deprecations) {
    return;
}
var $24808638338110d5$export$2e2bcd8739ae039 = $24808638338110d5$var$deprecationWarnings;

});

parcelRegister("6Pdx8", function(module, exports) {

$parcel$export(module.exports, "findNodePosByFragmentLocalIds", () => $4f0bf41d03b55c89$export$1dc8bea8646ac811);
const $4f0bf41d03b55c89$export$1dc8bea8646ac811 = (state, ids)=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    state.doc.descendants((node, pos)=>{
        const fragmentLocalIdList = node.marks?.filter((m)=>m.type.name === 'fragment').map((m)=>m.attrs?.localId).filter((id)=>id && localIdSet.has(id));
        if (fragmentLocalIdList.length > 0) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};

});

parcelRegister("4oXlU", function(module, exports) {

$parcel$export(module.exports, "isEmptyDocument", () => $1ec3bd762a62c85b$export$2da47a16c0b6bcb);
/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ function $1ec3bd762a62c85b$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}
function $1ec3bd762a62c85b$export$2da47a16c0b6bcb(node) {
    const nodeChild = node.content.firstChild;
    if (node.childCount !== 1 || !nodeChild) return false;
    return $1ec3bd762a62c85b$export$b648602b09795358(nodeChild);
}

});

parcelRegister("erkez", function(module, exports) {

$parcel$export(module.exports, "findNodePosByLocalIds", () => $9bc21d8203f55b17$export$947fc26275418e36);
/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ const $9bc21d8203f55b17$export$947fc26275418e36 = (state, ids, option = {})=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    if (option.includeDocNode && localIdSet.has(state.doc.attrs?.localId)) nodes.push({
        node: state.doc,
        pos: 0
    });
    state.doc.descendants((node, pos)=>{
        if (localIdSet.has(node.attrs?.localId)) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};

});

parcelRegister("XtzgJ", function(module, exports) {

$parcel$export(module.exports, "toJSON", () => $e456faba3d0c2065$export$54fd2c36b5cc6731);
/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ 
var $h9yJL = parcelRequire("h9yJL");
const $e456faba3d0c2065$var$transformer = new (0, $h9yJL.JSONTransformer)();
function $e456faba3d0c2065$export$54fd2c36b5cc6731(node) {
    return $e456faba3d0c2065$var$transformer.encode(node);
}

});


parcelRegister("auTg8", function(module, exports) {

$parcel$export(module.exports, "useEditorContext", () => $f19f4e00be795c13$export$b119c82498f162a5);
$parcel$export(module.exports, "default", () => $f19f4e00be795c13$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fppBw = parcelRequire("fppBw");

var $jZrBc = parcelRequire("jZrBc");

var $dh538 = parcelRequire("dh538");

var $fswVK = parcelRequire("fswVK");
const $f19f4e00be795c13$export$b119c82498f162a5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useContext((0, $jZrBc.EditorContext));
class $f19f4e00be795c13$export$797df872f5526664 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        if ((0, $dh538.fg)('platform_editor_react18_phase2_v2') || (0, $dh538.fg)('platform_editor_react18_phase2_v2_extended')) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $7UHDa.jsx)($f19f4e00be795c13$var$LegacyEditorContextNew, {
            ...this.props,
            children: this.props.children
        });
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $7UHDa.jsx)($f19f4e00be795c13$export$2e2bcd8739ae039, {
            ...this.props,
            children: this.props.children
        });
    }
    constructor(props){
        super(props);
    }
}
function $f19f4e00be795c13$var$LegacyEditorContextNew({ children: children, editorActions: editorActions }) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jZrBc.EditorContext).Provider, {
        value: {
            editorActions: editorActions ?? new (0, $fswVK.default)()
        },
        children: children
    });
}
class $f19f4e00be795c13$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    getChildContext() {
        return {
            editorActions: this.editorActions
        };
    }
    render() {
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jZrBc.EditorContext).Provider, {
            value: this.getChildContext(),
            children: this.props.children
        });
    }
    constructor(props){
        super(props);
        this.editorActions = void 0;
        this.editorActions = props.editorActions || new (0, $fswVK.default)();
    }
}
$f19f4e00be795c13$export$2e2bcd8739ae039.childContextTypes = {
    editorActions: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object
};

});
parcelRegister("jZrBc", function(module, exports) {

$parcel$export(module.exports, "EditorContext", () => $ff30c9f22b7e82bd$export$27b8dd149e32f6c7);

var $gwFzn = parcelRequire("gwFzn");
const $ff30c9f22b7e82bd$export$27b8dd149e32f6c7 = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({});

});


parcelRegister("6DQRK", function(module, exports) {

$parcel$export(module.exports, "createFeatureFlagsFromProps", () => $157ce49029366e0b$export$63102b0cbe181144);

var $9ciHB = parcelRequire("9ciHB");
function $157ce49029366e0b$var$verifyJSON(json) {
    try {
        return JSON.parse(json);
    } catch (e) {
        return undefined;
    }
}
function $157ce49029366e0b$var$getSpellCheck(featureFlags) {
    if (!!featureFlags?.['disableSpellcheckByBrowser']) return typeof featureFlags?.['disableSpellcheckByBrowser'] === 'object' ? featureFlags?.['disableSpellcheckByBrowser'] : typeof featureFlags?.['disableSpellcheckByBrowser'] === 'string' ? $157ce49029366e0b$var$verifyJSON(featureFlags?.['disableSpellcheckByBrowser']) : undefined;
    if (!!featureFlags?.['disable-spellcheck-by-browser']) return typeof featureFlags?.['disable-spellcheck-by-browser'] === 'object' ? featureFlags?.['disable-spellcheck-by-browser'] : typeof featureFlags?.['disable-spellcheck-by-browser'] === 'string' ? $157ce49029366e0b$var$verifyJSON(featureFlags?.['disable-spellcheck-by-browser']) : undefined;
    return undefined;
}
function $157ce49029366e0b$export$63102b0cbe181144(featureFlags) {
    const normalizedFeatureFlags = (0, $9ciHB.normalizeFeatureFlags)(featureFlags);
    return {
        ...normalizedFeatureFlags,
        catchAllTracking: false,
        showAvatarGroupAsPlugin: Boolean(typeof featureFlags?.showAvatarGroupAsPlugin === 'boolean' ? !!featureFlags?.showAvatarGroupAsPlugin : false),
        errorBoundaryDocStructure: Boolean(typeof featureFlags?.useErrorBoundaryDocStructure === 'boolean' ? !!featureFlags?.useErrorBoundaryDocStructure : false),
        synchronyErrorDocStructure: Boolean(typeof featureFlags?.synchronyErrorDocStructure === 'boolean' ? !!featureFlags?.synchronyErrorDocStructure : false),
        enableViewUpdateSubscription: Boolean(typeof featureFlags?.enableViewUpdateSubscription === 'boolean' ? !!featureFlags?.enableViewUpdateSubscription : false),
        collabAvatarScroll: Boolean(typeof featureFlags?.collabAvatarScroll === 'boolean' ? !!featureFlags?.collabAvatarScroll : false),
        twoLineEditorToolbar: Boolean(typeof featureFlags?.twoLineEditorToolbar === 'boolean' ? !!featureFlags?.twoLineEditorToolbar : false),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        disableSpellcheckByBrowser: $157ce49029366e0b$var$getSpellCheck(featureFlags)
    };
}

});

parcelRegister("7lreV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a614873fe7dde33$export$2e2bcd8739ae039);
var $2a614873fe7dde33$export$2e2bcd8739ae039 = {
    EDITOR_MOUNTED: 'Editor Component Mount Time',
    PROSEMIRROR_RENDERED: 'ProseMirror Render Time',
    PROSEMIRROR_CONTENT_RENDERED: 'ProseMirror Content Render Time',
    ON_EDITOR_READY_CALLBACK: 'onEditorReady Callback Duration'
};

});

parcelRegister("75KVc", function(module, exports) {

$parcel$export(module.exports, "name", () => $23e0513e23b2d5c1$export$a8ff84c12d48cfa6);
$parcel$export(module.exports, "version", () => $23e0513e23b2d5c1$export$83d89fbfd8236492);
const $23e0513e23b2d5c1$export$a8ff84c12d48cfa6 = "platform-pkg";
const $23e0513e23b2d5c1$export$83d89fbfd8236492 = "0.0.0-use.local";

});

parcelRegister("eqcbK", function(module, exports) {

$parcel$export(module.exports, "EditorINPMetrics", () => $32714f82364735d9$export$5942461441325be9);

var $gwFzn = parcelRequire("gwFzn");

var $2jjxD = parcelRequire("2jjxD");

var $inPa6 = parcelRequire("inPa6");

var $d925B = parcelRequire("d925B");
var $ajtqX = parcelRequire("ajtqX");

var $aCbFD = parcelRequire("aCbFD");

var $4u5NT = parcelRequire("4u5NT");
const $32714f82364735d9$export$5942461441325be9 = ()=>{
    const analyticsEvents = (0, $inPa6.useAnalyticsEvents)();
    // onMount lifecycle hook
    (0, $gwFzn.useEffect)(()=>{
        let cleanupFn;
        const cleanupIdleCallback = $32714f82364735d9$var$createIdleCallback(()=>{
            cleanupFn = (0, $aCbFD.setupINPTracking)(({ value: value })=>{
                const interaction = (0, $4u5NT.getActiveInteraction)();
                const ufoName = interaction?.ufoName;
                $32714f82364735d9$var$sendAnalytics(analyticsEvents.createAnalyticsEvent, value, ufoName);
            });
        });
        // Cleanup function that will be called when the component unmounts
        return ()=>{
            cleanupIdleCallback();
            cleanupFn?.();
        };
    // Using hook as mount lifecycle hook.
    // We do not need to set dependency on analyticsEvents since we are using the analyticsEvents object reference
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // This component doesn't render anything
    return null;
};
const $32714f82364735d9$var$sendAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))((createAnalyticsEvent, value, ufoName)=>{
    (0, $ajtqX.fireAnalyticsEvent)(createAnalyticsEvent)({
        payload: {
            // @ts-expect-error Temporary data
            action: 'inp',
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                inp: value,
                ufoName: ufoName
            }
        }
    });
}, 1000, {
    trailing: true
});
const $32714f82364735d9$var$createIdleCallback = (callback)=>{
    if (typeof window.requestIdleCallback === 'function') {
        const id = window.requestIdleCallback(callback);
        return ()=>window.cancelIdleCallback(id);
    }
    // Fallback to setTimeout with 0 delay if requestIdleCallback is not available
    const id = window.setTimeout(callback, 0);
    return ()=>window.clearTimeout(id);
};

});
parcelRegister("aCbFD", function(module, exports) {

$parcel$export(module.exports, "setupINPTracking", () => $1035ef17fe90bcc8$export$56930d9a67e0aae6);

var $2CrBA = parcelRequire("2CrBA");

var $3mTvL = parcelRequire("3mTvL");
const $1035ef17fe90bcc8$export$56930d9a67e0aae6 = (callback)=>{
    if (!$1035ef17fe90bcc8$var$isINPSupported()) return;
    return (0, $2CrBA.onINP)((metric)=>{
        callback({
            value: metric.value
        });
    });
};
const $1035ef17fe90bcc8$var$isINPSupported = ()=>{
    const isSSR = !window || typeof $3mTvL !== 'undefined' && Boolean($3mTvL?.env?.REACT_SSR || false);
    if (isSSR) return false;
    // Return if the browser doesn't support all APIs needed to measure INP.
    if (!('PerformanceEventTiming' in window && 'interactionId' in PerformanceEventTiming.prototype)) return false;
    if (!PerformanceObserver.supportedEntryTypes.includes('event') && !PerformanceObserver.supportedEntryTypes.includes('first-input')) return false;
    return true;
};

});
parcelRegister("2CrBA", function(module, exports) {

$parcel$export(module.exports, "onINP", () => $e53cd74394c138c9$export$7df4b36ecaed99e1);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/onINP.ts

var $bH22n = parcelRequire("bH22n");

var $8z7gv = parcelRequire("8z7gv");

var $1UCry = parcelRequire("1UCry");

var $c3PW0 = parcelRequire("c3PW0");
const $e53cd74394c138c9$export$7df4b36ecaed99e1 = (callback)=>{
    const metric = {
        value: 0,
        delta: 0,
        entries: []
    };
    const reporter = (0, $bH22n.bindReporter)(callback);
    const interactionManager = new (0, $8z7gv.InteractionManager)();
    const handleEntries = (entries)=>{
        (0, $c3PW0.whenIdle)(()=>{
            entries.forEach((entry)=>interactionManager.processInteractionEntry(entry));
            const inp = interactionManager.estimateP98LongestInteraction();
            if (inp && inp.latency !== metric.value) {
                metric.value = inp.latency;
                metric.entries = entries;
                reporter(metric);
            }
        });
    };
    const po = $e53cd74394c138c9$var$observeInteractionEvent(handleEntries);
    const onHiddenCleanup = (0, $1UCry.onHidden)(()=>{
        handleEntries(po.takeRecords());
        reporter(metric);
    });
    return ()=>{
        po.disconnect();
        interactionManager.cleanup();
        onHiddenCleanup();
    };
};
const $e53cd74394c138c9$var$observeInteractionEvent = (callback)=>{
    const po = new PerformanceObserver((list)=>{
        // Delay by a microtask to workaround a bug in Safari where the
        // callback is invoked immediately, rather than in a separate task.
        // See: https://github.com/GoogleChrome/web-vitals/issues/277
        Promise.resolve().then(()=>{
            callback(list.getEntries());
        });
    });
    // Event Timing entries have their durations rounded to the nearest 8ms,
    // so a duration of 40ms would be any event that spans 2.5 or more frames
    // at 60Hz. This threshold is chosen to strike a balance between usefulness
    // and performance. Running this callback for any interaction that spans
    // just one or two frames is likely not worth the insight that could be
    // gained.
    if (PerformanceObserver.supportedEntryTypes.includes('event')) po.observe({
        type: 'event',
        buffered: true,
        durationThreshold: 40
    });
    if (PerformanceObserver.supportedEntryTypes.includes('first-input')) po.observe({
        type: 'first-input',
        buffered: true
    });
    return po;
};

});
parcelRegister("bH22n", function(module, exports) {

$parcel$export(module.exports, "bindReporter", () => $df33a49f9570fdc5$export$17679dccdd551979);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/bindReporter.ts
const $df33a49f9570fdc5$export$17679dccdd551979 = (callback)=>{
    let prevValue;
    let delta;
    return (metric)=>{
        if (metric.value >= 0) {
            delta = metric.value - (prevValue || 0);
            // Report the metric if there's a non-zero delta or if no previous
            // value exists (which can happen in the case of the document becoming
            // hidden when the metric value is 0).
            // See: https://github.com/GoogleChrome/web-vitals/issues/14
            if (delta || prevValue === undefined) {
                prevValue = metric.value;
                metric.delta = delta;
                callback(metric);
            }
        }
    };
};

});

parcelRegister("8z7gv", function(module, exports) {

$parcel$export(module.exports, "InteractionManager", () => $11086031fa1bcc5c$export$aaa80641d584351c);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/interactions.ts

var $dXj5z = parcelRequire("dXj5z");
class $11086031fa1bcc5c$export$aaa80641d584351c {
    cleanup() {
        this.interactionCountPolyfill.cleanup();
    }
    /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */ estimateP98LongestInteraction() {
        const candidateInteractionIndex = Math.min(this.longestInteractionList.length - 1, Math.floor(this.interactionCountPolyfill.getInteractionCount() / 50));
        return this.longestInteractionList[candidateInteractionIndex];
    }
    /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */ processInteractionEntry(entry) {
        // Skip further processing for entries that cannot be INP candidates.
        if (!(entry.interactionId || entry.entryType === 'first-input')) return;
        // The least-long of the 10 longest interactions.
        const minLongestInteraction = this.longestInteractionList[this.longestInteractionList.length - 1];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const existingInteraction = this.longestInteractionMap.get(entry.interactionId);
        // Only process the entry if it's possibly one of the ten longest,
        // or if it's part of an existing interaction.
        if (existingInteraction || this.longestInteractionList.length < $11086031fa1bcc5c$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
            // If the interaction already exists, update it. Otherwise create one.
            if (existingInteraction) {
                // If the new entry has a longer duration, replace the old entries,
                // otherwise add to the array.
                if (entry.duration > existingInteraction.latency) {
                    existingInteraction.entries = [
                        entry
                    ];
                    existingInteraction.latency = entry.duration;
                } else if (entry.duration === existingInteraction.latency && entry.startTime === existingInteraction.entries[0].startTime) existingInteraction.entries.push(entry);
            } else {
                const interaction = {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: entry.interactionId,
                    latency: entry.duration,
                    entries: [
                        entry
                    ]
                };
                this.longestInteractionMap.set(interaction.id, interaction);
                this.longestInteractionList.push(interaction);
            }
            // Sort the entries by latency (descending) and keep only the top ten.
            this.longestInteractionList.sort((a, b)=>b.latency - a.latency);
            if (this.longestInteractionList.length > $11086031fa1bcc5c$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER) this.longestInteractionList.splice($11086031fa1bcc5c$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>this.longestInteractionMap.delete(i.id));
        }
    }
    constructor(){
        this.longestInteractionList = void 0;
        this.longestInteractionMap = void 0;
        this.interactionCountPolyfill = void 0;
        this.longestInteractionList = [];
        this.longestInteractionMap = new Map();
        this.interactionCountPolyfill = new (0, $dXj5z.InteractionCountPolyfill)();
    }
}
$11086031fa1bcc5c$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER = 10;

});
parcelRegister("dXj5z", function(module, exports) {

$parcel$export(module.exports, "InteractionCountPolyfill", () => $2791f7d61bdfd64e$export$51e52147760fc784);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/polyfills/interactionCountPolyfill.ts
class $2791f7d61bdfd64e$export$51e52147760fc784 {
    cleanup() {
        this.po?.disconnect();
    }
    updateEstimate(entries) {
        entries.forEach((e)=>{
            if (e.interactionId) {
                this.minKnownInteractionId = Math.min(this.minKnownInteractionId, e.interactionId);
                this.maxKnownInteractionId = Math.max(this.maxKnownInteractionId, e.interactionId);
                this.interactionCountEstimate = this.maxKnownInteractionId ? (this.maxKnownInteractionId - this.minKnownInteractionId) / 7 + 1 : 0;
            }
        });
    }
    /**
   * Returns the `interactionCount` value using the native API (if available)
   * or the polyfill estimate in this module.
   */ getInteractionCount() {
        return this.po ? this.interactionCountEstimate : performance.interactionCount || 0;
    }
    constructor(){
        this.interactionCountEstimate = 0;
        this.minKnownInteractionId = Infinity;
        this.maxKnownInteractionId = 0;
        this.po = void 0;
        if ('interactionCount' in performance || this.po) return;
        if (!PerformanceObserver.supportedEntryTypes.includes('event')) return;
        this.po = new PerformanceObserver((list)=>{
            // Delay by a microtask to workaround a bug in Safari where the
            // callback is invoked immediately, rather than in a separate task.
            // See: https://github.com/GoogleChrome/web-vitals/issues/277
            Promise.resolve().then(()=>{
                this.updateEstimate(list.getEntries());
            });
        });
        this.po.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 0
        });
    }
}

});


parcelRegister("1UCry", function(module, exports) {

$parcel$export(module.exports, "onHidden", () => $a86e91972531a920$export$91ec2be6fdd8f1b4);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/onHidden.ts
const $a86e91972531a920$export$91ec2be6fdd8f1b4 = (cb)=>{
    const handleVisibilityChange = ()=>{
        if (document.visibilityState === 'hidden') cb();
    };
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return ()=>{
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
};

});

parcelRegister("c3PW0", function(module, exports) {

$parcel$export(module.exports, "whenIdle", () => $4716358fa782d9bd$export$4d9952dcbf5b2792);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/whenIdle.ts

var $1UCry = parcelRequire("1UCry");
const $4716358fa782d9bd$export$4d9952dcbf5b2792 = (cb)=>{
    const rIC = window.requestIdleCallback || window.setTimeout;
    let handle = -1;
    cb = $4716358fa782d9bd$var$runOnce(cb);
    // If the document is hidden, run the callback immediately, otherwise
    // race an idle callback with the next `visibilitychange` event.
    if (document.visibilityState === 'hidden') cb();
    else {
        const cleanup = (0, $1UCry.onHidden)(()=>{
            cb();
            cleanup();
        });
        handle = rIC(()=>{
            cb();
            cleanup();
        });
    }
    return handle;
};
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/runOnce.ts
const $4716358fa782d9bd$var$runOnce = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};

});




parcelRegister("blhF9", function(module, exports) {

$parcel$export(module.exports, "EditorInternal", () => $93c55730732033da$export$2617c0dabe49c335);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $d925B = parcelRequire("d925B");

var $7nd6h = parcelRequire("7nd6h");

var $dh538 = parcelRequire("dh538");

var $hkDEL = parcelRequire("hkDEL");

var $bn5lP = parcelRequire("bn5lP");

var $auTg8 = parcelRequire("auTg8");

var $f8zg2 = parcelRequire("f8zg2");

var $6DQRK = parcelRequire("6DQRK");

var $2oRGU = parcelRequire("2oRGU");

var $lJ3BR = parcelRequire("lJ3BR");

var $jTtEd = parcelRequire("jTtEd");
const $93c55730732033da$var$editorContainerStyles = (0, $3jLHL.css)({
    position: 'relative',
    width: '100%',
    height: '100%'
});
const $93c55730732033da$export$2617c0dabe49c335 = /*#__PURE__*/ (0, $gwFzn.memo)(({ props: props, handleAnalyticsEvent: handleAnalyticsEvent, createAnalyticsEvent: createAnalyticsEvent, handleSave: handleSave, editorActions: editorActions, providerFactory: providerFactory, onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed, preset: preset, AppearanceComponent: AppearanceComponent })=>{
    const overriddenEditorProps = {
        ...props,
        onSave: props.onSave ? handleSave : undefined,
        // noop all analytic events, even if a handler is still passed.
        analyticsHandler: undefined
    };
    const featureFlags = (0, $6DQRK.createFeatureFlagsFromProps)(props.featureFlags);
    // Render tracking is firing too many events in Jira so we are disabling them for now. See - https://product-fabric.atlassian.net/browse/ED-25616
    // Also firing too many events for the legacy content macro, so disabling for now. See - https://product-fabric.atlassian.net/browse/ED-26650
    const renderTrackingEnabled = !(0, $dh538.fg)('platform_editor_disable_rerender_tracking_jira') && !featureFlags.lcmPreventRenderTracking;
    const useShallow = false;
    const [portalProviderAPI, PortalRenderer] = (0, $7nd6h.usePortalProvider)();
    const [nodeViewPortalProviderAPI, NodeViewPortalRenderer] = (0, $7nd6h.usePortalProvider)();
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, renderTrackingEnabled && /*#__PURE__*/ (0, $3jLHL.jsx)((0, $2oRGU.RenderTracking), {
        componentProps: props,
        action: (0, $d925B.ACTION).RE_RENDERED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
        handleAnalyticsEvent: handleAnalyticsEvent,
        propsToIgnore: [
            'defaultValue'
        ],
        useShallow: useShallow
    }), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $hkDEL.default), {
        errorTracking: true,
        createAnalyticsEvent: createAnalyticsEvent,
        contextIdentifierProvider: props.contextIdentifierProvider,
        featureFlags: featureFlags
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $93c55730732033da$var$editorContainerStyles
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $auTg8.default), {
        editorActions: editorActions
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $f8zg2.IntlProviderIfMissingWrapper), null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $bn5lP.default), {
        editorProps: overriddenEditorProps,
        createAnalyticsEvent: createAnalyticsEvent,
        portalProviderAPI: portalProviderAPI,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
        providerFactory: providerFactory,
        onEditorCreated: onEditorCreated,
        onEditorDestroyed: onEditorDestroyed,
        disabled: props.disabled,
        preset: preset,
        render: ({ editor: editor, view: view, eventDispatcher: eventDispatcher, config: config, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorRef: editorRef, editorAPI: editorAPI })=>/*#__PURE__*/ (0, $3jLHL.jsx)((0, $lJ3BR.BaseThemeWrapper), {
                baseFontSize: (0, $jTtEd.getBaseFontSize)(props.appearance)
            }, /*#__PURE__*/ (0, $3jLHL.jsx)(AppearanceComponent, {
                innerRef: editorRef,
                editorAPI: editorAPI,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                appearance: props.appearance,
                disabled: props.disabled,
                editorActions: editorActions,
                editorDOMElement: editor,
                editorView: view,
                providerFactory: providerFactory,
                eventDispatcher: eventDispatcher,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                maxHeight: props.maxHeight,
                minHeight: props.minHeight,
                onSave: props.onSave ? handleSave : undefined,
                onCancel: props.onCancel,
                popupsMountPoint: props.popupsMountPoint,
                popupsBoundariesElement: props.popupsBoundariesElement,
                popupsScrollableElement: props.popupsScrollableElement,
                contentComponents: config.contentComponents,
                primaryToolbarComponents: config.primaryToolbarComponents,
                primaryToolbarIconBefore: props.primaryToolbarIconBefore,
                secondaryToolbarComponents: config.secondaryToolbarComponents,
                customContentComponents: props.contentComponents,
                customPrimaryToolbarComponents: props.primaryToolbarComponents,
                customSecondaryToolbarComponents: props.secondaryToolbarComponents,
                contextPanel: props.contextPanel,
                collabEdit: props.collabEdit,
                persistScrollGutter: props.persistScrollGutter,
                enableToolbarMinWidth: props.featureFlags?.toolbarMinWidthOverflow != null ? !!props.featureFlags?.toolbarMinWidthOverflow : props.allowUndoRedoButtons,
                useStickyToolbar: props.useStickyToolbar,
                featureFlags: featureFlags,
                pluginHooks: config.pluginHooks,
                __livePage: props.__livePage,
                preset: preset
            }))
    }), /*#__PURE__*/ (0, $3jLHL.jsx)(PortalRenderer, null), /*#__PURE__*/ (0, $3jLHL.jsx)(NodeViewPortalRenderer, null)))))));
});

});
parcelRegister("7nd6h", function(module, exports) {

$parcel$export(module.exports, "usePortalProvider", () => $b81f72f3142ef144$export$9b00782c24eb3d6b);

var $gwFzn = parcelRequire("gwFzn");

var $Qzrjc = parcelRequire("Qzrjc");

var $fqraH = parcelRequire("fqraH");
function $b81f72f3142ef144$export$9b00782c24eb3d6b() {
    const portalManager = (0, $gwFzn.useMemo)(()=>new (0, $fqraH.PortalManager)(), []);
    const PortalRenderer = (0, $gwFzn.useMemo)(()=>(0, $Qzrjc.createPortalRendererComponent)(portalManager), [
        portalManager
    ]);
    const portalProviderAPI = (0, $gwFzn.useMemo)(()=>(0, $Qzrjc.getPortalProviderAPI)(portalManager), [
        portalManager
    ]);
    // Cleanup on unmount
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            portalProviderAPI.destroy();
        };
    }, [
        portalManager,
        portalProviderAPI
    ]);
    return [
        portalProviderAPI,
        PortalRenderer
    ];
}

});
parcelRegister("Qzrjc", function(module, exports) {

$parcel$export(module.exports, "createPortalRendererComponent", () => $07ca771f5bf2bd0c$export$adfaaa25a1ea6e69);
$parcel$export(module.exports, "getPortalProviderAPI", () => $07ca771f5bf2bd0c$export$3a6b5f5c5bba4bde);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4FhhO = parcelRequire("4FhhO");

var $GD6Gl = parcelRequire("GD6Gl");
function $07ca771f5bf2bd0c$export$adfaaa25a1ea6e69(portalManager) {
    return function PortalRenderer() {
        const [buckets, setBuckets] = (0, $gwFzn.useState)(portalManager.getBuckets());
        (0, $gwFzn.useLayoutEffect)(()=>{
            portalManager.registerPortalRenderer(setBuckets);
            return ()=>{
                portalManager.unregisterPortalRenderer();
            };
        }, []);
        const portalsElements = (0, $gwFzn.useMemo)(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        ()=>buckets.map((_, i)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $GD6Gl.PortalBucket), {
                    id: i,
                    portalManager: portalManager
                }, i)), [
            buckets
        ]);
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
            children: portalsElements
        });
    };
}
const $07ca771f5bf2bd0c$export$eab0ea19ad3bed77 = ({ getChildren: getChildren, onBeforeRender: onBeforeRender })=>{
    (0, $gwFzn.useLayoutEffect)(()=>{
        if (onBeforeRender) onBeforeRender();
    }, [
        onBeforeRender
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: getChildren()
    });
};
const $07ca771f5bf2bd0c$var$PortalRenderWrapper = /*#__PURE__*/ (0, $gwFzn.memo)($07ca771f5bf2bd0c$export$eab0ea19ad3bed77);
$07ca771f5bf2bd0c$var$PortalRenderWrapper.displayName = 'PortalRenderWrapper';
const $07ca771f5bf2bd0c$export$3a6b5f5c5bba4bde = (portalManager)=>{
    const portalsMap = new Map();
    return {
        render: (children, container, key, onBeforeReactDomRender)=>{
            if (typeof onBeforeReactDomRender === 'function') {
                const portal = /*#__PURE__*/ (0, $4FhhO.createPortal)(/*#__PURE__*/ (0, $7UHDa.jsx)($07ca771f5bf2bd0c$var$PortalRenderWrapper, {
                    getChildren: children,
                    onBeforeRender: onBeforeReactDomRender
                }), container, key);
                portalsMap.set(key, portalManager.registerPortal(key, portal));
            } else {
                const portal = /*#__PURE__*/ (0, $4FhhO.createPortal)(children(), container, key);
                portalsMap.set(key, portalManager.registerPortal(key, portal));
            }
        },
        remove: (key)=>{
            portalsMap.get(key)?.();
            portalsMap.delete(key);
        },
        destroy: ()=>{
            portalsMap.clear();
            portalManager.destroy();
        }
    };
};

});
parcelRegister("GD6Gl", function(module, exports) {

$parcel$export(module.exports, "PortalBucket", () => $03c9dba1f478f2d1$export$828f0f29e8293a07);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
function $03c9dba1f478f2d1$export$828f0f29e8293a07({ id: id, portalManager: portalManager }) {
    // State to hold the current portals for this bucket
    const [portals, setPortals] = (0, $gwFzn.useState)({});
    // Effect to register/unregister this bucket with the portal manager on mount/unmount
    (0, $gwFzn.useLayoutEffect)(()=>{
        portalManager.registerBucket(id, setPortals);
        return ()=>{
            portalManager.unregisterBucket(id);
        };
    }, [
        id,
        portalManager
    ]);
    // Memoize the portal elements to avoid unnecessary re-renders
    const portalElements = (0, $gwFzn.useMemo)(()=>Object.values(portals), [
        portals
    ]);
    // Render the current portal elements
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: portalElements
    });
}

});


parcelRegister("fqraH", function(module, exports) {

$parcel$export(module.exports, "PortalManager", () => $3a8111d444031088$export$52c7ef79917c2f38);
const $3a8111d444031088$var$DEFAULT_INITIAL_BUCKETS = 50;
const $3a8111d444031088$var$DEFAULT_MAX_BUCKET_CAPACITY = 50;
const $3a8111d444031088$var$DEFAULT_SCALE_RATIO = 0.5;
/**
 * Creates an empty bucket object with a specified capacity. Each bucket is designed
 * to hold a certain number of React portals and has an associated updater function
 * which can be null initially.
 *
 * @function createEmptyBucket
 * @param {number} capacity - The maximum capacity of the bucket.
 * @returns {PortalBucketType} An object representing an empty bucket with the specified capacity.
 */ function $3a8111d444031088$var$createEmptyBucket(capacity) {
    return {
        portals: {},
        capacity: capacity,
        updater: null
    };
}
class $3a8111d444031088$export$52c7ef79917c2f38 {
    getCurrentBucket() {
        return this.availableBuckets.values().next().value;
    }
    createBucket() {
        const currentBucket = this.getCurrentBucket();
        //If the current bucket has capacity, skip this logic
        if (this.buckets[currentBucket].capacity > 0) return;
        else // The current bucket is full, delete the bucket from the list of available buckets
        this.availableBuckets.delete(currentBucket);
        // Skip creating new bucket if there are buckets still available
        if (this.availableBuckets.size > 0) return;
        // Scale the buckets up only if there are no available buckets left
        // Calculate how many new buckets need to be added
        const numBucketsToAdd = Math.floor(this.buckets.length * this.scaleRatio);
        this.buckets = [
            ...this.buckets
        ];
        for(let i = 0; i < numBucketsToAdd; i++){
            this.buckets.push($3a8111d444031088$var$createEmptyBucket(this.maxBucketCapacity));
            this.availableBuckets.add(this.buckets.length - 1);
        }
        this.portalRendererUpdater?.(this.buckets);
    }
    getBuckets() {
        return this.buckets;
    }
    registerBucket(id, updater) {
        this.buckets[id].updater = updater;
        this.buckets[id].updater?.(()=>({
                ...this.buckets[id].portals
            }));
    }
    unregisterBucket(id) {
        this.buckets[id].updater = null;
    }
    updateBuckets(id) {
        this.buckets[id].updater?.(()=>{
            // new object is required to trigger react updates
            return {
                ...this.buckets[id].portals
            };
        });
    }
    registerPortal(key, portal) {
        this.createBucket();
        this.buckets[this.getCurrentBucket()].capacity -= 1;
        const id = this.portalToBucketMap.get(key) ?? this.getCurrentBucket();
        this.portalToBucketMap.set(key, id);
        if (this.buckets[id].portals[key] !== portal) {
            this.buckets[id].portals[key] = portal;
            this.updateBuckets(id);
        }
        //returns a function to unregister the portal
        return ()=>{
            delete this.buckets[id].portals[key];
            this.portalToBucketMap.delete(key);
            this.buckets[id].capacity += 1;
            if (this.buckets[id].capacity > this.scaleCapacityThreshold) this.availableBuckets.add(id);
            this.updateBuckets(id);
        };
    }
    registerPortalRenderer(updater) {
        if (!this.portalRendererUpdater) updater(()=>this.buckets);
        this.portalRendererUpdater = updater;
    }
    unregisterPortalRenderer() {
        this.portalRendererUpdater = null;
    }
    /**
   * Cleans up resources used by the PortalManager. This includes clearing all portals,
   * unregistering all buckets, and resetting internal state.
   */ destroy() {
        // Iterate through each bucket and clear its portals and unset the updater function
        this.buckets.forEach((bucket, id)=>{
            bucket.portals = {}; // Clearing all portals from the bucket
            bucket.updater = null; // Unsetting the bucket's updater function
            this.availableBuckets.add(id); // Mark all buckets as available
        });
        this.portalToBucketMap.clear();
        this.portalRendererUpdater = null;
        this.availableBuckets = new Set(this.buckets.map((_, index)=>index));
    }
    constructor(initialBuckets = $3a8111d444031088$var$DEFAULT_INITIAL_BUCKETS, maxBucketCapacity = $3a8111d444031088$var$DEFAULT_MAX_BUCKET_CAPACITY, scaleRatio = $3a8111d444031088$var$DEFAULT_SCALE_RATIO){
        this.maxBucketCapacity = void 0;
        this.scaleRatio = void 0;
        this.buckets = void 0;
        this.availableBuckets = void 0;
        this.portalToBucketMap = void 0;
        this.portalRendererUpdater = void 0;
        this.scaleCapacityThreshold = void 0;
        this.maxBucketCapacity = maxBucketCapacity;
        this.scaleRatio = scaleRatio;
        // Initialise buckets array by creating an array of length `initialBuckets` containing empty buckets
        this.buckets = Array.from({
            length: initialBuckets
        }, ()=>$3a8111d444031088$var$createEmptyBucket(maxBucketCapacity));
        this.portalToBucketMap = new Map();
        this.availableBuckets = new Set(Array.from({
            length: initialBuckets
        }, (_, i)=>i));
        this.portalRendererUpdater = null;
        this.scaleCapacityThreshold = maxBucketCapacity / 2;
    }
}

});


parcelRegister("hkDEL", function(module, exports) {

$parcel$export(module.exports, "default", () => $24b7332c0d770745$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $9HkI0 = parcelRequire("9HkI0");

var $d925B = parcelRequire("d925B");
var $ajtqX = parcelRequire("ajtqX");

var $56Wjx = parcelRequire("56Wjx");

var $kckFS = parcelRequire("kckFS");

var $hWRJP = parcelRequire("hWRJP");

var $iStJM = parcelRequire("iStJM");

var $8DdhL = parcelRequire("8DdhL");
class $24b7332c0d770745$export$d6d3bedcc5fc09c8 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    componentDidCatch(error, errorInfo) {
        // Only report and re-render once, to avoid over-reporting errors and infinite rerendering
        if (this.state.error) return;
        if (this.props.errorTracking) this.sendErrorData({
            error: error,
            errorInfo: errorInfo,
            errorStack: error.stack
        });
        // Update state to allow a re-render to attempt graceful recovery (in the event that
        // the error was caused by a race condition or is intermittent)
        this.setState({
            error: error
        }, ()=>{
            if (this.props.rethrow) // Now that a re-render has occurred, we re-throw to allow product error boundaries
            // to catch and handle the error too.
            //
            // Note that when rethrowing inside a error boundary, the stack trace
            // from a higher error boundary's componentDidCatch.info param will reset
            // to this component, instead of the original component which threw it.
            throw error;
        });
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // FIXME: This is causing more problems then it's solving. The async check to sniff the browser extensions is block some
    // react unit tests. Essentially jest never completes and just hangs. This was code was added 3yrs ago so that errors
    // would detail if the browser had grammarly extension installed or not. I'm not sure if anyone has every inspecting this
    // as it doesn't look like any dashboards exist for it.
    // You can see the open handles that are block tests if you run unit tests with --detectOpenHandles
    // async componentDidMount() {
    // 	this.browserExtensions = await sniffUserBrowserExtensions({
    // 		extensions: ['grammarly'],
    // 		async: true,
    // 		asyncTimeoutMs: 20000,
    // 	});
    // }
    render() {
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kckFS.IntlErrorBoundary), {
            children: this.props.children
        });
    }
    constructor(props){
        super(props);
        this.featureFlags = void 0;
        this.browserExtensions = undefined;
        this.state = {
            error: undefined
        };
        this.sendErrorData = async (analyticsErrorPayload)=>{
            const product = await this.getProductName();
            const { error: error, errorInfo: errorInfo } = analyticsErrorPayload;
            const sharedId = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
            const browserInfo = window?.navigator?.userAgent || 'unknown';
            const attributes = {
                product: product,
                browserInfo: browserInfo,
                error: error.toString(),
                errorInfo: errorInfo,
                errorId: sharedId,
                browserExtensions: this.browserExtensions,
                docStructure: this.featureFlags.errorBoundaryDocStructure && this.props.editorView ? (0, $56Wjx.getDocStructure)(this.props.editorView.state.doc, {
                    compact: true
                }) : undefined,
                outdatedBrowser: (0, $iStJM.isOutdatedBrowser)(browserInfo)
            };
            this.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).EDITOR_CRASHED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: attributes
            });
            this.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).EDITOR_CRASHED_ADDITIONAL_INFORMATION,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorId: sharedId
                }
            });
            (0, $hWRJP.logException)(error, {
                location: 'editor-core/create-editor',
                product: product
            });
        };
        this.getProductName = async ()=>{
            const { contextIdentifierProvider: contextIdentifierProvider } = this.props;
            if (contextIdentifierProvider) {
                const context = await contextIdentifierProvider;
                if (context.product) return context.product;
            }
            return 'atlaskit';
        };
        this.fireAnalyticsEvent = (event)=>{
            this.props.createAnalyticsEvent?.(event).fire((0, $ajtqX.editorAnalyticsChannel));
        };
        this.featureFlags = props.featureFlags;
    }
}
$24b7332c0d770745$export$d6d3bedcc5fc09c8.defaultProps = {
    rethrow: true,
    errorTracking: true
};
var $24b7332c0d770745$export$2e2bcd8739ae039 = (0, $8DdhL.WithEditorView)($24b7332c0d770745$export$d6d3bedcc5fc09c8);

});
parcelRegister("56Wjx", function(module, exports) {

$parcel$export(module.exports, "getDocStructure", () => $34f2b048c002519b$export$6451b72139862cbd);
const $34f2b048c002519b$var$hash = {
    nodes: {
        doc: 'doc',
        paragraph: 'p',
        text: 't',
        bulletList: 'ul',
        orderedList: 'ol',
        listItem: 'li',
        heading: 'h',
        blockquote: 'blockq',
        codeBlock: 'codebl',
        panel: 'pnl',
        rule: 'rl',
        hardBreak: 'br',
        mention: 'ment',
        emoji: 'emj',
        image: 'img',
        caption: 'cap',
        media: 'media',
        mediaGroup: 'mediag',
        mediaSingle: 'medias',
        plain: 'pln',
        table: 'table',
        tableCell: 'td',
        tableHeader: 'th',
        tableRow: 'tr',
        decisionList: 'dl',
        decisionItem: 'di',
        taskList: 'tl',
        taskItem: 'ti',
        extension: 'ext',
        inlineExtension: 'exti',
        bodiedExtension: 'extb',
        multiBodiedExtension: 'extmbe',
        extensionFrame: 'extfrm',
        status: 'sts',
        placeholder: 'plh',
        inlineCard: 'cardi',
        blockCard: 'cardb',
        embedCard: 'carde',
        expand: 'exp',
        nestedExpand: 'expn',
        unsupportedBlock: 'unsupb',
        unsupportedInline: 'unsupi',
        unknownBlock: 'unkb',
        date: 'date'
    },
    marks: {
        em: 'em',
        strong: 'strong',
        code: 'code',
        strike: 'strike',
        underline: 'undline',
        link: 'lnk',
        subsup: 'subsup',
        textColor: 'txtclr',
        unsupportedMark: 'unsupmrk',
        unsupportedNodeAttribute: 'unsupnattr',
        annotation: 'anno'
    }
};
function $34f2b048c002519b$var$shortHash(type, isMark) {
    const code = $34f2b048c002519b$var$hash[isMark ? 'marks' : 'nodes'][type];
    return code ? code : type;
}
function $34f2b048c002519b$var$compactStringifier(node) {
    const isContentEmpty = !node.content;
    const isTextNode = node?.type === 'text';
    const hasMarks = node.marks?.length;
    const isContentArray = Array.isArray(node.content);
    const marks = (child)=>{
        if (hasMarks) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return node.marks.reduce((str, mark)=>`${$34f2b048c002519b$var$shortHash(mark, true)}(${str})`, child);
        return child;
    };
    let content;
    if (isTextNode) content = String(node.nodeSize);
    else if (isContentEmpty) content = '';
    else if (isContentArray) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    content = node.content.map((node)=>$34f2b048c002519b$var$compactStringifier(node)).join(',');
    return marks(`${$34f2b048c002519b$var$shortHash(node.type, false)}(${content})`);
}
const $34f2b048c002519b$export$6451b72139862cbd = (doc, options)=>{
    try {
        const result = $34f2b048c002519b$var$getBlockNode(doc, 0);
        if (options?.compact) return $34f2b048c002519b$var$compactStringifier(result);
        return result;
    } catch (error) {
        return `Error logging document structure: ${error}`;
    }
};
const $34f2b048c002519b$var$getBlockNode = (node, pos)=>{
    const blockNode = {
        type: node.type.name,
        pos: pos,
        nodeSize: node.nodeSize
    };
    const content = $34f2b048c002519b$var$getBlockNodeContent(node.content, pos);
    if (content.length > 0) blockNode.content = content;
    const marks = $34f2b048c002519b$var$getMarks(node);
    if (marks.length > 0) blockNode.marks = marks;
    return blockNode;
};
const $34f2b048c002519b$var$getBlockNodeContent = (node, pos)=>{
    if (!node || !node.content || !node.content.length) return [];
    let blockNodeContent = [];
    const { content: content } = node;
    if (content[0].isBlock) {
        // children are block nodes
        let prevNode;
        blockNodeContent = content.map((node)=>{
            pos += prevNode ? prevNode.nodeSize : 1;
            prevNode = node;
            return $34f2b048c002519b$var$getBlockNode(node, pos);
        });
    } else {
        // children are inline nodes .
        const result = $34f2b048c002519b$var$getInlineNodes(content, pos);
        blockNodeContent = result.inlineNodes;
        pos = result.pos;
    }
    return blockNodeContent;
};
const $34f2b048c002519b$var$getInlineNodes = (nodes, pos)=>{
    const inlineNodes = nodes.map((node)=>{
        const { nodeSize: nodeSize } = node;
        const inlineNode = {
            type: node.type.name,
            pos: pos,
            nodeSize: nodeSize
        };
        const marks = $34f2b048c002519b$var$getMarks(node);
        if (marks.length > 0) inlineNode.marks = marks;
        pos += nodeSize;
        return inlineNode;
    });
    return {
        inlineNodes: inlineNodes,
        pos: pos
    };
};
const $34f2b048c002519b$var$getMarks = (node)=>node.marks.map((mark)=>mark.type.name);

});

parcelRegister("iStJM", function(module, exports) {

$parcel$export(module.exports, "isOutdatedBrowser", () => $1ad229e75f2927fb$export$12d09524e028927);
const $1ad229e75f2927fb$export$12d09524e028927 = (userAgent)=>{
    // Take browsers in both Desktop and Mobile (includes Chrome, Firefox, Edge and Safari) within last 2 years
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const chrome = /Chrome\//.test(userAgent) && !/OPR\//.test(userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const chromeVersion = chrome ? parseInt((userAgent.match(/Chrome\/(\d+)/) || [])[1], 10) : 0;
    if (chromeVersion >= 84) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const gecko = /gecko\/\d/i.test(userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const geckoVersion = gecko ? parseInt((userAgent.match(/Firefox\/(\d+)/) || [])[1], 10) : 0;
    if (geckoVersion >= 84) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const edge = /Edge\/(\d+)/.exec(userAgent);
    const edgeVersion = edge ? +edge[1] : 0;
    if (edgeVersion >= 84) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const safari = !chrome && !gecko && /Version\/([0-9\._]+).*Safari/.test(userAgent);
    const safariVersion = safari ? // eslint-disable-next-line require-unicode-regexp
    parseInt((userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10) : 0;
    if (safariVersion >= 12) return false;
    return true;
};

});

parcelRegister("8DdhL", function(module, exports) {

$parcel$export(module.exports, "WithEditorView", () => $090d7aafd4648237$export$cf381084b490bd31);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $auTg8 = parcelRequire("auTg8");
const $090d7aafd4648237$export$cf381084b490bd31 = (WrappedComponent)=>{
    const _WithFeatureFlags = (props)=>{
        const { editorActions: editorActions } = (0, $auTg8.useEditorContext)();
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $7UHDa.jsx)(WrappedComponent, {
            ...props,
            editorView: editorActions?._privateGetEditorView()
        }));
    };
    return _WithFeatureFlags;
};

});


parcelRegister("bn5lP", function(module, exports) {

$parcel$export(module.exports, "default", () => $024596570cb688e3$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $kyKWe = parcelRequire("kyKWe");

var $d925B = parcelRequire("d925B");
var $ajtqX = parcelRequire("ajtqX");
var $e2wMq = parcelRequire("e2wMq");

var $5vVM5 = parcelRequire("5vVM5");

var $9HtP4 = parcelRequire("9HtP4");
var $7541v = parcelRequire("7541v");

var $9ciHB = parcelRequire("9ciHB");

var $jz9wK = parcelRequire("jz9wK");

var $8pwxt = parcelRequire("8pwxt");

var $jsk1R = parcelRequire("jsk1R");

var $6tl2G = parcelRequire("6tl2G");

var $40aJG = parcelRequire("40aJG");

var $lWghV = parcelRequire("lWghV");

var $2pjJ5 = parcelRequire("2pjJ5");

var $7T7aA = parcelRequire("7T7aA");

var $jvHoz = parcelRequire("jvHoz");

var $dh538 = parcelRequire("dh538");

var $1FT2u = parcelRequire("1FT2u");

var $6DQRK = parcelRequire("6DQRK");

var $hEPfr = parcelRequire("hEPfr");

var $geLSP = parcelRequire("geLSP");

var $2oRGU = parcelRequire("2oRGU");

var $7lreV = parcelRequire("7lreV");

var $67R1n = parcelRequire("67R1n");

var $4T0J6 = parcelRequire("4T0J6");

var $1B55v = parcelRequire("1B55v");

var $a0rZe = parcelRequire("a0rZe");

var $2q16N = parcelRequire("2q16N");

var $kbBd7 = parcelRequire("kbBd7");

var $dHwSr = parcelRequire("dHwSr");

var $cUiRv = parcelRequire("cUiRv");

var $hQcZ1 = parcelRequire("hQcZ1");
const $024596570cb688e3$var$EDIT_AREA_ID = 'ak-editor-textarea';
function $024596570cb688e3$export$e7d1b1cbca007e16(props) {
    const { preset: preset, editorProps: { appearance: nextAppearance, disabled: disabled, featureFlags: editorPropFeatureFlags, errorReporterHandler: errorReporterHandler, defaultValue: defaultValue, shouldFocus: shouldFocus, __livePage: __livePage }, onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed } = props;
    const [editorAPI, setEditorAPI] = (0, $gwFzn.useState)(undefined);
    const editorRef = (0, $gwFzn.useRef)(null);
    const viewRef = (0, $gwFzn.useRef)();
    const focusTimeoutId = (0, $gwFzn.useRef)();
    // ProseMirror is instantiated prior to the initial React render cycle,
    // so we allow transactions by default, to avoid discarding the initial one.
    const canDispatchTransactions = (0, $gwFzn.useRef)(true);
    const editorId = (0, $gwFzn.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))());
    const eventDispatcher = (0, $gwFzn.useMemo)(()=>new (0, $5vVM5.EventDispatcher)(), []);
    const config = (0, $gwFzn.useRef)({
        nodes: [],
        marks: [],
        pmPlugins: [],
        contentComponents: [],
        pluginHooks: [],
        primaryToolbarComponents: [],
        secondaryToolbarComponents: [],
        onEditorViewStateUpdatedCallbacks: []
    });
    const contentTransformer = (0, $gwFzn.useRef)(undefined);
    const featureFlags = (0, $gwFzn.useMemo)(()=>(0, $6DQRK.createFeatureFlagsFromProps)(editorPropFeatureFlags), [
        editorPropFeatureFlags
    ]);
    const getEditorState = (0, $gwFzn.useCallback)(()=>viewRef.current?.state, []);
    const getEditorView = (0, $gwFzn.useCallback)(()=>viewRef.current, []);
    const dispatch = (0, $gwFzn.useMemo)(()=>(0, $5vVM5.createDispatch)(eventDispatcher), [
        eventDispatcher
    ]);
    const errorReporter = (0, $gwFzn.useMemo)(()=>(0, $4T0J6.createErrorReporter)(errorReporterHandler), [
        errorReporterHandler
    ]);
    const handleAnalyticsEvent = (0, $gwFzn.useCallback)((payload)=>{
        (0, $ajtqX.fireAnalyticsEvent)(props.createAnalyticsEvent)(payload);
    }, [
        props.createAnalyticsEvent
    ]);
    const dispatchAnalyticsEvent = (0, $gwFzn.useCallback)((payload)=>{
        const dispatch = (0, $5vVM5.createDispatch)(eventDispatcher);
        dispatch((0, $lWghV.analyticsEventKey), {
            payload: payload
        });
    }, [
        eventDispatcher
    ]);
    const pluginInjectionAPI = (0, $gwFzn.useRef)(new (0, $jsk1R.EditorPluginInjectionAPI)({
        getEditorState: getEditorState,
        getEditorView: getEditorView,
        fireAnalyticsEvent: handleAnalyticsEvent
    }));
    (0, $gwFzn.useLayoutEffect)(()=>{
        setEditorAPI(pluginInjectionAPI.current.api());
    }, []);
    const createEditorState = (0, $gwFzn.useCallback)((options)=>{
        let schema;
        if (viewRef.current) {
            if (options.resetting) /**
         * ReactEditorView currently does NOT handle dynamic schema,
         * We are reusing the existing schema, and rely on #reconfigureState
         * to update `this.config`
         */ schema = viewRef.current.state.schema;
            else {
                /**
         * There's presently a number of issues with changing the schema of a
         * editor inflight. A significant issue is that we lose the ability
         * to keep track of a user's history as the internal plugin state
         * keeps a list of Steps to undo/redo (which are tied to the schema).
         * Without a good way to do work around this, we prevent this for now.
         */ // eslint-disable-next-line no-console
                console.warn('The editor does not support changing the schema dynamically.');
                return viewRef.current.state;
            }
        } else {
            config.current = (0, $4T0J6.processPluginsList)((0, $1B55v.default)(options.props.preset, props.editorProps, pluginInjectionAPI.current));
            schema = (0, $a0rZe.createSchema)(config.current);
        }
        const { contentTransformerProvider: contentTransformerProvider } = options.props.editorProps;
        const plugins = (0, $4T0J6.createPMPlugins)({
            schema: schema,
            dispatch: dispatch,
            errorReporter: errorReporter,
            editorConfig: config.current,
            eventDispatcher: eventDispatcher,
            providerFactory: options.props.providerFactory,
            portalProviderAPI: props.portalProviderAPI,
            nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            featureFlags: featureFlags,
            getIntl: ()=>props.intl,
            onEditorStateUpdated: (0, $dh538.fg)('platform_editor_catch_missing_injection_states') ? pluginInjectionAPI.current.onEditorViewUpdated : undefined
        });
        contentTransformer.current = contentTransformerProvider ? contentTransformerProvider(schema) : undefined;
        const api = pluginInjectionAPI.current.api();
        // If we have a doc prop, we need to process it into a PMNode
        let doc;
        if (options.doc) {
            // if the collabEdit API is set, skip this validation due to potential pm validation errors
            // from docs that end up with invalid marks after processing (See #hot-111702 for more details)
            if (api?.collabEdit !== undefined && (0, $dh538.fg)('editor_load_conf_collab_docs_without_checks') || options.props.editorProps.skipValidation) doc = (0, $6tl2G.processRawValueWithoutValidation)(schema, options.doc, dispatchAnalyticsEvent);
            else doc = (0, $6tl2G.processRawValue)(schema, options.doc, options.props.providerFactory, options.props.editorProps.sanitizePrivateContent, contentTransformer.current, dispatchAnalyticsEvent);
        }
        const isViewMode = api?.editorViewMode?.sharedState.currentState().mode === 'view';
        let selection;
        if (doc) {
            if (isViewMode) {
                const emptySelection = new (0, $7T7aA.TextSelection)(doc.resolve(0));
                return (0, $7T7aA.EditorState).create({
                    schema: schema,
                    plugins: plugins,
                    doc: doc,
                    selection: emptySelection
                });
            } else selection = options.selectionAtStart ? (0, $7T7aA.Selection).atStart(doc) : (0, $7T7aA.Selection).atEnd(doc);
        }
        // Workaround for ED-3507: When media node is the last element, scrollIntoView throws an error
        const patchedSelection = selection ? (0, $7T7aA.Selection).findFrom(selection.$head, -1, true) || undefined : undefined;
        return (0, $7T7aA.EditorState).create({
            schema: schema,
            plugins: plugins,
            doc: doc,
            selection: patchedSelection
        });
    }, [
        errorReporter,
        featureFlags,
        props.intl,
        props.portalProviderAPI,
        props.nodeViewPortalProviderAPI,
        props.editorProps,
        dispatchAnalyticsEvent,
        eventDispatcher,
        dispatch
    ]);
    const initialEditorState = (0, $gwFzn.useMemo)(()=>createEditorState({
            props: props,
            doc: defaultValue,
            // ED-4759: Don't set selection at end for full-page editor - should be at start.
            selectionAtStart: (0, $geLSP.isFullPage)(nextAppearance)
        }), // This is only used for the initial state - afterwards we will have `viewRef` available for use
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const getCurrentEditorState = (0, $gwFzn.useCallback)(()=>{
        return viewRef.current?.state ?? initialEditorState;
    }, [
        initialEditorState
    ]);
    const blur = (0, $gwFzn.useCallback)(()=>{
        if (!viewRef.current) return;
        if (viewRef.current.dom instanceof HTMLElement && viewRef.current.hasFocus()) viewRef.current.dom.blur();
        // The selectionToDOM method uses the document selection to determine currently selected node
        // We need to mimic blurring this as it seems doing the above is not enough.
        // @ts-expect-error
        const sel = viewRef.current.root.getSelection();
        if (sel) sel.removeAllRanges();
    }, []);
    const resetEditorState = (0, $gwFzn.useCallback)(({ doc: doc, shouldScrollToBottom: shouldScrollToBottom })=>{
        if (!viewRef.current) return;
        // We cannot currently guarantee when all the portals will have re-rendered during a reconfigure
        // so we blur here to stop ProseMirror from trying to apply selection to detached nodes or
        // nodes that haven't been re-rendered to the document yet.
        blur();
        const newEditorState = createEditorState({
            props: props,
            doc: doc,
            resetting: true,
            selectionAtStart: !shouldScrollToBottom
        });
        viewRef.current.updateState(newEditorState);
        props.editorProps.onChange?.(viewRef.current, {
            source: 'local'
        });
    }, [
        blur,
        createEditorState,
        props
    ]);
    // Initialise phase
    // Using constructor hook so we setup and dispatch analytics before anything else
    (0, $9HtP4.default)(()=>{
        // This needs to be before initialising editorState because
        // we dispatch analytics events in plugin initialisation
        eventDispatcher.on((0, $lWghV.analyticsEventKey), handleAnalyticsEvent);
        eventDispatcher.on('resetEditorState', resetEditorState);
        dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).STARTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            attributes: {
                platform: (0, $e2wMq.PLATFORMS).WEB,
                featureFlags: featureFlags ? (0, $9ciHB.getEnabledFeatureFlagKeys)(featureFlags) : [],
                accountLocale: props.intl?.locale,
                browserLocale: window.navigator.language
            },
            eventType: (0, $d925B.EVENT_TYPE).UI
        });
    });
    (0, $gwFzn.useLayoutEffect)(()=>{
        // Transaction dispatching is already enabled by default prior to
        // mounting, but we reset it here, just in case the editor view
        // instance is ever recycled (mounted again after unmounting) with
        // the same key.
        // AND since React 18 effects may run multiple times so we need to ensure
        // this is reset so that transactions are still allowed.
        // Although storing mounted state is an anti-pattern in React,
        // we do so here so that we can intercept and abort asynchronous
        // ProseMirror transactions when a dismount is imminent.
        canDispatchTransactions.current = true;
        return ()=>{
            // We can ignore any transactions from this point onwards.
            // This serves to avoid potential runtime exceptions which could arise
            // from an async dispatched transaction after it's unmounted.
            canDispatchTransactions.current = false;
        };
    }, []);
    // Cleanup
    (0, $gwFzn.useLayoutEffect)(()=>{
        return ()=>{
            const focusTimeoutIdCurrent = focusTimeoutId.current;
            if (focusTimeoutIdCurrent) clearTimeout(focusTimeoutIdCurrent);
            if (viewRef.current) {
                // Destroy the state if the Editor is being unmounted
                const editorState = viewRef.current.state;
                editorState.plugins.forEach((plugin)=>{
                    const state = plugin.getState(editorState);
                    if (state && state.destroy) state.destroy();
                });
            }
            eventDispatcher.destroy();
        // this.view will be destroyed when React unmounts in handleEditorViewRef
        };
    }, [
        eventDispatcher
    ]);
    const reconfigureState = (0, $gwFzn.useCallback)((props)=>{
        if (!viewRef.current) return;
        // We cannot currently guarantee when all the portals will have re-rendered during a reconfigure
        // so we blur here to stop ProseMirror from trying to apply selection to detached nodes or
        // nodes that haven't been re-rendered to the document yet.
        blur();
        const editorPlugins = (0, $1B55v.default)(props.preset, props.editorProps, pluginInjectionAPI.current);
        config.current = (0, $4T0J6.processPluginsList)(editorPlugins);
        const state = viewRef.current.state;
        const plugins = (0, $4T0J6.createPMPlugins)({
            schema: state.schema,
            dispatch: dispatch,
            errorReporter: errorReporter,
            editorConfig: config.current,
            eventDispatcher: eventDispatcher,
            providerFactory: props.providerFactory,
            portalProviderAPI: props.portalProviderAPI,
            nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            featureFlags: featureFlags,
            getIntl: ()=>props.intl,
            onEditorStateUpdated: (0, $dh538.fg)('platform_editor_catch_missing_injection_states') ? pluginInjectionAPI.current.onEditorViewUpdated : undefined
        });
        const newState = state.reconfigure({
            plugins: plugins
        });
        // need to update the state first so when the view builds the nodeviews it is
        // using the latest plugins
        viewRef.current.updateState(newState);
        return viewRef.current.update({
            ...viewRef.current.props,
            state: newState
        });
    }, [
        blur,
        dispatchAnalyticsEvent,
        eventDispatcher,
        dispatch,
        errorReporter,
        featureFlags
    ]);
    const onEditorViewUpdated = (0, $gwFzn.useCallback)(({ originalTransaction: originalTransaction, transactions: transactions, oldEditorState: oldEditorState, newEditorState: newEditorState })=>{
        if (!(0, $dh538.fg)('platform_editor_catch_missing_injection_states')) pluginInjectionAPI.current.onEditorViewUpdated({
            newEditorState: newEditorState,
            oldEditorState: oldEditorState
        });
        if (!(0, $dh538.fg)('platform_editor_migrate_state_updates')) config.current?.onEditorViewStateUpdatedCallbacks.forEach((entry)=>{
            entry.callback({
                originalTransaction: originalTransaction,
                transactions: transactions,
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            });
        });
    }, []);
    const dispatchTransaction = (0, $cUiRv.useDispatchTransaction)({
        onChange: props.editorProps.onChange,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        onEditorViewUpdated: onEditorViewUpdated,
        isRemoteReplaceDocumentTransaction: pluginInjectionAPI.current.api()?.collabEdit?.actions?.isRemoteReplaceDocumentTransaction
    });
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Remove these when we deprecate these props from editor-props - smartLinks is unfortunately still used in some places, we can sidestep this problem if we move everyone across to ComposableEditor and deprecate Editor
    const UNSAFE_cards = props.editorProps.UNSAFE_cards;
    const smartLinks = props.editorProps.smartLinks;
    // Temporary to replace provider factory while migration to `ComposableEditor` occurs
    (0, $1FT2u.useProviders)({
        editorApi: editorAPI,
        contextIdentifierProvider: props.editorProps.contextIdentifierProvider,
        mediaProvider: props.editorProps.media?.provider,
        mentionProvider: props.editorProps.mentionProvider,
        cardProvider: props.editorProps.linking?.smartLinks?.provider || smartLinks && smartLinks.provider || UNSAFE_cards && UNSAFE_cards.provider,
        emojiProvider: props.editorProps.emojiProvider,
        autoformattingProvider: props.editorProps.autoformattingProvider,
        taskDecisionProvider: props.editorProps.taskDecisionProvider
    });
    const getDirectEditorProps = (0, $gwFzn.useCallback)((state)=>{
        return {
            state: state ?? getCurrentEditorState(),
            dispatchTransaction: (tr)=>{
                // Block stale transactions:
                // Prevent runtime exceptions from async transactions that would attempt to
                // update the DOM after React has unmounted the Editor.
                if (canDispatchTransactions.current) dispatchTransaction(viewRef.current, tr);
            },
            // Disables the contentEditable attribute of the editor if the editor is disabled
            editable: (_state)=>!disabled,
            attributes: {
                'data-gramm': 'false'
            }
        };
    }, [
        dispatchTransaction,
        disabled,
        getCurrentEditorState
    ]);
    const createEditorView = (0, $gwFzn.useCallback)((node)=>{
        (0, $jz9wK.measureRender)((0, $7lreV.default).PROSEMIRROR_RENDERED, ({ duration: duration, startTime: startTime, distortedDuration: distortedDuration })=>{
            const proseMirrorRenderedSeverity = (0, $lWghV.getAnalyticsEventSeverity)(duration, (0, $67R1n.PROSEMIRROR_RENDERED_NORMAL_SEVERITY_THRESHOLD), (0, $67R1n.PROSEMIRROR_RENDERED_DEGRADED_SEVERITY_THRESHOLD));
            if (viewRef.current) {
                const nodes = (0, $hEPfr.getNodesCount)(viewRef.current.state.doc);
                const ttfb = (0, $8pwxt.getResponseEndTime)();
                const contextIdentifier = pluginInjectionAPI.current.api().base?.sharedState.currentState();
                dispatchAnalyticsEvent({
                    action: (0, $d925B.ACTION).PROSEMIRROR_RENDERED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        duration: duration,
                        startTime: startTime,
                        nodes: nodes,
                        ttfb: ttfb,
                        severity: proseMirrorRenderedSeverity,
                        objectId: contextIdentifier?.objectId,
                        distortedDuration: distortedDuration
                    },
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                });
            }
        });
        // Creates the editor-view from this.editorState. If an editor has been mounted
        // previously, this will contain the previous state of the editor.
        const view = new (0, $jvHoz.EditorView)({
            mount: node
        }, getDirectEditorProps());
        viewRef.current = view;
        pluginInjectionAPI.current.onEditorViewUpdated({
            newEditorState: viewRef.current.state,
            oldEditorState: undefined
        });
        return view;
    }, [
        getDirectEditorProps,
        dispatchAnalyticsEvent
    ]);
    const [editorView, setEditorView] = (0, $gwFzn.useState)(undefined);
    const originalScrollToRestore = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef((0, $geLSP.isFullPage)(props.editorProps.appearance) && (0, $dh538.fg)('platform_editor_reduce_scroll_jump_on_editor_start') ? document.querySelector('[data-editor-scroll-container]')?.scrollTop : undefined);
    const mitigateScrollJump = // The feature gate here is being used to avoid potential bugs with the scroll restoration code
    // moving it to the end of the expression negates the point of the feature gate
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $geLSP.isFullPage)(props.editorProps.appearance) && (0, $dh538.fg)('platform_editor_reduce_scroll_jump_on_editor_start') && originalScrollToRestore.current && originalScrollToRestore.current !== 0;
    (0, $gwFzn.useLayoutEffect)(()=>{
        if (shouldFocus && editorView?.props.editable?.(editorView.state) && (0, $dh538.fg)('platform_editor_react_18_autofocus_fix')) {
            if ((0, $dh538.fg)('platform_editor_reduce_scroll_jump_on_editor_start')) {
                if (!mitigateScrollJump) {
                    const liveDocWithContent = __livePage && !(0, $2pjJ5.isEmptyDocument)(editorView.state.doc);
                    if (!liveDocWithContent || !(0, $dh538.fg)('platform_editor_no_cursor_on_live_doc_init')) focusTimeoutId.current = (0, $dHwSr.handleEditorFocus)(editorView);
                }
            } else {
                const liveDocWithContent = __livePage && !(0, $2pjJ5.isEmptyDocument)(editorView.state.doc);
                if (!liveDocWithContent || !(0, $dh538.fg)('platform_editor_no_cursor_on_live_doc_init')) focusTimeoutId.current = (0, $dHwSr.handleEditorFocus)(editorView);
            }
        }
    }, [
        editorView,
        shouldFocus,
        __livePage,
        mitigateScrollJump
    ]);
    const handleEditorViewRef = (0, $gwFzn.useCallback)((node)=>{
        if (!viewRef.current && node) {
            const view = createEditorView(node);
            if ((0, $dh538.fg)('platform_editor_reduce_scroll_jump_on_editor_start')) {
                if (mitigateScrollJump) {
                    const scrollElement = document.querySelector('[data-editor-scroll-container]');
                    scrollElement?.scrollTo({
                        top: originalScrollToRestore.current,
                        behavior: 'instant'
                    });
                }
            }
            onEditorCreated({
                view: view,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current
            });
            if ((0, $dh538.fg)('platform_editor_react_18_autofocus_fix')) {
                /**
         * Defer using startTransition when it is available (in React 18) to fix
         * autofocus bug where React 18's concurrent rendering mode interferes with
         * setTimeout used in handleEditorFocus, causing autofocus to break.
         */ const react18OnlyStartTransition = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn)))?.startTransition ?? ((fn)=>fn());
                react18OnlyStartTransition(()=>{
                    // Force React to re-render so consumers get a reference to the editor view
                    setEditorView(view);
                });
            } else {
                if (shouldFocus && view.props.editable && view.props.editable(view.state)) {
                    if ((0, $dh538.fg)('platform_editor_reduce_scroll_jump_on_editor_start')) {
                        if (!mitigateScrollJump) {
                            const isLivePageWithContent = __livePage && !(0, $2pjJ5.isEmptyDocument)(view.state.doc) && (0, $dh538.fg)('platform_editor_no_cursor_on_live_doc_init');
                            if (!isLivePageWithContent && shouldFocus && view.props.editable && view.props.editable(view.state)) focusTimeoutId.current = (0, $dHwSr.handleEditorFocus)(view);
                        }
                    } else {
                        const isLivePageWithContent = __livePage && !(0, $2pjJ5.isEmptyDocument)(view.state.doc) && (0, $dh538.fg)('platform_editor_no_cursor_on_live_doc_init');
                        if (!isLivePageWithContent && shouldFocus && view.props.editable && view.props.editable(view.state)) focusTimeoutId.current = (0, $dHwSr.handleEditorFocus)(view);
                    }
                }
                // Force React to re-render so consumers get a reference to the editor view
                setEditorView(view);
            }
        } else if (viewRef.current && !node) {
            // When the appearance is changed, React will call handleEditorViewRef with node === null
            // to destroy the old EditorView, before calling this method again with node === div to
            // create the new EditorView
            onEditorDestroyed({
                view: viewRef.current,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current
            });
            const wasAnalyticsDisconnected = !eventDispatcher.has((0, $lWghV.analyticsEventKey), handleAnalyticsEvent);
            // If we disabled event listening for some reason we should re-enable it temporarily while we destroy
            // the view for any analytics that occur there.
            if (wasAnalyticsDisconnected) {
                eventDispatcher.on((0, $lWghV.analyticsEventKey), handleAnalyticsEvent);
                viewRef.current.destroy(); // Destroys the dom node & all node views
                eventDispatcher.off((0, $lWghV.analyticsEventKey), handleAnalyticsEvent);
            } else viewRef.current.destroy(); // Destroys the dom node & all node views
            viewRef.current = undefined;
        }
    }, [
        createEditorView,
        onEditorCreated,
        eventDispatcher,
        shouldFocus,
        __livePage,
        onEditorDestroyed,
        handleAnalyticsEvent,
        mitigateScrollJump
    ]);
    const createEditor = (0, $gwFzn.useCallback)((assistiveLabel, assistiveDescribedBy)=>{
        return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $kbBd7.getUAPrefix)(),
            ref: handleEditorViewRef,
            "aria-label": assistiveLabel || props.intl.formatMessage((0, $2q16N.editorMessages).editorAssistiveLabel),
            // setting aria-multiline to true when not mobile appearance.
            //  because somehow mobile tests are failing when it set.
            //  don't know why that is happening.
            // Created https://product-fabric.atlassian.net/jira/servicedesk/projects/DTR/queues/issue/DTR-1675
            //  to investigate further.
            "aria-multiline": true,
            role: "textbox",
            id: $024596570cb688e3$var$EDIT_AREA_ID,
            "aria-describedby": assistiveDescribedBy,
            "data-editor-id": editorId.current
        }, "ProseMirror");
    }, [
        handleEditorViewRef,
        props.intl
    ]);
    const previousPreset = (0, $7541v.default)(preset);
    (0, $gwFzn.useLayoutEffect)(()=>{
        if (previousPreset && previousPreset !== preset) reconfigureState(props);
    }, [
        reconfigureState,
        previousPreset,
        preset,
        props
    ]);
    const previousDisabledState = (0, $7541v.default)(disabled);
    (0, $gwFzn.useLayoutEffect)(()=>{
        if (viewRef.current && previousDisabledState !== disabled) {
            // Disables the contentEditable attribute of the editor if the editor is disabled
            viewRef.current.setProps({
                editable: (_state)=>!disabled
            });
            const isLivePageWithContent = __livePage && !(0, $2pjJ5.isEmptyDocument)(viewRef.current.state.doc) && (0, $dh538.fg)('platform_editor_no_cursor_on_live_doc_init');
            if (!disabled && shouldFocus && !isLivePageWithContent) focusTimeoutId.current = (0, $dHwSr.handleEditorFocus)(viewRef.current);
        }
    }, [
        disabled,
        shouldFocus,
        previousDisabledState,
        __livePage
    ]);
    (0, $hQcZ1.useFireFullWidthEvent)(nextAppearance, dispatchAnalyticsEvent);
    const editor = (0, $gwFzn.useMemo)(()=>createEditor(props.editorProps.assistiveLabel, props.editorProps.assistiveDescribedBy), // `createEditor` changes a little too frequently - we don't want to recreate the editor view in this case
    // We should follow-up
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        props.editorProps.assistiveLabel,
        props.editorProps.assistiveDescribedBy
    ]);
    // Render tracking is firing too many events in Jira so we are disabling them for now. See - https://product-fabric.atlassian.net/browse/ED-25616
    // Also firing too many events for the legacy content macro, so disabling for now. See - https://product-fabric.atlassian.net/browse/ED-26650
    const renderTrackingEnabled = !(0, $dh538.fg)('platform_editor_disable_rerender_tracking_jira') && !featureFlags.lcmPreventRenderTracking;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $40aJG.default).Provider, {
        value: {
            editorRef: editorRef,
            editorView: viewRef.current,
            popupsMountPoint: props.editorProps.popupsMountPoint
        },
        children: [
            renderTrackingEnabled && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2oRGU.RenderTracking), {
                componentProps: props,
                action: (0, $d925B.ACTION).RE_RENDERED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).REACT_EDITOR_VIEW,
                handleAnalyticsEvent: handleAnalyticsEvent,
                useShallow: true
            }),
            props.render ? props.render?.({
                editor: editor,
                view: viewRef.current,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                editorRef: editorRef,
                editorAPI: editorAPI
            }) ?? editor : editor
        ]
    });
}
var $024596570cb688e3$export$2e2bcd8739ae039 = (0, $js7oX.default)($024596570cb688e3$export$e7d1b1cbca007e16);

});
parcelRegister("e2wMq", function(module, exports) {

$parcel$export(module.exports, "PLATFORMS", () => $c8d6368806133d17$export$a8d23193462f2b63);
$parcel$export(module.exports, "MODE", () => $c8d6368806133d17$export$e48589d9e4824227);
$parcel$export(module.exports, "FULL_WIDTH_MODE", () => $c8d6368806133d17$export$57453495b81e2dde);
$parcel$export(module.exports, "BROWSER_FREEZE_INTERACTION_TYPE", () => $c8d6368806133d17$export$60a219cfaef9722);
var $c8d6368806133d17$export$a8d23193462f2b63 = /*#__PURE__*/ function(PLATFORMS) {
    PLATFORMS["NATIVE"] = "mobileNative";
    PLATFORMS["HYBRID"] = "mobileHybrid";
    PLATFORMS["WEB"] = "web";
    return PLATFORMS;
}({});
var $c8d6368806133d17$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $c8d6368806133d17$export$57453495b81e2dde = /*#__PURE__*/ function(FULL_WIDTH_MODE) {
    FULL_WIDTH_MODE["FIXED_WIDTH"] = "fixedWidth";
    FULL_WIDTH_MODE["FULL_WIDTH"] = "fullWidth";
    return FULL_WIDTH_MODE;
}({});
var $c8d6368806133d17$export$60a219cfaef9722 = /*#__PURE__*/ function(BROWSER_FREEZE_INTERACTION_TYPE) {
    BROWSER_FREEZE_INTERACTION_TYPE["LOADING"] = "loading";
    BROWSER_FREEZE_INTERACTION_TYPE["TYPING"] = "typing";
    BROWSER_FREEZE_INTERACTION_TYPE["CLICKING"] = "clicking";
    BROWSER_FREEZE_INTERACTION_TYPE["PASTING"] = "pasting";
    return BROWSER_FREEZE_INTERACTION_TYPE;
}({});

});

parcelRegister("9HtP4", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e1d16a2959b92a8$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");
function $1e1d16a2959b92a8$export$2e2bcd8739ae039(callback) {
    const hasRun = (0, $gwFzn.useRef)(false);
    if (!hasRun.current) {
        callback();
        hasRun.current = true;
    }
}

});

parcelRegister("7541v", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebe99912880d9fde$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");
function $ebe99912880d9fde$export$2e2bcd8739ae039(value, initialValue) {
    const ref = (0, $gwFzn.useRef)(initialValue);
    (0, $gwFzn.useEffect)(()=>{
        // Setting the value to ref.current inside an effect, or otherwise the behaviour in staging/prod doesn't match with local
        // In local, the double rendering in react dev mode causes the previous value to be the same as next value immediately after
        // In prod and staging, double rendering is not done since that is a react prod build
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("jsk1R", function(module, exports) {

$parcel$export(module.exports, "EditorPluginInjectionAPI", () => $a71d406c80bedd2b$export$50ccbedb1c6559a0);

var $atveb = parcelRequire("atveb");

var $eEhUN = parcelRequire("eEhUN");

var $apxVI = parcelRequire("apxVI");
function $a71d406c80bedd2b$var$hasGetSharedState(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.getSharedState === 'function';
}
function $a71d406c80bedd2b$var$hasActions(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.actions === 'object';
}
function $a71d406c80bedd2b$var$hasCommands(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.commands === 'object';
}
const $a71d406c80bedd2b$var$filterPluginsWithListeners = ({ listeners: listeners, plugins: plugins })=>Array.from(listeners.keys()).map((pluginName)=>plugins.get(pluginName)).filter((plugin)=>plugin !== undefined && $a71d406c80bedd2b$var$hasGetSharedState(plugin));
const $a71d406c80bedd2b$var$extractSharedStateFromPlugins = ({ oldEditorState: oldEditorState, newEditorState: newEditorState, plugins: plugins })=>{
    const isInitialization = !oldEditorState && newEditorState;
    const result = new Map();
    for (const plugin of plugins){
        if (!plugin || !$a71d406c80bedd2b$var$hasGetSharedState(plugin)) continue;
        const nextSharedState = plugin.getSharedState(newEditorState);
        const prevSharedState = !isInitialization && oldEditorState ? plugin.getSharedState(oldEditorState) : undefined;
        const isSamePluginState = (0, (/*@__PURE__*/$parcel$interopDefault($atveb)))(prevSharedState, nextSharedState);
        if (isInitialization || !isSamePluginState) result.set(plugin.name, {
            nextSharedState: nextSharedState,
            prevSharedState: prevSharedState
        });
    }
    return result;
};
const $a71d406c80bedd2b$var$THROTTLE_CALLS_FOR_MILLISECONDS = 0;
const $a71d406c80bedd2b$var$notifyListenersThrottled = (0, (/*@__PURE__*/$parcel$interopDefault($eEhUN)))(({ listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue })=>{
    const callbacks = [];
    for (const [pluginName, diffs] of updatesToNotifyQueue.entries()){
        const pluginListeners = listeners.get(pluginName) || [];
        pluginListeners.forEach((callback)=>{
            diffs.forEach((diff)=>{
                callbacks.push(callback.bind(callback, diff));
            });
        });
    }
    updatesToNotifyQueue.clear();
    if (callbacks.length === 0) return;
    callbacks.reverse().forEach((cb)=>{
        cb();
    });
}, $a71d406c80bedd2b$var$THROTTLE_CALLS_FOR_MILLISECONDS);
class $a71d406c80bedd2b$export$855252f33d470a3f {
}
class $a71d406c80bedd2b$var$ActionsAPI {
    createAPI(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    plugin) {
        if (!plugin || !$a71d406c80bedd2b$var$hasActions(plugin)) return {};
        return new Proxy(plugin.actions || {}, {
            get: function(target, prop, receiver) {
                // We will be able to track perfomance here
                return Reflect.get(target, prop);
            }
        });
    }
}
class $a71d406c80bedd2b$var$EditorCommandsAPI {
    createAPI(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    plugin) {
        if (!plugin || !$a71d406c80bedd2b$var$hasCommands(plugin)) return {};
        return new Proxy(plugin.commands || {}, {
            get: function(target, prop, receiver) {
                // We will be able to track perfomance here
                return Reflect.get(target, prop);
            }
        });
    }
}
class $a71d406c80bedd2b$export$da7528f3fb233b4a {
    createAPI(plugin) {
        if (!plugin) return {
            currentState: ()=>undefined,
            onChange: (sub)=>{
                return ()=>{};
            }
        };
        const pluginName = plugin.name;
        return {
            currentState: ()=>{
                if (!$a71d406c80bedd2b$var$hasGetSharedState(plugin)) return undefined;
                const state = this.getEditorState();
                return plugin.getSharedState(state);
            },
            onChange: (sub)=>{
                const pluginListeners = this.listeners.get(pluginName) || new Set();
                pluginListeners.add(sub);
                this.listeners.set(pluginName, pluginListeners);
                return ()=>this.cleanupSubscription(pluginName, sub);
            }
        };
    }
    cleanupSubscription(pluginName, sub) {
        (this.listeners.get(pluginName) || new Set()).delete(sub);
    }
    notifyListeners({ newEditorState: newEditorState, oldEditorState: oldEditorState, plugins: plugins }) {
        const { listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue } = this;
        const pluginsFiltered = $a71d406c80bedd2b$var$filterPluginsWithListeners({
            plugins: plugins,
            listeners: listeners
        });
        const sharedStateDiffs = $a71d406c80bedd2b$var$extractSharedStateFromPlugins({
            oldEditorState: oldEditorState,
            newEditorState: newEditorState,
            plugins: pluginsFiltered
        });
        if (sharedStateDiffs.size === 0) return;
        for (const [pluginName, nextDiff] of sharedStateDiffs){
            const currentDiffQueue = updatesToNotifyQueue.get(pluginName) || [];
            updatesToNotifyQueue.set(pluginName, [
                ...currentDiffQueue,
                nextDiff
            ]);
        }
        $a71d406c80bedd2b$var$notifyListenersThrottled({
            updatesToNotifyQueue: updatesToNotifyQueue,
            listeners: listeners
        });
    }
    destroy() {
        this.listeners.clear();
        this.updatesToNotifyQueue.clear();
    }
    constructor({ getEditorState: getEditorState }){
        this.getEditorState = void 0;
        this.listeners = void 0;
        this.updatesToNotifyQueue = new Map();
        this.getEditorState = getEditorState;
        this.listeners = new Map();
    }
}
const $a71d406c80bedd2b$var$editorAPICache = new WeakMap();
class $a71d406c80bedd2b$export$50ccbedb1c6559a0 {
    createAPI() {
        const { sharedStateAPI: sharedStateAPI, actionsAPI: actionsAPI, commandsAPI: commandsAPI, getPluginByName: getPluginByName } = this;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new Proxy({}, {
            get: function(target, prop, receiver) {
                // If we pass this as a prop React hates us
                // Let's just reflect the result and ignore these
                if (prop === 'toJSON') return Reflect.get(target, prop);
                const plugin = getPluginByName(prop);
                if (!plugin) return undefined;
                const sharedState = sharedStateAPI.createAPI(plugin);
                const actions = actionsAPI.createAPI(plugin);
                const commands = commandsAPI.createAPI(plugin);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const proxyCoreAPI = {
                    sharedState: sharedState,
                    actions: actions,
                    commands: commands
                };
                return proxyCoreAPI;
            }
        });
    }
    api() {
        if (!$a71d406c80bedd2b$var$editorAPICache.get(this)) $a71d406c80bedd2b$var$editorAPICache.set(this, this.createAPI());
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $a71d406c80bedd2b$var$editorAPICache.get(this);
    }
    constructor({ getEditorState: getEditorState, getEditorView: getEditorView, fireAnalyticsEvent: fireAnalyticsEvent }){
        this.sharedStateAPI = void 0;
        this.actionsAPI = void 0;
        this.commandsAPI = void 0;
        this.plugins = void 0;
        this.onEditorViewUpdated = ({ newEditorState: newEditorState, oldEditorState: oldEditorState })=>{
            this.sharedStateAPI.notifyListeners({
                newEditorState: newEditorState,
                oldEditorState: oldEditorState,
                plugins: this.plugins
            });
        };
        this.onEditorPluginInitialized = (plugin)=>{
            this.addPlugin(plugin);
        };
        this.addPlugin = (plugin)=>{
            // Plugins other than `core` are checked by the preset itself
            // For some reason in some tests we have duplicates that are missed.
            // To follow-up in ED-19611
            if (plugin.name === 'core' && this.plugins.has(plugin.name)) throw new Error(`Plugin ${plugin.name} has already been initialised in the Editor API!
        There cannot be duplicate plugins or you will have unexpected behaviour`);
            this.plugins.set(plugin.name, plugin);
        };
        this.getPluginByName = (pluginName)=>{
            const plugin = this.plugins.get(pluginName);
            return plugin;
        };
        this.sharedStateAPI = new $a71d406c80bedd2b$export$da7528f3fb233b4a({
            getEditorState: getEditorState
        });
        this.plugins = new Map();
        this.actionsAPI = new $a71d406c80bedd2b$var$ActionsAPI();
        this.commandsAPI = new $a71d406c80bedd2b$var$EditorCommandsAPI();
        // Special core plugin that is always added
        this.addPlugin((0, $apxVI.corePlugin)({
            config: {
                getEditorView: getEditorView,
                fireAnalyticsEvent: fireAnalyticsEvent
            }
        }));
    }
}

});
parcelRegister("apxVI", function(module, exports) {

$parcel$export(module.exports, "corePlugin", () => $9e9cac93742fed46$export$71ab138dd170c35);

var $kviC1 = parcelRequire("kviC1");

var $dh538 = parcelRequire("dh538");

var $6tl2G = parcelRequire("6tl2G");

var $gmyMu = parcelRequire("gmyMu");

var $eqCon = parcelRequire("eqCon");
const $9e9cac93742fed46$export$71ab138dd170c35 = ({ config: config })=>{
    // Create the document request throttler per editor (rather than at a module level)
    const scheduleDocumentRequest = (0, $eqCon.createThrottleSchedule)((0, $eqCon.returnDocumentRequest));
    return {
        name: 'core',
        actions: {
            execute: (command)=>{
                const editorView = config?.getEditorView();
                if (!editorView || !command) return false;
                const { state: state, dispatch: dispatch } = editorView;
                return (0, $gmyMu.editorCommandToPMCommand)(command)(state, dispatch);
            },
            // Code copied from `EditorActions.focus()`
            focus: (options)=>{
                const editorView = config?.getEditorView();
                if (!editorView || editorView.hasFocus()) return false;
                editorView.focus();
                if (options?.scrollIntoView ?? true) editorView.dispatch(editorView.state.tr.scrollIntoView());
                return true;
            },
            // Code copied from `EditorActions.blur()`
            blur: ()=>{
                const editorView = config?.getEditorView();
                if (!editorView || !editorView.hasFocus()) return false;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                editorView.dom.blur();
                return true;
            },
            scrollToPos (pos, scrollOptions) {
                const editorView = config?.getEditorView();
                if (!editorView) return false;
                const tr = editorView.state.tr;
                const isValidPos = typeof pos === 'number' && pos >= 0 && pos <= tr.doc.content.size;
                if (!isValidPos) return false;
                const dom = editorView.domAtPos(pos).node;
                if (!(dom instanceof Element)) {
                    // If it's not an element (e.g. #text node), we'll try the parent.
                    // This is expected to cover most of the scenarios, if not, window.scrollTo is an alternative
                    if (dom.parentNode instanceof Element) {
                        dom.parentNode.scrollIntoView(scrollOptions);
                        return true;
                    }
                    return false;
                }
                dom.scrollIntoView(scrollOptions);
                return true;
            },
            replaceDocument: (replaceValue, options)=>{
                const editorView = config?.getEditorView();
                if (!editorView || replaceValue === undefined || replaceValue === null) return false;
                const { state: state } = editorView;
                const { schema: schema } = state;
                const content = options?.skipValidation ? (0, $6tl2G.processRawValueWithoutValidation)(schema, replaceValue) : Array.isArray(replaceValue) ? (0, $6tl2G.processRawFragmentValue)(schema, replaceValue) : (0, $6tl2G.processRawValue)(schema, replaceValue);
                // Don't replace the document if it's the same document, as full size
                // replace transactions cause issues for collaborative editing and
                // content reconciliation (eg. inline comments getting dropped)
                if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
                (0, $dh538.fg)('platform_editor_replace_document_shortcircuit') && content instanceof (0, $kviC1.Node) && state.doc.eq(content)) return false;
                if (content) {
                    const tr = state.tr.replaceWith(0, state.doc.nodeSize - 2, content);
                    if (options?.scrollIntoView ?? true) editorView.dispatch(tr.scrollIntoView());
                    else editorView.dispatch(tr);
                    return true;
                }
                return false;
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            requestDocument (onReceive, options) {
                const view = config?.getEditorView() ?? null;
                scheduleDocumentRequest(view, onReceive, options?.transformer, config?.fireAnalyticsEvent);
            },
            createTransformer (cb) {
                const view = config?.getEditorView() ?? null;
                if (!view?.state.schema) return undefined;
                return cb(view?.state.schema);
            }
        }
    };
};

});
parcelRegister("gmyMu", function(module, exports) {

$parcel$export(module.exports, "editorCommandToPMCommand", () => $42952c725d367d8e$export$bd352a83a17b2af8);
$parcel$export(module.exports, "PassiveTransaction", () => $42952c725d367d8e$export$95069e054e554fa9);

var $7T7aA = parcelRequire("7T7aA");
function $42952c725d367d8e$export$bd352a83a17b2af8(command) {
    return ({ tr: tr }, dispatch)=>{
        const newTr = command?.({
            tr: tr
        });
        if (!newTr) return false;
        if (newTr instanceof $42952c725d367d8e$export$95069e054e554fa9) return true;
        dispatch?.(newTr);
        return true;
    };
}
class $42952c725d367d8e$export$95069e054e554fa9 extends (0, $7T7aA.Transaction) {
    // This is very cheeky but this should never be used outside its intended
    // purpose - it will likely crash the editor so we should get an early warning
    // signal
    constructor(){
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        super({});
    }
}

});

parcelRegister("eqCon", function(module, exports) {

$parcel$export(module.exports, "createThrottleSchedule", () => $c623ea262c2cbc76$export$6a1dd68d75badcc7);
$parcel$export(module.exports, "returnDocumentRequest", () => $c623ea262c2cbc76$export$dce79649e5264171);

var $h9yJL = parcelRequire("h9yJL");

var $kviC1 = parcelRequire("kviC1");

var $d925B = parcelRequire("d925B");
const $c623ea262c2cbc76$var$transformer = new (0, $h9yJL.JSONTransformer)();
function $c623ea262c2cbc76$export$54fd2c36b5cc6731(node) {
    return $c623ea262c2cbc76$var$transformer.encode(node);
}
function $c623ea262c2cbc76$export$6a1dd68d75badcc7(callback) {
    let frameId;
    let lastArgs;
    const wrapperFn = (...args)=>{
        lastArgs = args;
        if (frameId) return;
        // If `requestIdleCallback` doesn't exist - fallback to `requestAnimationFrame`
        const delayFunction = globalThis.requestIdleCallback ?? globalThis.requestAnimationFrame;
        frameId = delayFunction(()=>{
            frameId = undefined;
            if (lastArgs) callback(...lastArgs);
        }, {
            timeout: 100
        });
    };
    return wrapperFn;
}
function $c623ea262c2cbc76$export$dce79649e5264171(editorView, callback, transformer, fireAnalyticsEvent) {
    const { doc: doc, schema: schema } = editorView?.state ?? {};
    if (!doc || !schema) return undefined;
    try {
        const json = $c623ea262c2cbc76$export$54fd2c36b5cc6731(doc);
        if (typeof transformer === 'undefined') callback(json);
        else {
            const nodeSanitized = (0, $kviC1.Node).fromJSON(schema, json);
            callback(transformer.encode(nodeSanitized));
        }
    } catch (e) {
        fireAnalyticsEvent?.({
            payload: {
                action: (0, $d925B.ACTION).DOCUMENT_PROCESSING_ERROR,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform one or more nested tables' : undefined}`
                }
            }
        });
        throw e;
    }
}

});



parcelRegister("40aJG", function(module, exports) {

$parcel$export(module.exports, "default", () => $737f8c3c28a9bc31$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");
const $737f8c3c28a9bc31$var$ReactEditorViewContext = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({});
var $737f8c3c28a9bc31$export$2e2bcd8739ae039 = $737f8c3c28a9bc31$var$ReactEditorViewContext;

});

parcelRegister("1FT2u", function(module, exports) {

$parcel$export(module.exports, "useProviders", () => $9dc7d15a9979d8e6$export$e4c19534640d7866);

var $gwFzn = parcelRequire("gwFzn");
const $9dc7d15a9979d8e6$export$e4c19534640d7866 = ({ editorApi: editorApi, contextIdentifierProvider: contextIdentifierProvider, mediaProvider: mediaProvider, mentionProvider: mentionProvider, cardProvider: cardProvider, emojiProvider: emojiProvider, autoformattingProvider: autoformattingProvider, taskDecisionProvider: taskDecisionProvider })=>{
    (0, $gwFzn.useEffect)(()=>{
        async function setProvider() {
            if (!contextIdentifierProvider) return;
            const provider = await contextIdentifierProvider;
            editorApi?.core?.actions.execute(editorApi?.contextIdentifier?.commands.setProvider({
                contextIdentifierProvider: provider
            }));
        }
        setProvider();
    }, [
        contextIdentifierProvider,
        editorApi
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (mediaProvider) editorApi?.media?.actions.setProvider(mediaProvider);
    }, [
        mediaProvider,
        editorApi
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (mentionProvider) editorApi?.mention?.actions.setProvider(mentionProvider);
    }, [
        mentionProvider,
        editorApi
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (cardProvider) editorApi?.card?.actions.setProvider(cardProvider);
    }, [
        cardProvider,
        editorApi
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (emojiProvider) editorApi?.emoji?.actions.setProvider(emojiProvider);
    }, [
        emojiProvider,
        editorApi
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (autoformattingProvider) editorApi?.customAutoformat?.actions.setProvider(autoformattingProvider);
    }, [
        autoformattingProvider,
        editorApi
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (taskDecisionProvider) editorApi?.taskDecision?.actions.setProvider(taskDecisionProvider);
    }, [
        taskDecisionProvider,
        editorApi
    ]);
};

});

parcelRegister("hEPfr", function(module, exports) {

$parcel$export(module.exports, "getNodesCount", () => $0f830263e94a6c1b$export$3674f49b2d541ad);
function $0f830263e94a6c1b$export$3674f49b2d541ad(node) {
    const count = {};
    node.nodesBetween(0, node.nodeSize - 2, (node)=>{
        count[node.type.name] = (count[node.type.name] || 0) + 1;
    });
    return count;
}

});

parcelRegister("geLSP", function(module, exports) {

$parcel$export(module.exports, "isFullPage", () => $636443110c5c1dfb$export$2800a15841f40ad7);
function $636443110c5c1dfb$export$2800a15841f40ad7(appearance) {
    return appearance === 'full-page' || appearance === 'full-width';
}

});

parcelRegister("2oRGU", function(module, exports) {

$parcel$export(module.exports, "RenderTracking", () => $7292b2eba851ae1a$export$fe16de086fea1f5f);

var $gwFzn = parcelRequire("gwFzn");

var $2jjxD = parcelRequire("2jjxD");

var $d925B = parcelRequire("d925B");

var $h9Yad = parcelRequire("h9Yad");
function $7292b2eba851ae1a$export$fe16de086fea1f5f(props) {
    const debouncedHandleAnalyticsEvent = (0, $gwFzn.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(props.handleAnalyticsEvent, 500), [
        props.handleAnalyticsEvent
    ]);
    (0, $h9Yad.useComponentRenderTracking)({
        onRender: ({ renderCount: renderCount, propsDifference: propsDifference })=>{
            if (!renderCount) return;
            debouncedHandleAnalyticsEvent({
                payload: {
                    action: props.action,
                    actionSubject: props.actionSubject,
                    attributes: {
                        count: renderCount,
                        propsDifference: propsDifference
                    },
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                }
            });
        },
        propsDiffingOptions: {
            enabled: true,
            props: props.componentProps,
            propsToIgnore: props.propsToIgnore,
            useShallow: props.useShallow
        },
        zeroBasedCount: true
    });
    return null;
}

});
parcelRegister("h9Yad", function(module, exports) {

$parcel$export(module.exports, "useComponentRenderTracking", () => $3946837408650aa8$export$ebce6d7d8ca67353);

var $gwFzn = parcelRequire("gwFzn");

var $kyKWe = parcelRequire("kyKWe");

var $ZkPRR = parcelRequire("ZkPRR");
function $3946837408650aa8$export$ebce6d7d8ca67353({ onRender: onRender, propsDiffingOptions: propsDiffingOptions, zeroBasedCount: zeroBasedCount = true }) {
    const propsRef = (0, $gwFzn.useRef)();
    const renderCountRef = (0, $gwFzn.useRef)(zeroBasedCount ? 0 : 1);
    const { current: componentId } = (0, $gwFzn.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))());
    (0, $gwFzn.useEffect)(()=>{
        const lastProps = propsRef.current;
        const renderCount = renderCountRef.current;
        let propsDifference;
        if (propsDiffingOptions?.enabled && lastProps) propsDifference = propsDiffingOptions?.useShallow ? (0, $ZkPRR.getShallowPropsDifference)(lastProps, propsDiffingOptions.props) : (0, $ZkPRR.getPropsDifference)(lastProps, propsDiffingOptions.props, 0, 2, propsDiffingOptions?.propsToIgnore);
        const result = {
            renderCount: renderCount,
            propsDifference: propsDifference,
            componentId: componentId
        };
        onRender(result);
        if (propsDiffingOptions?.enabled) propsRef.current = propsDiffingOptions.props;
        renderCountRef.current = renderCountRef.current + 1;
    }); // No dependencies run on each render
}

});
parcelRegister("ZkPRR", function(module, exports) {

$parcel$export(module.exports, "getPropsDifference", () => $88475e86f62b9e57$export$d438af18e3a25d10);
$parcel$export(module.exports, "getShallowPropsDifference", () => $88475e86f62b9e57$export$418b0a935c0a0030);

var $gwFzn = parcelRequire("gwFzn");
const $88475e86f62b9e57$export$74743eda5dda3ccf = Object.keys;
const $88475e86f62b9e57$export$aedd1a2d18cbf42b = (object1, object2)=>{
    const oldKeys = object1 !== null ? $88475e86f62b9e57$export$74743eda5dda3ccf(object1) : [];
    const newKeys = object2 !== null ? $88475e86f62b9e57$export$74743eda5dda3ccf(object2) : [];
    const removed = oldKeys.filter((key)=>!newKeys.includes(key));
    const added = newKeys.filter((key)=>!oldKeys.includes(key));
    const common = oldKeys.filter((key)=>newKeys.includes(key));
    return {
        added: added,
        common: common,
        removed: removed
    };
};
const $88475e86f62b9e57$export$f4c1dafc9df1f03 = (value)=>{
    const valueType = typeof value;
    if (value === null) return 'null';
    else if (value === undefined) return 'undefined';
    else if (valueType === 'string' || valueType === 'number') return value;
    else if (valueType === 'symbol') return value.toString();
    else if (valueType === 'function') return `function:${value.name}`;
    else if (valueType === 'object') return {
        type: 'object',
        keys: Object.keys(value)
    };
};
const $88475e86f62b9e57$export$d438af18e3a25d10 = (object1, object2, curDepth = 0, maxDepth = 2, keysToIgnore = [])=>{
    const { added: added, common: common, removed: removed } = $88475e86f62b9e57$export$aedd1a2d18cbf42b(object1, object2);
    const changed = [];
    common.forEach((key)=>{
        const value1 = object1[key];
        const value2 = object2[key];
        const value1Type = typeof value1;
        const value2Type = typeof value2;
        // Do comparision only if values doesn't match (or reference to same object in memory).
        // Or if key does not exist in keys to ignore.
        if (value1 !== value2 && keysToIgnore.indexOf(key) === -1) {
            // if both key value are objects and not referencing same object in memory.
            //  then get recursive difference.
            if ((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(value1) || (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(value2)) changed.push({
                key: key,
                reactElementChanged: true
            });
            else if (value1Type === 'object' && value2Type === 'object') {
                if (curDepth <= maxDepth) {
                    const difference = $88475e86f62b9e57$export$d438af18e3a25d10(value1, value2, curDepth + 1, maxDepth);
                    changed.push({
                        key: key,
                        difference: difference
                    });
                } else changed.push({
                    key: key,
                    maxDepthReached: true
                });
            } else changed.push({
                key: key,
                oldValue: $88475e86f62b9e57$export$f4c1dafc9df1f03(value1),
                newValue: $88475e86f62b9e57$export$f4c1dafc9df1f03(value2)
            });
        }
    });
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};
const $88475e86f62b9e57$export$418b0a935c0a0030 = (object1, object2)=>{
    const { added: added, common: common, removed: removed } = $88475e86f62b9e57$export$aedd1a2d18cbf42b(object1, object2);
    const changed = common.filter((key)=>object1[key] !== object2[key]);
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};

});



parcelRegister("67R1n", function(module, exports) {

$parcel$export(module.exports, "PROSEMIRROR_RENDERED_NORMAL_SEVERITY_THRESHOLD", () => $769e182f77e7bc85$export$646a6982857f2cd5);
$parcel$export(module.exports, "PROSEMIRROR_RENDERED_DEGRADED_SEVERITY_THRESHOLD", () => $769e182f77e7bc85$export$79d7eac6cbb6352d);
const $769e182f77e7bc85$export$646a6982857f2cd5 = 2000;
const $769e182f77e7bc85$export$79d7eac6cbb6352d = 3000;
const $769e182f77e7bc85$export$7d7bd496a5206996 = 100;

});

parcelRegister("4T0J6", function(module, exports) {

$parcel$export(module.exports, "fixExcludes", () => $5b9727cf4df72475$export$ef6c09ff452189fa);
$parcel$export(module.exports, "processPluginsList", () => $5b9727cf4df72475$export$7265233e78178a4);
$parcel$export(module.exports, "createPMPlugins", () => $5b9727cf4df72475$export$169329cb2979ef81);
$parcel$export(module.exports, "createErrorReporter", () => $5b9727cf4df72475$export$e98521bb0cea2db1);

var $dSVmA = parcelRequire("dSVmA");

var $2oGxU = parcelRequire("2oGxU");

var $9CUJY = parcelRequire("9CUJY");
function $5b9727cf4df72475$export$935d38a2e170d1f3(a, b) {
    return a.rank - b.rank;
}
function $5b9727cf4df72475$export$ef6c09ff452189fa(marks) {
    const markKeys = Object.keys(marks);
    const markGroups = new Set(markKeys.map((mark)=>marks[mark].group));
    markKeys.forEach((markKey)=>{
        const mark = marks[markKey];
        if (mark.excludes) mark.excludes = mark.excludes.split(' ').filter((group)=>markGroups.has(group)).join(' ');
    });
    return marks;
}
function $5b9727cf4df72475$export$7265233e78178a4(plugins) {
    /**
	 * First pass to collect pluginsOptions
	 */ const pluginsOptions = plugins.reduce((acc, plugin)=>{
        if (plugin.pluginsOptions) Object.keys(plugin.pluginsOptions).forEach((pluginName)=>{
            if (!acc[pluginName]) acc[pluginName] = [];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            acc[pluginName].push(plugin.pluginsOptions[pluginName]);
        });
        return acc;
    }, {});
    /**
	 * Process plugins
	 */ return plugins.reduce((acc, plugin)=>{
        if (plugin.pmPlugins) acc.pmPlugins.push(...plugin.pmPlugins(plugin.name ? pluginsOptions[plugin.name] : undefined));
        if (plugin.nodes) acc.nodes.push(...plugin.nodes());
        if (plugin.marks) acc.marks.push(...plugin.marks());
        if (plugin.contentComponent) acc.contentComponents.push(plugin.contentComponent);
        if (plugin.usePluginHook) acc.pluginHooks.push(plugin.usePluginHook);
        if (plugin.primaryToolbarComponent) acc.primaryToolbarComponents.push(plugin.primaryToolbarComponent);
        if (plugin.secondaryToolbarComponent) acc.secondaryToolbarComponents.push(plugin.secondaryToolbarComponent);
        if (plugin.onEditorViewStateUpdated) acc.onEditorViewStateUpdatedCallbacks.push({
            pluginName: plugin.name,
            callback: plugin.onEditorViewStateUpdated
        });
        return acc;
    }, {
        nodes: [],
        marks: [],
        pmPlugins: [],
        contentComponents: [],
        pluginHooks: [],
        primaryToolbarComponents: [],
        secondaryToolbarComponents: [],
        onEditorViewStateUpdatedCallbacks: []
    });
}
function $5b9727cf4df72475$export$169329cb2979ef81(config) {
    const { editorConfig: editorConfig } = config;
    const pmPlugins = editorConfig.pmPlugins.sort((0, $2oGxU.sortByOrder)('plugins')).map(({ plugin: plugin })=>plugin({
            schema: config.schema,
            dispatch: config.dispatch,
            eventDispatcher: config.eventDispatcher,
            providerFactory: config.providerFactory,
            errorReporter: config.errorReporter,
            portalProviderAPI: config.portalProviderAPI,
            nodeViewPortalProviderAPI: config.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: config.dispatchAnalyticsEvent,
            featureFlags: config.featureFlags || {},
            getIntl: config.getIntl
        })).filter((plugin)=>typeof plugin !== 'undefined');
    if (config.onEditorStateUpdated !== undefined) return [
        (0, $9CUJY.createEditorStateNotificationPlugin)(config.onEditorStateUpdated, config.editorConfig.onEditorViewStateUpdatedCallbacks),
        ...pmPlugins
    ];
    return pmPlugins;
}
function $5b9727cf4df72475$export$e98521bb0cea2db1(errorReporterHandler) {
    const errorReporter = new (0, $dSVmA.ErrorReporter)();
    if (errorReporterHandler) errorReporter.handler = errorReporterHandler;
    return errorReporter;
}

});
parcelRegister("2oGxU", function(module, exports) {

$parcel$export(module.exports, "sortByOrder", () => $1829e3410f9040f1$export$49afdc3354d5c84e);
$parcel$export(module.exports, "sortByOrderWithTypeName", () => $1829e3410f9040f1$export$b4ae7ad1c009d0a1);
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
// @deprecated
// @private This rank is not stable and should not be trusted. If you need to change this file, please let the Editor lego team know about it
const $1829e3410f9040f1$export$d4a08ec0aa6e0cef = {
    plugins: [
        'featureFlagsContextPlugin',
        'compositionPlugin',
        'inlineCursorTargetPlugin',
        'typeAhead',
        'typeAheadInsertItem',
        'focusHandlerPlugin',
        'frozenEditor',
        'submitEditor',
        'saveOnEnter',
        'customAutoformatting',
        'newlinePreserveMarksPlugin',
        'imageUpload',
        'imageUploadInputRule',
        'clipboard',
        'paste',
        'pasteKeymap',
        'mention',
        'mentionInputRule',
        'mentionKeymap',
        'emoji',
        'placeholderText',
        'emojiInputRule',
        'emojiKeymap',
        'emojiAsciiInputRule',
        'blockType',
        'quickInsert',
        'tasksAndDecisions',
        'blockTypeInputRule',
        'tasksAndDecisionsInputRule',
        'list',
        'typeAheadKeymap',
        'typeAheadInputRule',
        'date',
        'dateKeymap',
        // This should be always after `typeAheadKeymap` & `emojiKeymap`
        'indentationKeymap',
        'textColor',
        'highlight',
        'highlightKeymap',
        'alignmentPlugin',
        'listInputRule',
        'listKeymap',
        'codeBlock',
        'codeBlockIDEKeyBindings',
        'codeBlockKeyMap',
        'textFormatting',
        'textFormattingCursor',
        'textFormattingInputRule',
        'textFormattingSmartRule',
        'textFormattingClear',
        'textFormattingKeymap',
        // task/decisions keymap needs to be above table keymap so can indent actions in a table
        'tasksAndDecisionsKeyMap',
        // expand and table keymaps need to be above selection keymap to add their custom selection behaviour:
        // https://product-fabric.atlassian.net/wiki/spaces/E/pages/1113098008/Selection+Guide#Special-Cases
        'expandKeymap',
        'tableSelectionKeymap',
        'tableKeymap',
        'captionKeymap',
        // media keymap above selection keymap to allow navigating past the mediaSingle node
        'mediaKeymap',
        // selection keymap needs to be above gap cursor keymap so it can set node selections from
        // left/right arrows
        'selectionKeymap',
        'gapCursorKeymap',
        'gapCursor',
        'syncUrlText',
        'fakeCursorToolbarPlugin',
        'hyperLink',
        'table',
        'tableDecorations',
        'hyperlinkInputRule',
        'tablePMColResizing',
        'hyperlinkKeymap',
        'tableColResizing',
        'undoRedoKeyMap',
        'blockTypeKeyMap',
        'tableEditing',
        'filterStepsPlugin',
        'pmCollab',
        'collab',
        'ruleInputRule',
        'ruleKeymap',
        'panel',
        'media',
        'mediaSingleKeymap',
        'mediaEditor',
        'unsupportedContent',
        'jiraIssue',
        'helpDialog',
        'helpDialogKeymap',
        'macro',
        'expand',
        'extension',
        'layout',
        'contextPanel',
        'selectionToolbar',
        'floatingToolbar',
        'clearMarksOnChange',
        'reactNodeView',
        'history',
        'undoRedoPlugin',
        'codeBlockIndent',
        'placeholder',
        'width',
        'maxContentSize',
        'multilineContent',
        'grid',
        'mobileDimensions',
        'scrollGutterPlugin',
        'analytics',
        'findReplace',
        'selection',
        'avatarGroup',
        'viewUpdateSubscription',
        'beforePrimaryToolbar',
        'inlineCode'
    ],
    nodes: [
        'doc',
        'paragraph',
        'text',
        'bulletList',
        'orderedList',
        'listItem',
        'heading',
        'blockquote',
        'codeBlock',
        'rule',
        'panel',
        'mention',
        'confluenceUnsupportedBlock',
        'confluenceUnsupportedInline',
        'unsupportedBlock',
        'unsupportedInline',
        'confluenceJiraIssue',
        'hardBreak',
        'emoji',
        'placeholder',
        'mediaSingle',
        'mediaGroup',
        'table',
        'expand',
        'nestedExpand',
        'media',
        'tableHeader',
        'decisionList',
        'tableRow',
        'decisionItem',
        'tableCell',
        'taskList',
        'taskItem',
        'extension',
        'bodiedExtension',
        'multiBodiedExtension',
        'inlineExtension',
        'layoutSection',
        'layoutColumn',
        'inlineCard',
        'blockCard',
        'embedCard'
    ],
    marks: [
        // Fragment mark is both for inline and block elements
        'fragment',
        // Inline marks
        'link',
        'em',
        'strong',
        'textColor',
        'backgroundColor',
        'strike',
        'subsup',
        'underline',
        'code',
        'typeAheadQuery',
        // Block marks
        'alignment',
        'breakout',
        'indentation',
        'annotation',
        'dataConsumer',
        'border',
        // Unsupported mark
        'unsupportedMark',
        'unsupportedNodeAttribute'
    ]
};
function $1829e3410f9040f1$export$49afdc3354d5c84e(item) {
    return function(a, b) {
        return $1829e3410f9040f1$export$d4a08ec0aa6e0cef[item].indexOf(a.name) - $1829e3410f9040f1$export$d4a08ec0aa6e0cef[item].indexOf(b.name);
    };
}
function $1829e3410f9040f1$export$b4ae7ad1c009d0a1(item) {
    return function(a, b) {
        return $1829e3410f9040f1$export$d4a08ec0aa6e0cef[item].indexOf(a.type.name) - $1829e3410f9040f1$export$d4a08ec0aa6e0cef[item].indexOf(b.type.name);
    };
}

});

parcelRegister("9CUJY", function(module, exports) {

$parcel$export(module.exports, "createEditorStateNotificationPlugin", () => $0857bd5143cc04f2$export$e0355cecc74597d);

var $1S4f7 = parcelRequire("1S4f7");

var $7T7aA = parcelRequire("7T7aA");

var $dh538 = parcelRequire("dh538");
const $0857bd5143cc04f2$var$key = new (0, $7T7aA.PluginKey)('editorStateNotificationPlugin');
const $0857bd5143cc04f2$export$e0355cecc74597d = (onEditorStateUpdated, onEditorViewStateUpdatedCallbacks)=>{
    let transactions = [];
    return new (0, $1S4f7.SafePlugin)({
        key: $0857bd5143cc04f2$var$key,
        state: {
            init () {
                return {
                    latestTransaction: undefined
                };
            },
            apply (tr) {
                transactions.push(tr);
                return {
                    latestTransaction: tr
                };
            }
        },
        view: ()=>{
            return {
                update: (view, oldEditorState)=>{
                    const originalTransaction = $0857bd5143cc04f2$var$key.getState(view.state)?.latestTransaction;
                    if (originalTransaction && (0, $dh538.fg)('platform_editor_migrate_state_updates')) {
                        onEditorViewStateUpdatedCallbacks.forEach((entry)=>{
                            entry.callback({
                                originalTransaction: originalTransaction,
                                transactions: transactions,
                                oldEditorState: oldEditorState,
                                newEditorState: view.state
                            });
                        });
                        transactions = [];
                    }
                    onEditorStateUpdated({
                        oldEditorState: oldEditorState,
                        newEditorState: view.state
                    });
                }
            };
        }
    });
};

});


parcelRegister("1B55v", function(module, exports) {

$parcel$export(module.exports, "getDefaultPresetOptionsFromEditorProps", () => $a071074fd2398ee1$export$fdea1e40b8747a5b);
$parcel$export(module.exports, "default", () => $a071074fd2398ee1$export$2e2bcd8739ae039);

var $6DQRK = parcelRequire("6DQRK");

var $geLSP = parcelRequire("geLSP");
const $a071074fd2398ee1$var$isCodeBlockAllowed = (options)=>{
    const exclude = options && options.allowBlockType && options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
    return exclude.indexOf('codeBlock') === -1;
};
function $a071074fd2398ee1$export$f94443780f769f8(props) {
    const { appearance: appearance } = props;
    if ((0, $geLSP.isFullPage)(appearance)) // Full Page appearance uses a scrollable div wrapper.
    return {
        getScrollElement: ()=>document.querySelector('.fabric-editor-popup-scroll-parent')
    };
    return undefined;
}
function $a071074fd2398ee1$export$fdea1e40b8747a5b(props, createAnalyticsEvent) {
    const appearance = props.appearance;
    const cardOptions = props.linking?.smartLinks || props.smartLinks || props.UNSAFE_cards;
    return {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent,
        typeAhead: {
            isMobile: false
        },
        featureFlags: (0, $6DQRK.createFeatureFlagsFromProps)(props.featureFlags),
        paste: {
            cardOptions: cardOptions,
            sanitizePrivateContent: props.sanitizePrivateContent
        },
        base: {
            allowInlineCursorTarget: true,
            allowScrollGutter: $a071074fd2398ee1$export$f94443780f769f8(props)
        },
        blockType: {
            lastNodeMustBeParagraph: appearance === 'comment' || appearance === 'chromeless',
            allowBlockType: props.allowBlockType,
            isUndoRedoButtonsEnabled: props.allowUndoRedoButtons
        },
        placeholder: {
            placeholder: props.placeholder,
            placeholderBracketHint: props.placeholderBracketHint
        },
        textFormatting: {
            ...props.textFormatting || {},
            responsiveToolbarMenu: props.textFormatting?.responsiveToolbarMenu != null ? props.textFormatting.responsiveToolbarMenu : props.allowUndoRedoButtons
        },
        submitEditor: props.onSave,
        quickInsert: {
            enableElementBrowser: props.elementBrowser && props.elementBrowser.showModal,
            elementBrowserHelpUrl: props.elementBrowser && props.elementBrowser.helpUrl,
            disableDefaultItems: false,
            headless: false,
            emptyStateHandler: props.elementBrowser && props.elementBrowser.emptyStateHandler,
            prioritySortingFn: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.prioritySortingFn || undefined,
            onInsert: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.onInsert || undefined
        },
        selection: {
            useLongPressSelection: false
        },
        hyperlinkOptions: {
            editorAppearance: props.appearance,
            linkPicker: props.linking?.linkPicker,
            onClickCallback: cardOptions?.onClickCallback,
            platform: 'web'
        },
        codeBlock: {
            ...props.codeBlock,
            useLongPressSelection: false,
            allowCompositionInputOverride: false
        }
    };
}
function $a071074fd2398ee1$export$2e2bcd8739ae039(// eslint-disable-next-line @typescript-eslint/no-explicit-any
preset, props, pluginInjectionAPI) {
    const excludes = new Set();
    if (!$a071074fd2398ee1$var$isCodeBlockAllowed({
        allowBlockType: props.allowBlockType
    })) excludes.add('codeBlock');
    return preset.build({
        pluginInjectionAPI: pluginInjectionAPI,
        excludePlugins: excludes
    });
}

});

parcelRegister("a0rZe", function(module, exports) {

$parcel$export(module.exports, "createSchema", () => $083bb79fcbe2f990$export$5f4ce795563f4211);

var $8Nly5 = parcelRequire("8Nly5");

var $2oGxU = parcelRequire("2oGxU");

var $6VsTy = parcelRequire("6VsTy");

var $kviC1 = parcelRequire("kviC1");

var $4T0J6 = parcelRequire("4T0J6");
const $083bb79fcbe2f990$export$29c1e593063b23a7 = ({ nodeOrMark: nodeOrMark, domSpec: domSpec })=>{
    if (!Array.isArray(domSpec)) return domSpec;
    const maybeDefinedAttributes = domSpec[1];
    const metadata = (0, $6VsTy.createProseMirrorMetadata)(nodeOrMark);
    const hasDefinedAttributes = typeof maybeDefinedAttributes === 'object' && !Array.isArray(maybeDefinedAttributes);
    if (hasDefinedAttributes) domSpec[1] = Object.assign(maybeDefinedAttributes, metadata);
    else domSpec.splice(1, 0, metadata);
    return domSpec;
};
const $083bb79fcbe2f990$export$48404bb361c0cbc1 = (toDOM)=>{
    return new Proxy(toDOM, {
        apply (target, thisArg, argumentsList) {
            const domSpec = Reflect.apply(target, thisArg, argumentsList);
            if (!Array.isArray(domSpec)) return domSpec;
            const nodeOrMark = argumentsList[0];
            return $083bb79fcbe2f990$export$29c1e593063b23a7({
                nodeOrMark: nodeOrMark,
                domSpec: domSpec
            });
        }
    });
};
const $083bb79fcbe2f990$export$83e999ea28e263f4 = (spec)=>{
    return new Proxy(spec, {
        get (target, prop, receiver) {
            const result = Reflect.get(target, prop, receiver);
            if (prop === 'toDOM' && typeof result === 'function') return $083bb79fcbe2f990$export$48404bb361c0cbc1(result);
            return result;
        }
    });
};
function $083bb79fcbe2f990$export$5f4ce795563f4211(editorConfig) {
    const marks = (0, $4T0J6.fixExcludes)(editorConfig.marks.sort((0, $2oGxU.sortByOrder)('marks')).reduce((acc, mark)=>{
        acc[mark.name] = $083bb79fcbe2f990$export$83e999ea28e263f4(mark.mark);
        return acc;
    }, {}));
    const nodes = (0, $8Nly5.sanitizeNodes)(editorConfig.nodes.sort((0, $2oGxU.sortByOrder)('nodes')).reduce((acc, node)=>{
        acc[node.name] = $083bb79fcbe2f990$export$83e999ea28e263f4(node.node);
        return acc;
    }, {}), marks);
    return new (0, $kviC1.Schema)({
        nodes: nodes,
        marks: marks
    });
}

});

parcelRegister("2q16N", function(module, exports) {

$parcel$export(module.exports, "editorMessages", () => $170f814baa647977$export$3b488057bfc1868f);

var $2nPZH = parcelRequire("2nPZH");
const $170f814baa647977$export$3b488057bfc1868f = (0, $2nPZH.defineMessages)({
    editorAssistiveLabel: {
        id: "fabric.editor.editorAssistiveLabel",
        defaultMessage: "Main content area, start typing to enter text."
    }
});

});

parcelRegister("kbBd7", function(module, exports) {

$parcel$export(module.exports, "getUAPrefix", () => $f1dc1dfba26b7751$export$11a24c7b1b4aab81);

var $d7ZU3 = parcelRequire("d7ZU3");
function $f1dc1dfba26b7751$export$11a24c7b1b4aab81() {
    if ((0, $d7ZU3.browser).chrome) return 'ua-chrome';
    else if ((0, $d7ZU3.browser).ie) return 'ua-ie';
    else if ((0, $d7ZU3.browser).gecko) return 'ua-firefox';
    else if ((0, $d7ZU3.browser).safari) return 'ua-safari';
    return '';
}

});

parcelRegister("dHwSr", function(module, exports) {

$parcel$export(module.exports, "handleEditorFocus", () => $565b25adcfad3caf$export$ebebb7f5b9271fd7);

var $gwFzn = parcelRequire("gwFzn");

var $7T7aA = parcelRequire("7T7aA");

var $dh538 = parcelRequire("dh538");
function $565b25adcfad3caf$export$ebebb7f5b9271fd7(view) {
    if (view?.hasFocus()) return;
    /**
	 * If startTransition is available (in React 18),
	 * don't use setTimeout as startTransition will be used in ReactEditorViewNext.
	 * setTimeout(fn, 0) will not defer the focus reliably in React 18 with
	 * concurrent rendering.
	 */ const react16OnlySetTimeout = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn)))?.startTransition && (0, $dh538.fg)('platform_editor_react_18_autofocus_fix') ? (fn)=>fn() : (fn)=>window.setTimeout(fn, 0);
    return react16OnlySetTimeout(()=>{
        // Due to race conditions during editor lifecycle transitions (e.g. SPA route changes during opening or closing)
        // where the view (and its internal docView) may have been destroyed, the timeout callback may fire on a stale view.
        // Bail out in that scenario to prevent operating on an unmounted view.
        if ((0, $dh538.fg)('platform_editor_posfromdom_null_fix')) {
            if (view?.isDestroyed) return;
        }
        if (view?.hasFocus()) return;
        if (!window.getSelection) {
            view?.focus();
            return;
        }
        const domSelection = window.getSelection();
        if (!domSelection || domSelection.rangeCount === 0) {
            view?.focus();
            return;
        }
        const range = domSelection.getRangeAt(0);
        // if selection is outside editor focus and exit
        if (view && range.startContainer.contains(view.dom)) {
            view.focus();
            return;
        }
        // set cursor/selection and focus
        const anchor = view?.posAtDOM(range.startContainer, range.startOffset);
        const head = view?.posAtDOM(range.endContainer, range.endOffset);
        // if anchor or head < 0 focus and exit
        if (anchor && anchor < 0 || head && head < 0) {
            view?.focus();
            return;
        }
        if (view && anchor) {
            const selection = (0, $7T7aA.TextSelection).create(view.state.doc, anchor, head);
            const tr = view.state.tr.setSelection(selection);
            view.dispatch(tr);
            view.focus();
        }
    });
}

});

parcelRegister("cUiRv", function(module, exports) {

$parcel$export(module.exports, "useDispatchTransaction", () => $f260cf531ae15748$export$b582387940572fe7);

var $gwFzn = parcelRequire("gwFzn");

var $d925B = parcelRequire("d925B");
var $4VpM8 = parcelRequire("4VpM8");

var $56Wjx = parcelRequire("56Wjx");

var $2T4ch = parcelRequire("2T4ch");

var $dh538 = parcelRequire("dh538");

var $TRQ5b = parcelRequire("TRQ5b");

var $jNGLw = parcelRequire("jNGLw");

var $8IgYx = parcelRequire("8IgYx");

var $bE9x1 = parcelRequire("bE9x1");
const $f260cf531ae15748$export$b582387940572fe7 = ({ onChange: onChange, dispatchAnalyticsEvent: dispatchAnalyticsEvent, onEditorViewUpdated: onEditorViewUpdated, isRemoteReplaceDocumentTransaction: isRemoteReplaceDocumentTransaction })=>{
    // We need to have a ref to the latest `onChange` since the `dispatchTransaction` gets captured
    const onChangeRef = (0, $gwFzn.useRef)(onChange);
    (0, $gwFzn.useEffect)(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    const dispatchTransaction = (0, $gwFzn.useCallback)((view, unsafeTransaction)=>{
        if (!view) return;
        const nodes = (0, $TRQ5b.findChangedNodesFromTransaction)(unsafeTransaction);
        const changedNodesValid = (0, $bE9x1.validateNodes)(nodes);
        const transaction = new Proxy(unsafeTransaction, (0, $jNGLw.freezeUnsafeTransactionProperties)({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginKey: 'unknown-reacteditorview'
        }));
        // If the transaction is a remote replaceDocument transaction, we should skip validation.
        // Remote replaceDocument transactions are fired when the document is replaced by initialization of editor-plugin-collab-edit
        // If there is a discrepancy in the ProseMirror schema at initialization, it results in the editor being loaded with no content,
        // giving the user the impression that content has been lost
        const isRemoteReplace = isRemoteReplaceDocumentTransaction ? (0, $dh538.fg)('platform_editor_transaction_skip_validation') && isRemoteReplaceDocumentTransaction(transaction) : false;
        if (changedNodesValid || isRemoteReplace) {
            const oldEditorState = view.state;
            // go ahead and update the state now we know the transaction is good
            const { state: newEditorState, transactions: transactions } = view.state.applyTransaction(transaction);
            if (newEditorState === oldEditorState) return;
            view.updateState(newEditorState);
            onEditorViewUpdated({
                originalTransaction: transaction,
                transactions: transactions,
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            });
            if (onChangeRef.current && transaction.docChanged) {
                const source = transaction.getMeta('isRemote') ? 'remote' : 'local';
                (0, $2T4ch.startMeasure)((0, $8IgYx.EVENT_NAME_ON_CHANGE));
                onChangeRef.current(view, {
                    source: source
                });
                (0, $2T4ch.stopMeasure)((0, $8IgYx.EVENT_NAME_ON_CHANGE));
            }
        }
        if (!changedNodesValid) {
            const invalidNodes = nodes.filter((node)=>!(0, $bE9x1.validNode)(node)).map((node)=>(0, $56Wjx.getDocStructure)(node, {
                    compact: true
                }));
            dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).DISPATCHED_INVALID_TRANSACTION,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    analyticsEventPayloads: (0, $4VpM8.getAnalyticsEventsFromTransaction)(transaction),
                    invalidNodes: invalidNodes,
                    ...(0, $dh538.fg)('platform_editor_transaction_skip_validation') ? {
                        isRemoteReplaceDocumentTransaction: isRemoteReplace
                    } : {}
                }
            });
        }
    }, [
        dispatchAnalyticsEvent,
        onEditorViewUpdated,
        isRemoteReplaceDocumentTransaction
    ]);
    return dispatchTransaction;
};

});
parcelRegister("4VpM8", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsEventsFromTransaction", () => $62c5e4b0ecece381$export$d9985be1ece4b7ee);

var $lTYwY = parcelRequire("lTYwY");
function $62c5e4b0ecece381$export$d9985be1ece4b7ee(tr) {
    return tr.steps.filter((step)=>step instanceof (0, $lTYwY.AnalyticsStep)).reduce((acc, step)=>[
            ...acc,
            ...step.analyticsEvents
        ], []);
}

});

parcelRegister("TRQ5b", function(module, exports) {

$parcel$export(module.exports, "findChangedNodesFromTransaction", () => $015e54f1cc15a3ff$export$cdc577fd3f583194);

var $gWR1e = parcelRequire("gWR1e");

var $dh538 = parcelRequire("dh538");
const $015e54f1cc15a3ff$export$cdc577fd3f583194 = (tr)=>{
    const nodes = [];
    const steps = tr.steps || [];
    steps.forEach((step)=>{
        step.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node)=>{
                let nodeToCheck = node;
                if ((0, $dh538.fg)('cc_complexit_fe_improve_node_validation')) {
                    const { schema: schema } = tr.selection.$from.doc.type;
                    const parentNode = (0, $gWR1e.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(tr.selection);
                    nodeToCheck = parentNode ? parentNode.node : node;
                }
                if (!nodes.find((n)=>n === nodeToCheck)) nodes.push(nodeToCheck);
                return false;
            });
        });
    });
    return nodes;
};

});

parcelRegister("jNGLw", function(module, exports) {

$parcel$export(module.exports, "freezeUnsafeTransactionProperties", () => $b985ded6f19ca760$export$668aa008bdae439f);

var $d925B = parcelRequire("d925B");
const $b985ded6f19ca760$export$9f24e92219b6e945 = 'Setting an unsafe property on transaction after dispatch!';
// since selection uses curSelection under the hood, we guard setSelection instead
const $b985ded6f19ca760$var$isUnsafeMethod = (prop)=>[
        'setSelection'
    ].includes(prop.toString());
const $b985ded6f19ca760$var$isReadOnlyProperty = (prop)=>[
        'doc',
        'docs',
        'steps',
        'selection'
    ].includes(prop.toString());
const $b985ded6f19ca760$export$668aa008bdae439f = ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginKey: pluginKey })=>{
    const isUnsafe = ()=>{
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).TRANSACTION_MUTATED_AFTER_DISPATCH,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                pluginKey: pluginKey || 'unknown'
            }
        });
        throw new Error($b985ded6f19ca760$export$9f24e92219b6e945);
    };
    return {
        get: function(target, prop, receiver) {
            if ($b985ded6f19ca760$var$isUnsafeMethod(prop)) isUnsafe();
            return Reflect.get(target, prop, receiver);
        },
        set: function(target, prop, receiver) {
            if ($b985ded6f19ca760$var$isReadOnlyProperty(prop)) isUnsafe();
            return Reflect.set(target, prop, receiver);
        }
    };
};

});

parcelRegister("8IgYx", function(module, exports) {

$parcel$export(module.exports, "EVENT_NAME_ON_CHANGE", () => $a17905ab9de46c9b$export$bb82e7cfb8987f35);

var $aAn37 = parcelRequire("aAn37");

var $2T4ch = parcelRequire("2T4ch");

var $gpGrj = parcelRequire("gpGrj");
const $a17905ab9de46c9b$export$5e38f3b295505ec8 = `\u{1F989} EditorView::state::apply`;
const $a17905ab9de46c9b$export$646ca0d076c98ad5 = `\u{1F989} EditorView::updateState`;
const $a17905ab9de46c9b$export$2f488cec9729a7d6 = `\u{1F989} EditorView::onEditorViewStateUpdated`;
const $a17905ab9de46c9b$export$bb82e7cfb8987f35 = `\u{1F989} ReactEditorView::onChange`;
const $a17905ab9de46c9b$export$373baa16b824d295 = `\u{1F989} ReactEditorView::dispatchTransaction`;
const $a17905ab9de46c9b$export$735da5ee20c885d5 = false;
const $a17905ab9de46c9b$var$DEFAULT_SAMPLING_RATE = 100;
const $a17905ab9de46c9b$var$noop = ()=>{};
class $a17905ab9de46c9b$export$7a054319813aafa {
    addMeasureListener(listener) {
        this.measureListeners.push(listener);
    }
    removeMeasureListener(listener) {
        const index = this.measureListeners.indexOf(listener);
        if (index > -1) this.measureListeners.splice(index, 1);
    }
    shouldTrackTransaction(options) {
        const { enabled: trackingEnabled, samplingRate: samplingRate = $a17905ab9de46c9b$var$DEFAULT_SAMPLING_RATE } = options;
        return trackingEnabled && this.dispatchCallCounter === samplingRate;
    }
    constructor(){
        // Counter so we can rate limit the transaction performance tracking
        this.dispatchCallCounter = 0;
        // A map containing the time which measurement starts
        this.measureMap = new Map();
        this.measureListeners = [];
        this.bumpDispatchCounter = (options)=>{
            const { enabled: trackingEnabled, samplingRate: samplingRate = $a17905ab9de46c9b$var$DEFAULT_SAMPLING_RATE } = options;
            if (trackingEnabled) {
                if (this.dispatchCallCounter >= samplingRate) this.dispatchCallCounter = 0;
                this.dispatchCallCounter++;
            }
            return this.dispatchCallCounter;
        };
        this.getMeasureHelpers = (options)=>{
            const { usePerformanceMarks: usePerformanceMarks = $a17905ab9de46c9b$export$735da5ee20c885d5 } = options;
            if (!this.shouldTrackTransaction(options)) return {
                startMeasure: $a17905ab9de46c9b$var$noop,
                stopMeasure: $a17905ab9de46c9b$var$noop
            };
            return {
                startMeasure: usePerformanceMarks ? (0, $2T4ch.startMeasure) : this.startMeasureSimple,
                stopMeasure: usePerformanceMarks ? (0, $2T4ch.stopMeasure) : this.stopMeasureSimple
            };
        };
        this.startMeasureSimple = (measureName)=>{
            if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
            this.measureMap.set(measureName, performance.now());
        };
        this.stopMeasureSimple = (measureName, onMeasureComplete)=>{
            if (!(0, $aAn37.isPerformanceAPIAvailable)()) return;
            const startTime = this.measureMap.get(measureName);
            if (startTime) {
                const duration = (0, $gpGrj.getTimeSince)(startTime);
                this.measureMap.delete(measureName);
                if (onMeasureComplete) onMeasureComplete(duration, startTime);
                // Call each subscribed listener
                this.measureListeners.forEach((listener)=>listener({
                        name: measureName,
                        duration: duration,
                        startTime: startTime
                    }));
            }
        };
    }
}

});
parcelRegister("gpGrj", function(module, exports) {

$parcel$export(module.exports, "getTimeSince", () => $1d60a1b0507e65ba$export$a26b90db2c8f1b97);
/**
 * Calculate the difference between performance.now() and the given startTime.
 * This allows for the timing to be overridable during tests.
 *
 * @param startTime DOMHighResTimeStamp
 * @returns DOMHighResTimeStamp
 */ const $1d60a1b0507e65ba$export$a26b90db2c8f1b97 = (startTime)=>performance.now() - startTime;

});


parcelRegister("bE9x1", function(module, exports) {

$parcel$export(module.exports, "validNode", () => $e81162bdf75802d2$export$4c39e41e39b3c449);
$parcel$export(module.exports, "validateNodes", () => $e81162bdf75802d2$export$996213f7c272fc6f);
const $e81162bdf75802d2$export$4c39e41e39b3c449 = (node)=>{
    try {
        node.check(); // this will throw an error if the node is invalid
    } catch (error) {
        return false;
    }
    return true;
};
const $e81162bdf75802d2$export$996213f7c272fc6f = (nodes)=>nodes.every($e81162bdf75802d2$export$4c39e41e39b3c449);

});


parcelRegister("hQcZ1", function(module, exports) {

$parcel$export(module.exports, "useFireFullWidthEvent", () => $5953f1dbb50e9aa2$export$4998b7b36606f9c3);

var $gwFzn = parcelRequire("gwFzn");

var $d925B = parcelRequire("d925B");

var $7541v = parcelRequire("7541v");

var $9tU17 = parcelRequire("9tU17");
const $5953f1dbb50e9aa2$export$4998b7b36606f9c3 = (appearance, dispatchAnalyticsEvent)=>{
    const previousAppearance = (0, $7541v.default)(appearance);
    (0, $gwFzn.useEffect)(()=>{
        if (appearance !== previousAppearance) {
            if (appearance === 'full-width' || previousAppearance === 'full-width') dispatchAnalyticsEvent({
                action: (0, $d925B.ACTION).CHANGED_FULL_WIDTH_MODE,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    previousMode: (0, $9tU17.formatFullWidthAppearance)(previousAppearance),
                    newMode: (0, $9tU17.formatFullWidthAppearance)(appearance)
                }
            });
        }
    }, [
        appearance,
        previousAppearance,
        dispatchAnalyticsEvent
    ]);
};

});
parcelRegister("9tU17", function(module, exports) {

$parcel$export(module.exports, "formatFullWidthAppearance", () => $2507994582b7e2f3$export$47d5b79f3ddf0b92);

var $e2wMq = parcelRequire("e2wMq");
const $2507994582b7e2f3$export$47d5b79f3ddf0b92 = (appearance)=>{
    if (appearance === 'full-width') return (0, $e2wMq.FULL_WIDTH_MODE).FULL_WIDTH;
    return (0, $e2wMq.FULL_WIDTH_MODE).FIXED_WIDTH;
};

});



parcelRegister("f8zg2", function(module, exports) {

$parcel$export(module.exports, "IntlProviderIfMissingWrapper", () => $2dfeb0eb8ad08222$export$742fe272b8921eea);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");
var $hlhtG = parcelRequire("hlhtG");
const $2dfeb0eb8ad08222$var$useCheckIntlContext = ()=>(0, $gwFzn.useContext)((0, $js7oX.Context)) === null;
function $2dfeb0eb8ad08222$export$742fe272b8921eea({ children: children }) {
    const missingIntlContext = $2dfeb0eb8ad08222$var$useCheckIntlContext();
    if (missingIntlContext) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hlhtG.default), {
        locale: "en",
        children: children
    });
    return children;
}

});

parcelRegister("lJ3BR", function(module, exports) {

$parcel$export(module.exports, "BaseThemeWrapper", () => $67f6e75f4f4df09d$export$3de34996b814f0f0);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ja596 = parcelRequire("ja596");

var $aFUXX = parcelRequire("aFUXX");
// Default value from: `import { fontSize } from '@atlaskit/theme/constants';`
const $67f6e75f4f4df09d$var$defaultFontSize = 14;
function $67f6e75f4f4df09d$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $gwFzn.useMemo)(()=>({
            baseFontSize: baseFontSize || $67f6e75f4f4df09d$var$defaultFontSize,
            layoutMaxWidth: (0, $aFUXX.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ja596.a), {
        theme: memoizedTheme,
        children: children
    });
}

});

parcelRegister("jTtEd", function(module, exports) {

$parcel$export(module.exports, "getBaseFontSize", () => $8e2fd2af7fc541b0$export$8e2864079bc476bd);

var $aFUXX = parcelRequire("aFUXX");
function $8e2fd2af7fc541b0$export$8e2864079bc476bd(appearance) {
    if (appearance === undefined) return 0, $aFUXX.akEditorFullPageDefaultFontSize;
    return ![
        'comment',
        'chromeless'
    ].includes(appearance) ? (0, $aFUXX.akEditorFullPageDefaultFontSize) : undefined;
}

});


parcelRegister("eilyC", function(module, exports) {

$parcel$export(module.exports, "default", () => $4672b7597b696155$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $d925B = parcelRequire("d925B");

var $2T4ch = parcelRequire("2T4ch");

var $7lreV = parcelRequire("7lreV");

var $amGDM = parcelRequire("amGDM");

var $el1xD = parcelRequire("el1xD");
function $4672b7597b696155$export$2e2bcd8739ae039(props, createAnalyticsEvent) {
    (0, $el1xD.default)();
    (0, $gwFzn.useEffect)(()=>{
        (0, $2T4ch.stopMeasure)((0, $7lreV.default).EDITOR_MOUNTED, (0, $amGDM.default)((0, $d925B.ACTION).EDITOR_MOUNTED, props, createAnalyticsEvent));
        return ()=>{
            (0, $2T4ch.clearMeasure)((0, $7lreV.default).EDITOR_MOUNTED);
            (0, $2T4ch.clearMeasure)((0, $7lreV.default).ON_EDITOR_READY_CALLBACK);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
// Disable Exhaustive Deps here since we only want to stop the measure on mount.
}

});
parcelRegister("amGDM", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea8d7238f61ed9d1$export$2e2bcd8739ae039);

var $d925B = parcelRequire("d925B");
var $ajtqX = parcelRequire("ajtqX");
function $ea8d7238f61ed9d1$export$2e2bcd8739ae039(action, props, createAnalyticsEvent) {
    return async (duration, startTime)=>{
        const contextIdentifier = await props.contextIdentifierProvider;
        const objectId = contextIdentifier?.objectId;
        if (createAnalyticsEvent) (0, $ajtqX.fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: action,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                attributes: {
                    duration: duration,
                    startTime: startTime,
                    objectId: objectId
                },
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            }
        });
    };
}

});

parcelRegister("el1xD", function(module, exports) {

$parcel$export(module.exports, "default", () => $04f7f6d8a5e7af43$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9HtP4 = parcelRequire("9HtP4");

var $2T4ch = parcelRequire("2T4ch");

var $7lreV = parcelRequire("7lreV");
function $04f7f6d8a5e7af43$export$2e2bcd8739ae039() {
    (0, $9HtP4.default)(()=>{
        (0, $2T4ch.startMeasure)((0, $7lreV.default).EDITOR_MOUNTED);
    });
}

});


parcelRegister("19Ub2", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b1b779d278e7645$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");
const $1b1b779d278e7645$export$d9d7e48a5f16fb4d = (passedProps)=>{
    const memodProps = (0, $gwFzn.useMemo)(()=>{
        // That sounds awful but this is the only way to make sure we didn't missed any EditorProps
        const allProps = {
            preset: passedProps.preset,
            appearance: passedProps.appearance,
            contentComponents: passedProps.contentComponents,
            primaryToolbarIconBefore: passedProps.primaryToolbarIconBefore,
            secondaryToolbarComponents: passedProps.secondaryToolbarComponents,
            persistScrollGutter: passedProps.persistScrollGutter,
            quickInsert: passedProps.quickInsert,
            shouldFocus: passedProps.shouldFocus,
            disabled: passedProps.disabled,
            contextPanel: passedProps.contextPanel,
            errorReporterHandler: passedProps.errorReporterHandler,
            contentTransformerProvider: passedProps.contentTransformerProvider,
            maxHeight: passedProps.maxHeight,
            minHeight: passedProps.minHeight,
            placeholder: passedProps.placeholder,
            placeholderBracketHint: passedProps.placeholderBracketHint,
            defaultValue: passedProps.defaultValue,
            assistiveLabel: passedProps.assistiveLabel,
            assistiveDescribedBy: passedProps.assistiveDescribedBy,
            popupsMountPoint: passedProps.popupsMountPoint,
            popupsBoundariesElement: passedProps.popupsBoundariesElement,
            popupsScrollableElement: passedProps.popupsScrollableElement,
            editorActions: passedProps.editorActions,
            onEditorReady: passedProps.onEditorReady,
            onDestroy: passedProps.onDestroy,
            onChange: passedProps.onChange,
            onCancel: passedProps.onCancel,
            extensionProviders: passedProps.extensionProviders,
            UNSAFE_useAnalyticsContext: passedProps.UNSAFE_useAnalyticsContext,
            useStickyToolbar: passedProps.useStickyToolbar,
            featureFlags: passedProps.featureFlags,
            onSave: passedProps.onSave,
            sanitizePrivateContent: passedProps.sanitizePrivateContent,
            media: passedProps.media,
            collabEdit: passedProps.collabEdit,
            primaryToolbarComponents: passedProps.primaryToolbarComponents,
            performanceTracking: passedProps.performanceTracking,
            inputSamplingLimit: passedProps.inputSamplingLimit,
            allowUndoRedoButtons: passedProps.allowUndoRedoButtons,
            linking: passedProps.linking,
            activityProvider: passedProps.activityProvider,
            searchProvider: passedProps.searchProvider,
            annotationProviders: passedProps.annotationProviders,
            collabEditProvider: passedProps.collabEditProvider,
            presenceProvider: passedProps.presenceProvider,
            emojiProvider: passedProps.emojiProvider,
            taskDecisionProvider: passedProps.taskDecisionProvider,
            legacyImageUploadProvider: passedProps.legacyImageUploadProvider,
            mentionProvider: passedProps.mentionProvider,
            autoformattingProvider: passedProps.autoformattingProvider,
            macroProvider: passedProps.macroProvider,
            contextIdentifierProvider: passedProps.contextIdentifierProvider,
            allowExpand: passedProps.allowExpand,
            allowNestedTasks: passedProps.allowNestedTasks,
            allowBlockType: passedProps.allowBlockType,
            allowTasksAndDecisions: passedProps.allowTasksAndDecisions,
            allowBreakout: passedProps.allowBreakout,
            allowRule: passedProps.allowRule,
            allowHelpDialog: passedProps.allowHelpDialog,
            allowPanel: passedProps.allowPanel,
            allowExtension: passedProps.allowExtension,
            allowConfluenceInlineComment: passedProps.allowConfluenceInlineComment,
            allowTemplatePlaceholders: passedProps.allowTemplatePlaceholders,
            allowDate: passedProps.allowDate,
            allowLayouts: passedProps.allowLayouts,
            allowStatus: passedProps.allowStatus,
            allowTextAlignment: passedProps.allowTextAlignment,
            allowIndentation: passedProps.allowIndentation,
            showIndentationButtons: passedProps.showIndentationButtons,
            allowFindReplace: passedProps.allowFindReplace,
            allowBorderMark: passedProps.allowBorderMark,
            allowFragmentMark: passedProps.allowFragmentMark,
            autoScrollIntoView: passedProps.autoScrollIntoView,
            elementBrowser: passedProps.elementBrowser,
            maxContentSize: passedProps.maxContentSize,
            saveOnEnter: passedProps.saveOnEnter,
            feedbackInfo: passedProps.feedbackInfo,
            mention: passedProps.mention,
            mentionInsertDisplayName: passedProps.mentionInsertDisplayName,
            uploadErrorHandler: passedProps.uploadErrorHandler,
            waitForMediaUpload: passedProps.waitForMediaUpload,
            extensionHandlers: passedProps.extensionHandlers,
            allowTextColor: passedProps.allowTextColor,
            allowTables: passedProps.allowTables,
            insertMenuItems: passedProps.insertMenuItems,
            UNSAFE_cards: passedProps.UNSAFE_cards,
            smartLinks: passedProps.smartLinks,
            allowAnalyticsGASV3: passedProps.allowAnalyticsGASV3,
            codeBlock: passedProps.codeBlock,
            textFormatting: passedProps.textFormatting,
            __livePage: passedProps.__livePage,
            AppearanceComponent: passedProps.AppearanceComponent,
            skipValidation: passedProps.skipValidation
        };
        const defaultProps = {
            appearance: 'comment',
            disabled: false,
            quickInsert: true
        };
        const nextProps = {
            ...defaultProps,
            ...allProps
        };
        return nextProps;
    }, [
        passedProps.preset,
        passedProps.appearance,
        passedProps.contentComponents,
        passedProps.primaryToolbarIconBefore,
        passedProps.secondaryToolbarComponents,
        passedProps.persistScrollGutter,
        passedProps.quickInsert,
        passedProps.shouldFocus,
        passedProps.disabled,
        passedProps.contextPanel,
        passedProps.errorReporterHandler,
        passedProps.contentTransformerProvider,
        passedProps.maxHeight,
        passedProps.minHeight,
        passedProps.placeholder,
        passedProps.placeholderBracketHint,
        passedProps.performanceTracking,
        passedProps.inputSamplingLimit,
        passedProps.defaultValue,
        passedProps.assistiveLabel,
        passedProps.assistiveDescribedBy,
        passedProps.popupsMountPoint,
        passedProps.popupsBoundariesElement,
        passedProps.popupsScrollableElement,
        passedProps.editorActions,
        passedProps.onEditorReady,
        passedProps.onDestroy,
        passedProps.onChange,
        passedProps.onCancel,
        passedProps.extensionProviders,
        passedProps.UNSAFE_useAnalyticsContext,
        passedProps.useStickyToolbar,
        passedProps.featureFlags,
        passedProps.onSave,
        passedProps.sanitizePrivateContent,
        passedProps.media,
        passedProps.collabEdit,
        passedProps.primaryToolbarComponents,
        passedProps.allowUndoRedoButtons,
        passedProps.linking,
        passedProps.activityProvider,
        passedProps.searchProvider,
        passedProps.annotationProviders,
        passedProps.collabEditProvider,
        passedProps.presenceProvider,
        passedProps.emojiProvider,
        passedProps.taskDecisionProvider,
        passedProps.legacyImageUploadProvider,
        passedProps.mentionProvider,
        passedProps.autoformattingProvider,
        passedProps.macroProvider,
        passedProps.contextIdentifierProvider,
        passedProps.allowExpand,
        passedProps.allowNestedTasks,
        passedProps.allowBlockType,
        passedProps.allowTasksAndDecisions,
        passedProps.allowBreakout,
        passedProps.allowRule,
        passedProps.allowHelpDialog,
        passedProps.allowPanel,
        passedProps.allowExtension,
        passedProps.allowConfluenceInlineComment,
        passedProps.allowTemplatePlaceholders,
        passedProps.allowDate,
        passedProps.allowLayouts,
        passedProps.allowStatus,
        passedProps.allowTextAlignment,
        passedProps.allowIndentation,
        passedProps.showIndentationButtons,
        passedProps.allowFindReplace,
        passedProps.allowBorderMark,
        passedProps.allowFragmentMark,
        passedProps.autoScrollIntoView,
        passedProps.elementBrowser,
        passedProps.maxContentSize,
        passedProps.saveOnEnter,
        passedProps.feedbackInfo,
        passedProps.mention,
        passedProps.mentionInsertDisplayName,
        passedProps.uploadErrorHandler,
        passedProps.waitForMediaUpload,
        passedProps.extensionHandlers,
        passedProps.allowTextColor,
        passedProps.allowTables,
        passedProps.insertMenuItems,
        passedProps.UNSAFE_cards,
        passedProps.smartLinks,
        passedProps.allowAnalyticsGASV3,
        passedProps.codeBlock,
        passedProps.textFormatting,
        passedProps.__livePage,
        passedProps.AppearanceComponent,
        passedProps.skipValidation
    ]);
    return memodProps;
};
var $1b1b779d278e7645$export$2e2bcd8739ae039 = $1b1b779d278e7645$export$d9d7e48a5f16fb4d;

});

parcelRegister("1T1oM", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf88016029b1c3dc$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $4FxUL = parcelRequire("4FxUL");

var $ewD0v = parcelRequire("ewD0v");

var $g9y33 = parcelRequire("g9y33");

var $b5VLW = parcelRequire("b5VLW");

var $4G7Gx = parcelRequire("4G7Gx");
function $cf88016029b1c3dc$var$useEditorRef(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
preset) {
    const apiRef = (0, $gwFzn.useRef)();
    (0, $gwFzn.useEffect)(()=>{
        return preset?.apiResolver.on((api)=>{
            apiRef.current = api;
        });
    }, [
        preset?.apiResolver
    ]);
    return apiRef;
}
function $cf88016029b1c3dc$var$prepareProviders(editorActions, apiRef, quickInsert, extensionProviders, createAnalyticsEvent) {
    const extensionProvider = (0, $ewD0v.default)(()=>editorActions)(extensionProviders);
    const quickInsertProvider = (0, $g9y33.default)(editorActions, apiRef, extensionProvider, quickInsert, createAnalyticsEvent);
    return {
        extensionProvider: extensionProvider,
        quickInsertProvider: quickInsertProvider
    };
}
function $cf88016029b1c3dc$export$2e2bcd8739ae039(props, editorActions, createAnalyticsEvent) {
    const { autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider, quickInsert: quickInsert, extensionProviders: extensionProviders } = props;
    const providers = (0, $gwFzn.useMemo)(()=>(0, $b5VLW.default)({
            autoformattingProvider: autoformattingProvider,
            emojiProvider: emojiProvider,
            mentionProvider: mentionProvider,
            legacyImageUploadProvider: legacyImageUploadProvider,
            taskDecisionProvider: taskDecisionProvider,
            contextIdentifierProvider: contextIdentifierProvider,
            searchProvider: searchProvider,
            macroProvider: macroProvider,
            activityProvider: activityProvider,
            collabEdit: collabEdit,
            collabEditProvider: collabEditProvider,
            presenceProvider: presenceProvider
        }), [
        autoformattingProvider,
        emojiProvider,
        mentionProvider,
        legacyImageUploadProvider,
        taskDecisionProvider,
        contextIdentifierProvider,
        searchProvider,
        macroProvider,
        activityProvider,
        collabEdit,
        collabEditProvider,
        presenceProvider
    ]);
    const providerFactory = (0, $gwFzn.useRef)(new (0, $4FxUL.default)());
    const editorRef = $cf88016029b1c3dc$var$useEditorRef(props.preset);
    const preparedProviders = (0, $gwFzn.useMemo)(()=>// Though this will introduce some performance regression related to quick insert
        // loading but we can remove it soon when Forge will move to new API.
        // quickInsert={Promise.resolve(consumerQuickInsert)} is one of the main reason behind this performance issue.
        $cf88016029b1c3dc$var$prepareProviders(editorActions, editorRef, quickInsert, extensionProviders, createAnalyticsEvent), [
        extensionProviders,
        quickInsert,
        editorActions,
        createAnalyticsEvent,
        editorRef
    ]);
    (0, $gwFzn.useEffect)(()=>{
        (0, $4G7Gx.default)(providerFactory.current, providers, preparedProviders.extensionProvider, preparedProviders.quickInsertProvider);
    }, [
        providers,
        preparedProviders
    ]);
    // componentWillUnmount equivalent
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            // Disable this next line because it is not a React node
            // so we can safely call destroy on the ref.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            providerFactory.current.destroy();
        };
    }, []);
    return providerFactory.current;
}

});
parcelRegister("ewD0v", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b8bf99e5ea95e38$export$2e2bcd8739ae039);

var $csnse = parcelRequire("csnse");

var $eEmxu = parcelRequire("eEmxu");
function $9b8bf99e5ea95e38$var$prepareExtensionProvidersInternal(editorActions, extensionProviders) {
    if (!extensionProviders) return;
    if (typeof extensionProviders === 'function') return (0, $eEmxu.default)(extensionProviders(editorActions));
    return (0, $eEmxu.default)(extensionProviders);
}
const $9b8bf99e5ea95e38$var$prepareExtensionProvider = (getEditorActions)=>(0, $csnse.default)((extensionProviders)=>$9b8bf99e5ea95e38$var$prepareExtensionProvidersInternal(getEditorActions(), extensionProviders));
var $9b8bf99e5ea95e38$export$2e2bcd8739ae039 = $9b8bf99e5ea95e38$var$prepareExtensionProvider;

});

parcelRegister("g9y33", function(module, exports) {

$parcel$export(module.exports, "default", () => $857dcb67a4f61ef1$export$2e2bcd8739ae039);

var $b2s9f = parcelRequire("b2s9f");
function $857dcb67a4f61ef1$export$2e2bcd8739ae039(editorActions, apiRef, extensionProvider, quickInsert, createAnalyticsEvent) {
    const quickInsertProvider = quickInsert && typeof quickInsert !== 'boolean' && quickInsert.provider;
    const extensionQuickInsertProvider = extensionProvider && (0, $b2s9f.extensionProviderToQuickInsertProvider)(extensionProvider, editorActions, apiRef, createAnalyticsEvent);
    return quickInsertProvider && extensionQuickInsertProvider ? (0, $b2s9f.combineQuickInsertProviders)([
        quickInsertProvider,
        extensionQuickInsertProvider
    ]) : quickInsertProvider || extensionQuickInsertProvider;
}

});
parcelRegister("b2s9f", function(module, exports) {

$parcel$export(module.exports, "extensionProviderToQuickInsertProvider", () => $4a8f1fc352d7e11f$export$6b0bb34c2583056f);
$parcel$export(module.exports, "combineQuickInsertProviders", () => $4a8f1fc352d7e11f$export$e3759a254d73dcb7);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4wH3g = parcelRequire("4wH3g");

var $d925B = parcelRequire("d925B");
var $ajtqX = parcelRequire("ajtqX");

var $2cmfr = parcelRequire("2cmfr");
var $3jQ9y = parcelRequire("3jQ9y");

var $iScNA = parcelRequire("iScNA");

var $lWghV = parcelRequire("lWghV");

var $dh538 = parcelRequire("dh538");
/**
 * Utils to send analytics event when a extension is inserted using quickInsert
 */ function $4a8f1fc352d7e11f$var$sendExtensionQuickInsertAnalytics(item, selection, createAnalyticsEvent, source) {
    if (createAnalyticsEvent) {
        const insertLocation = (0, $dh538.fg)('platform_nested_nbm_analytics_location') ? (0, $lWghV.findInsertLocation)(selection) : undefined;
        (0, $ajtqX.fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: (0, $d925B.ACTION).INSERTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EXTENSION,
                attributes: {
                    extensionType: item.extensionType,
                    extensionKey: item.extensionKey,
                    key: item.key,
                    inputMethod: source || (0, $d925B.INPUT_METHOD).QUICK_INSERT,
                    ...insertLocation ? {
                        insertLocation: insertLocation
                    } : {}
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            }
        });
    }
}
const $4a8f1fc352d7e11f$var$showDummyAPIWarning = (location)=>{};
const $4a8f1fc352d7e11f$var$dummyExtensionAPI = {
    editInContextPanel: ()=>$4a8f1fc352d7e11f$var$showDummyAPIWarning('editInContextPanel'),
    _editInLegacyMacroBrowser: ()=>$4a8f1fc352d7e11f$var$showDummyAPIWarning('_editInLegacyMacroBrowser'),
    getNodeWithPosByLocalId: ()=>({
            node: null,
            pos: null
        }),
    doc: {
        insertAfter: ()=>$4a8f1fc352d7e11f$var$showDummyAPIWarning('doc:insertAfter'),
        scrollTo: ()=>$4a8f1fc352d7e11f$var$showDummyAPIWarning('doc:scrollTo'),
        update: ()=>$4a8f1fc352d7e11f$var$showDummyAPIWarning('doc:update')
    }
};
async function $4a8f1fc352d7e11f$export$6b0bb34c2583056f(extensionProvider, editorActions, apiRef, createAnalyticsEvent) {
    const extensions = await extensionProvider.getExtensions();
    return {
        getItems: ()=>{
            const quickInsertItems = (0, $2cmfr.getQuickInsertItemsFromModule)(extensions, (item)=>{
                const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
                    __loadable_id__: "N8xjw",
                    name: "Icon",
                    loader: item.icon,
                    loading: ()=>null
                });
                return {
                    title: item.title,
                    description: item.description,
                    icon: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
                            label: ""
                        }),
                    keywords: item.keywords,
                    featured: item.featured,
                    categories: item.categories,
                    isDisabledOffline: true,
                    action: (insert, state, source)=>{
                        if (typeof item.node === 'function') {
                            const extensionAPI = apiRef?.current?.extension?.actions?.api();
                            // While this should only run when the extension some setups of editor
                            // may not have the extension API
                            if (extensionAPI) (0, $3jQ9y.resolveImport)(item.node(extensionAPI)).then((node)=>{
                                $4a8f1fc352d7e11f$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                                if (node) editorActions.replaceSelection(node);
                            });
                            else // Originally it was understood we could only use this if we were using the extension plugin
                            // However there are some edge cases where this is not true (ie. in jira)
                            // Since making it optional now would be a breaking change - instead we can just pass a dummy
                            // extension API to consumers that warns them of using the methods.
                            (0, $3jQ9y.resolveImport)(item.node($4a8f1fc352d7e11f$var$dummyExtensionAPI)).then((node)=>{
                                $4a8f1fc352d7e11f$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                                if (node) editorActions.replaceSelection(node);
                            });
                            return insert('');
                        } else {
                            $4a8f1fc352d7e11f$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                            return insert(item.node);
                        }
                    }
                };
            });
            return Promise.all(quickInsertItems);
        }
    };
}
async function $4a8f1fc352d7e11f$export$e3759a254d73dcb7(quickInsertProviders) {
    const { invokeList: invokeList } = (0, $iScNA.default)(quickInsertProviders);
    return {
        getItems () {
            return invokeList('getItems');
        }
    };
}

});


parcelRegister("b5VLW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5d3ec72975fd3ba$export$2e2bcd8739ae039);
function $e5d3ec72975fd3ba$export$2e2bcd8739ae039({ autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider }) {
    return {
        emojiProvider: emojiProvider,
        mentionProvider: mentionProvider,
        autoformattingProvider: autoformattingProvider,
        activityProvider: activityProvider,
        imageUploadProvider: legacyImageUploadProvider,
        taskDecisionProvider: taskDecisionProvider,
        contextIdentifierProvider: contextIdentifierProvider,
        searchProvider: searchProvider,
        presenceProvider: presenceProvider,
        macroProvider: macroProvider,
        collabEditProvider: collabEdit?.provider ? collabEdit.provider : collabEditProvider
    };
}

});

parcelRegister("4G7Gx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c9d292cfdbfb05b$export$2e2bcd8739ae039);
function $6c9d292cfdbfb05b$export$2e2bcd8739ae039(providerFactory, { mentionProvider: mentionProvider, contextIdentifierProvider: contextIdentifierProvider, collabEditProvider: collabEditProvider, activityProvider: activityProvider, presenceProvider: presenceProvider, macroProvider: macroProvider, imageUploadProvider: imageUploadProvider, searchProvider: searchProvider }, extensionProvider, quickInsertProvider) {
    providerFactory.setProvider('mentionProvider', mentionProvider);
    providerFactory.setProvider('contextIdentifierProvider', contextIdentifierProvider);
    providerFactory.setProvider('imageUploadProvider', imageUploadProvider);
    providerFactory.setProvider('collabEditProvider', collabEditProvider);
    providerFactory.setProvider('activityProvider', activityProvider);
    providerFactory.setProvider('searchProvider', searchProvider);
    providerFactory.setProvider('presenceProvider', presenceProvider);
    providerFactory.setProvider('macroProvider', macroProvider);
    if (extensionProvider) providerFactory.setProvider('extensionProvider', Promise.resolve(extensionProvider));
    if (quickInsertProvider) providerFactory.setProvider('quickInsertProvider', quickInsertProvider);
}

});



parcelRegister("1PKpt", function(module, exports) {

$parcel$export(module.exports, "default", () => $949a60155d5990f5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $574ry = parcelRequire("574ry");
var $1Oo9w = parcelRequire("1Oo9w");

var $b3YrF = parcelRequire("b3YrF");

var $26eEE = parcelRequire("26eEE");

var $9JpPs = parcelRequire("9JpPs");

var $iu6m9 = parcelRequire("iu6m9");

var $761rI = parcelRequire("761rI");

var $axOCf = parcelRequire("axOCf");

var $3ae8F = parcelRequire("3ae8F");

var $uq7dM = parcelRequire("uq7dM");
const $949a60155d5990f5$var$chromelessEditorStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px',
    height: 'auto',
    overflowX: 'hidden',
    overflowY: 'auto'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $26eEE.scrollbarStyles), {
    maxWidth: 'inherit',
    boxSizing: 'border-box',
    wordWrap: 'break-word',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    'div > .ProseMirror': {
        outline: 'none',
        whiteSpace: 'pre-wrap',
        padding: 0,
        margin: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& > :last-child': {
            paddingBottom: "var(--ds-space-100, 0.5em)"
        }
    }
});
const $949a60155d5990f5$export$fceb9665be86d56e = (0, $761rI.createEditorContentStyle)();
$949a60155d5990f5$export$fceb9665be86d56e.displayName = 'ContentArea';
const $949a60155d5990f5$var$EditorContainer = (0, $9JpPs.componentWithCondition)(()=>(0, $iu6m9.editorExperiment)('platform_editor_core_static_emotion', true, {
        exposure: true
    }), (0, $axOCf.default), $949a60155d5990f5$export$fceb9665be86d56e);
const $949a60155d5990f5$var$useEditorViewModePluginState = (0, $574ry.sharedPluginStateHookMigratorFactory)((pluginInjectionApi)=>{
    const { editorViewModeState: editorViewModeState } = (0, $1Oo9w.useSharedPluginState)(pluginInjectionApi, [
        'editorViewMode'
    ]);
    return editorViewModeState?.mode;
}, (pluginInjectionApi)=>{
    return (0, $b3YrF.useSharedPluginStateSelector)(pluginInjectionApi, 'editorViewMode.mode');
});
class $949a60155d5990f5$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        return /*#__PURE__*/ (0, $3jLHL.jsx)($949a60155d5990f5$var$RenderWithPluginState, {
            editorAPI: this.props.editorAPI,
            renderChrome: this.renderChrome
        });
    }
    constructor(...args){
        super(...args);
        this.appearance = 'chromeless';
        this.containerElement = null;
        this.renderChrome = ({ maxContentSize: maxContentSize })=>{
            const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, maxHeight: maxHeight, minHeight: minHeight = 30, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginHooks: pluginHooks, featureFlags: featureFlags } = this.props;
            const maxContentSizeReached = Boolean(maxContentSize?.maxContentSizeReached);
            const editorViewMode = $949a60155d5990f5$var$useEditorViewModePluginState(this.props.editorAPI);
            return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $uq7dM.default), {
                animate: maxContentSizeReached
            }, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
                css: [
                    $949a60155d5990f5$var$chromelessEditorStyles,
                    maxHeight && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                    (0, $3jLHL.css)({
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                        maxHeight: `${maxHeight}px`
                    }),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                    (0, $3jLHL.css)({
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                        minHeight: `${minHeight}px`
                    })
                ],
                "data-testid": "chromeless-editor",
                ref: (ref)=>this.containerElement = ref
            }, /*#__PURE__*/ (0, $3jLHL.jsx)($949a60155d5990f5$var$EditorContainer, {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: "ak-editor-content-area",
                featureFlags: featureFlags,
                viewMode: editorViewMode,
                appearance: this.appearance
            }, customContentComponents && 'before' in customContentComponents ? customContentComponents.before : customContentComponents, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3ae8F.default), {
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                providerFactory: providerFactory,
                appearance: this.appearance,
                items: contentComponents,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                containerElement: this.containerElement,
                disabled: !!disabled,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                wrapperElement: this.containerElement,
                pluginHooks: pluginHooks
            }), editorDOMElement, customContentComponents && 'after' in customContentComponents ? customContentComponents.after : null)));
        };
    }
}
$949a60155d5990f5$export$2e2bcd8739ae039.displayName = 'ChromelessEditorAppearance';
const $949a60155d5990f5$var$useMaxContentSizePluginState = (0, $574ry.sharedPluginStateHookMigratorFactory)((pluginInjectionApi)=>{
    const { maxContentSizeState: maxContentSizeState } = (0, $1Oo9w.useSharedPluginState)(pluginInjectionApi, [
        'maxContentSize'
    ]);
    return {
        maxContentSizeState: maxContentSizeState
    };
}, (pluginInjectionApi)=>{
    const maxContentSizeReached = (0, $b3YrF.useSharedPluginStateSelector)(pluginInjectionApi, 'maxContentSize.maxContentSizeReached');
    return {
        maxContentSizeState: maxContentSizeReached === undefined ? undefined : {
            maxContentSizeReached: maxContentSizeReached
        }
    };
});
function $949a60155d5990f5$var$RenderWithPluginState({ renderChrome: renderChrome, editorAPI: editorAPI }) {
    const { maxContentSizeState: maxContentSizeState } = $949a60155d5990f5$var$useMaxContentSizePluginState(editorAPI);
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, renderChrome({
        maxContentSize: maxContentSizeState
    }));
}

});
parcelRegister("26eEE", function(module, exports) {

$parcel$export(module.exports, "scrollbarStyles", () => $3e9f2b46b7207c53$export$b2380b18b089518f);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $3e9f2b46b7207c53$export$b2380b18b089518f = `
  -ms-overflow-style: -ms-autohiding-scrollbar;

  &::-webkit-scrollbar {
    overflow: hidden,
  }

  &::-webkit-scrollbar-corner {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${"var(--ds-background-neutral-subtle, #00000000)"};
  }

  &:hover::-webkit-scrollbar-thumb {
    background-color: ${"var(--ds-background-neutral-bold, #44546F)"};
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${"var(--ds-background-neutral-bold-hovered, #2C3E5D)"};
  }
`;

});

parcelRegister("761rI", function(module, exports) {

$parcel$export(module.exports, "createEditorContentStyle", () => $868db914546607cf$export$91e7c20fa6d6a4b5);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable react-hooks/rules-of-hooks */ /* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Requires manual remediation over time due to use of unsafe nested mixins */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");
var $ja596 = parcelRequire("ja596");

var $d7ZU3 = parcelRequire("d7ZU3");

var $h3X17 = parcelRequire("h3X17");

var $fhsiz = parcelRequire("fhsiz");
var $98HrB = parcelRequire("98HrB");

var $9WN1A = parcelRequire("9WN1A");

var $DoNsZ = parcelRequire("DoNsZ");

var $4AaC5 = parcelRequire("4AaC5");

var $6ESsx = parcelRequire("6ESsx");
var $52bSY = parcelRequire("52bSY");
var $kZBrC = parcelRequire("kZBrC");
var $5MaNT = parcelRequire("5MaNT");
var $7zsay = parcelRequire("7zsay");
var $7bDsi = parcelRequire("7bDsi");
var $xdUPw = parcelRequire("xdUPw");
var $iMS6j = parcelRequire("iMS6j");
var $cV5SN = parcelRequire("cV5SN");
var $87iYj = parcelRequire("87iYj");
var $diPla = parcelRequire("diPla");
var $idF2b = parcelRequire("idF2b");
var $4mSjx = parcelRequire("4mSjx");
var $ag6aQ = parcelRequire("ag6aQ");
var $3Khgq = parcelRequire("3Khgq");
var $7QdQz = parcelRequire("7QdQz");
var $eRvLS = parcelRequire("eRvLS");
var $cRffC = parcelRequire("cRffC");
var $0vvte = parcelRequire("0vvte");
var $7iisy = parcelRequire("7iisy");
var $4h2HM = parcelRequire("4h2HM");
var $2wkZs = parcelRequire("2wkZs");
var $3iemu = parcelRequire("3iemu");
parcelRequire("o46Yq");
var $4jPB7 = parcelRequire("4jPB7");
parcelRequire("9PfP2");
var $hAOTs = parcelRequire("hAOTs");
parcelRequire("agKS6");
var $gg4RV = parcelRequire("gg4RV");
parcelRequire("axrL7");
var $319kp = parcelRequire("319kp");

var $aFUXX = parcelRequire("aFUXX");
var $ieXGd = parcelRequire("ieXGd");
var $b38UX = parcelRequire("b38UX");

var $dh538 = parcelRequire("dh538");

var $iu6m9 = parcelRequire("iu6m9");

var $cOrQJ = parcelRequire("cOrQJ");

var $gYSj7 = parcelRequire("gYSj7");

var $bl6tp = parcelRequire("bl6tp");

var $1zjTz = parcelRequire("1zjTz");

var $jFND0 = parcelRequire("jFND0");

var $gSnRq = parcelRequire("gSnRq");

var $6dFlY = parcelRequire("6dFlY");

var $3oH64 = parcelRequire("3oH64");

var $6Ra3A = parcelRequire("6Ra3A");

var $bD4Xf = parcelRequire("bD4Xf");

var $ftMAt = parcelRequire("ftMAt");

var $dR5Bd = parcelRequire("dR5Bd");
const $868db914546607cf$export$4ea5976125a01ffa = (0, $3jLHL.css)`
	.ProseMirror {
		${(0, $idF2b.linkSharedStyle)()}
	}
`;
const $868db914546607cf$var$ruleStyles = ()=>(0, $3jLHL.css)`
	.ProseMirror {
		${(0, $eRvLS.ruleSharedStyles)()};

		hr {
			cursor: pointer;
			padding: ${"var(--ds-space-050, 4px)"} 0;
			margin: ${"var(--ds-space-300, 24px)"} 0;
			background-clip: content-box;

			&.${0, $aFUXX.akEditorSelectedNodeClassName} {
				outline: none;
				background-color: ${`var(--ds-border-selected, ${0, $aFUXX.akEditorSelectedBorderColor})`};
			}
		}
	}
`;
const $868db914546607cf$var$vanillaMentionsStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive': {
        display: 'inline',
        borderRadius: '20px',
        cursor: 'pointer',
        padding: '0 0.3em 2px 0.23em',
        fontWeight: "var(--ds-font-weight-regular, 400)",
        wordBreak: 'break-word',
        background: "var(--ds-background-neutral, #091E420F)",
        border: '1px solid transparent',
        color: "var(--ds-text-subtle, #44546F)",
        '&:hover': {
            background: "var(--ds-background-neutral-hovered, #091E4224)"
        },
        '&:active': {
            background: "var(--ds-background-neutral-pressed, #091E424F)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive.mention-restricted': {
        background: 'transparent',
        border: `1px solid ${"var(--ds-border-bold, #758195)"}`,
        color: "var(--ds-text, #172B4D)",
        '&:hover': {
            background: 'transparent'
        },
        '&:active': {
            background: 'transparent'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive.mention-self': {
        background: "var(--ds-background-brand-bold, #0C66E4)",
        border: '1px solid transparent',
        color: "var(--ds-text-inverse, #FFFFFF)",
        '&:hover': {
            background: "var(--ds-background-brand-bold-hovered, #0055CC)"
        },
        '&:active': {
            background: "var(--ds-background-brand-bold-pressed, #09326C)"
        }
    }
});
const $868db914546607cf$var$vanillaSelectionStyles = (0, $3jLHL.css)`
	.danger {
		.editor-mention-primitive {
			box-shadow: 0 0 0 ${(0, $aFUXX.akEditorSelectedBorderSize)}px ${(0, $aFUXX.akEditorDeleteBorder)};
			background-color: ${`var(--ds-background-danger, ${(0, $aFUXX.akEditorDeleteBackgroundWithOpacity)})`};
		}
	}

	.${(0, $aFUXX.akEditorSelectedNodeClassName)} > .editor-mention-primitive,
	.${(0, $aFUXX.akEditorSelectedNodeClassName)} > .editor-mention-primitive.mention-self,
	.${(0, $aFUXX.akEditorSelectedNodeClassName)} > .editor-mention-primitive.mention-restricted {
		${(0, $ieXGd.getSelectionStyles)([
    (0, $b38UX.SelectionStyle).BoxShadow,
    (0, $b38UX.SelectionStyle).Background
])}
		/* need to specify dark text colour because personal mentions
	       (in dark blue) have white text by default */
		color: ${"var(--ds-text-subtle, #44546F)"}
	}
`;
const $868db914546607cf$var$mentionsStyles = (0, $3jLHL.css)`
	.${(0, $9WN1A.MentionSharedCssClassName).MENTION_CONTAINER} {
		&.${(0, $aFUXX.akEditorSelectedNodeClassName)} [data-mention-id] > span {
			${(0, $ieXGd.getSelectionStyles)([
    (0, $b38UX.SelectionStyle).BoxShadow,
    (0, $b38UX.SelectionStyle).Background
])}

			/* need to specify dark text colour because personal mentions
         (in dark blue) have white text by default */
      color: ${"var(--ds-text-subtle, #44546F)"};
		}
	}

	.danger {
		.${(0, $9WN1A.MentionSharedCssClassName).MENTION_CONTAINER}.${(0, $aFUXX.akEditorSelectedNodeClassName)}
			> span
			> span
			> span {
			box-shadow: 0 0 0 ${(0, $aFUXX.akEditorSelectedBorderSize)}px ${(0, $aFUXX.akEditorDeleteBorder)};
			background-color: ${`var(--ds-background-danger, ${(0, $aFUXX.akEditorDeleteBackgroundWithOpacity)})`};
		}
		.${(0, $9WN1A.MentionSharedCssClassName).MENTION_CONTAINER} > span > span > span {
			background-color: ${"var(--ds-background-neutral, #091E420F)"};
			color: ${"var(--ds-text-subtle, #44546F)"};
		}
	}
`;
const $868db914546607cf$var$listsStyles = (0, $3jLHL.css)`
	.ProseMirror {
		li {
			position: relative;

			> p:not(:first-child) {
				margin: ${"var(--ds-space-050, 4px)"} 0 0 0;
			}

			/* In SSR the above rule will apply to all p tags because first-child would be a style tag.
			The following rule resets the first p tag back to its original margin
			defined in packages/editor/editor-common/src/styles/shared/paragraph.ts */
			> style:first-child + p {
				margin-top: ${(0, $aFUXX.blockNodesVerticalMargin)};
			}
		}

		&:not([data-node-type='decisionList']) > li,
    /* This prevents https://product-fabric.atlassian.net/browse/ED-20924 */
    &:not(.${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}) > li {
			${(0, $d7ZU3.browser).safari ? (0, $5MaNT.codeBlockInListSafariFix) : ''}
		}
	}
`;
const $868db914546607cf$var$reactEmojiStyles = (0, $3jLHL.css)`
	.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_CONTAINER} {
		display: inline-block;

		.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_NODE} {
			cursor: pointer;

			&.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE} > span {
				/** needed for selection style to cover custom emoji image properly */
				display: flex;
			}
		}

		&.${(0, $aFUXX.akEditorSelectedNodeClassName)} {
			.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE} {
				border-radius: 2px;
				${(0, $ieXGd.getSelectionStyles)([
    (0, $b38UX.SelectionStyle).Blanket,
    (0, $b38UX.SelectionStyle).BoxShadow
])}
			}
		}
	}
`;
const $868db914546607cf$var$emojiStyles = (0, $3jLHL.css)`
	[data-prosemirror-node-view-type='vanilla'] {
		.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_CONTAINER} {
			display: inline-block;
		}

		.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE} {
			background: no-repeat transparent;
			display: inline-block;
			height: ${(0, $fhsiz.defaultEmojiHeight)}px;
			max-height: ${(0, $fhsiz.defaultEmojiHeight)}px;
			cursor: pointer;
			vertical-align: middle;
			user-select: all;
		}

		&.${(0, $aFUXX.akEditorSelectedNodeClassName)} {
			.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE} {
				border-radius: 2px;
				${(0, $ieXGd.getSelectionStyles)([
    (0, $b38UX.SelectionStyle).Blanket,
    (0, $b38UX.SelectionStyle).BoxShadow
])}
			}
		}
	}
`;
const $868db914546607cf$export$d3bdc0d52bb6c2c8 = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror .placeholder-decoration': {
        color: "var(--ds-text-subtlest, #626F86)",
        width: '100%',
        pointerEvents: 'none',
        userSelect: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.placeholder-android': {
            pointerEvents: 'none',
            outline: 'none',
            userSelect: 'none',
            position: 'absolute'
        }
    }
});
const $868db914546607cf$var$placeholderOverflowStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p:has(.placeholder-decoration-hide-overflow)': {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    }
});
const $868db914546607cf$var$placeholderWrapStyles = (0, $3jLHL.css)({
    // As part of controls work, we add placeholder `Search` to quick insert command
    // This style is to prevent `/Search` being wrapped if it's triggered at the end of the line
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ProseMirror mark[data-type-ahead-query="true"]:has(.placeholder-decoration-wrap)': {
        whiteSpace: 'nowrap'
    }
});
const $868db914546607cf$var$firstBlockNodeStyles = (0, $3jLHL.css)`
	.ProseMirror {
		> .${(0, $DoNsZ.PanelSharedCssClassName).prefix},
			> .${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER},
			> .${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER},
			> div[data-task-list-local-id],
		> div[data-layout-section],
		> .${(0, $iMS6j.expandClassNames).prefix} {
			&:first-child {
				margin-top: 0;
			}
		}

		> hr:first-of-type {
			margin-top: 0;
		}
	}
`;
const $868db914546607cf$var$firstBlockNodeStylesNew = (0, $3jLHL.css)`
	.ProseMirror {
		> .${(0, $DoNsZ.PanelSharedCssClassName).prefix},
			> .${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER},
			> .${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER},
			> div[data-task-list-local-id],
		> div[data-layout-section],
		> .${(0, $iMS6j.expandClassNames).prefix} {
			&:first-child {
				margin-top: 0;
			}
		}

		> hr:first-child,
		> .ProseMirror-widget:first-child + hr {
			margin-top: 0;
		}
	}
`;
const $868db914546607cf$export$42a58e6dfeaffebe = ()=>{
    if ((0, $dh538.fg)('platform_editor_element_dnd_nested_fix_patch_6')) return $868db914546607cf$var$firstBlockNodeStylesNew;
    return $868db914546607cf$var$firstBlockNodeStyles;
};
// The breakpoint for small devices is 1266px, copied from getBreakpoint in platform/packages/editor/editor-common/src/ui/WidthProvider/index.tsx
const $868db914546607cf$var$akEditorBreakpointForSmallDevice = `1266px`;
// We are going to deprecate this in near future
// Currently, we are migrating content styles in packages/editor/editor-core/src/ui/EditorContentContainer.tsx
// Under editor experiment platform_editor_core_static_emotion
// If you are making changes to this file, please make sure to update in EditorContentContainer.tsx as well
const $868db914546607cf$var$legacyContentStyles = (props)=>(0, $3jLHL.css)`
	--ak-editor--default-gutter-padding: ${0, $aFUXX.akEditorGutterPadding}px;
	/* 52 is from akEditorGutterPaddingDynamic via editor-shared-styles */
	--ak-editor--large-gutter-padding: ${(0, $aFUXX.akEditorGutterPaddingDynamic)()}px;
	--ak-editor--default-layout-width: ${0, $aFUXX.akEditorDefaultLayoutWidth}px;
	--ak-editor--full-width-layout-width: ${0, $aFUXX.akEditorFullWidthLayoutWidth}px;
	/* calculate editor line length, 100cqw is the editor container width */
	--ak-editor--line-length: min(
		calc(100cqw - var(--ak-editor--large-gutter-padding) * 2),
		var(--ak-editor--default-layout-width)
	);
	--ak-editor--breakout-wide-layout-width: ${0, $aFUXX.akEditorCalculatedWideLayoutWidthSmallViewport}px;
	--ak-editor--breakout-full-page-guttering-padding: calc(
		var(--ak-editor--large-gutter-padding) * 2 + var(--ak-editor--default-gutter-padding)
	);

	.fabric-editor--full-width-mode {
		--ak-editor--line-length: min(
			calc(100cqw - var(--ak-editor--large-gutter-padding) * 2),
			var(--ak-editor--full-width-layout-width)
		);
	}

	.ProseMirror {
		--ak-editor-max-container-width: calc(100cqw - var(--ak-editor--large-gutter-padding));
	}

	/* We can't allow nodes that are inside other nodes to bleed from the parent container */
	.ProseMirror > div[data-prosemirror-node-block] [data-prosemirror-node-block] {
		--ak-editor-max-container-width: 100%;
	}

	/* container editor-area is defined in platform/packages/editor/editor-core/src/ui/Appearance/FullPage/StyledComponents.ts */
	@container editor-area (width >= ${$868db914546607cf$var$akEditorBreakpointForSmallDevice}) {
		.ProseMirror {
			--ak-editor--breakout-wide-layout-width: ${0, $aFUXX.akEditorCalculatedWideLayoutWidth}px;
		}
	}

	.ProseMirror {
		outline: none;
		font-size: ${(0, $aFUXX.editorFontSize)({
        theme: props.theme
    })}px;
		${0, $3iemu.whitespaceSharedStyles};
		${(0, $3Khgq.paragraphSharedStyles)(props.typographyTheme)};
		${0, $4mSjx.listsSharedStyles};
		${0, $diPla.indentationSharedStyles};
		${0, $cRffC.shadowSharedStyle};
		${0, $gYSj7.InlineNodeViewSharedStyles};
	}

	${(0, $dh538.fg)('editor_request_to_edit_task') ? null : (0, $3jLHL.css)`
				.ProseMirror[contenteditable='false'] .taskItemView-content-wrap {
					pointer-events: none;
					opacity: 0.7;
				}
			`}

	.ProseMirror-hideselection *::selection {
		background: transparent;
	}

	.ProseMirror-hideselection *::-moz-selection {
		background: transparent;
	}

	/**
	 * This prosemirror css style: https://github.com/ProseMirror/prosemirror-view/blob/f37ebb29befdbde3cd194fe13fe17b78e743d2f2/style/prosemirror.css#L24
	 *
	 * 1. Merge and Release platform_editor_hide_cursor_when_pm_hideselection
	 * 2. Cleanup duplicated style from platform_editor_advanced_code_blocks
	 *    https://product-fabric.atlassian.net/browse/ED-26331
	 */
	${(0, $dh538.fg)('platform_editor_hide_cursor_when_pm_hideselection') ? (0, $3jLHL.css)`
				.ProseMirror-hideselection {
					caret-color: transparent;
				}
			` : null}

	/* This prosemirror css style: https://github.com/ProseMirror/prosemirror-view/blob/f37ebb29befdbde3cd194fe13fe17b78e743d2f2/style/prosemirror.css#L24 */
	${(0, $iu6m9.editorExperiment)('platform_editor_advanced_code_blocks', true) ? (0, $3jLHL.css)`
				.ProseMirror-hideselection {
					caret-color: transparent;
				}
			` : null}

	.ProseMirror-selectednode {
		outline: none;
	}

	.ProseMirror-selectednode:empty {
		outline: 2px solid ${"var(--ds-border-focused, #8cf)"};
	}

	.ProseMirror.ProseMirror-focused:has(.ProseMirror-mark-boundary-cursor) {
		caret-color: transparent;
	}
	.ProseMirror:not(.ProseMirror-focused) .ProseMirror-mark-boundary-cursor {
		display: none;
	}

	${0, $319kp.placeholderTextStyles}
	${$868db914546607cf$export$d3bdc0d52bb6c2c8}
	${(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? $868db914546607cf$var$placeholderOverflowStyles : null}
	${(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_quick_insert_placeholder') ? $868db914546607cf$var$placeholderWrapStyles : null}

  ${(0, $1zjTz.codeBlockStyles)()}

  ${(0, $4jPB7.blocktypeStyles)(props.typographyTheme)}
  ${(0, $7zsay.codeMarkSharedStyles)()}
  ${0, $4h2HM.textColorStyles}
  ${(0, $52bSY.backgroundColorStyles)()}
  ${$868db914546607cf$var$listsStyles}
  ${$868db914546607cf$var$ruleStyles()}
  ${(0, $6Ra3A.mediaStyles)()}
  ${(0, $3oH64.layoutStyles)(props.viewMode)}
  ${(0, $dh538.fg)('confluence_team_presence_scroll_to_pointer') ? (0, $h3X17.telepointerStyle) : (0, $h3X17.telepointerStyleWithInitialOnly)}
  ${0, $4AaC5.gapCursorStyles};
	${(0, $bD4Xf.panelStyles)()}
	${$868db914546607cf$var$mentionsStyles}
	${(0, $iu6m9.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && $868db914546607cf$var$vanillaMentionsStyles}
	${(0, $iu6m9.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && $868db914546607cf$var$vanillaSelectionStyles}
	${(0, $iu6m9.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) ? $868db914546607cf$var$emojiStyles : $868db914546607cf$var$reactEmojiStyles}
  ${$868db914546607cf$var$emojiStyles}
  ${0, $7iisy.tasksAndDecisionsStyles}
  ${0, $87iYj.gridStyles}
  ${$868db914546607cf$export$4ea5976125a01ffa}
  ${0, $kZBrC.blockMarksSharedStyles}
  ${0, $7bDsi.dateSharedStyle}
  ${0, $6dFlY.extensionStyles}
  ${(0, $gSnRq.expandStyles)()}
  ${0, $hAOTs.findReplaceStyles}
  ${0, $gg4RV.textHighlightStyle}
  ${0, $dR5Bd.taskDecisionStyles}
  ${(0, $iu6m9.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && (0, $dR5Bd.vanillaTaskItemStyles)}
  ${(0, $iu6m9.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && (0, $dR5Bd.vanillaTaskDecisionStyles)}
  /* Switch between the two icons based on the visual refresh feature gate */
  ${(0, $iu6m9.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && (0, $dh538.fg)('platform-visual-refresh-icons') && (0, $dR5Bd.vanillaTaskDecisionIconWithVisualRefresh)}
  ${(0, $iu6m9.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && !(0, $dh538.fg)('platform-visual-refresh-icons') && (0, $dR5Bd.vanillaTaskDecisionIconWithoutVisualRefresh)}
  ${0, $ftMAt.statusStyles}
  ${(0, $iu6m9.editorExperiment)('platform_editor_vanilla_dom', true) ? (0, $ftMAt.vanillaStatusStyles)() : null}
  ${(0, $6ESsx.annotationSharedStyles)()}
  ${(0, $0vvte.smartCardStyles)()}
  ${(0, $dh538.fg)('platform-linking-visual-refresh-v1') ? (0, $cV5SN.getSmartCardSharedStyles)() : (0, $cV5SN.smartCardSharedStyles)}
  ${(0, $iu6m9.editorExperiment)('platform_editor_vanilla_dom', true) ? (0, $jFND0.dateVanillaStyles) : null}
	${0, $jFND0.dateStyles}
  ${(0, $xdUPw.embedCardStyles)()}
  ${0, $2wkZs.unsupportedStyles}
  ${0, $7QdQz.resizerStyles}
  ${(0, $7QdQz.pragmaticResizerStyles)()}
  ${(0, $bl6tp.aiPanelStyles)(props.colorMode)}
  ${$868db914546607cf$export$42a58e6dfeaffebe()}

  .panelView-content-wrap {
		box-sizing: border-box;
	}

	.mediaGroupView-content-wrap ul {
		padding: 0;
	}

	/** Needed to override any cleared floats, e.g. image wrapping */

	div.fabric-editor-block-mark[class^='fabric-editor-align'] {
		clear: none !important;
	}

	.fabric-editor-align-end {
		text-align: right;
	}

	.fabric-editor-align-start {
		text-align: left;
	}

	.fabric-editor-align-center {
		text-align: center;
	}

	/* For FullPage only when inside a table
	Related code all lives inside: packages/editor/editor-core/src/ui/Appearance/FullPage/StyledComponents.ts
	In the "editorContentAreaContainerStyle" function */
	.fabric-editor--full-width-mode {
		.pm-table-container {
			.code-block,
			.extension-container,
			.multiBodiedExtension--container {
				max-width: 100%;
			}
		}
	}

	.pm-table-header-content-wrap :not(.fabric-editor-alignment),
	.pm-table-header-content-wrap :not(p, .fabric-editor-block-mark) + div.fabric-editor-block-mark,
	.pm-table-cell-content-wrap :not(p, .fabric-editor-block-mark) + div.fabric-editor-block-mark {
		p:first-of-type {
			margin-top: 0;
		}
	}
	.pm-table-cell-content-wrap .mediaGroupView-content-wrap {
		clear: both;
	}

	.hyperlink-floating-toolbar,
	.${(0, $ag6aQ.ClassNames).FLOATING_TOOLBAR_COMPONENT} {
		padding: 0;
	}

	/* Legacy Link icon in the Atlaskit package
     is bigger than the others, new ADS icon does not have this issue
  */
	${!(0, $dh538.fg)('platform-visual-refresh-icons') ? (0, $3jLHL.css)`
				.hyperlink-open-link {
					min-width: 24px;
					svg {
						max-width: 18px;
					}
				}
			` : null}
`;
const $868db914546607cf$var$listLayoutShiftFix = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror ul, .ProseMirror ol': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '10px'
    }
});
const $868db914546607cf$export$91e7c20fa6d6a4b5 = (styles)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef((props, ref)=>{
        const { className: className, children: children, featureFlags: featureFlags } = props;
        const theme = (0, $ja596.u)();
        const { colorMode: colorMode, typography: typography } = (0, $cOrQJ.default)();
        const memoizedStyle = (0, $gwFzn.useMemo)(()=>$868db914546607cf$var$legacyContentStyles({
                theme: theme,
                colorMode: colorMode,
                featureFlags: featureFlags,
                viewMode: props.viewMode,
                typographyTheme: typography
            }), [
            theme,
            colorMode,
            featureFlags,
            props.viewMode,
            typography
        ]);
        if (props.isScrollable) return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            css: [
                memoizedStyle,
                styles
            ],
            "data-editor-scroll-container": "true",
            "data-testid": "editor-content-container"
        }, children);
        return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            css: [
                memoizedStyle,
                styles,
                (0, $dh538.fg)('platform_editor_ssr_fix_lists') && $868db914546607cf$var$listLayoutShiftFix
            ],
            "data-testid": "editor-content-container"
        }, children);
    });
};
var $868db914546607cf$export$2e2bcd8739ae039 = $868db914546607cf$export$91e7c20fa6d6a4b5();

});
parcelRegister("98HrB", function(module, exports) {

$parcel$export(module.exports, "EmojiSharedCssClassName", () => $200d6bd4f803d466$export$ee47248f9a998789);

var $8hpYf = parcelRequire("8hpYf");
const $200d6bd4f803d466$export$ee47248f9a998789 = {
    EMOJI_CONTAINER: 'emojiView-content-wrap',
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_NODE: (0, $8hpYf.emojiNodeStyles),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_SPRITE: (0, $8hpYf.emojiSprite),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_IMAGE: (0, $8hpYf.emojiImage),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_PLACEHOLDER: (0, $8hpYf.placeholder)
};

});

parcelRegister("9WN1A", function(module, exports) {

$parcel$export(module.exports, "MentionSharedCssClassName", () => $1d1e174580119dab$export$e5f60e08987c4e73);
const $1d1e174580119dab$export$e5f60e08987c4e73 = {
    MENTION_CONTAINER: 'mentionView-content-wrap'
};

});

parcelRegister("4AaC5", function(module, exports) {

$parcel$export(module.exports, "hideCaretModifier", () => $952b6472eb391b70$export$8adc5edbc4a22166);
$parcel$export(module.exports, "gapCursorStyles", () => $952b6472eb391b70$export$f6b9d90c2745834e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");
const $952b6472eb391b70$var$gapCursorBlink = (0, $3jLHL.keyframes)({
    'from, to': {
        opacity: 0
    },
    '50%': {
        opacity: 1
    }
});
const $952b6472eb391b70$export$8adc5edbc4a22166 = 'ProseMirror-hide-gapcursor';
const $952b6472eb391b70$var$gapCursor = '.ProseMirror-gapcursor';
const $952b6472eb391b70$var$prosemirrorwidgetNotBlock = '.ProseMirror-widget:not([data-blocks-decoration-container="true"]):not([data-blocks-drag-handle-container="true"]):not([data-blocks-quick-insert-container="true"])';
const $952b6472eb391b70$var$wrapLeft = '[layout="wrap-left"]';
const $952b6472eb391b70$var$wrapRight = '[layout="wrap-right"]';
const $952b6472eb391b70$export$f6b9d90c2745834e = (0, $3jLHL.css)`
	/* =============== GAP CURSOR ================== */
	.ProseMirror {
		&.${$952b6472eb391b70$export$8adc5edbc4a22166} {
			caret-color: transparent;
		}

		${$952b6472eb391b70$var$gapCursor} {
			display: none;
			pointer-events: none;
			position: relative;

			& span {
				caret-color: transparent;
				position: absolute;
				height: 100%;
				width: 100%;
				display: block;
			}

			& span::after {
				animation: 1s ${$952b6472eb391b70$var$gapCursorBlink} step-start infinite;
				border-left: 1px solid;
				content: '';
				display: block;
				position: absolute;
				top: 0;
				height: 100%;
			}
			&.-left span::after {
				left: ${"var(--ds-space-negative-050, -4px)"};
			}
			&.-right span::after {
				right: ${"var(--ds-space-negative-050, -4px)"};
			}
			& span[layout='full-width'],
			& span[layout='wide'],
			& span[layout='fixed-width'] {
				margin-left: 50%;
				transform: translateX(-50%);
			}
			&${$952b6472eb391b70$var$wrapRight} {
				float: right;
			}

			/* fix vertical alignment of gap cursor */
			&:first-of-type + ul,
			&:first-of-type + span + ul,
			&:first-of-type + ol,
			&:first-of-type + span + ol,
			&:first-of-type + pre,
			&:first-of-type + span + pre,
			&:first-of-type + blockquote,
			&:first-of-type + span + blockquote {
				margin-top: 0;
			}
		}
		&.ProseMirror-focused ${$952b6472eb391b70$var$gapCursor} {
			display: block;
			border-color: transparent;
		}
	}

	/* This hack below is for two images aligned side by side */
	${$952b6472eb391b70$var$gapCursor}${$952b6472eb391b70$var$wrapLeft} + span + ${$952b6472eb391b70$var$wrapLeft},
  ${$952b6472eb391b70$var$gapCursor}${$952b6472eb391b70$var$wrapRight} + span + ${$952b6472eb391b70$var$wrapRight},
  ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapLeft} + ${$952b6472eb391b70$var$wrapRight},
  ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapLeft} + span + ${$952b6472eb391b70$var$wrapRight},
  ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapRight} + ${$952b6472eb391b70$var$wrapLeft},
  ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapRight} + span + ${$952b6472eb391b70$var$wrapLeft},
  ${$952b6472eb391b70$var$wrapLeft} + ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapRight},
  ${$952b6472eb391b70$var$wrapLeft} + ${$952b6472eb391b70$var$gapCursor} + span ${$952b6472eb391b70$var$wrapRight},
  ${$952b6472eb391b70$var$wrapRight} + ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapLeft},
  ${$952b6472eb391b70$var$wrapRight} + ${$952b6472eb391b70$var$gapCursor} + span + ${$952b6472eb391b70$var$wrapLeft},
  ${$952b6472eb391b70$var$wrapLeft} + ${$952b6472eb391b70$var$gapCursor} {
		clear: none;
	}

	${$952b6472eb391b70$var$wrapLeft} + ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapRight} > div,
  ${$952b6472eb391b70$var$wrapLeft} + ${$952b6472eb391b70$var$gapCursor} + span + ${$952b6472eb391b70$var$wrapRight} > div,
  ${$952b6472eb391b70$var$wrapRight} + ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapLeft} > div,
  ${$952b6472eb391b70$var$wrapRight} + ${$952b6472eb391b70$var$gapCursor} + span + ${$952b6472eb391b70$var$wrapLeft} > div,
  ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapRight} + ${$952b6472eb391b70$var$wrapLeft} > div,
  ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapRight} + span + ${$952b6472eb391b70$var$wrapLeft} > div,
  ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapLeft} + ${$952b6472eb391b70$var$wrapRight} > div,
  ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapLeft} + span + ${$952b6472eb391b70$var$wrapRight} > div {
		margin-right: 0;
		margin-left: 0;
		margin-bottom: 0;
	}

	${$952b6472eb391b70$var$wrapLeft} + ${$952b6472eb391b70$var$gapCursor},
  ${$952b6472eb391b70$var$wrapRight} + ${$952b6472eb391b70$var$gapCursor} {
		float: left;
	}

	${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapLeft} + span + ${$952b6472eb391b70$var$wrapRight}::after,
  ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapRight} + span + ${$952b6472eb391b70$var$wrapLeft}::after,
  ${$952b6472eb391b70$var$wrapLeft} + ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapRight}::after,
  ${$952b6472eb391b70$var$wrapLeft} + ${$952b6472eb391b70$var$gapCursor} + span + ${$952b6472eb391b70$var$wrapRight}::after,
  ${$952b6472eb391b70$var$wrapRight} + ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapLeft}::after,
  ${$952b6472eb391b70$var$wrapRight} + ${$952b6472eb391b70$var$gapCursor} + span + ${$952b6472eb391b70$var$wrapLeft}::after {
		visibility: hidden;
		display: block;
		font-size: 0;
		content: ' ';
		clear: both;
		height: 0;
	}

	${$952b6472eb391b70$var$wrapLeft} + ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapRight} + *,
  ${$952b6472eb391b70$var$wrapLeft} + ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapRight} + span + *,
  ${$952b6472eb391b70$var$wrapRight} + ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapLeft} + *,
  ${$952b6472eb391b70$var$wrapRight} + ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapLeft} + span + *,
  ${$952b6472eb391b70$var$wrapLeft} + ${$952b6472eb391b70$var$gapCursor} + span + ${$952b6472eb391b70$var$wrapRight} + *,
  ${$952b6472eb391b70$var$wrapRight} + ${$952b6472eb391b70$var$gapCursor} + span + ${$952b6472eb391b70$var$wrapLeft} + *,
  ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapLeft} + span + ${$952b6472eb391b70$var$wrapRight} + *,
  ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapRight} + span + ${$952b6472eb391b70$var$wrapLeft} + *,
  ${$952b6472eb391b70$var$wrapLeft} + ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapRight} + * > *,
  ${$952b6472eb391b70$var$wrapLeft} + ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapRight} + span + * > *,
  ${$952b6472eb391b70$var$wrapRight} + ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapLeft} + * > *,
  ${$952b6472eb391b70$var$wrapRight} + ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapLeft} + span + * > *,
  ${$952b6472eb391b70$var$wrapLeft} + ${$952b6472eb391b70$var$gapCursor} + span + ${$952b6472eb391b70$var$wrapRight} + * > *,
  ${$952b6472eb391b70$var$wrapRight} + ${$952b6472eb391b70$var$gapCursor} + span + ${$952b6472eb391b70$var$wrapLeft} + * > *,
  ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapLeft} + span + ${$952b6472eb391b70$var$wrapRight} + * > *,
  ${$952b6472eb391b70$var$gapCursor} + ${$952b6472eb391b70$var$wrapRight} + span + ${$952b6472eb391b70$var$wrapLeft} + * > *,
  ${$952b6472eb391b70$var$prosemirrorwidgetNotBlock} + ${$952b6472eb391b70$var$gapCursor} + *,
  ${$952b6472eb391b70$var$prosemirrorwidgetNotBlock} + ${$952b6472eb391b70$var$gapCursor} + span + * {
		margin-top: 0;
	}
`;

});

parcelRegister("6ESsx", function(module, exports) {

$parcel$export(module.exports, "AnnotationSharedClassNames", () => $a4c21b9fb66bf546$export$b0aeb22a160e5b4c);
$parcel$export(module.exports, "BlockAnnotationSharedClassNames", () => $a4c21b9fb66bf546$export$ac15f3ad21fefeac);
$parcel$export(module.exports, "annotationSharedStyles", () => $a4c21b9fb66bf546$export$5f72fe1d39f8129b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $dh538 = parcelRequire("dh538");
const $a4c21b9fb66bf546$export$6d0ce11e3a04da25 = 'ak-editor-annotation';
const $a4c21b9fb66bf546$export$b0aeb22a160e5b4c = {
    focus: `${$a4c21b9fb66bf546$export$6d0ce11e3a04da25}-focus`,
    blur: `${$a4c21b9fb66bf546$export$6d0ce11e3a04da25}-blur`,
    draft: `${$a4c21b9fb66bf546$export$6d0ce11e3a04da25}-draft`,
    hover: `${$a4c21b9fb66bf546$export$6d0ce11e3a04da25}-hover`
};
const $a4c21b9fb66bf546$export$3600479d19dfa7a9 = 'ak-editor-block-annotation';
const $a4c21b9fb66bf546$export$ac15f3ad21fefeac = {
    focus: `${$a4c21b9fb66bf546$export$3600479d19dfa7a9}-focus`,
    blur: `${$a4c21b9fb66bf546$export$3600479d19dfa7a9}-blur`,
    draft: `${$a4c21b9fb66bf546$export$3600479d19dfa7a9}-draft`
};
const $a4c21b9fb66bf546$export$261ebe180da42726 = ()=>{
    if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) // NOTE: These styles are shared between renderer and editor. Sometimes they
    // need different selectors and other times they apply the same attributes
    // in a different way. For example in renderer the focus styles are an
    // override, not a separate class. Be sure to check both usages of this
    // before modifying.
    return {
        common: {
            borderBottom: '2px solid transparent',
            cursor: 'pointer',
            padding: '1px 0 2px',
            '&:has(.card), &:has([data-inline-card])': (0, $dh538.fg)('annotations_align_editor_and_renderer_styles') ? {
                padding: '5px 0 3px 0'
            } : {
                paddingTop: '4px',
                border: 'none',
                boxShadow: `0 2px 0 0 ${"var(--ds-border-accent-yellow, #B38600)"}`
            },
            '&:has(.date-lozenger-container)': {
                paddingTop: '2px'
            }
        },
        focus: (0, $3jLHL.css)({
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
        }),
        blur: (0, $3jLHL.css)({
            background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)"
        }),
        hover: (0, $3jLHL.css)({
            background: "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
        })
    };
    else return {
        focus: (0, $3jLHL.css)({
            // Background is not coming through in confluence, suspecting to be caused by some specific combination of
            // emotion and token look up
            background: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            // TODO: DSP-4147 - Annotation shadow
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
            cursor: 'pointer'
        }),
        blur: (0, $3jLHL.css)({
            background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            cursor: 'pointer'
        })
    };
};
const $a4c21b9fb66bf546$export$5f72fe1d39f8129b = ()=>(0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState()` is not safe in object syntax
    (0, $3jLHL.css)`
				.ProseMirror {
					.${$a4c21b9fb66bf546$export$b0aeb22a160e5b4c.blur},
						.${$a4c21b9fb66bf546$export$b0aeb22a160e5b4c.focus},
						.${$a4c21b9fb66bf546$export$b0aeb22a160e5b4c.draft} {
						${$a4c21b9fb66bf546$export$261ebe180da42726().common};
					}

					.${$a4c21b9fb66bf546$export$b0aeb22a160e5b4c.focus} {
						${$a4c21b9fb66bf546$export$261ebe180da42726().focus};
					}

					.${$a4c21b9fb66bf546$export$b0aeb22a160e5b4c.draft} {
						${$a4c21b9fb66bf546$export$261ebe180da42726().focus};
						cursor: initial;
					}

					.${$a4c21b9fb66bf546$export$b0aeb22a160e5b4c.blur} {
						${$a4c21b9fb66bf546$export$261ebe180da42726().blur};
					}
					.${$a4c21b9fb66bf546$export$b0aeb22a160e5b4c.hover} {
						${$a4c21b9fb66bf546$export$261ebe180da42726().common};
						${$a4c21b9fb66bf546$export$261ebe180da42726().hover};
					}
				}
			` : // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState()` is not safe in object syntax
    (0, $3jLHL.css)`
				.ProseMirror {
					.${$a4c21b9fb66bf546$export$b0aeb22a160e5b4c.focus} {
						${$a4c21b9fb66bf546$export$261ebe180da42726().focus};
					}

					.${$a4c21b9fb66bf546$export$b0aeb22a160e5b4c.draft} {
						${$a4c21b9fb66bf546$export$261ebe180da42726().focus};
						cursor: initial;
					}

					.${$a4c21b9fb66bf546$export$b0aeb22a160e5b4c.blur} {
						${$a4c21b9fb66bf546$export$261ebe180da42726().blur};
					}
				}
			`;

});

parcelRegister("52bSY", function(module, exports) {

$parcel$export(module.exports, "backgroundColorStyles", () => $b3e4ea5199670e3c$export$e4cca17cf56e99d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");
const $b3e4ea5199670e3c$export$e4cca17cf56e99d = ()=>{
    return (0, $3jLHL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.fabric-background-color-mark': {
            backgroundColor: 'var(--custom-palette-color, inherit)',
            borderRadius: '2px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            paddingTop: '1px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            paddingBottom: '2px',
            boxDecorationBreak: 'clone'
        },
        // Don't show text highlight styling when there is a hyperlink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'a .fabric-background-color-mark': {
            backgroundColor: 'unset'
        },
        // Don't show text highlight styling when there is an inline comment
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.fabric-background-color-mark .ak-editor-annotation': {
            backgroundColor: 'unset'
        }
    });
};

});

parcelRegister("kZBrC", function(module, exports) {

$parcel$export(module.exports, "blockMarksSharedStyles", () => $287233bc07026ea1$export$33edc553df878c50);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Perfectly safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");
const $287233bc07026ea1$export$33edc553df878c50 = (0, $3jLHL.css)`
	/**
   * We need to remove margin-top from first item
   * inside doc, tableCell, tableHeader, blockquote, etc.
   */
	*:not(.fabric-editor-block-mark) >,
  /* For nested block marks apart from those with indentation mark */
  *:not(.fabric-editor-block-mark) >
    div.fabric-editor-block-mark:first-of-type
    /* Do not remove the margin top for nodes inside indentation marks */
      :not(.fabric-editor-indentation-mark)
    /* Do not remove the margin top for nodes inside alignment marks */
      :not(.fabric-editor-alignment),
  /* If first element inside a block node has alignment mark, then remove the margin-top */
  .fabric-editor-alignment:first-of-type:first-child,
  /* If first document element has indentation mark remove margin-top */
  .ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child {
		p,
		h1,
		h2,
		h3,
		h4,
		h5,
		h6,
		.heading-wrapper {
			:first-child:not(style),
			style:first-child + * {
				margin-top: 0;
			}
		}
	}
`;

});

parcelRegister("7zsay", function(module, exports) {

$parcel$export(module.exports, "codeMarkSharedStyles", () => $d9fccf0aa4f2bb51$export$ea799c18f699972b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");
const $d9fccf0aa4f2bb51$export$ea799c18f699972b = ()=>{
    return (0, $3jLHL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.code': {
            '--ds--code--bg-color': "var(--ds-background-neutral, #091E420F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            display: 'inline',
            padding: '2px 0.5ch',
            backgroundColor: `var(--ds--code--bg-color,${"var(--ds-background-neutral, #091E420F)"})`,
            borderRadius: "var(--ds-border-radius, 3px)",
            borderStyle: 'none',
            boxDecorationBreak: 'clone',
            color: "var(--ds-text, #172B4D)",
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: '0.875em',
            fontWeight: "var(--ds-font-weight-regular, 400)",
            overflow: 'auto',
            overflowWrap: 'break-word',
            whiteSpace: 'pre-wrap'
        }
    });
};

});

parcelRegister("xdUPw", function(module, exports) {

$parcel$export(module.exports, "embedCardStyles", () => $46967ce47683f437$export$5a1f57c6600b90f1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $aFUXX = parcelRequire("aFUXX");
const $46967ce47683f437$export$5a1f57c6600b90f1 = ()=>(0, $3jLHL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.ProseMirror': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            ".embedCardView-content-wrap[layout^='wrap-']": {
                maxWidth: '100%',
                position: 'relative',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                zIndex: (0, $aFUXX.akEditorWrappedNodeZIndex)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            ".embedCardView-content-wrap[layout='wrap-left']": {
                float: 'left'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            ".embedCardView-content-wrap[layout='wrap-right']": {
                float: 'right'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            ".embedCardView-content-wrap[layout='wrap-right'] + .embedCardView-content-wrap[layout='wrap-left']": {
                clear: 'both'
            }
        }
    });
const $46967ce47683f437$export$9a900b6b0c1fa45 = (0, $3jLHL.css)({
    margin: `0 ${"var(--ds-space-150, 12px)"}`
});

});

parcelRegister("iMS6j", function(module, exports) {

$parcel$export(module.exports, "expandIconWrapperStyle", () => $76cf05f628aba256$export$e1f541b6d8e35681);
$parcel$export(module.exports, "expandIconContainerStyle", () => $76cf05f628aba256$export$2e9dabdcf16aeb54);
$parcel$export(module.exports, "expandClassNames", () => $76cf05f628aba256$export$6ba39aa0ead007b7);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");
const $76cf05f628aba256$export$e1f541b6d8e35681 = (0, $3jLHL.css)({
    marginLeft: "var(--ds-space-negative-100, -8px)"
});
const $76cf05f628aba256$export$2e9dabdcf16aeb54 = (0, $3jLHL.css)({
    display: 'flex',
    alignItems: 'center'
});
const $76cf05f628aba256$var$prefix = 'ak-editor-expand';
const $76cf05f628aba256$export$6ba39aa0ead007b7 = {
    prefix: $76cf05f628aba256$var$prefix,
    expanded: `${$76cf05f628aba256$var$prefix}__expanded`,
    titleContainer: `${$76cf05f628aba256$var$prefix}__title-container`,
    inputContainer: `${$76cf05f628aba256$var$prefix}__input-container`,
    iconContainer: `${$76cf05f628aba256$var$prefix}__icon-container`,
    icon: `${$76cf05f628aba256$var$prefix}__icon`,
    titleInput: `${$76cf05f628aba256$var$prefix}__title-input`,
    content: `${$76cf05f628aba256$var$prefix}__content`,
    type: (type)=>`${$76cf05f628aba256$var$prefix}__type-${type}`
};

});

parcelRegister("87iYj", function(module, exports) {

$parcel$export(module.exports, "GRID_GUTTER", () => $fed20d357db2e647$export$108900bf32350a8b);
$parcel$export(module.exports, "gridStyles", () => $fed20d357db2e647$export$61d0da483c72dda3);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $aFUXX = parcelRequire("aFUXX");
const $fed20d357db2e647$export$108900bf32350a8b = 12;
const $fed20d357db2e647$export$61d0da483c72dda3 = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridParent': {
        width: `calc(100% + ${$fed20d357db2e647$export$108900bf32350a8b * 2}px)`,
        marginLeft: "var(--ds-space-negative-150, -12px)",
        marginRight: "var(--ds-space-negative-150, -12px)",
        transform: 'scale(1)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $aFUXX.akEditorGridLineZIndex)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridContainer': {
        position: 'fixed',
        height: '100vh',
        width: '100%',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridLine': {
        borderLeft: `1px solid ${"var(--ds-border, #091E4224)"}`,
        display: 'inline-block',
        boxSizing: 'border-box',
        height: '100%',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginLeft: '-1px',
        transition: 'border-color 0.15s linear',
        zIndex: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.highlight': {
        borderLeft: `1px solid ${"var(--ds-border-focused, #388BFF)"}`
    }
});

});

parcelRegister("diPla", function(module, exports) {

$parcel$export(module.exports, "indentationSharedStyles", () => $64ffc6fb6a264f83$export$6856b92f564d3de8);
/* eslint-disable @atlaskit/design-system/use-tokens-space */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");
const $64ffc6fb6a264f83$export$6856b92f564d3de8 = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor-indentation-mark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&[data-level='1']": {
            marginLeft: '30px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&[data-level='2']": {
            marginLeft: '60px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&[data-level='3']": {
            marginLeft: '90px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&[data-level='4']": {
            marginLeft: '120px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&[data-level='5']": {
            marginLeft: '150px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&[data-level='6']": {
            marginLeft: '180px'
        }
    }
});

});

parcelRegister("idF2b", function(module, exports) {

$parcel$export(module.exports, "linkSharedStyle", () => $d93b99092038057e$export$d835732bf782c240);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $dh538 = parcelRequire("dh538");
const $d93b99092038057e$export$d835732bf782c240 = ()=>{
    return (0, $dh538.fg)('platform_editor_hyperlink_underline') ? (0, $3jLHL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'a.blockLink': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'a[data-prosemirror-mark-name="link"]': {
            textDecoration: 'underline'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'a[data-prosemirror-mark-name="link"]:hover': {
            textDecoration: 'none'
        }
    }) : (0, $3jLHL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'a.blockLink': {
            display: 'block'
        }
    });
};

});

parcelRegister("3Khgq", function(module, exports) {

$parcel$export(module.exports, "paragraphSharedStyles", () => $b9bdaad9d3887681$export$2f49074d75b0e29f);
/* eslint-disable @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $aFUXX = parcelRequire("aFUXX");

var $dh538 = parcelRequire("dh538");

var $ilPbq = parcelRequire("ilPbq");
const $b9bdaad9d3887681$export$2f49074d75b0e29f = (typographyTheme)=>{
    return (0, $dh538.fg)('platform_editor_typography_ugc') ? (0, $3jLHL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            font: (0, $ilPbq.default)('editor.font.body'),
            marginTop: (0, $aFUXX.blockNodesVerticalMargin),
            marginBottom: 0
        }
    }) : (0, $3jLHL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            fontSize: '1em',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            lineHeight: (0, $aFUXX.akEditorLineHeight),
            fontWeight: "var(--ds-font-weight-regular, 400)",
            marginTop: (0, $aFUXX.blockNodesVerticalMargin),
            marginBottom: 0,
            letterSpacing: '-0.005em'
        }
    });
};

});

parcelRegister("7QdQz", function(module, exports) {

$parcel$export(module.exports, "resizerItemClassName", () => $18d786e757e244a7$export$a06160db3520e5a2);
$parcel$export(module.exports, "resizerHoverZoneClassName", () => $18d786e757e244a7$export$c42cdcfd48254bda);
$parcel$export(module.exports, "resizerExtendedZone", () => $18d786e757e244a7$export$10b67c6ff1748bd);
$parcel$export(module.exports, "resizerHandleClassName", () => $18d786e757e244a7$export$6afc20f0ff6d041);
$parcel$export(module.exports, "resizerHandleTrackClassName", () => $18d786e757e244a7$export$a5792d7e2a486d41);
$parcel$export(module.exports, "resizerHandleThumbClassName", () => $18d786e757e244a7$export$2201bc1aaee73f36);
$parcel$export(module.exports, "resizerDangerClassName", () => $18d786e757e244a7$export$97a99610b6f0a178);
$parcel$export(module.exports, "handleWrapperClass", () => $18d786e757e244a7$export$b123b2c8a2536d05);
$parcel$export(module.exports, "resizerHandleZIndex", () => $18d786e757e244a7$export$3d867927ebf9bc1f);
$parcel$export(module.exports, "resizerStyles", () => $18d786e757e244a7$export$ce55ec61aa49b942);
$parcel$export(module.exports, "pragmaticResizerStyles", () => $18d786e757e244a7$export$62cd5dfd9881f590);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $aFUXX = parcelRequire("aFUXX");

var $iu6m9 = parcelRequire("iu6m9");
const $18d786e757e244a7$export$a06160db3520e5a2 = 'resizer-item';
const $18d786e757e244a7$export$c42cdcfd48254bda = 'resizer-hover-zone';
const $18d786e757e244a7$export$10b67c6ff1748bd = 'resizer-is-extended';
const $18d786e757e244a7$export$6afc20f0ff6d041 = 'resizer-handle';
const $18d786e757e244a7$export$a5792d7e2a486d41 = `${$18d786e757e244a7$export$6afc20f0ff6d041}-track`;
const $18d786e757e244a7$export$2201bc1aaee73f36 = `${$18d786e757e244a7$export$6afc20f0ff6d041}-thumb`;
const $18d786e757e244a7$export$97a99610b6f0a178 = `${$18d786e757e244a7$export$6afc20f0ff6d041}-danger`;
// akEditorSelectedNodeClassName from '@atlaskit/editor-shared-styles';
const $18d786e757e244a7$var$akEditorSelectedNodeClassName = 'ak-editor-selected-node';
const $18d786e757e244a7$export$b123b2c8a2536d05 = 'resizer-handle-wrapper';
const $18d786e757e244a7$export$3d867927ebf9bc1f = 1;
const $18d786e757e244a7$export$ce55ec61aa49b942 = (0, $3jLHL.css)`
	.${$18d786e757e244a7$export$a06160db3520e5a2} {
		will-change: width;

		&:hover,
		&.display-handle {
			& > .${$18d786e757e244a7$export$b123b2c8a2536d05} > .${$18d786e757e244a7$export$6afc20f0ff6d041} {
				visibility: visible;
				opacity: 1;
			}
		}

		&.is-resizing {
			& .${$18d786e757e244a7$export$2201bc1aaee73f36} {
				background: ${"var(--ds-border-focused, #388BFF)"};
			}
		}

		&.${$18d786e757e244a7$export$97a99610b6f0a178} {
			& .${$18d786e757e244a7$export$2201bc1aaee73f36} {
				transition: none;
				background: ${`var(--ds-icon-danger, ${(0, $aFUXX.akEditorDeleteIconColor)})`};
			}
		}
	}

	.${$18d786e757e244a7$export$6afc20f0ff6d041} {
		display: flex;
		visibility: hidden;
		opacity: 0;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 7px;
		transition:
			visibility 0.2s,
			opacity 0.2s;

		/*
      NOTE: The below style is targeted at the div element added by the tooltip. We don't have any means of injecting styles
      into the tooltip
    */
		& div[role='presentation'] {
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			margin-top: ${"var(--ds-space-negative-200, -16px)"};
			white-space: normal;
		}

		/*
      Handle Positions
    */
		&.left {
			align-items: flex-start;
		}
		&.right {
			align-items: flex-end;
		}

		/*
      Handle Sizing
    */
		&.small {
			& .${$18d786e757e244a7$export$2201bc1aaee73f36} {
				height: 43px;
			}
		}
		&.medium {
			& .${$18d786e757e244a7$export$2201bc1aaee73f36} {
				height: 64px;
			}
		}
		&.large {
			& .${$18d786e757e244a7$export$2201bc1aaee73f36} {
				height: 96px;
			}
		}
		&.clamped {
			& .${$18d786e757e244a7$export$2201bc1aaee73f36} {
				height: clamp(43px, calc(100% - 32px), 96px);
			}
		}

		/*
      Handle Alignment
    */
		&.sticky {
			& .${$18d786e757e244a7$export$2201bc1aaee73f36} {
				position: sticky;
				top: ${"var(--ds-space-150, 12px)"};
				bottom: ${"var(--ds-space-150, 12px)"};
			}
		}

		&:hover {
			& .${$18d786e757e244a7$export$2201bc1aaee73f36} {
				background: ${"var(--ds-border-focused, #388BFF)"};
			}

			& .${$18d786e757e244a7$export$a5792d7e2a486d41} {
				visibility: visible;
				opacity: 0.5;
			}
		}
	}

	.${$18d786e757e244a7$export$2201bc1aaee73f36} {
		content: ' ';
		display: flex;
		width: 3px;
		margin: 0 ${"var(--ds-space-025, 2px)"};
		height: 64px;
		transition: background-color 0.2s;
		border-radius: 6px;
		border: 0;
		padding: 0;
		z-index: 2;
		outline: none;
		min-height: 24px;
		background: ${"var(--ds-border, #091E4224)"};

		&:hover {
			cursor: col-resize;
		}

		&:focus {
			background: ${"var(--ds-border-selected, #0C66E4)"};

			&::after {
				content: '';
				position: absolute;
				top: ${"var(--ds-space-negative-050, -4px)"};
				right: ${"var(--ds-space-negative-050, -4px)"};
				bottom: ${"var(--ds-space-negative-050, -4px)"};
				left: ${"var(--ds-space-negative-050, -4px)"};
				border: 2px solid ${"var(--ds-border-focused, #388BFF)"};
				border-radius: inherit;
				z-index: -1;
			}
		}
	}

	.${$18d786e757e244a7$export$a5792d7e2a486d41} {
		visibility: hidden;
		position: absolute;
		width: 7px;
		height: calc(100% - 40px);
		border-radius: 4px;
		opacity: 0;
		transition:
			background-color 0.2s,
			visibility 0.2s,
			opacity 0.2s;

		&.none {
			background: none;
		}

		&.shadow {
			background: ${"var(--ds-background-selected, #E9F2FF)"};
		}

		&.full-height {
			background: ${"var(--ds-background-selected, #E9F2FF)"};
			height: 100%;
			min-height: 36px;
		}
	}

	.${$18d786e757e244a7$var$akEditorSelectedNodeClassName} {
		& .${$18d786e757e244a7$export$2201bc1aaee73f36} {
			background: ${"var(--ds-border-focused, #388BFF)"};
		}
	}

	.ak-editor-no-interaction
		.${$18d786e757e244a7$var$akEditorSelectedNodeClassName}
		.${$18d786e757e244a7$export$6afc20f0ff6d041}:not(:hover)
		.${$18d786e757e244a7$export$2201bc1aaee73f36} {
		background: ${"var(--ds-border, #091E4224)"};
	}

	.${$18d786e757e244a7$export$c42cdcfd48254bda} {
		position: relative;
		display: inline-block;
		width: 100%;

		&.${$18d786e757e244a7$export$10b67c6ff1748bd} {
			padding: 0 ${"var(--ds-space-150, 12px)"};
			left: ${"var(--ds-space-negative-150, -12px)"};
		}
	}

	/* This below style is here to make sure the image width is correct when nested in a table */
	table .${$18d786e757e244a7$export$c42cdcfd48254bda}, table .${$18d786e757e244a7$export$c42cdcfd48254bda}.${$18d786e757e244a7$export$10b67c6ff1748bd} {
		padding: unset;
		left: unset;
	}
`;
const $18d786e757e244a7$export$62cd5dfd9881f590 = ()=>{
    if ((0, $iu6m9.editorExperiment)('platform_editor_breakout_resizing', false)) return;
    return (0, $3jLHL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle': {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            width: 7,
            alignSelf: 'center',
            gridRow: 1,
            gridColumn: 1,
            cursor: 'col-resize',
            borderRadius: 4,
            transition: 'background-color 0.2s, visibility 0.2s, opacity 0.2s',
            '&:hover': {
                background: "var(--ds-background-selected, #E9F2FF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.pm-breakout-resize-handle-inner': {
                    background: "var(--ds-border-focused, #388BFF)"
                }
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-left': {
            justifySelf: 'start',
            left: -20
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-right': {
            justifySelf: 'end',
            right: -20
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-inner': {
            minWidth: 3,
            // copied from resizeStyles.clamped
            height: 'clamp(27px, calc(100% - 32px), 96px)',
            background: "var(--ds-border, #091E4224)",
            borderRadius: 6,
            // sticky styles
            position: 'sticky',
            top: "var(--ds-space-150, 12px)",
            bottom: "var(--ds-space-150, 12px)"
        }
    });
};

});

parcelRegister("eRvLS", function(module, exports) {

$parcel$export(module.exports, "ruleSharedStyles", () => $bab5efafd7334a23$export$329434b3a2da905e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $aFUXX = parcelRequire("aFUXX");
const $bab5efafd7334a23$export$329434b3a2da905e = ()=>(0, $3jLHL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& hr': {
            border: 'none',
            backgroundColor: "var(--ds-border, #091E4224)",
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            margin: `${(0, $aFUXX.akEditorLineHeight)}em 0`,
            height: '2px',
            borderRadius: '1px'
        }
    });

});

parcelRegister("cRffC", function(module, exports) {

$parcel$export(module.exports, "shadowSharedStyle", () => $07384343ec5083c6$export$985ce3da3286f9ed);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $aFUXX = parcelRequire("aFUXX");

var $frt7o = parcelRequire("frt7o");

var $fp8V7 = parcelRequire("fp8V7");
const $07384343ec5083c6$var$shadowWidth = 8;
/**
 * TODO: This is close to working and removes a tone of JS from OverflowShadow component
 *
 *  background: linear-gradient(to right, white 30%, rgba(255, 255, 255, 0)),
 *         linear-gradient(to right, rgba(255, 255, 255, 0), white 70%) 100% 0,
 *        linear-gradient(to right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)),
 *         linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.2)) 100% 0;
 *       background-repeat: no-repeat;
 *       background-color: white;
 *       background-size: 40px 100%, 40px 100%, 14px 100%, 14px 100%;
 *
 *      background-attachment: local, local, scroll, scroll;
 */ const $07384343ec5083c6$export$985ce3da3286f9ed = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $frt7o.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $frt7o.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $frt7o.shadowClassNames).LEFT_SHADOW}::before, .${(0, $frt7o.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $aFUXX.akEditorShadowZIndex),
        width: `${$07384343ec5083c6$var$shadowWidth}px`,
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $frt7o.shadowClassNames).RIGHT_SHADOW}, .${(0, $frt7o.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $frt7o.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $frt7o.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $fp8V7.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $fp8V7.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});

});

parcelRegister("0vvte", function(module, exports) {

$parcel$export(module.exports, "DATASOURCE_INNER_CONTAINER_CLASSNAME", () => $c37b3947c7842800$export$32f80df830e375f6);
$parcel$export(module.exports, "FLOATING_TOOLBAR_LINKPICKER_CLASSNAME", () => $c37b3947c7842800$export$863ae87a9d233606);
$parcel$export(module.exports, "smartCardStyles", () => $c37b3947c7842800$export$b346a5d6d598424c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $aFUXX = parcelRequire("aFUXX");
var $ieXGd = parcelRequire("ieXGd");
var $b38UX = parcelRequire("b38UX");

var $dh538 = parcelRequire("dh538");

var $iu6m9 = parcelRequire("iu6m9");

var $cV5SN = parcelRequire("cV5SN");
const $c37b3947c7842800$export$32f80df830e375f6 = 'datasourceView-content-inner-wrap';
const $c37b3947c7842800$export$863ae87a9d233606 = 'card-floating-toolbar--link-picker';
const $c37b3947c7842800$export$b346a5d6d598424c = ()=>(0, $3jLHL.css)`
	.${(0, $cV5SN.SmartCardSharedCssClassName).INLINE_CARD_CONTAINER} {
		max-width: calc(100% - 20px);
		vertical-align: top;
		word-break: break-all;
		${(0, $dh538.fg)('editor_inline_comments_on_inline_nodes') ? `.card-with-comment {
          background: ${"var(--ds-background-accent-yellow-subtler, #F8E6A0)"};
          border-bottom: 2px solid ${"var(--ds-border-accent-yellow, #B38600)"};
          box-shadow: ${"var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"};
        }` : ''}
		.card {
			padding-left: ${"var(--ds-space-025, 2px)"};
			padding-right: ${"var(--ds-space-025, 2px)"};
			padding-top: 0.5em;
			padding-bottom: 0.5em;
			margin-bottom: -0.5em;

			.${(0, $cV5SN.SmartCardSharedCssClassName).LOADER_WRAPPER} > a:focus {
				${(0, $ieXGd.getSelectionStyles)([
        (0, $b38UX.SelectionStyle).BoxShadow
    ])}
			}
		}

		${(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? `[data-inlinecard-button-overlay='icon-wrapper-line-height'] span {
				line-height: 0;
			}` : ''}

		&.${0, $aFUXX.akEditorSelectedNodeClassName} .${(0, $cV5SN.SmartCardSharedCssClassName).LOADER_WRAPPER} > a {
			${(0, $ieXGd.getSelectionStyles)([
        (0, $b38UX.SelectionStyle).BoxShadow
    ])}
		}
		.${(0, $cV5SN.SmartCardSharedCssClassName).LOADER_WRAPPER} > a {
			/* EDM-1717: box-shadow Safari fix start */
			z-index: 1;
			position: relative;
			/* EDM-1717: box-shadow Safari fix end */
		}

		&.danger {
			.${(0, $cV5SN.SmartCardSharedCssClassName).LOADER_WRAPPER} > a {
				box-shadow: 0 0 0 1px ${`var(--ds-border-danger, ${0, $aFUXX.akEditorDeleteBorder})`};
				/* EDM-1717: box-shadow Safari fix start */
				z-index: 2;
				/* EDM-1717: box-shadow Safari fix end */
			}
		}
	}

	.${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER} {
		.${(0, $cV5SN.SmartCardSharedCssClassName).LOADER_WRAPPER} > div {
			cursor: ${// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
    (0, $dh538.fg)('linking_platform_smart_links_in_live_pages') ? 'text' : 'pointer'};

			a {
				cursor: ${// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
    (0, $dh538.fg)('linking_platform_smart_links_in_live_pages') ? 'pointer' : 'auto'};
			}
		}

		&.${0, $aFUXX.akEditorSelectedNodeClassName} .${(0, $cV5SN.SmartCardSharedCssClassName).LOADER_WRAPPER} > div {
			${(0, $ieXGd.getSelectionStyles)([
        (0, $b38UX.SelectionStyle).BoxShadow
    ])}
			border-radius: ${"var(--ds-border-radius-200, 8px)"};
		}

		&.danger {
			.${(0, $cV5SN.SmartCardSharedCssClassName).LOADER_WRAPPER} > div {
				box-shadow: 0 0 0 1px ${`var(--ds-border-danger, ${0, $aFUXX.akEditorDeleteBorder})`} !important;
			}
		}
	}

	.${(0, $cV5SN.SmartCardSharedCssClassName).DATASOURCE_CONTAINER}.${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER} {
		max-width: 100%;
		display: flex;
		justify-content: center;

		.${$c37b3947c7842800$export$32f80df830e375f6} {
			cursor: pointer;
			background-color: ${"var(--ds-background-neutral-subtle, #00000000)"};
			border-radius: ${"var(--ds-border-radius-200, 8px)"};
			border: 1px solid ${"var(--ds-border, #091E4224)"};
			overflow: hidden;
		}

		&.${0, $aFUXX.akEditorSelectedNodeClassName} {
			.${$c37b3947c7842800$export$32f80df830e375f6} {
				${(0, $ieXGd.getSelectionStyles)([
        (0, $b38UX.SelectionStyle).BoxShadow
    ])}

				input::selection {
					background-color: ${"var(--ds-background-selected-hovered, #CCE0FF)"};
				}
				input::-moz-selection {
					background-color: ${"var(--ds-background-selected-hovered, #CCE0FF)"};
				}
			}
		}

		&.danger {
			.${$c37b3947c7842800$export$32f80df830e375f6} {
				box-shadow: 0 0 0 1px ${`var(--ds-border-danger, ${0, $aFUXX.akEditorDeleteBorder})`};
			}
		}
	}

	.${(0, $cV5SN.SmartCardSharedCssClassName).EMBED_CARD_CONTAINER} {
		.${(0, $cV5SN.SmartCardSharedCssClassName).LOADER_WRAPPER} > div {
			cursor: pointer;
			a {
				cursor: ${// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
    (0, $dh538.fg)('linking_platform_smart_links_in_live_pages') ? 'pointer' : 'auto'};
			}
			&::after {
				transition: box-shadow 0s;
			}
		}

		&.${0, $aFUXX.akEditorSelectedNodeClassName} .${(0, $cV5SN.SmartCardSharedCssClassName).LOADER_WRAPPER} > div::after {
			${(0, $ieXGd.getSelectionStyles)([
        (0, $b38UX.SelectionStyle).BoxShadow
    ])}
		}

		&.danger {
			.media-card-frame::after {
				box-shadow: 0 0 0 1px ${`var(--ds-border-danger, ${0, $aFUXX.akEditorDeleteBorder})`} !important;
				background: ${`var(--ds-background-danger, ${0, $aFUXX.akEditorDeleteBackground})`} !important;
			}
			.richMedia-resize-handle-right::after,
			.richMedia-resize-handle-left::after {
				background: ${`var(--ds-border-danger, ${0, $aFUXX.akEditorDeleteBorder})`};
			}
		}
	}

	.${$c37b3947c7842800$export$863ae87a9d233606} {
		padding: 0;
	}
`;

});

parcelRegister("4h2HM", function(module, exports) {

$parcel$export(module.exports, "textColorStyles", () => $ebe298ee528de109$export$a518ea5d00002b38);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");
const $ebe298ee528de109$export$a518ea5d00002b38 = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-text-color-mark': {
        color: 'var(--custom-palette-color, inherit)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    'a .fabric-text-color-mark': {
        color: 'unset'
    }
});

});

parcelRegister("2wkZs", function(module, exports) {

$parcel$export(module.exports, "UnsupportedSharedCssClassName", () => $aaa72554d92ed7ed$export$629043421dcc56e5);
$parcel$export(module.exports, "unsupportedStyles", () => $aaa72554d92ed7ed$export$637bcb89343f7ef4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $aFUXX = parcelRequire("aFUXX");
var $ieXGd = parcelRequire("ieXGd");
var $b38UX = parcelRequire("b38UX");
const $aaa72554d92ed7ed$export$629043421dcc56e5 = {
    BLOCK_CONTAINER: 'unsupportedBlockView-content-wrap',
    INLINE_CONTAINER: 'unsupportedInlineView-content-wrap'
};
const $aaa72554d92ed7ed$var$inlineUnsupportedSelector = `.${$aaa72554d92ed7ed$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`;
const $aaa72554d92ed7ed$var$blockUnsupportedSelector = `.${$aaa72554d92ed7ed$export$629043421dcc56e5.BLOCK_CONTAINER} > div`;
const $aaa72554d92ed7ed$export$637bcb89343f7ef4 = (0, $3jLHL.css)`
	${$aaa72554d92ed7ed$var$blockUnsupportedSelector}, ${$aaa72554d92ed7ed$var$inlineUnsupportedSelector} {
		cursor: pointer;
	}

	.${(0, $aFUXX.akEditorSelectedNodeClassName)}${$aaa72554d92ed7ed$var$blockUnsupportedSelector},
		.${(0, $aFUXX.akEditorSelectedNodeClassName)}${$aaa72554d92ed7ed$var$inlineUnsupportedSelector} {
		${(0, $ieXGd.getSelectionStyles)([
    (0, $b38UX.SelectionStyle).Background,
    (0, $b38UX.SelectionStyle).Border
])}
	}

	.danger {
		.${(0, $aFUXX.akEditorSelectedNodeClassName)}${$aaa72554d92ed7ed$var$blockUnsupportedSelector},
			.${(0, $aFUXX.akEditorSelectedNodeClassName)}${$aaa72554d92ed7ed$var$inlineUnsupportedSelector} {
			border: ${(0, $aFUXX.akEditorSelectedBorderSize)}px solid
				${`var(--ds-border-danger, ${(0, $aFUXX.akEditorDeleteBorder)})`};
			background-color: ${`var(--ds-blanket-danger, ${(0, $aFUXX.akEditorDeleteBackgroundWithOpacity)})`};
		}
	}
`;

});

parcelRegister("3iemu", function(module, exports) {

$parcel$export(module.exports, "whitespaceSharedStyles", () => $3b935e4d3a09690a$export$c9ce3bfa46d7acba);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");
const $3b935e4d3a09690a$export$c9ce3bfa46d7acba = (0, $3jLHL.css)({
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap'
});

});

parcelRegister("o46Yq", function(module, exports) {

$parcel$export(module.exports, "blocktypeStyles", () => (parcelRequire("4jPB7")).blocktypeStyles);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4jPB7 = parcelRequire("4jPB7");

});
parcelRegister("4jPB7", function(module, exports) {

$parcel$export(module.exports, "blocktypeStyles", () => $54626e1d120d5adf$export$610a2509037eaf6);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $bEu8b = parcelRequire("bEu8b");
var $8tkd3 = parcelRequire("8tkd3");

var $dh538 = parcelRequire("dh538");
const $54626e1d120d5adf$export$610a2509037eaf6 = (typographyTheme)=>(0, $3jLHL.css)`
	.ProseMirror {
		${0, $bEu8b.blockquoteSharedStyles};
		${(0, $8tkd3.headingsSharedStyles)(typographyTheme)};
	}

	${(0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') && `.ak-editor-content-area.appearance-full-page .ProseMirror blockquote {
		padding-left: ${"var(--ds-space-250, 20px)"};
	}

	/* Don't want extra padding for inline editor (nested) */
	.ak-editor-content-area .ak-editor-content-area .ProseMirror blockquote {
		padding-left: ${"var(--ds-space-200, 16px)"};
	}`}
`;

});
parcelRegister("bEu8b", function(module, exports) {

$parcel$export(module.exports, "blockquoteSharedStyles", () => $c7d9f9b88472f185$export$1b5f3b43e6c4a8ee);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $aFUXX = parcelRequire("aFUXX");
const $c7d9f9b88472f185$export$1b5f3b43e6c4a8ee = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `2px solid ${`var(--ds-border, ${(0, $aFUXX.akEditorBlockquoteBorderColor)})`}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $aFUXX.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: 'block'
        }
    }
});

});

parcelRegister("8tkd3", function(module, exports) {

$parcel$export(module.exports, "headingsSharedStyles", () => $040b8d996f78bca8$export$9272613b68afed4b);
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/use-tokens-space */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $dh538 = parcelRequire("dh538");

var $ilPbq = parcelRequire("ilPbq");
const $040b8d996f78bca8$var$headingWithAlignmentStyles = ()=>// Override marginTop: 0 with default margin found in headingsSharedStyles for first heading in alignment block that is not the first child
    ({
        '.fabric-editor-block-mark.fabric-editor-alignment:not(:first-child)': {
            '> h1:first-child': {
                marginTop: '1.667em'
            },
            ' > h2:first-child': {
                marginTop: '1.8em'
            },
            '> h3:first-child': {
                marginTop: '2em'
            },
            '> h4:first-child': {
                marginTop: '1.357em'
            },
            '> h5:first-child': {
                marginTop: '1.667em'
            },
            '> h6:first-child': {
                marginTop: '1.455em'
            }
        },
        // Set marginTop: 0 if alignment block is next to a gap cursor or widget that is first child
        '.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment': {
            '> :is(h1, h2, h3, h4, h5, h6):first-child': {
                marginTop: '0'
            }
        }
    });
const $040b8d996f78bca8$export$9272613b68afed4b = (typographyTheme)=>{
    if ((0, $dh538.fg)('platform_editor_typography_ugc')) return (0, $3jLHL.css)({
        '& h1': {
            font: (0, $ilPbq.default)('editor.font.heading.h1'),
            marginBottom: 0,
            marginTop: '1.45833em',
            '& strong': {
                fontWeight: (0, $ilPbq.default)('editor.font.weight.heading.h1.bold')
            },
            '&::before': {}
        },
        '& h2': {
            font: (0, $ilPbq.default)('editor.font.heading.h2'),
            marginTop: '1.4em',
            marginBottom: 0,
            '& strong': {
                fontWeight: (0, $ilPbq.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h3': {
            font: (0, $ilPbq.default)('editor.font.heading.h3'),
            marginTop: '1.31249em',
            marginBottom: 0,
            '& strong': {
                fontWeight: (0, $ilPbq.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h4': {
            font: (0, $ilPbq.default)('editor.font.heading.h4'),
            marginTop: '1.25em',
            '& strong': {
                fontWeight: (0, $ilPbq.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h5': {
            font: (0, $ilPbq.default)('editor.font.heading.h5'),
            marginTop: '1.45833em',
            textTransform: 'none',
            '& strong': {
                fontWeight: (0, $ilPbq.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h6': {
            font: (0, $ilPbq.default)('editor.font.heading.h6'),
            marginTop: '1.59091em',
            textTransform: 'none',
            '& strong': {
                fontWeight: (0, $ilPbq.default)('editor.font.weight.heading.h1.bold')
            }
        },
        ...$040b8d996f78bca8$var$headingWithAlignmentStyles()
    });
    else return (0, $3jLHL.css)({
        '& h1': {
            fontSize: `${24 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 28 / 24,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            letterSpacing: `-0.01em`,
            marginBottom: 0,
            marginTop: '1.667em'
        },
        '& h2': {
            fontSize: `${20 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 1.2,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            letterSpacing: `-0.008em`,
            marginTop: '1.8em',
            marginBottom: 0
        },
        '& h3': {
            fontSize: `${16 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 1.25,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            letterSpacing: `-0.006em`,
            marginTop: '2em',
            marginBottom: 0
        },
        '& h4': {
            fontSize: `${1}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 14,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            letterSpacing: `-0.003em`,
            marginTop: '1.357em'
        },
        '& h5': {
            fontSize: `${12 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 12,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            marginTop: '1.667em',
            textTransform: 'none'
        },
        '& h6': {
            fontSize: `${11 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 11,
            color: "var(--ds-text-subtlest, #626F86)",
            fontWeight: "var(--ds-font-weight-bold, 700)",
            marginTop: '1.455em',
            textTransform: 'none'
        },
        ...$040b8d996f78bca8$var$headingWithAlignmentStyles()
    });
};

});



parcelRegister("9PfP2", function(module, exports) {

$parcel$export(module.exports, "findReplaceStyles", () => (parcelRequire("hAOTs")).findReplaceStyles);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $hAOTs = parcelRequire("hAOTs");

});
parcelRegister("hAOTs", function(module, exports) {

$parcel$export(module.exports, "searchMatchClass", () => $a2f418c832d6976a$export$cec6db4af40340f0);
$parcel$export(module.exports, "selectedSearchMatchClass", () => $a2f418c832d6976a$export$bf208a338b2a2f1f);
$parcel$export(module.exports, "findReplaceStyles", () => $a2f418c832d6976a$export$c5ceb9c726010930);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable */ 
var $3jLHL = parcelRequire("3jLHL");

var $6fnsQ = parcelRequire("6fnsQ");
const $a2f418c832d6976a$export$cec6db4af40340f0 = 'search-match';
const $a2f418c832d6976a$export$bf208a338b2a2f1f = 'selected-search-match';
const $a2f418c832d6976a$export$c5ceb9c726010930 = (0, $3jLHL.css)({
    [`.${$a2f418c832d6976a$export$cec6db4af40340f0}`]: {
        borderRadius: '3px',
        backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        boxShadow: `var(--ds-shadow-raised, ${`0 1px 1px 0 ${(0, $6fnsQ.N50A)}, 0 0 1px 0 ${(0, $6fnsQ.N60A)}`})` + ', inset 0 0 0 1px ' + `var(--ds-border-input, ${`${0, $6fnsQ.N40A}`})`
    },
    [`.${$a2f418c832d6976a$export$bf208a338b2a2f1f}`]: {
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
    }
});

});


parcelRegister("agKS6", function(module, exports) {

$parcel$export(module.exports, "textHighlightStyle", () => (parcelRequire("gg4RV")).textHighlightStyle);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $gg4RV = parcelRequire("gg4RV");

});
parcelRegister("gg4RV", function(module, exports) {

$parcel$export(module.exports, "textHighlightStyle", () => $5cd1780f04fd7730$export$b286500adc7d91cd);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $jHrqf = parcelRequire("jHrqf");
const $5cd1780f04fd7730$export$b286500adc7d91cd = (0, $3jLHL.css)`
	.${(0, $jHrqf.TEXT_HIGHLIGHT_CLASS)} {
		background-color: ${"var(--ds-background-accent-blue-subtlest, #E9F2FF)"};

		border-bottom: 2px solid ${"var(--ds-background-accent-blue-subtler, #cce0ff)"};
	}
`;

});
parcelRegister("jHrqf", function(module, exports) {

$parcel$export(module.exports, "PASTE_TOOLBAR_CLASS", () => $1f78ff91b043d5f4$export$164821e1c3d789fd);
$parcel$export(module.exports, "TEXT_HIGHLIGHT_CLASS", () => $1f78ff91b043d5f4$export$78dda1ebb9a1ea84);
$parcel$export(module.exports, "PASTE_HIGHLIGHT_DECORATION_KEY", () => $1f78ff91b043d5f4$export$d829547aa567b0f1);
$parcel$export(module.exports, "PASTE_TOOLBAR_ITEM_CLASS", () => $1f78ff91b043d5f4$export$af443436fa5992cb);
$parcel$export(module.exports, "PASTE_OPTIONS_TEST_ID", () => $1f78ff91b043d5f4$export$299d35c5583816ad);
$parcel$export(module.exports, "PASTE_OPTIONS_META_ID", () => $1f78ff91b043d5f4$export$d1234a98f427930);
const $1f78ff91b043d5f4$export$164821e1c3d789fd = 'ak-editor-paste-toolbar';
const $1f78ff91b043d5f4$export$81e541fc7755f475 = 'ak-editor-paste-toolbar-item-dropdownList';
const $1f78ff91b043d5f4$export$78dda1ebb9a1ea84 = 'text-highlight';
const $1f78ff91b043d5f4$export$d829547aa567b0f1 = 'paste-highlight-decoration-key';
const $1f78ff91b043d5f4$export$af443436fa5992cb = 'ak-editor-paste-toolbar-item';
const $1f78ff91b043d5f4$export$220f0307408bc0c = 'akEditor';
const $1f78ff91b043d5f4$export$299d35c5583816ad = 'paste-options-testid';
const $1f78ff91b043d5f4$export$d1234a98f427930 = 'paste-options$';

});



parcelRegister("axrL7", function(module, exports) {

$parcel$export(module.exports, "placeholderTextStyles", () => (parcelRequire("319kp")).placeholderTextStyles);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $319kp = parcelRequire("319kp");

});
parcelRegister("319kp", function(module, exports) {

$parcel$export(module.exports, "placeholderTextStyles", () => $87ac8abb7f5a5cdb$export$56bce713f2cb8aa7);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $aFUXX = parcelRequire("aFUXX");
var $ieXGd = parcelRequire("ieXGd");
var $b38UX = parcelRequire("b38UX");

var $6fnsQ = parcelRequire("6fnsQ");
const $87ac8abb7f5a5cdb$export$56bce713f2cb8aa7 = (0, $3jLHL.css)`
	.ProseMirror span[data-placeholder] {
		color: ${`var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`};
		display: inline;
	}

	.ProseMirror span.pm-placeholder {
		display: inline;
		color: ${`var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`};
	}
	.ProseMirror span.pm-placeholder__text {
		display: inline;
		color: ${`var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`};
	}

	.ProseMirror span.pm-placeholder.${(0, $aFUXX.akEditorSelectedNodeClassName)} {
		${(0, $ieXGd.getSelectionStyles)([
    (0, $b38UX.SelectionStyle).Background
])}
	}

	.ProseMirror span.pm-placeholder__text[data-placeholder]::after {
		color: ${`var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`};
		cursor: text;
		content: attr(data-placeholder);
		display: inline;
	}

	.ProseMirror {
		.ProseMirror-fake-text-cursor {
			display: inline;
			pointer-events: none;
			position: relative;
		}

		.ProseMirror-fake-text-cursor::after {
			content: '';
			display: inline;
			top: 0;
			position: absolute;
			border-right: 1px solid ${"var(--ds-border, rgba(0, 0, 0, 0.4))"};
		}

		.ProseMirror-fake-text-selection {
			display: inline;
			pointer-events: none;
			position: relative;
			background-color: ${`var(--ds-background-selected, ${(0, $6fnsQ.B75)})`};
		}
	}
`;

});


parcelRegister("gYSj7", function(module, exports) {

$parcel$export(module.exports, "InlineNodeViewSharedStyles", () => $8f30998f7f7c17c9$export$3fc32cdc53f6edeb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $bT1qC = parcelRequire("bT1qC");

var $TfRUG = parcelRequire("TfRUG");
const $8f30998f7f7c17c9$export$3fc32cdc53f6edeb = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`.${0, $bT1qC.inlineNodeViewClassname}`]: {
        display: 'inline',
        userSelect: 'all',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& > *:not(.zeroWidthSpaceContainer)': {
            whiteSpace: 'pre-wrap'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .assistive': {
            userSelect: 'none'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-safari': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`.${0, $bT1qC.inlineNodeViewClassname}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '::selection, *::selection': {
                background: 'transparent'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`&.ua-chrome .${0, $bT1qC.inlineNodeViewClassname} > span`]: {
        userSelect: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`.${0, $bT1qC.inlineNodeViewClassname}AddZeroWidthSpace`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            content: `'${(0, $TfRUG.ZERO_WIDTH_SPACE)}'`
        }
    }
});

});

parcelRegister("bl6tp", function(module, exports) {

$parcel$export(module.exports, "aiPanelStyles", () => $5c666726bcf85159$export$cdf1b75966a7ba92);
/**
 * TODO ED-26957 - remove legacy styles when static emotion refactor is complete
 * We are moving this to new location under FF: platform_editor_core_static_emotion
 * New location: packages/editor/editor-core/src/ui/EditorContentContainer.tsx
 * If you are making updates to this file, please updates in new location as well.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");
const $5c666726bcf85159$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $5c666726bcf85159$var$rotationAnimation = (0, $3jLHL.keyframes)({
    '0%': {
        '--panel-gradient-angle': '0deg',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$5c666726bcf85159$var$isFirefox ? {
            backgroundPosition: '100%'
        } : {}
    },
    '100%': {
        '--panel-gradient-angle': '360deg',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$5c666726bcf85159$var$isFirefox ? {
            backgroundPosition: '-100%'
        } : {}
    }
});
const $5c666726bcf85159$var$aiPrismColor = {
    ['prism.border.step.1']: {
        light: '#0065FF',
        dark: '#0065FF80'
    },
    ['prism.border.step.2']: {
        light: '#0469FF',
        dark: '#0469FF80'
    },
    ['prism.border.step.3']: {
        light: '#BF63F3',
        dark: '#BF63F380'
    },
    ['prism.border.step.4']: {
        light: '#FFA900',
        dark: '#FFA90080'
    }
};
const $5c666726bcf85159$var$prismBorderAnimationStyles = (0, $3jLHL.css)({
    '&::before, &::after': {
        animationName: $5c666726bcf85159$var$rotationAnimation,
        animationDuration: '2s',
        animationTimingFunction: 'linear',
        animationIterationCount: 'infinite',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$5c666726bcf85159$var$isFirefox ? {
            animationDirection: 'normal',
            animationDuration: '1s'
        } : {},
        '@media (prefers-reduced-motion)': {
            animation: 'none'
        }
    }
});
const $5c666726bcf85159$var$prismBorderStyles = (colorMode, hover)=>(0, $3jLHL.css)({
        content: "''",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: -1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `calc(100% + 2px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `calc(100% + 2px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: `-1px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: `-1px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `calc(${"var(--ds-border-radius-100, 3px)"} + 1px)`,
        transform: 'translate3d(0, 0, 0)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...hover ? {
            background: "var(--ds-border-input, #8590A2)"
        } : $5c666726bcf85159$var$isFirefox ? {
            background: `linear-gradient(90deg,
								${$5c666726bcf85159$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 0%,
								${$5c666726bcf85159$var$aiPrismColor['prism.border.step.2'][colorMode ?? 'light']} 12%,
								${$5c666726bcf85159$var$aiPrismColor['prism.border.step.3'][colorMode ?? 'light']} 24%,
								${$5c666726bcf85159$var$aiPrismColor['prism.border.step.4'][colorMode ?? 'light']} 48%,
								${$5c666726bcf85159$var$aiPrismColor['prism.border.step.3'][colorMode ?? 'light']} 64%,
								${$5c666726bcf85159$var$aiPrismColor['prism.border.step.2'][colorMode ?? 'light']} 80%,
								${$5c666726bcf85159$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 100%
							)`,
            backgroundSize: '200%'
        } : {
            background: `conic-gradient(
								from var(--panel-gradient-angle, 270deg),
								${$5c666726bcf85159$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 0%,
								${$5c666726bcf85159$var$aiPrismColor['prism.border.step.2'][colorMode ?? 'light']} 20%,
								${$5c666726bcf85159$var$aiPrismColor['prism.border.step.3'][colorMode ?? 'light']} 50%,
								${$5c666726bcf85159$var$aiPrismColor['prism.border.step.4'][colorMode ?? 'light']} 56%,
								${$5c666726bcf85159$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 100%
							)`
        }
    });
const $5c666726bcf85159$export$cdf1b75966a7ba92 = (colorMode)=>(0, $3jLHL.css)`
	@property --panel-gradient-angle {
		syntax: '<angle>';
		initial-value: 270deg;
		inherits: false;
	}

	div[extensionType='com.atlassian.ai-blocks'] {
		/* This hides the label for the extension */
		.extension-label {
			display: none;
		}

		/* This styles the ai panel correctly when its just sitting on the page and there
		is no user interaction */
		.extension-container {
			position: relative;
			box-shadow: none;
			overflow: unset;
			background-color: ${"var(--ds-surface, #FFFFFF)"} !important;
			&::before,
			&::after {
				${$5c666726bcf85159$var$prismBorderStyles(colorMode)}
			}
			&.with-hover-border {
				&::before,
				&::after {
					${$5c666726bcf85159$var$prismBorderStyles(colorMode, true)}
				}
			}
			& .with-margin-styles {
				background-color: ${"var(--ds-surface, #FFFFFF)"} !important;
				border-radius: ${"var(--ds-border-radius-100, 3px)"};
			}
		}
	}

	/* This styles the ai panel correctly when its streaming */
	div[extensionType='com.atlassian.ai-blocks']:has(.streaming) {
		.extension-container {
			box-shadow: none;
			overflow: unset;
			${$5c666726bcf85159$var$prismBorderAnimationStyles}
			&::before,
			&::after {
				${$5c666726bcf85159$var$prismBorderStyles(colorMode)}
			}
		}
	}

	/* This styles the ai panel correctly when a user is hovering over the delete button in the floating panel */
	div[extensionType='com.atlassian.ai-blocks'].danger {
		.extension-container {
			box-shadow: 0 0 0 1px ${"var(--ds-border-danger, #E2483D)"};
		}
	}

	/* This removes the margin from the action list when inside an ai panel */
	div[extensiontype='com.atlassian.ai-blocks'][extensionkey='ai-action-items-block:aiActionItemsBodiedExtension'] {
		div[data-node-type='actionList'] {
			margin: 0 !important;
		}
	}
`;

});

parcelRegister("1zjTz", function(module, exports) {

$parcel$export(module.exports, "codeBlockStyles", () => $0e92dcce8e740ae5$export$4baaed2b257b830);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $5MaNT = parcelRequire("5MaNT");

var $aFUXX = parcelRequire("aFUXX");
var $ieXGd = parcelRequire("ieXGd");
var $b38UX = parcelRequire("b38UX");

var $49YLc = parcelRequire("49YLc");
const $0e92dcce8e740ae5$var$GutterDangerOverlay = ()=>(0, $3jLHL.css)`
	&::after {
		height: 100%;
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		width: 24px;
		background-color: ${"var(--ds-blanket-danger, none)"};
	}
`;
/* When code-block is inside the panel  */ const $0e92dcce8e740ae5$var$firstCodeBlockWithNoMargin = (0, $49YLc.functionWithFG)('platform_editor_nested_dnd_styles_changes', ()=>(0, $3jLHL.css)`
		.ak-editor-panel__content {
			> .code-block:first-child,
			> .ProseMirror-widget:first-child + .code-block,
			> .ProseMirror-widget:first-child + .ProseMirror-widget + .code-block {
				margin: 0 0 0 0 !important;
			}
		}
	`, ()=>(0, $3jLHL.css)`
		.ak-editor-panel__content {
			> .code-block:first-child {
				margin: 0 0 0 0 !important;
			}
		}
	`);
const $0e92dcce8e740ae5$export$4baaed2b257b830 = ()=>(0, $3jLHL.css)`
	.ProseMirror {
		${(0, $5MaNT.codeBlockSharedStyles)()}
	}

	.ProseMirror li {
		/* if same list item has multiple code blocks we need top margin for all but first */
		> .code-block {
			margin: ${0, $aFUXX.blockNodesVerticalMargin} 0 0 0;
		}
		> .code-block:first-child,
		> .ProseMirror-gapcursor:first-child + .code-block {
			margin-top: 0;
		}

		> div:last-of-type.code-block,
		> pre:last-of-type.code-block {
			margin-bottom: ${0, $aFUXX.blockNodesVerticalMargin};
		}
	}

	.ProseMirror .code-block.${0, $aFUXX.akEditorSelectedNodeClassName}:not(.danger) {
		${(0, $ieXGd.getSelectionStyles)([
        (0, $b38UX.SelectionStyle).BoxShadow,
        (0, $b38UX.SelectionStyle).Blanket
    ])}
	}

	/* Danger when top level node */
	.ProseMirror .danger.code-block {
		box-shadow: 0 0 0 ${0, $aFUXX.akEditorSelectedBorderSize}px
			${`var(--ds-border-danger, ${0, $aFUXX.akEditorDeleteBorder})`};

		.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER} {
			background-color: ${"var(--ds-background-danger, #FFECEB)"};
			color: ${`var(--ds-text-danger, ${0, $aFUXX.akEditorDeleteIconColor})`};
			${$0e92dcce8e740ae5$var$GutterDangerOverlay()};
		}

		.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT} {
			background-color: ${`var(--ds-blanket-danger, ${0, $aFUXX.akEditorDeleteBackground})`};
		}
	}

	/* Danger when nested node */
	.ProseMirror .danger .code-block {
		.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER} {
			background-color: ${"var(--ds-background-danger, rgba(255, 143, 115, 0.5))"};
			color: ${`var(--ds-text-danger, ${0, $aFUXX.akEditorDeleteIconColor})`};
			${$0e92dcce8e740ae5$var$GutterDangerOverlay()};
		}

		.${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT} {
			background-color: ${"var(--ds-blanket-danger, rgba(255, 189, 173, 0.5))"};
		}
	}

	${$0e92dcce8e740ae5$var$firstCodeBlockWithNoMargin()}
`;

});
parcelRegister("49YLc", function(module, exports) {

$parcel$export(module.exports, "functionWithFG", () => $45703bb7386f8863$export$53903226fff06fbb);

var $dh538 = parcelRequire("dh538");

var $1I43V = parcelRequire("1I43V");
const $45703bb7386f8863$export$53903226fff06fbb = (featureFlagName, functionTrue, functionFalse)=>(0, $1I43V.functionWithCondition)(()=>(0, $dh538.fg)(featureFlagName), functionTrue, functionFalse);

});
parcelRegister("1I43V", function(module, exports) {

$parcel$export(module.exports, "functionWithCondition", () => $4bac077259c47cd6$export$af3c0e82a18fc057);
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ function $4bac077259c47cd6$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
function $4bac077259c47cd6$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return $4bac077259c47cd6$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
}

});



parcelRegister("jFND0", function(module, exports) {

$parcel$export(module.exports, "dateVanillaStyles", () => $11af6579d10ca807$export$b89fadc5134d50fa);
$parcel$export(module.exports, "dateStyles", () => $11af6579d10ca807$export$37579fbc35dcc1a9);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $7bDsi = parcelRequire("7bDsi");

var $aFUXX = parcelRequire("aFUXX");
var $ieXGd = parcelRequire("ieXGd");
var $b38UX = parcelRequire("b38UX");
const $11af6579d10ca807$export$b89fadc5134d50fa = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "[data-prosemirror-node-view-type='vanilla'][data-prosemirror-node-name='date'] .date-lozenger-container span": {
        backgroundColor: "var(--ds-background-neutral, #091E420F)",
        color: "var(--ds-text, #172B4D)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
        margin: '0 1px',
        position: 'relative',
        transition: 'background 0.3s',
        whiteSpace: 'nowrap',
        cursor: 'unset'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "[data-prosemirror-node-view-type='vanilla'][data-prosemirror-node-name='date'] .date-lozenger-container span:hover": {
        backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "[data-prosemirror-node-view-type='vanilla'][data-prosemirror-node-name='date'] .date-lozenger-container span.date-node-color-red": {
        backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "[data-prosemirror-node-view-type='vanilla'][data-prosemirror-node-name='date'] .date-lozenger-container span.date-node-color-red:hover": {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
    }
});
const $11af6579d10ca807$export$37579fbc35dcc1a9 = (0, $3jLHL.css)`
	.${(0, $7bDsi.DateSharedCssClassName).DATE_CONTAINER} {
		.${(0, $7bDsi.DateSharedCssClassName).DATE_WRAPPER} {
			line-height: initial;
			cursor: pointer;
		}

		&.${(0, $aFUXX.akEditorSelectedNodeClassName)} {
			.${(0, $7bDsi.DateSharedCssClassName).DATE_WRAPPER} > span {
				${(0, $ieXGd.getSelectionStyles)([
    (0, $b38UX.SelectionStyle).BoxShadow
])}
			}
		}
	}

	.danger {
		.${(0, $7bDsi.DateSharedCssClassName).DATE_CONTAINER}.${(0, $aFUXX.akEditorSelectedNodeClassName)}
			.${(0, $7bDsi.DateSharedCssClassName).DATE_WRAPPER}
			> span {
			box-shadow: 0 0 0 ${(0, $aFUXX.akEditorSelectedBorderSize)}px
				${`var(--ds-border-danger, ${(0, $aFUXX.akEditorDeleteBorder)})`};
		}
	}
`;

});

parcelRegister("gSnRq", function(module, exports) {

$parcel$export(module.exports, "expandStyles", () => $60a22b2df96afb5e$export$4bb28258452e3b9a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $ly3wu = parcelRequire("ly3wu");
var $iMS6j = parcelRequire("iMS6j");
var $4zRjW = parcelRequire("4zRjW");

var $aFUXX = parcelRequire("aFUXX");
var $ieXGd = parcelRequire("ieXGd");
var $b38UX = parcelRequire("b38UX");

var $dh538 = parcelRequire("dh538");
const $60a22b2df96afb5e$var$EXPAND_SELECTED_BACKGROUND = "var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0.6))";
const $60a22b2df96afb5e$var$EXPAND_ICON_COLOR = ()=>(0, $3jLHL.css)({
        color: "var(--ds-icon-subtle, #626F86)"
    });
const $60a22b2df96afb5e$var$DANGER_STATE_BACKGROUND_COLOR = "var(--ds-background-danger, #FFECEB)";
const $60a22b2df96afb5e$var$DANGER_STATE_BORDER_COLOR = "var(--ds-border-danger, #E2483D)";
const $60a22b2df96afb5e$var$firstNodeWithNotMarginTop = ()=>(0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $3jLHL.css)`
				> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)) {
					margin-top: 0;
				}

				> div.ak-editor-expand[data-node-type='nestedExpand'] {
					margin-top: ${"var(--ds-space-050, 0.25rem)"};
				}
			` : '';
const $60a22b2df96afb5e$export$4bb28258452e3b9a = ()=>(0, $3jLHL.css)`
	.${(0, $iMS6j.expandClassNames).icon} > div {
		display: flex;
	}

	.${(0, $iMS6j.expandClassNames).prefix} {
		${(0, $4zRjW.sharedExpandStyles).containerStyles({
        expanded: false,
        focused: false
    })()}

		cursor: pointer;
		box-sizing: border-box;

		td > & {
			margin-top: 0;
		}

		.${(0, $iMS6j.expandClassNames).iconContainer} svg {
			${$60a22b2df96afb5e$var$EXPAND_ICON_COLOR()};
			transform: rotate(90deg);
		}

		&.${0, $aFUXX.akEditorSelectedNodeClassName}:not(.danger) {
			${(0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? (0, $ieXGd.getSelectionStyles)([
        (0, $b38UX.SelectionStyle).Blanket
    ]) + `border: ${0, $aFUXX.akEditorSelectedBorder};` : (0, $ieXGd.getSelectionStyles)([
        (0, $b38UX.SelectionStyle).Blanket,
        (0, $b38UX.SelectionStyle).Border
    ])}
		}

		&.danger {
			background: ${$60a22b2df96afb5e$var$DANGER_STATE_BACKGROUND_COLOR};
			border-color: ${$60a22b2df96afb5e$var$DANGER_STATE_BORDER_COLOR};
		}
	}

	.ProseMirror
		> .${(0, $iMS6j.expandClassNames).type('expand')},
		.${(0, $ly3wu.BreakoutCssClassName).BREAKOUT_MARK_DOM}
		> .${(0, $iMS6j.expandClassNames).type('expand')} {
		margin-left: -${0, $aFUXX.akLayoutGutterOffset}px;
		margin-right: -${0, $aFUXX.akLayoutGutterOffset}px;
	}

	${(0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') && `.ak-editor-content-area.appearance-full-page .ProseMirror
		> .${(0, $iMS6j.expandClassNames).type('expand')},
		.${(0, $ly3wu.BreakoutCssClassName).BREAKOUT_MARK_DOM}
		> .${(0, $iMS6j.expandClassNames).type('expand')} {
		margin-left: -${(0, $aFUXX.akLayoutGutterOffset) + 8}px;
		margin-right: -${(0, $aFUXX.akLayoutGutterOffset) + 8}px;
	}`}

	.${(0, $iMS6j.expandClassNames).content} {
		${(0, $4zRjW.sharedExpandStyles).contentStyles({
        expanded: false,
        focused: false
    })()}
		cursor: text;
		padding-top: 0px;
	}

	.${(0, $iMS6j.expandClassNames).titleInput} {
		${(0, $4zRjW.sharedExpandStyles).titleInputStyles()}
	}

	.${(0, $iMS6j.expandClassNames).titleContainer} {
		${(0, $4zRjW.sharedExpandStyles).titleContainerStyles()};
		align-items: center;
		overflow: visible;
	}

	.${(0, $iMS6j.expandClassNames).expanded} {
		background: ${$60a22b2df96afb5e$var$EXPAND_SELECTED_BACKGROUND};
		border-color: ${"var(--ds-border, #091E4224)"};

		.${(0, $iMS6j.expandClassNames).content} {
			padding-top: ${"var(--ds-space-100, 8px)"};

			${$60a22b2df96afb5e$var$firstNodeWithNotMarginTop()}
		}
	}

	.${(0, $iMS6j.expandClassNames).inputContainer} {
		width: 100%;
	}

	/* stylelint-disable property-no-unknown, value-keyword-case */
	.${(0, $iMS6j.expandClassNames).prefix}:(.${(0, $iMS6j.expandClassNames).expanded}) {
		.expand-content-wrapper {
			height: auto;
		}
	}
	/* stylelint-enable property-no-unknown, value-keyword-case */

	.${(0, $iMS6j.expandClassNames).prefix}:not(.${(0, $iMS6j.expandClassNames).expanded}) {
		.ak-editor-expand__content {
			position: absolute;
			height: 1px;
			width: 1px;
			overflow: hidden;
			clip: rect(1px, 1px, 1px, 1px);
			white-space: nowrap;
		}

		.${(0, $iMS6j.expandClassNames).iconContainer} svg {
			${$60a22b2df96afb5e$var$EXPAND_ICON_COLOR()};
			transform: rotate(0deg);
		}

		&:not(.${0, $aFUXX.akEditorSelectedNodeClassName}):not(.danger) {
			background: transparent;
			border-color: transparent;

			&:hover {
				border-color: ${"var(--ds-border, #091E4224)"};
				background: ${$60a22b2df96afb5e$var$EXPAND_SELECTED_BACKGROUND};
			}
		}
	}
`;

});
parcelRegister("ly3wu", function(module, exports) {

$parcel$export(module.exports, "BreakoutCssClassName", () => $fe361930a2595c94$export$c21a3b023fccd534);
const $fe361930a2595c94$export$c21a3b023fccd534 = {
    BREAKOUT_MARK: 'fabric-editor-breakout-mark',
    BREAKOUT_MARK_DOM: 'fabric-editor-breakout-mark-dom'
};

});

parcelRegister("4zRjW", function(module, exports) {

$parcel$export(module.exports, "sharedExpandStyles", () => $631ba4830cc4824c$export$8c0b53d8e8508fed);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $aFUXX = parcelRequire("aFUXX");

var $dh538 = parcelRequire("dh538");
const $631ba4830cc4824c$var$BORDER_RADIUS = "var(--ds-border-radius-100, 4px)";
const $631ba4830cc4824c$var$EXPAND_COLLAPSED_BACKGROUND = "var(--ds-background-neutral-subtle, transparent)";
const $631ba4830cc4824c$var$EXPAND_SELECTED_BACKGROUND = "var(--ds-surface, rgba(255, 255, 255, 0.6))";
const $631ba4830cc4824c$var$EXPAND_FOCUSED_BORDER_COLOR = "var(--ds-border-focused, #388BFF)";
const $631ba4830cc4824c$var$EXPAND_COLLAPSED_BORDER_COLOR = 'transparent';
const $631ba4830cc4824c$var$EXPAND_EXPANDED_BORDER_COLOR = "var(--ds-border, #091E4224)";
const $631ba4830cc4824c$var$containerStyles = (styleProps)=>{
    const { expanded: expanded, focused: focused } = styleProps;
    const marginTop = "var(--ds-space-050, 0.25rem)";
    const marginBottom = 0;
    // Only only these margins if the expand isn't editable
    // and is the root level expand.
    const marginHorizontal = styleProps['data-node-type'] === 'expand' ? `-${0, $aFUXX.akLayoutGutterOffset}px` : 0;
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const margin = `${marginTop} ${marginHorizontal} ${marginBottom}`;
    return ()=>(0, $3jLHL.css)({
            borderWidth: '1px',
            borderStyle: 'solid',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: focused ? $631ba4830cc4824c$var$EXPAND_FOCUSED_BORDER_COLOR : expanded ? $631ba4830cc4824c$var$EXPAND_EXPANDED_BORDER_COLOR : $631ba4830cc4824c$var$EXPAND_COLLAPSED_BORDER_COLOR,
            borderRadius: $631ba4830cc4824c$var$BORDER_RADIUS,
            minHeight: '25px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: !expanded ? $631ba4830cc4824c$var$EXPAND_COLLAPSED_BACKGROUND : $631ba4830cc4824c$var$EXPAND_SELECTED_BACKGROUND,
            margin: margin,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `background 0.3s ${(0, $aFUXX.akEditorSwoopCubicBezier)}, border-color 0.3s ${(0, $aFUXX.akEditorSwoopCubicBezier)}`,
            padding: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            'td > :not(style):first-child, td > style:first-child + *': {
                marginTop: 0
            }
        });
};
const $631ba4830cc4824c$var$contentStyles = (styleProps)=>()=>// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        (0, $3jLHL.css)`
		padding-top: ${styleProps.expanded ? "var(--ds-space-100, 8px)" : "var(--ds-space-0, 0px)"};
		padding-right: ${"var(--ds-space-100, 8px)"};
		padding-left: ${"var(--ds-space-300, 24px)"};
		margin-left: ${"var(--ds-space-050, 4px)"};
		display: flow-root;

		/* The follow rules inside @supports block are added as a part of ED-8893
		The fix is targeting mobile bridge on iOS 12 or below,
		We should consider remove this fix when we no longer support iOS 12 */
		@supports not (display: flow-root) {
			width: 100%;
			box-sizing: border-box;
		}

		${!styleProps.expanded ? `
        .expand-content-wrapper, .nestedExpand-content-wrapper {
          /* We visually hide the content here to preserve the content during copy+paste */
          /* Do not add text nowrap here because inline comment navigation depends on the location of the text */
          width: 100%;
          display: block;
          height: 0;
          overflow: hidden;
          clip: rect(1px, 1px, 1px, 1px);
          user-select: none;
        }
      ` : ''}
	`;
const $631ba4830cc4824c$var$titleInputStyles = ()=>(0, $3jLHL.css)({
        outline: 'none',
        border: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $aFUXX.relativeFontSizeToBase16)(14),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        lineHeight: (0, $dh538.fg)('platform-visual-refresh-icons') ? 1 : (0, $aFUXX.akEditorLineHeight),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        color: "var(--ds-text-subtlest, #626F86)",
        background: 'transparent',
        display: 'flex',
        flex: 1,
        padding: `0 0 0 ${"var(--ds-space-050, 4px)"}`,
        width: '100%',
        '&::placeholder': {
            opacity: 1,
            color: "var(--ds-text-subtlest, #626F86)"
        }
    });
const $631ba4830cc4824c$var$titleContainerStyles = ()=>(0, $3jLHL.css)({
        padding: 0,
        display: 'flex',
        alignItems: 'flex-start',
        background: 'none',
        border: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $aFUXX.relativeFontSizeToBase16)(14),
        width: '100%',
        color: "var(--ds-text-subtle, #44546F)",
        overflow: 'hidden',
        cursor: 'pointer',
        '&:focus': {
            outline: 0
        }
    });
const $631ba4830cc4824c$export$8c0b53d8e8508fed = {
    titleInputStyles: $631ba4830cc4824c$var$titleInputStyles,
    titleContainerStyles: $631ba4830cc4824c$var$titleContainerStyles,
    containerStyles: $631ba4830cc4824c$var$containerStyles,
    contentStyles: $631ba4830cc4824c$var$contentStyles
};

});


parcelRegister("6dFlY", function(module, exports) {

$parcel$export(module.exports, "extensionStyles", () => $d82bd765b1d3bdb0$export$c0c648396dbd86d3);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $aFUXX = parcelRequire("aFUXX");
var $ieXGd = parcelRequire("ieXGd");
var $b38UX = parcelRequire("b38UX");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
const $d82bd765b1d3bdb0$var$extensionLabelStyles = (0, $3jLHL.css)`
	&.danger > span > div > .extension-label {
		background-color: ${"var(--ds-background-accent-red-subtler, #FFD5D2)"};
		color: ${"var(--ds-text-danger, #AE2E24)"};
		opacity: 1;
		box-shadow: none;
	}

	&:not(.danger).${(0, $aFUXX.akEditorSelectedNodeClassName)} > span > div > .extension-label {
		background-color: ${"var(--ds-background-selected, #E9F2FF)"};
		color: ${"var(--ds-text-selected, #0C66E4)"};
		opacity: 1;
		box-shadow: none;
	}

	/* Targets the icon for bodied macro styling in button label */
	&.danger > span > div > .extension-label > span {
		display: inline;
	}

	&:not(.danger).${(0, $aFUXX.akEditorSelectedNodeClassName)} > span > div .extension-label > span {
		display: inline;
	}

	/* Start of bodied extension edit toggle styles */
	&.danger.${(0, $aFUXX.akEditorSelectedNodeClassName)} > span > .extension-edit-toggle-container {
		opacity: 1;
	}

	&:not(.danger).${(0, $aFUXX.akEditorSelectedNodeClassName)} > span > .extension-edit-toggle-container {
		opacity: 1;
	}

	/* In view mode of the bodied macro, we never want to show the extension label */
	&.danger.${(0, $aFUXX.akEditorSelectedNodeClassName)} > span > div > .extension-label.always-hide-label {
		opacity: 0;
	}

	&:not(.danger).${(0, $aFUXX.akEditorSelectedNodeClassName)}
		> span
		> div
		> .extension-label.always-hide-label {
		opacity: 0;
	}

	/* .with-bodied-macro-live-page-styles class will only be added to bodied macros with the renderer mode gate enabled */
	&:not(.danger).${(0, $aFUXX.akEditorSelectedNodeClassName)}
		> span
		> div
		> .extension-label.with-bodied-macro-live-page-styles {
		box-shadow: 0 0 0 ${(0, $aFUXX.akEditorSelectedBorderSize)}px ${"var(--ds-border-selected, #0C66E4)"};
	}

	&.danger.${(0, $aFUXX.akEditorSelectedNodeClassName)}
		> span
		> div
		> .extension-label.with-bodied-macro-live-page-styles {
		box-shadow: 0 0 0 ${(0, $aFUXX.akEditorSelectedBorderSize)}px ${"var(--ds-border-danger, #E2483D)"};
	}

	&.danger.${(0, $aFUXX.akEditorSelectedNodeClassName)}
		> span
		> .extension-edit-toggle-container
		> .extension-edit-toggle {
		background-color: ${"var(--ds-background-accent-red-subtler, #FFD5D2)"};
		color: ${"var(--ds-text-danger, #AE2E24)"};
		box-shadow: none;
	}
`;
const $d82bd765b1d3bdb0$var$dangerOverlayStyles = (0, $3jLHL.css)({
    opacity: 0.3,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-background-danger-hovered, ${(0, $aFUXX.akEditorDeleteBackground)})`
});
const $d82bd765b1d3bdb0$export$c0c648396dbd86d3 = (0, $3jLHL.css)`
	.multiBodiedExtensionView-content-wrap {
		&.danger > span > .multiBodiedExtension--container {
			box-shadow: 0 0 0 ${(0, $aFUXX.akEditorSelectedBorderSize)}px
				${`var(--ds-border-danger, ${(0, $aFUXX.akEditorDeleteBorder)})`};
			background-color: ${`var(--ds-background-danger, ${(0, $aFUXX.akEditorDeleteBackground)})`};
		}

		${$d82bd765b1d3bdb0$var$extensionLabelStyles}

		&.danger > span > .with-danger-overlay {
			background-color: transparent;
			.multiBodiedExtension--overlay {
				${$d82bd765b1d3bdb0$var$dangerOverlayStyles}
			}
		}

		&:not(.danger).${(0, $aFUXX.akEditorSelectedNodeClassName)} {
			& > span > .multiBodiedExtension--container {
				${(0, $ieXGd.getSelectionStyles)([
    (0, $b38UX.SelectionStyle).BoxShadow,
    (0, $b38UX.SelectionStyle).Blanket
])}
			}
		}
		.multiBodiedExtension--container {
			width: 100%;
			max-width: 100%; /* ensure width can't go over 100% */
		}
	}

	.inlineExtensionView-content-wrap {
		&.danger > span > .extension-container {
			box-shadow: 0 0 0 ${(0, $aFUXX.akEditorSelectedBorderSize)}px
				${`var(--ds-border-danger, ${(0, $aFUXX.akEditorDeleteBorder)})`};
			background-color: ${`var(--ds-background-danger, ${(0, $aFUXX.akEditorDeleteBackground)})`};
		}

		&.danger > span > .with-danger-overlay {
			/* If the macro turned used to turn red before, not setting the background to be transparent will cause the
			danger state to have two layers of red which we don't want. */
			background-color: transparent;
			.extension-overlay {
				${$d82bd765b1d3bdb0$var$dangerOverlayStyles}
			}
		}

		&:not(.danger).${(0, $aFUXX.akEditorSelectedNodeClassName)} {
			& > span > .extension-container {
				${(0, $ieXGd.getSelectionStyles)([
    (0, $b38UX.SelectionStyle).BoxShadow
])}
			}
		}

		${$d82bd765b1d3bdb0$var$extensionLabelStyles}
	}

	/* This is referenced in the toDOM of a bodied extension and is used to put
	label content into the bodied extension.
	We do this so that we don't serialise the label (which causes the label to be
	be copied to the clipboard causing copy-paste issues). */
	.bodied-extension-to-dom-label::after {
		content: attr(data-bodied-extension-label);
	}

	.extensionView-content-wrap,
	.multiBodiedExtensionView-content-wrap,
	.bodiedExtensionView-content-wrap {
		margin: ${(0, $aFUXX.blockNodesVerticalMargin)} 0;

		&:first-of-type {
			margin-top: 0;
		}

		&:last-of-type {
			margin-bottom: 0;
		}

		&:not(.danger).${(0, $aFUXX.akEditorSelectedNodeClassName)} {
			& > span > .extension-container {
				${(0, $ieXGd.getSelectionStyles)([
    (0, $b38UX.SelectionStyle).BoxShadow
])}
			}
		}

		&.danger > span > .extension-container {
			box-shadow: 0 0 0 ${(0, $aFUXX.akEditorSelectedBorderSize)}px
				${`var(--ds-border-danger, ${(0, $aFUXX.akEditorDeleteBorder)})`};
			background-color: ${`var(--ds-background-danger, ${(0, $aFUXX.akEditorDeleteBackground)})`};
		}

		${$d82bd765b1d3bdb0$var$extensionLabelStyles}

		&.danger > span > .with-danger-overlay {
			background-color: transparent;
			.extension-overlay {
				${$d82bd765b1d3bdb0$var$dangerOverlayStyles}
			}
		}

		&.inline {
			word-wrap: break-all;
		}
	}

	.extensionView-content-wrap .extension-container {
		overflow: hidden;

		/* Don't hide overflow for editors inside extensions */
		&:has(.extension-editable-area) {
			overflow: visible;
		}
	}

	.bodiedExtensionView-content-wrap .extensionView-content-wrap .extension-container {
		width: 100%;
		max-width: 100%; /* ensure width can't go over 100% */
	}

	[data-mark-type='fragment'] {
		& > .extensionView-content-wrap,
		& > .bodiedExtensionView-content-wrap {
			margin: ${(0, $aFUXX.blockNodesVerticalMargin)} 0;
		}

		& > [data-mark-type='dataConsumer'] {
			& > .extensionView-content-wrap,
			& > .bodiedExtensionView-content-wrap {
				margin: ${(0, $aFUXX.blockNodesVerticalMargin)} 0;
			}
		}

		&:first-child {
			& > .extensionView-content-wrap,
			& > .bodiedExtensionView-content-wrap {
				margin-top: 0;
			}

			& > [data-mark-type='dataConsumer'] {
				& > .extensionView-content-wrap,
				& > .bodiedExtensionView-content-wrap {
					margin-top: 0;
				}
			}
		}

		&:nth-last-of-type(-n + 2):not(:first-of-type) {
			& > .extensionView-content-wrap,
			& > .bodiedExtensionView-content-wrap {
				margin-bottom: 0;
			}

			& > [data-mark-type='dataConsumer'] {
				& > .extensionView-content-wrap,
				& > .bodiedExtensionView-content-wrap {
					margin-bottom: 0;
				}
			}
		}
	}
`;

});

parcelRegister("3oH64", function(module, exports) {

$parcel$export(module.exports, "layoutStyles", () => $d4229973896577c1$export$ac8f5049e4e10701);
/**
 * TODO ED-26957 - remove legacy styles when static emotion refactor is complete
 * We are moving this to new location under FF: platform_editor_core_static_emotion
 * New location: packages/editor/editor-core/src/ui/EditorContentContainer.tsx
 * If you are making updates to this file, please updates in new location as well.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $lfBm5 = parcelRequire("lfBm5");
var $boKri = parcelRequire("boKri");
parcelRequire("jK0dl");
var $d5aTJ = parcelRequire("d5aTJ");
parcelRequire("eJQfi");
var $eoFXy = parcelRequire("eoFXy");

var $aFUXX = parcelRequire("aFUXX");
var $ieXGd = parcelRequire("ieXGd");
var $b38UX = parcelRequire("b38UX");

var $dh538 = parcelRequire("dh538");

var $iu6m9 = parcelRequire("iu6m9");
const $d4229973896577c1$var$AK_NESTED_DND_GUTTER_OFFSET = 8;
const $d4229973896577c1$var$firstNodeWithNotMarginTop = ()=>(0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $3jLHL.css)`
				> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)) {
					margin-top: 0;
				}
			` : // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $3jLHL.css)`
				> :not(style):first-child,
				> style:first-child + * {
					margin-top: 0;
				}

				> .ProseMirror-gapcursor:first-child + *,
				> style:first-child + .ProseMirror-gapcursor + * {
					margin-top: 0;
				}

				> .ProseMirror-gapcursor:first-child + span + * {
					margin-top: 0;
				}
			`;
// Ignored via go/ees007
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO handle responsive
const $d4229973896577c1$var$layoutColumnStyles = ()=>(0, $iu6m9.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $3jLHL.css)`
				> [data-layout-column] {
					margin: 0 ${(0, $boKri.LAYOUT_SECTION_MARGIN) / 2}px;
				}

				> [data-layout-column]:first-of-type {
					margin-left: 0;
				}

				> [data-layout-column]:last-of-type {
					margin-right: 0;
				}

				@media screen and (max-width: ${0, $aFUXX.gridMediumMaxWidth}px) {
					[data-layout-column] + [data-layout-column] {
						margin: 0;
					}
				}

				> [data-layout-column].${0, $aFUXX.akEditorSelectedNodeClassName}:not(.danger) {
					${(0, $ieXGd.getSelectionStyles)([
        (0, $b38UX.SelectionStyle).Blanket
    ])};
					/* layout column selection shorter after layout border has been removed */
					::before {
						width: calc(100% - 8px);
						left: 4px;
						border-radius: ${"var(--ds-border-radius, 3px)"};
					}
				}
			` : // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $3jLHL.css)`
				[data-layout-column] + [data-layout-column] {
					margin-left: ${0, $boKri.LAYOUT_SECTION_MARGIN}px;
				}

				@media screen and (max-width: ${0, $aFUXX.gridMediumMaxWidth}px) {
					[data-layout-column] + [data-layout-column] {
						margin-left: 0;
					}
				}
			`;
const $d4229973896577c1$var$layoutSectionStyles = ()=>(0, $iu6m9.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $3jLHL.css)`
				${0, $lfBm5.columnLayoutResponsiveSharedStyle};
				.layout-section-container [data-layout-section] {
					> .ProseMirror-widget {
						flex: none;
						display: contents !important;

						&[data-blocks-drag-handle-container] div {
							display: contents !important;
						}

						&[data-blocks-drop-target-container] {
							display: block !important;
							margin: ${"var(--ds-space-negative-050, -4px)"};

							[data-drop-target-for-element] {
								position: absolute;
							}
						}

						& + [data-layout-column] {
							margin: 0;
						}
					}

					> [data-layout-column] {
						margin: 0;
					}
				}
			` : // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $3jLHL.css)`
				${0, $lfBm5.columnLayoutSharedStyle}
			`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $d4229973896577c1$var$layoutBorderStyles = (viewMode)=>(0, $3jLHL.css)`
	/* TODO: Remove the border styles below once design tokens have been enabled and fallbacks are no longer triggered.
	This is because the default state already uses the same token and, as such, the hover style won't change anything.
	https://product-fabric.atlassian.net/browse/DSP-4441 */
	/* Shows the border when cursor is inside a layout */
	&.selected [data-layout-column],
	&:hover [data-layout-column] {
		border: ${viewMode === 'view' ? 0 : (0, $aFUXX.akEditorSelectedBorderSize)}px solid ${"var(--ds-border, #091E4224)"};
	}

	&.selected.danger [data-layout-column] {
		background-color: ${`var(--ds-background-danger, ${0, $aFUXX.akEditorDeleteBackground})`};
		border-color: ${`var(--ds-border-danger, ${0, $aFUXX.akEditorDeleteBorder})`};
	}

	&.${0, $aFUXX.akEditorSelectedNodeClassName}:not(.danger) {
		[data-layout-column] {
			${(0, $ieXGd.getSelectionStyles)([
        (0, $b38UX.SelectionStyle).Border,
        (0, $b38UX.SelectionStyle).Blanket
    ])}
			::after {
				background-color: transparent;
			}
		}
	}
`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $d4229973896577c1$var$columnSeparatorStyles = (viewMode)=>(0, $3jLHL.css)`
	[data-layout-content]::before {
		content: '';
		border-left: ${viewMode === 'view' ? 0 : (0, $aFUXX.akEditorSelectedBorderSize)}px solid
			${"var(--ds-border, #091E4224)"};
		position: absolute;
		height: calc(100% - 24px);
		margin-left: -25px;
	}
`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $d4229973896577c1$var$rowSeparatorStyles = (viewMode)=>(0, $3jLHL.css)`
	[data-layout-content]::before {
		content: '';
		border-top: ${viewMode === 'view' ? 0 : (0, $aFUXX.akEditorSelectedBorderSize)}px solid
			${"var(--ds-border, #091E4224)"};
		position: absolute;
		width: calc(100% - 32px);
		margin-top: -13px;

		/* clear styles for column separator */
		border-left: unset;
		margin-left: unset;
		height: unset;
	}
`;
// jest warning: JSDOM version (22) doesn't support the new @container CSS rule
const $d4229973896577c1$var$layoutWithSeparatorBorderResponsiveStyles = (breakpoint, viewMode)=>(0, $3jLHL.css)`
	&.selected,
	&:hover,
	&.selected.danger,
	&.${0, $aFUXX.akEditorSelectedNodeClassName}:not(.danger) {
		[data-layout-column]:not(:first-of-type) {
			@container editor-area (max-width:${breakpoint}px) {
				${$d4229973896577c1$var$rowSeparatorStyles(viewMode)}
			}
		}
	}
`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $d4229973896577c1$var$layoutWithSeparatorBorderStyles = (viewMode)=>{
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    return (0, $3jLHL.css)`
		&.selected [data-layout-column]:not(:first-of-type),
		[data-empty-layout='true'] [data-layout-column]:not(:first-of-type),
		&:hover [data-layout-column]:not(:first-of-type) {
			${$d4229973896577c1$var$columnSeparatorStyles(viewMode)}
		}

		&.selected.danger [data-layout-section] {
			background-color: ${`var(--ds-background-danger, ${0, $aFUXX.akEditorDeleteBackground})`};

			box-shadow: 0 0 0 ${viewMode === 'view' ? 0 : (0, $aFUXX.akEditorSelectedBorderSize)}px
				${0, $aFUXX.akEditorDeleteBorder};
			border-radius: 4px;
			[data-layout-column]:not(:first-of-type) {
				${$d4229973896577c1$var$columnSeparatorStyles(viewMode)}
			}
		}

		&.${0, $aFUXX.akEditorSelectedNodeClassName}:not(.danger) [data-layout-section] {
			box-shadow: 0 0 0 ${viewMode === 'view' ? 0 : (0, $aFUXX.akEditorSelectedBorderSize)}px
				${"var(--ds-border-selected, #0C66E4)"};
			border-radius: 4px;
			background-color: ${"var(--ds-background-selected, #E9F2FF)"};
			[data-layout-column] {
				${(0, $ieXGd.getSelectionStyles)([
        (0, $b38UX.SelectionStyle).Blanket
    ])}
				border: 0px;
				::before {
					background-color: transparent;
				}
			}
			[data-layout-column]:not(:first-of-type) {
				${$d4229973896577c1$var$columnSeparatorStyles(viewMode)}
			}
		}
	`;
};
// jest warning: JSDOM version (22) doesn't support the new @container CSS rule
const $d4229973896577c1$var$layoutResponsiveStyles = (viewMode)=>// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $3jLHL.css)`
		/* chosen breakpoints in container queries are to make sure layout responsiveness in editor aligns with renderer */
		/* not resized layout in full-width editor */
		.fabric-editor--full-width-mode .ProseMirror {
			> .layoutSectionView-content-wrap {
				[data-layout-section] {
					@container editor-area (max-width:724px) {
						flex-direction: column;
					}
				}

				${$d4229973896577c1$var$layoutWithSeparatorBorderResponsiveStyles(724, viewMode)}
			}
		}

		/* not resized layout in fixed-width editor */
		.ak-editor-content-area:not(.fabric-editor--full-width-mode) .ProseMirror {
			> .layoutSectionView-content-wrap {
				[data-layout-section] {
					@container editor-area (max-width:788px) {
						flex-direction: column;
					}
				}

				${$d4229973896577c1$var$layoutWithSeparatorBorderResponsiveStyles(788, viewMode)}
			}
		}

		/* resized layout in full/fixed-width editor */
		.ProseMirror .fabric-editor-breakout-mark {
			.layoutSectionView-content-wrap {
				[data-layout-section] {
					@container editor-area (max-width:820px) {
						flex-direction: column;
					}
				}

				${$d4229973896577c1$var$layoutWithSeparatorBorderResponsiveStyles(820, viewMode)}
			}
		}
	`;
const $d4229973896577c1$export$ac8f5049e4e10701 = (viewMode)=>(0, $3jLHL.css)`
	.ProseMirror {
		${$d4229973896577c1$var$layoutSectionStyles()}
		[data-layout-section] {
			/* Ignored via go/ees007
			TODO: Migrate away from gridSize
			Recommendation: Replace directly with 7px */
			margin: ${"var(--ds-space-100, 8px)"} -${(0, $aFUXX.akLayoutGutterOffset) + ((0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? $d4229973896577c1$var$AK_NESTED_DND_GUTTER_OFFSET : 0)}px 0;
			transition: border-color 0.3s ${0, $aFUXX.akEditorSwoopCubicBezier};
			cursor: ${viewMode === 'view' ? 'default' : 'pointer'};

			/* Inner cursor located 26px from left */
			[data-layout-column] {
				flex: 1;
				position: relative;

				min-width: 0;
				/* disable 4 borders when in view mode and advanced layouts is on */
				border: ${viewMode === 'view' || (0, $iu6m9.editorExperiment)('advanced_layouts', true) ? 0 : (0, $aFUXX.akEditorSelectedBorderSize)}px
					solid ${"var(--ds-border, #091E4224)"};
				border-radius: 4px;
				padding: ${0, $boKri.LAYOUT_COLUMN_PADDING}px
					${(0, $boKri.LAYOUT_COLUMN_PADDING) + ((0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? 8 : 0)}px;
				box-sizing: border-box;

				> div {
					${$d4229973896577c1$var$firstNodeWithNotMarginTop()}

					> .embedCardView-content-wrap:first-of-type .rich-media-item {
						margin-top: 0;
					}

					> .mediaSingleView-content-wrap:first-of-type .rich-media-item {
						margin-top: 0;
					}

					> .ProseMirror-gapcursor.-right:first-child
						+ .mediaSingleView-content-wrap
						.rich-media-item,
					> style:first-child
						+ .ProseMirror-gapcursor.-right
						+ .mediaSingleView-content-wrap
						.rich-media-item,
					> .ProseMirror-gapcursor.-right:first-of-type
						+ .embedCardView-content-wrap
						.rich-media-item {
						margin-top: 0;
					}

					> .ProseMirror-gapcursor:first-child
						+ span
						+ .mediaSingleView-content-wrap
						.rich-media-item,
					> style:first-child
						+ .ProseMirror-gapcursor
						+ span
						+ .mediaSingleView-content-wrap
						.rich-media-item {
						margin-top: 0;
					}

					/* Prevent first DecisionWrapper's margin-top: 8px from shifting decisions down
             and shrinking layout's node selectable area (leniency margin) */
					> [data-node-type='decisionList'] {
						li:first-of-type [data-decision-wrapper] {
							margin-top: 0;
						}
					}
				}

				/* Make the 'content' fill the entire height of the layout column to allow click
           handler of layout section nodeview to target only data-layout-column */
				[data-layout-content] {
					height: 100%;
					cursor: text;
					.mediaGroupView-content-wrap {
						clear: both;
					}
				}
			}

			${$d4229973896577c1$var$layoutColumnStyles()}
		}

		/* styles to support borders for layout */
		[data-layout-section],
		.layoutSectionView-content-wrap {
			${(0, $iu6m9.editorExperiment)('advanced_layouts', true) ? $d4229973896577c1$var$layoutWithSeparatorBorderStyles(viewMode) : $d4229973896577c1$var$layoutBorderStyles(viewMode)}
		}
	}

	${(0, $iu6m9.editorExperiment)('advanced_layouts', true) && $d4229973896577c1$var$layoutResponsiveStyles(viewMode)}

	/* hide separator when element is dragging on top of a layout column */
	[data-blocks-drop-target-container] ~ [data-layout-column] > [data-layout-content]::before {
		display: none;
	}

	.fabric-editor--full-width-mode .ProseMirror {
		[data-layout-section] {
			.${(0, $d5aTJ.TableCssClassName).TABLE_CONTAINER} {
				margin: 0 ${0, $eoFXy.tableMarginFullWidthMode}px;
			}
		}
	}

	${(0, $iu6m9.editorExperiment)('advanced_layouts', false) && (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') && `.ak-editor-content-area.appearance-full-page .ProseMirror [data-layout-section] {
				margin: ${"var(--ds-space-100, 8px)"} -${(0, $aFUXX.akLayoutGutterOffset) + 8}px 0;
				}`}
`;

});
parcelRegister("lfBm5", function(module, exports) {

$parcel$export(module.exports, "columnLayoutSharedStyle", () => $856265a0c9696fc2$export$6891a39948814a80);
$parcel$export(module.exports, "columnLayoutResponsiveSharedStyle", () => $856265a0c9696fc2$export$3afcac98e7ca927d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $aFUXX = parcelRequire("aFUXX");
const $856265a0c9696fc2$export$6891a39948814a80 = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $aFUXX.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $856265a0c9696fc2$export$3afcac98e7ca927d = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-layout-section]': {
        display: 'flex',
        flexDirection: 'row',
        gap: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.layout-section-container': {
        containerType: 'inline-size',
        containerName: 'layout-area'
    }
});
const $856265a0c9696fc2$var$LAYOUT_BREAKPOINT_RENDERER = 629;
/* jest warning: JSDOM version (22) doesn't support the new @container CSS rule */ const $856265a0c9696fc2$export$f2451ec7aca7656c = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.layout-section-container': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            gap: "var(--ds-space-600, 48px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`@container layout-area (max-width:${$856265a0c9696fc2$var$LAYOUT_BREAKPOINT_RENDERER}px)`]: {
                flexDirection: 'column',
                gap: "var(--ds-space-400, 32px)"
            }
        }
    }
});

});

parcelRegister("jK0dl", function(module, exports) {

$parcel$export(module.exports, "TableCssClassName", () => (parcelRequire("d5aTJ")).TableCssClassName);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $d5aTJ = parcelRequire("d5aTJ");

});
parcelRegister("d5aTJ", function(module, exports) {

$parcel$export(module.exports, "RESIZE_HANDLE_AREA_DECORATION_GAP", () => $8b6ac7577f3a66b8$export$1a38c7157d718094);
$parcel$export(module.exports, "TableDecorations", () => $8b6ac7577f3a66b8$export$fe8f2ca19399400e);
$parcel$export(module.exports, "TableCssClassName", () => $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f);
$parcel$export(module.exports, "ShadowEvent", () => $8b6ac7577f3a66b8$export$ce63d9b315ac58c9);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $65GP4 = parcelRequire("65GP4");

var $1zav4 = parcelRequire("1zav4");
const $8b6ac7577f3a66b8$export$1a38c7157d718094 = 30;
var $8b6ac7577f3a66b8$export$fe8f2ca19399400e = /*#__PURE__*/ function(TableDecorations) {
    /** Classic controls */ TableDecorations["ALL_CONTROLS_HOVER"] = "CONTROLS_HOVER";
    TableDecorations["ROW_CONTROLS_HOVER"] = "ROW_CONTROLS_HOVER";
    TableDecorations["COLUMN_CONTROLS_HOVER"] = "COLUMN_CONTROLS_HOVER";
    TableDecorations["TABLE_CONTROLS_HOVER"] = "TABLE_CONTROLS_HOVER";
    TableDecorations["CELL_CONTROLS_HOVER"] = "CELL_CONTROLS_HOVER";
    TableDecorations["COLUMN_CONTROLS_DECORATIONS"] = "COLUMN_CONTROLS_DECORATIONS";
    TableDecorations["COLUMN_DROP_TARGET_DECORATIONS"] = "COLUMN_DROP_TARGET_DECORATIONS";
    TableDecorations["COLUMN_SELECTED"] = "COLUMN_SELECTED";
    TableDecorations["COLUMN_RESIZING_HANDLE"] = "COLUMN_RESIZING_HANDLE";
    TableDecorations["COLUMN_RESIZING_HANDLE_WIDGET"] = "COLUMN_RESIZING_HANDLE_WIDGET";
    TableDecorations["COLUMN_RESIZING_HANDLE_LINE"] = "COLUMN_RESIZING_HANDLE_LINE";
    TableDecorations["COLUMN_INSERT_LINE"] = "COLUMN_INSERT_LINE";
    TableDecorations["ROW_INSERT_LINE"] = "ROW_INSERT_LINE";
    TableDecorations["LAST_CELL_ELEMENT"] = "LAST_CELL_ELEMENT";
    return TableDecorations;
}({});
const $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f = {
    ...(0, $1zav4.TableSharedCssClassName),
    /** Classic controls */ COLUMN_CONTROLS: `${(0, $65GP4.tablePrefixSelector)}-column-controls`,
    COLUMN_CONTROLS_DECORATIONS: `${(0, $65GP4.tablePrefixSelector)}-column-controls-decoration`,
    COLUMN_SELECTED: `${(0, $65GP4.tablePrefixSelector)}-column__selected`,
    ROW_CONTROLS_WRAPPER: `${(0, $65GP4.tablePrefixSelector)}-row-controls-wrapper`,
    ROW_CONTROLS: `${(0, $65GP4.tablePrefixSelector)}-row-controls`,
    ROW_CONTROLS_INNER: `${(0, $65GP4.tablePrefixSelector)}-row-controls__inner`,
    ROW_CONTROLS_BUTTON_WRAP: `${(0, $65GP4.tablePrefixSelector)}-row-controls__button-wrap`,
    ROW_CONTROLS_BUTTON: `${(0, $65GP4.tablePrefixSelector)}-row-controls__button`,
    CONTROLS_BUTTON: `${(0, $65GP4.tablePrefixSelector)}-controls__button`,
    CONTROLS_BUTTON_ICON: `${(0, $65GP4.tablePrefixSelector)}-controls__button-icon`,
    CONTROLS_INSERT_BUTTON: `${(0, $65GP4.tablePrefixSelector)}-controls__insert-button`,
    CONTROLS_INSERT_BUTTON_INNER: `${(0, $65GP4.tablePrefixSelector)}-controls__insert-button-inner`,
    CONTROLS_INSERT_BUTTON_WRAP: `${(0, $65GP4.tablePrefixSelector)}-controls__insert-button-wrap`,
    CONTROLS_INSERT_LINE: `${(0, $65GP4.tablePrefixSelector)}-controls__insert-line`,
    CONTROLS_BUTTON_OVERLAY: `${(0, $65GP4.tablePrefixSelector)}-controls__button-overlay`,
    DRAG_CONTROLS_INSERT_BUTTON: `${(0, $65GP4.tablePrefixSelector)}-controls__drag-insert-button`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER: `${(0, $65GP4.tablePrefixSelector)}-controls__drag-insert-button-inner`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN: `${(0, $65GP4.tablePrefixSelector)}-controls__drag-insert-button-inner-column`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW: `${(0, $65GP4.tablePrefixSelector)}-controls__drag-insert-button-inner-row`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS: `${(0, $65GP4.tablePrefixSelector)}-controls__drag-insert-button-inner-row-chromeless`,
    DRAG_CONTROLS_INSERT_BUTTON_WRAP: `${(0, $65GP4.tablePrefixSelector)}-controls__drag-insert-button-wrap`,
    CONTROLS_INSERT_MARKER: `${(0, $65GP4.tablePrefixSelector)}-controls__insert-marker`,
    CONTROLS_INSERT_COLUMN: `${(0, $65GP4.tablePrefixSelector)}-controls__insert-column`,
    CONTROLS_INSERT_ROW: `${(0, $65GP4.tablePrefixSelector)}-controls__insert-row`,
    CONTROLS_DELETE_BUTTON_WRAP: `${(0, $65GP4.tablePrefixSelector)}-controls__delete-button-wrap`,
    CONTROLS_DELETE_BUTTON: `${(0, $65GP4.tablePrefixSelector)}-controls__delete-button`,
    CONTROLS_FLOATING_BUTTON_COLUMN: `${(0, $65GP4.tablePrefixSelector)}-controls-floating__button-column`,
    CONTROLS_FLOATING_BUTTON_ROW: `${(0, $65GP4.tablePrefixSelector)}-controls-floating__button-row`,
    CORNER_CONTROLS: `${(0, $65GP4.tablePrefixSelector)}-corner-controls`,
    CORNER_CONTROLS_INSERT_ROW_MARKER: `${(0, $65GP4.tablePrefixSelector)}-corner-controls__insert-row-marker`,
    CORNER_CONTROLS_INSERT_COLUMN_MARKER: `${(0, $65GP4.tablePrefixSelector)}-corner-controls__insert-column-marker`,
    CONTROLS_CORNER_BUTTON: `${(0, $65GP4.tablePrefixSelector)}-corner-button`,
    /** drag and drop controls */ DRAG_ROW_CONTROLS_WRAPPER: `${(0, $65GP4.tablePrefixSelector)}-drag-row-controls-wrapper`,
    DRAG_ROW_CONTROLS: `${(0, $65GP4.tablePrefixSelector)}-drag-row-controls`,
    DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER: `${(0, $65GP4.tablePrefixSelector)}-drag-row-floating-insert-dot-wrapper`,
    DRAG_ROW_FLOATING_INSERT_DOT: `${(0, $65GP4.tablePrefixSelector)}-drag-row-floating-insert-dot`,
    DRAG_COLUMN_CONTROLS: `${(0, $65GP4.tablePrefixSelector)}-drag-column-controls`,
    DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER: `${(0, $65GP4.tablePrefixSelector)}-drag-columns-floating-insert-dot-wrapper`,
    DRAG_COLUMN_FLOATING_INSERT_DOT: `${(0, $65GP4.tablePrefixSelector)}-drag-columns-floating-insert-dot`,
    DRAG_COLUMN_CONTROLS_WRAPPER: `${(0, $65GP4.tablePrefixSelector)}-col-controls-wrapper`,
    DRAG_COLUMN_DROP_TARGET_CONTROLS: `${(0, $65GP4.tablePrefixSelector)}-col-drop-target-controls`,
    DRAG_COLUMN_CONTROLS_INNER: `${(0, $65GP4.tablePrefixSelector)}-col-controls__inner`,
    DRAG_HANDLE_BUTTON_CONTAINER: `${(0, $65GP4.tablePrefixSelector)}-drag-handle-button-container`,
    DRAG_HANDLE_BUTTON_CLICKABLE_ZONE: `${(0, $65GP4.tablePrefixSelector)}-drag-handle-button-clickable-zone`,
    DRAG_CORNER_BUTTON: `${(0, $65GP4.tablePrefixSelector)}-drag-corner-button`,
    DRAG_CORNER_BUTTON_INNER: `${(0, $65GP4.tablePrefixSelector)}-drag-corner-button-inner`,
    /** nested tables classes */ NESTED_TABLE_WITH_CONTROLS: `${(0, $65GP4.tablePrefixSelector)}-nested-table-with-controls`,
    /** disabled classes */ DRAG_HANDLE_DISABLED: `${(0, $65GP4.tablePrefixSelector)}-drag-handle-disabled`,
    /** minimised handle class */ DRAG_HANDLE_MINIMISED: `${(0, $65GP4.tablePrefixSelector)}-drag-handle-minimised`,
    DRAG_SUBMENU: `${(0, $65GP4.tablePrefixSelector)}-drag-submenu`,
    DRAG_SUBMENU_ICON: `${(0, $65GP4.tablePrefixSelector)}-drag-submenu-icon`,
    /** Other classes */ NUMBERED_COLUMN: `${(0, $65GP4.tablePrefixSelector)}-numbered-column`,
    NUMBERED_COLUMN_BUTTON: `${(0, $65GP4.tablePrefixSelector)}-numbered-column__button`,
    NUMBERED_COLUMN_BUTTON_DISABLED: `${(0, $65GP4.tablePrefixSelector)}-numbered-column__button-disabled`,
    HOVERED_COLUMN: `${(0, $65GP4.tablePrefixSelector)}-hovered-column`,
    HOVERED_ROW: `${(0, $65GP4.tablePrefixSelector)}-hovered-row`,
    HOVERED_TABLE: `${(0, $65GP4.tablePrefixSelector)}-hovered-table`,
    HOVERED_NO_HIGHLIGHT: `${(0, $65GP4.tablePrefixSelector)}-hovered-no-highlight`,
    HOVERED_CELL: `${(0, $65GP4.tablePrefixSelector)}-hovered-cell`,
    HOVERED_CELL_IN_DANGER: 'danger',
    HOVERED_CELL_ACTIVE: 'active',
    HOVERED_CELL_WARNING: `${(0, $65GP4.tablePrefixSelector)}-hovered-cell__warning`,
    HOVERED_DELETE_BUTTON: `${(0, $65GP4.tablePrefixSelector)}-hovered-delete-button`,
    WITH_CONTROLS: `${(0, $65GP4.tablePrefixSelector)}-with-controls`,
    RESIZING_PLUGIN: `${(0, $65GP4.tablePrefixSelector)}-resizing-plugin`,
    RESIZE_CURSOR: `${(0, $65GP4.tablePrefixSelector)}-resize-cursor`,
    IS_RESIZING: `${(0, $65GP4.tablePrefixSelector)}-is-resizing`,
    RESIZE_HANDLE_DECORATION: `${(0, $65GP4.tablePrefixSelector)}-resize-decoration`,
    CONTEXTUAL_SUBMENU: `${(0, $65GP4.tablePrefixSelector)}-contextual-submenu`,
    CONTEXTUAL_MENU_BUTTON_WRAP: `${(0, $65GP4.tablePrefixSelector)}-contextual-menu-button-wrap`,
    CONTEXTUAL_MENU_BUTTON: `${(0, $65GP4.tablePrefixSelector)}-contextual-menu-button`,
    CONTEXTUAL_MENU_BUTTON_FIXED: `${(0, $65GP4.tablePrefixSelector)}-contextual-menu-button-fixed`,
    CONTEXTUAL_MENU_ICON: `${(0, $65GP4.tablePrefixSelector)}-contextual-submenu-icon`,
    CONTEXTUAL_MENU_ICON_SMALL: `${(0, $65GP4.tablePrefixSelector)}-contextual-submenu-icon-small`,
    // come from prosemirror-table
    SELECTED_CELL: 'selectedCell',
    // defined in ReactNodeView based on PM node name
    NODEVIEW_WRAPPER: 'tableView-content-wrap',
    TABLE_SELECTED: `${(0, $65GP4.tablePrefixSelector)}-table__selected`,
    TABLE_CELL: (0, $65GP4.tableCellSelector),
    TABLE_HEADER_CELL: (0, $65GP4.tableHeaderSelector),
    TABLE_STICKY: `${(0, $65GP4.tablePrefixSelector)}-sticky`,
    TABLE_CHROMELESS: `${(0, $65GP4.tablePrefixSelector)}-chromeless`,
    TOP_LEFT_CELL: 'table > tbody > tr:nth-child(2) > td:nth-child(1)',
    LAST_ITEM_IN_CELL: `${(0, $65GP4.tablePrefixSelector)}-last-item-in-cell`,
    WITH_COLUMN_INSERT_LINE: `${(0, $65GP4.tablePrefixSelector)}-column-insert-line`,
    WITH_COLUMN_INSERT_LINE_INACTIVE: `${(0, $65GP4.tablePrefixSelector)}-column-insert-line__inactive`,
    WITH_FIRST_COLUMN_INSERT_LINE: `${(0, $65GP4.tablePrefixSelector)}-first-column-insert-line`,
    WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE: `${(0, $65GP4.tablePrefixSelector)}-first-column-insert-line__inactive`,
    WITH_LAST_COLUMN_INSERT_LINE: `${(0, $65GP4.tablePrefixSelector)}-last-column-insert-line`,
    WITH_LAST_COLUMN_INSERT_LINE_INACTIVE: `${(0, $65GP4.tablePrefixSelector)}-last-column-insert-line__inactive`,
    WITH_RESIZE_LINE: `${(0, $65GP4.tablePrefixSelector)}-column-resize-line`,
    WITH_RESIZE_LINE_LAST_COLUMN: `${(0, $65GP4.tablePrefixSelector)}-column-resize-line-last-column`,
    WITH_DRAG_RESIZE_LINE: `${(0, $65GP4.tablePrefixSelector)}-drag-column-resize-line`,
    WITH_DRAG_RESIZE_LINE_LAST_COLUMN: `${(0, $65GP4.tablePrefixSelector)}-drag-column-resize-line-last-column`,
    WITH_ROW_INSERT_LINE: `${(0, $65GP4.tablePrefixSelector)}-row-insert-line`,
    WITH_ROW_INSERT_LINE_INACTIVE: `${(0, $65GP4.tablePrefixSelector)}-row-insert-line__inactive`,
    WITH_LAST_ROW_INSERT_LINE: `${(0, $65GP4.tablePrefixSelector)}-last-row-insert-line`,
    WITH_LAST_ROW_INSERT_LINE_INACTIVE: `${(0, $65GP4.tablePrefixSelector)}-last-row-insert-line__inactive`
};
var $8b6ac7577f3a66b8$export$ce63d9b315ac58c9 = /*#__PURE__*/ function(ShadowEvent) {
    ShadowEvent["SHOW_BEFORE_SHADOW"] = "showBeforeShadow";
    ShadowEvent["SHOW_AFTER_SHADOW"] = "showAfterShadow";
    return ShadowEvent;
}({});

});


parcelRegister("eJQfi", function(module, exports) {

$parcel$export(module.exports, "tableMarginFullWidthMode", () => (parcelRequire("eoFXy")).tableMarginFullWidthMode);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $eoFXy = parcelRequire("eoFXy");

});
parcelRegister("eoFXy", function(module, exports) {

$parcel$export(module.exports, "tableCellBackgroundColor", () => $fbbb9ee8877c285e$export$3efa753685336605);
$parcel$export(module.exports, "tableHeaderCellBackgroundColor", () => $fbbb9ee8877c285e$export$95883e661e73a1d1);
$parcel$export(module.exports, "tableTextColor", () => $fbbb9ee8877c285e$export$14da8da34a807702);
$parcel$export(module.exports, "tableBorderColor", () => $fbbb9ee8877c285e$export$60473ec4f7c2b794);
$parcel$export(module.exports, "tableCellSelectedColor", () => $fbbb9ee8877c285e$export$f26d047169b4195d);
$parcel$export(module.exports, "tableToolbarSelectedColor", () => $fbbb9ee8877c285e$export$8c5dd0fc35774ae1);
$parcel$export(module.exports, "tableBorderSelectedColor", () => $fbbb9ee8877c285e$export$9bf0891aaaf2fecb);
$parcel$export(module.exports, "tableCellSelectedDeleteIconColor", () => $fbbb9ee8877c285e$export$a699493d7d7580c3);
$parcel$export(module.exports, "tableCellSelectedDeleteIconBackground", () => $fbbb9ee8877c285e$export$cd5e5900c9fa42dc);
$parcel$export(module.exports, "tableCellDeleteColor", () => $fbbb9ee8877c285e$export$3c2a828febe9d506);
$parcel$export(module.exports, "tableBorderDeleteColor", () => $fbbb9ee8877c285e$export$870d72a5700e711d);
$parcel$export(module.exports, "tableToolbarDeleteColor", () => $fbbb9ee8877c285e$export$e7bba7ffd7bf3c50);
$parcel$export(module.exports, "tableCellHoverDeleteIconColor", () => $fbbb9ee8877c285e$export$6cc2aa96833a5989);
$parcel$export(module.exports, "tableCellHoverDeleteIconBackground", () => $fbbb9ee8877c285e$export$9907ca2ad437ddcc);
$parcel$export(module.exports, "tableBorderRadiusSize", () => $fbbb9ee8877c285e$export$371da7842ff35a5b);
$parcel$export(module.exports, "tablePadding", () => $fbbb9ee8877c285e$export$e5ff276883773ffd);
$parcel$export(module.exports, "tableScrollbarOffset", () => $fbbb9ee8877c285e$export$92421f8864c287b1);
$parcel$export(module.exports, "tableMarginFullWidthMode", () => $fbbb9ee8877c285e$export$cbcfa4314b903419);
$parcel$export(module.exports, "tableInsertColumnButtonSize", () => $fbbb9ee8877c285e$export$6d23b13c5fcb846c);
$parcel$export(module.exports, "tableDeleteButtonSize", () => $fbbb9ee8877c285e$export$cb376ed67c7ae37e);
$parcel$export(module.exports, "tableDeleteButtonOffset", () => $fbbb9ee8877c285e$export$52b432855099b8bd);
$parcel$export(module.exports, "tableToolbarSize", () => $fbbb9ee8877c285e$export$a4d60e31f4f6188b);
$parcel$export(module.exports, "tableControlsSpacing", () => $fbbb9ee8877c285e$export$880976487022eb5);
$parcel$export(module.exports, "tableInsertColumnButtonOffset", () => $fbbb9ee8877c285e$export$73b1242ebdcc73be);
$parcel$export(module.exports, "lineMarkerSize", () => $fbbb9ee8877c285e$export$a3e71c692f2c2213);
$parcel$export(module.exports, "columnControlsDecorationHeight", () => $fbbb9ee8877c285e$export$62374dd2f63076b0);
$parcel$export(module.exports, "columnControlsZIndex", () => $fbbb9ee8877c285e$export$da0ccd381b1a80f);
$parcel$export(module.exports, "columnControlsSelectedZIndex", () => $fbbb9ee8877c285e$export$83da30a15600a83e);
$parcel$export(module.exports, "rowControlsZIndex", () => $fbbb9ee8877c285e$export$45aeeddcedd441ab);
$parcel$export(module.exports, "insertLineWidth", () => $fbbb9ee8877c285e$export$cc7ed656b7dcf729);
$parcel$export(module.exports, "resizeHandlerAreaWidth", () => $fbbb9ee8877c285e$export$72409f838e9c33c7);
$parcel$export(module.exports, "resizeLineWidth", () => $fbbb9ee8877c285e$export$45d9825f76985b4e);
$parcel$export(module.exports, "resizeHandlerZIndex", () => $fbbb9ee8877c285e$export$887c1388be90c08e);
$parcel$export(module.exports, "contextualMenuTriggerSize", () => $fbbb9ee8877c285e$export$3969371f057ce1e5);
$parcel$export(module.exports, "contextualMenuDropdownWidth", () => $fbbb9ee8877c285e$export$a6ed027d1a83416d);
$parcel$export(module.exports, "contextualMenuDropdownWidthDnD", () => $fbbb9ee8877c285e$export$42d9040c5091b076);
$parcel$export(module.exports, "stickyRowZIndex", () => $fbbb9ee8877c285e$export$1279af870a198fea);
$parcel$export(module.exports, "stickyRowOffsetTop", () => $fbbb9ee8877c285e$export$83c60dd0aac17107);
$parcel$export(module.exports, "stickyHeaderBorderBottomWidth", () => $fbbb9ee8877c285e$export$13b0e72269a9a3aa);
$parcel$export(module.exports, "tableOverflowShadowWidth", () => $fbbb9ee8877c285e$export$40311377f05dbfc4);
$parcel$export(module.exports, "tableOverflowShadowWidthWide", () => $fbbb9ee8877c285e$export$1680d391e1ce7b96);
$parcel$export(module.exports, "tablePopupMenuFitHeight", () => $fbbb9ee8877c285e$export$3cdde837cf189e96);
$parcel$export(module.exports, "dropTargetsZIndex", () => $fbbb9ee8877c285e$export$b2015400488f9243);
$parcel$export(module.exports, "TABLE_SNAP_GAP", () => $fbbb9ee8877c285e$export$8f6133b6e2b4291);
$parcel$export(module.exports, "TABLE_HIGHLIGHT_GAP", () => $fbbb9ee8877c285e$export$edb1b9caf8ff5b32);
$parcel$export(module.exports, "TABLE_HIGHLIGHT_TOLERANCE", () => $fbbb9ee8877c285e$export$7af5c65e392a647);
$parcel$export(module.exports, "TABLE_GUIDELINE_VISIBLE_ADJUSTMENT", () => $fbbb9ee8877c285e$export$858d012f03ae70a5);
$parcel$export(module.exports, "TABLE_DRAG_MENU_SORT_GROUP_HEIGHT", () => $fbbb9ee8877c285e$export$a13bd817a2eda041);
$parcel$export(module.exports, "TABLE_DRAG_MENU_PADDING_TOP", () => $fbbb9ee8877c285e$export$e0140c2b978caac5);
$parcel$export(module.exports, "TABLE_DRAG_MENU_MENU_GROUP_BEFORE_HEIGHT", () => $fbbb9ee8877c285e$export$c6a9e7014cf7aedc);
$parcel$export(module.exports, "dragMenuDropdownWidth", () => $fbbb9ee8877c285e$export$963fb187132ee7cf);
$parcel$export(module.exports, "dragTableInsertColumnButtonSize", () => $fbbb9ee8877c285e$export$d18320cc8ee69115);
$parcel$export(module.exports, "dropTargetExtendedWidth", () => $fbbb9ee8877c285e$export$6bec1f8a2aa82be8);
$parcel$export(module.exports, "colorPalletteColumns", () => $fbbb9ee8877c285e$export$2c18704a8d793cdb);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $1zav4 = parcelRequire("1zav4");

var $aFUXX = parcelRequire("aFUXX");

var $6fnsQ = parcelRequire("6fnsQ");

var $d5aTJ = parcelRequire("d5aTJ");
const $fbbb9ee8877c285e$export$3efa753685336605 = `var(--ds-surface, ${(0, $6fnsQ.N0)})`;
const $fbbb9ee8877c285e$export$95883e661e73a1d1 = `var(--ds-background-accent-gray-subtlest, ${(0, $aFUXX.akEditorTableHeaderCellBackground)})`;
const $fbbb9ee8877c285e$export$1b578d7ab4fc0385 = `var(--ds-background-neutral-subtle, ${(0, $aFUXX.akEditorTableToolbar)})`;
const $fbbb9ee8877c285e$export$14da8da34a807702 = `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`;
const $fbbb9ee8877c285e$export$60473ec4f7c2b794 = `var(--ds-background-accent-gray-subtler, ${(0, $aFUXX.akEditorTableBorder)})`;
const $fbbb9ee8877c285e$export$5aac4cb73ae3f2da = `var(--ds-background-neutral, ${(0, $6fnsQ.N20)})`;
const $fbbb9ee8877c285e$export$f26d047169b4195d = `var(--ds-blanket-selected, ${(0, $aFUXX.akEditorTableCellBlanketSelected)})`;
const $fbbb9ee8877c285e$export$8c5dd0fc35774ae1 = `var(--ds-background-selected-pressed, ${(0, $6fnsQ.B200)})`;
const $fbbb9ee8877c285e$export$9bf0891aaaf2fecb = `var(--ds-border-focused, ${(0, $aFUXX.akEditorTableBorderSelected)})`;
const $fbbb9ee8877c285e$export$a699493d7d7580c3 = `var(--ds-icon-subtle, ${(0, $6fnsQ.N300)})`;
const $fbbb9ee8877c285e$export$cd5e5900c9fa42dc = `var(--ds-background-accent-gray-subtlest, ${(0, $6fnsQ.N20A)})`;
const $fbbb9ee8877c285e$export$3c2a828febe9d506 = `var(--ds-blanket-danger, ${(0, $aFUXX.akEditorTableCellBlanketDeleted)})`;
const $fbbb9ee8877c285e$export$870d72a5700e711d = `var(--ds-border-danger, ${(0, $6fnsQ.R400)})`;
const $fbbb9ee8877c285e$export$e7bba7ffd7bf3c50 = `var(--ds-background-danger-pressed, ${(0, $6fnsQ.R75)})`;
const $fbbb9ee8877c285e$export$6cc2aa96833a5989 = "var(--ds-icon-inverse, white)";
const $fbbb9ee8877c285e$export$9907ca2ad437ddcc = `var(--ds-background-danger-bold, ${(0, $6fnsQ.R300)})`;
const $fbbb9ee8877c285e$export$371da7842ff35a5b = 3;
const $fbbb9ee8877c285e$export$e5ff276883773ffd = 8;
const $fbbb9ee8877c285e$export$92421f8864c287b1 = 15;
const $fbbb9ee8877c285e$export$cbcfa4314b903419 = 2;
const $fbbb9ee8877c285e$export$6d23b13c5fcb846c = 20;
const $fbbb9ee8877c285e$export$cb376ed67c7ae37e = 16;
const $fbbb9ee8877c285e$export$52b432855099b8bd = 6;
const $fbbb9ee8877c285e$export$a4d60e31f4f6188b = (0, $aFUXX.akEditorTableToolbarSize);
const $fbbb9ee8877c285e$export$880976487022eb5 = (0, $1zav4.tableMarginTop) + $fbbb9ee8877c285e$export$e5ff276883773ffd - (0, $1zav4.tableCellBorderWidth);
const $fbbb9ee8877c285e$export$73b1242ebdcc73be = 3;
const $fbbb9ee8877c285e$export$86dfc955b6099b88 = 32;
const $fbbb9ee8877c285e$export$893fc0cfd2a0c40e = 13;
const $fbbb9ee8877c285e$export$a3e71c692f2c2213 = 4;
const $fbbb9ee8877c285e$export$62374dd2f63076b0 = 25;
const $fbbb9ee8877c285e$export$da0ccd381b1a80f = (0, $aFUXX.akEditorUnitZIndex) * 10;
const $fbbb9ee8877c285e$export$83da30a15600a83e = $fbbb9ee8877c285e$export$da0ccd381b1a80f + 1;
const $fbbb9ee8877c285e$export$45aeeddcedd441ab = (0, $aFUXX.akEditorUnitZIndex) * 10;
const $fbbb9ee8877c285e$export$5b53cc051bf05434 = $fbbb9ee8877c285e$export$83da30a15600a83e + 1;
const $fbbb9ee8877c285e$export$cc7ed656b7dcf729 = 3;
const $fbbb9ee8877c285e$export$72409f838e9c33c7 = (0, $d5aTJ.RESIZE_HANDLE_AREA_DECORATION_GAP) / 3;
const $fbbb9ee8877c285e$export$45d9825f76985b4e = 2;
const $fbbb9ee8877c285e$export$887c1388be90c08e = $fbbb9ee8877c285e$export$da0ccd381b1a80f + (0, $aFUXX.akRichMediaResizeZIndex);
const $fbbb9ee8877c285e$export$3969371f057ce1e5 = 16;
const $fbbb9ee8877c285e$export$a6ed027d1a83416d = 180;
const $fbbb9ee8877c285e$export$42d9040c5091b076 = 250;
const $fbbb9ee8877c285e$export$1279af870a198fea = $fbbb9ee8877c285e$export$887c1388be90c08e + 2;
const $fbbb9ee8877c285e$export$83c60dd0aac17107 = 8;
const $fbbb9ee8877c285e$export$13b0e72269a9a3aa = 1;
const $fbbb9ee8877c285e$export$40311377f05dbfc4 = 8;
const $fbbb9ee8877c285e$export$1680d391e1ce7b96 = 32;
const $fbbb9ee8877c285e$export$3cdde837cf189e96 = 188;
const $fbbb9ee8877c285e$export$b2015400488f9243 = 14;
const $fbbb9ee8877c285e$export$8f6133b6e2b4291 = 9;
const $fbbb9ee8877c285e$export$edb1b9caf8ff5b32 = 10;
const $fbbb9ee8877c285e$export$7af5c65e392a647 = 2;
const $fbbb9ee8877c285e$export$11cf30061861ec4a = 5;
const $fbbb9ee8877c285e$export$858d012f03ae70a5 = -68;
const $fbbb9ee8877c285e$export$a13bd817a2eda041 = 92;
const $fbbb9ee8877c285e$export$e0140c2b978caac5 = 4;
const $fbbb9ee8877c285e$export$c6a9e7014cf7aedc = 6;
const $fbbb9ee8877c285e$export$963fb187132ee7cf = 250;
const $fbbb9ee8877c285e$export$d18320cc8ee69115 = 16;
const $fbbb9ee8877c285e$export$6bec1f8a2aa82be8 = 150;
const $fbbb9ee8877c285e$export$2c18704a8d793cdb = 7;
const $fbbb9ee8877c285e$export$150cd2564fec30b7 = 8;

});



parcelRegister("6Ra3A", function(module, exports) {

$parcel$export(module.exports, "mediaStyles", () => $9858010db3402fee$export$abd2efc27ac7e809);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $fhm10 = parcelRequire("fhm10");

var $gnMzP = parcelRequire("gnMzP");

var $aFUXX = parcelRequire("aFUXX");

var $jTudT = parcelRequire("jTudT");
var $cDSVG = parcelRequire("cDSVG");
var $8jrlU = parcelRequire("8jrlU");
const $9858010db3402fee$export$abd2efc27ac7e809 = ()=>(0, $3jLHL.css)`
	.ProseMirror {
		${0, $gnMzP.mediaSingleSharedStyleNew} & [layout='full-width'] .${0, $gnMzP.richMediaClassName},
    & [layout='wide'] .${0, $gnMzP.richMediaClassName} {
			margin-left: 50%;
			transform: translateX(-50%);
		}

		.media-extended-resize-experience[layout^='wrap-'] {
			/* override 'overflow: auto' when viewport <= 410 set by mediaSingleSharedStyle
			to prevent scroll bar */
			overflow: visible !important;
		}

		& [layout^='wrap-'] + [layout^='wrap-'] {
			clear: none;
			& + p,
			& + div[class^='fabric-editor-align'],
			& + ul,
			& + ol,
			& + h1,
			& + h2,
			& + h3,
			& + h4,
			& + h5,
			& + h6 {
				clear: both !important;
			}
			& .${0, $gnMzP.richMediaClassName} {
				margin-left: 0;
				margin-right: 0;
			}
		}

		${0, $fhm10.mediaInlineImageStyles}

		.mediaSingleView-content-wrap[layout^='wrap-'] {
			max-width: 100%;
			/* overwrite default Prosemirror setting making it clear: both */
			clear: inherit;
		}

		.mediaSingleView-content-wrap[layout='wrap-left'] {
			float: left;
		}

		.mediaSingleView-content-wrap[layout='wrap-right'] {
			float: right;
		}

		.mediaSingleView-content-wrap[layout='wrap-right']
			+ .mediaSingleView-content-wrap[layout='wrap-left'] {
			clear: both;
		}

		/* Larger margins for resize handlers when at depth 0 of the document */
		& > .mediaSingleView-content-wrap {
			.richMedia-resize-handle-right {
				margin-right: -${0, $aFUXX.akEditorMediaResizeHandlerPaddingWide}px;
			}
			.richMedia-resize-handle-left {
				margin-left: -${0, $aFUXX.akEditorMediaResizeHandlerPaddingWide}px;
			}
		}
	}

	.richMedia-resize-handle-right,
	.richMedia-resize-handle-left {
		display: flex;
		flex-direction: column;

		/* vertical align */
		justify-content: center;
	}

	.richMedia-resize-handle-right {
		align-items: flex-end;
		padding-right: ${"var(--ds-space-150, 12px)"};
		margin-right: -${0, $aFUXX.akEditorMediaResizeHandlerPadding}px;
	}

	.richMedia-resize-handle-left {
		align-items: flex-start;
		padding-left: ${"var(--ds-space-150, 12px)"};
		margin-left: -${0, $aFUXX.akEditorMediaResizeHandlerPadding}px;
	}

	.richMedia-resize-handle-right::after,
	.richMedia-resize-handle-left::after {
		content: ' ';
		display: flex;
		width: 3px;
		height: 64px;

		border-radius: 6px;
	}

	.${0, $gnMzP.richMediaClassName}:hover .richMedia-resize-handle-left::after,
	.${0, $gnMzP.richMediaClassName}:hover .richMedia-resize-handle-right::after {
		background: ${"var(--ds-border, #091E4224)"};
	}

	.${0, $aFUXX.akEditorSelectedNodeClassName} .richMedia-resize-handle-right::after,
	.${0, $aFUXX.akEditorSelectedNodeClassName} .richMedia-resize-handle-left::after,
	.${0, $gnMzP.richMediaClassName} .richMedia-resize-handle-right:hover::after,
	.${0, $gnMzP.richMediaClassName} .richMedia-resize-handle-left:hover::after,
	.${0, $gnMzP.richMediaClassName}.is-resizing .richMedia-resize-handle-right::after,
	.${0, $gnMzP.richMediaClassName}.is-resizing .richMedia-resize-handle-left::after {
		background: ${"var(--ds-border-focused, #388BFF)"};
	}

	.__resizable_base__ {
		left: unset !important;
		width: auto !important;
		height: auto !important;
	}

	/* Danger when top level node for smart cards / inline links */
	.danger > div > div > .media-card-frame,
	.danger > span > a {
		background-color: ${`var(--ds-background-danger, ${0, $aFUXX.akEditorDeleteBackground})`};
		box-shadow: 0px 0px 0px ${0, $aFUXX.akEditorSelectedBorderBoldSize}px
			${`var(--ds-border-danger, ${0, $aFUXX.akEditorDeleteBorder})`};
		transition:
			background-color 0s,
			box-shadow 0s;
	}
	/* Danger when nested node or common */
	.danger {
		/* Media single */
		.${0, $gnMzP.richMediaClassName} .${0, $jTudT.fileCardImageViewSelector}::after {
			border: 1px solid ${`var(--ds-border-danger, ${0, $aFUXX.akEditorDeleteIconColor})`};
		}
		/* Media single video player */
		.${0, $gnMzP.richMediaClassName} .${0, $cDSVG.inlinePlayerClassName}::after {
			border: 1px solid ${`var(--ds-border-danger, ${0, $aFUXX.akEditorDeleteIconColor})`};
		}
		/* New file experience */
		.${0, $gnMzP.richMediaClassName} .${0, $8jrlU.newFileExperienceClassName} {
			box-shadow: 0 0 0 1px ${`var(--ds-border-danger, ${0, $aFUXX.akEditorDeleteIconColor})`} !important;
		}
		/* Media resize legacy handlers */
		.richMedia-resize-handle-right::after,
		.richMedia-resize-handle-left::after {
			background: ${`var(--ds-icon-danger, ${0, $aFUXX.akEditorDeleteIconColor})`} !important;
		}
		/* Media resize new handlers */
		.resizer-handle-thumb {
			background: ${`var(--ds-icon-danger, ${0, $aFUXX.akEditorDeleteIconColor})`} !important;
		}

		/* Smart cards */
		div div .media-card-frame,
		.inlineCardView-content-wrap > span > a {
			background-color: ${"var(--ds-blanket-danger, rgb(255, 189, 173, 0.5))"}; /* R75 with 50% opactiy */
			transition: background-color 0s;
		}

		div div .media-card-frame::after {
			box-shadow: none;
		}
	}

	.warning {
		/* Media single */
		.${0, $gnMzP.richMediaClassName} .${0, $jTudT.fileCardImageViewSelector}::after {
			border: 1px solid ${"var(--ds-border-warning, #E56910)"};
		}

		.${0, $gnMzP.richMediaClassName} .${0, $cDSVG.inlinePlayerClassName}::after {
			border: 1px solid ${"var(--ds-border-warning, #E56910)"};
		}

		.${0, $gnMzP.richMediaClassName} .${0, $8jrlU.newFileExperienceClassName} {
			box-shadow: 0 0 0 1px ${"var(--ds-border-warning, #E56910)"} !important;
		}

		.resizer-handle-thumb {
			background: ${"var(--ds-icon-warning, #E56910)"} !important;
		}
	}

	.media-filmstrip-list-item {
		cursor: pointer;
	}

	/* When clicking drag handle, mediaGroup node will be selected. Hence we need to apply selected style to each media node */
	.mediaGroupView-content-wrap.${0, $aFUXX.akEditorSelectedNodeClassName} #newFileExperienceWrapper {
		box-shadow: ${0, $aFUXX.akEditorSelectedBoxShadow};
	}

	.ak-editor-no-interaction #newFileExperienceWrapper {
		box-shadow: none;
	}
`; /* `left: unset` above is to work around Chrome bug where rendering a div with
 * that style applied inside a container that has a scroll, causes any svgs on
 * the page, without a border, that are inside a flexbox, to no longer align to
 * the center of their viewbox.
 *
 * for us, this means that all the toolbar icons start jumping around if
 * you make the viewport small
 */ 

});

parcelRegister("bD4Xf", function(module, exports) {

$parcel$export(module.exports, "panelStyles", () => $ce29671b03863bb5$export$8290cf129669d0cb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $DoNsZ = parcelRequire("DoNsZ");

var $aFUXX = parcelRequire("aFUXX");
var $ieXGd = parcelRequire("ieXGd");
var $b38UX = parcelRequire("b38UX");

var $dh538 = parcelRequire("dh538");
const $ce29671b03863bb5$export$8290cf129669d0cb = ()=>(0, $3jLHL.css)`
	.ProseMirror {
		.${(0, $DoNsZ.PanelSharedCssClassName).prefix} {
			cursor: pointer;

			/* Danger when top level node */
			&.danger {
				box-shadow: 0 0 0 ${0, $aFUXX.akEditorSelectedBorderSize}px ${0, $aFUXX.akEditorDeleteBorder};
				background-color: ${`var(--ds-background-danger, ${0, $aFUXX.akEditorDeleteBackground})`} !important;

				.${(0, $DoNsZ.PanelSharedCssClassName).icon} {
					color: ${`var(--ds-icon-danger, ${0, $aFUXX.akEditorDeleteIconColor})`} !important;
				}
			}
		}

		.${(0, $DoNsZ.PanelSharedCssClassName).content} {
			cursor: text;
		}

		/* Danger when nested node */
		.danger .${(0, $DoNsZ.PanelSharedCssClassName).prefix} {
			&[data-panel-type] {
				background-color: ${`var(--ds-blanket-danger, ${0, $aFUXX.akEditorDeleteBackgroundWithOpacity})`};

				.${(0, $DoNsZ.PanelSharedCssClassName).icon} {
					color: ${`var(--ds-icon-danger, ${0, $aFUXX.akEditorDeleteIconColor})`};
				}
			}
		}

		${(0, $DoNsZ.panelSharedStyles)()};
	}

	.${(0, $DoNsZ.PanelSharedCssClassName).prefix}.${0, $aFUXX.akEditorSelectedNodeClassName}:not(.danger) {
		${(0, $ieXGd.getSelectionStyles)([
        (0, $b38UX.SelectionStyle).BoxShadow,
        (0, $b38UX.SelectionStyle).Blanket
    ])}
	}

	${(0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') && `.ak-editor-content-area.appearance-full-page .ProseMirror {
		.ak-editor-panel .${(0, $DoNsZ.PanelSharedCssClassName).icon} {
			padding-right: ${"var(--ds-space-150, 12px)"};
		}

		.ak-editor-panel.${(0, $DoNsZ.PanelSharedCssClassName).noIcon} {
			padding-left: ${"var(--ds-space-250, 20px)"};
			padding-right: ${"var(--ds-space-250, 20px)"};
		}
	}`};

	/* Don't want extra padding for inline editor (nested) */
	${(0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') && `.ak-editor-content-area .ak-editor-content-area .ProseMirror {
		.ak-editor-panel .${(0, $DoNsZ.PanelSharedCssClassName).icon} {
			padding-right: ${"var(--ds-space-100, 8px)"};
		}
		.ak-editor-panel.${(0, $DoNsZ.PanelSharedCssClassName).noIcon} {
			padding-right: ${"var(--ds-space-150, 12px)"};
			padding-left: ${"var(--ds-space-150, 12px)"};
		}
	}`};
`;

});

parcelRegister("ftMAt", function(module, exports) {

$parcel$export(module.exports, "vanillaStatusStyles", () => $4ddd9aa5ac34f829$export$5393c24101671903);
$parcel$export(module.exports, "statusStyles", () => $4ddd9aa5ac34f829$export$79c8c9ad308bbe07);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $5UKg9 = parcelRequire("5UKg9");
var $1zav4 = parcelRequire("1zav4");

var $aFUXX = parcelRequire("aFUXX");
var $ieXGd = parcelRequire("ieXGd");
var $b38UX = parcelRequire("b38UX");

var $dh538 = parcelRequire("dh538");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $4ddd9aa5ac34f829$var$getVisualRefreshStatusStyles = ()=>// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $dh538.fg)('platform-component-visual-refresh') ? // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $3jLHL.css)`
				&.${0, $aFUXX.akEditorSelectedNodeClassName} .${(0, $5UKg9.StatusSharedCssClassName).STATUS_LOZENGE} > span {
					box-shadow: ${0, $aFUXX.akEditorSelectedBoldBoxShadow};
				}
			` : // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $3jLHL.css)`
				&.${0, $aFUXX.akEditorSelectedNodeClassName} .${(0, $5UKg9.StatusSharedCssClassName).STATUS_LOZENGE} > span {
					${(0, $ieXGd.getSelectionStyles)([
        (0, $b38UX.SelectionStyle).BoxShadow
    ])}
				}
			`;
const $4ddd9aa5ac34f829$var$getStatusColors = ()=>(0, $dh538.fg)('platform-component-visual-refresh') ? (0, $3jLHL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] .lozenge-text': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            color: '#292A2E'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] > [data-color=neutral] > .lozenge-wrapper': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            backgroundColor: '#DDDEE1'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] > [data-color=purple] > .lozenge-wrapper': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            backgroundColor: '#D8A0F7'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] > [data-color=blue] > .lozenge-wrapper': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            backgroundColor: '#8FB8F6'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] > [data-color=yellow] > .lozenge-wrapper': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            backgroundColor: '#F9C84E'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] > [data-color=red] > .lozenge-wrapper': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            backgroundColor: '#FD9891'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] > [data-color=green] > .lozenge-wrapper': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            backgroundColor: '#B3DF72'
        }
    }) : (0, $3jLHL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-wrapper': {
            backgroundColor: "var(--ds-background-neutral, #091E420F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-text': {
            color: "var(--ds-text-subtle, #44546F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-wrapper': {
            backgroundColor: "var(--ds-background-discovery, #F3F0FF)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-text': {
            color: "var(--ds-text-discovery, #5E4DB2)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-wrapper': {
            backgroundColor: "var(--ds-background-information, #E9F2FF)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-text': {
            color: "var(--ds-text-information, #0055CC)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-wrapper': {
            backgroundColor: "var(--ds-background-warning, #FFF7D6)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-text': {
            color: "var(--ds-text-warning, #A54800)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] > [data-color=red] .lozenge-wrapper': {
            backgroundColor: "var(--ds-background-danger, #FFECEB)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] > [data-color=red] .lozenge-text': {
            color: "var(--ds-text-danger, #AE2E24)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] > [data-color=green] .lozenge-wrapper': {
            backgroundColor: "var(--ds-background-success, #DCFFF1)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] > [data-color=green] .lozenge-text': {
            color: "var(--ds-text-success, #216E4E)"
        }
    });
const $4ddd9aa5ac34f829$var$baseVanillaStatusStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-neutral, #091E420F)",
        maxWidth: '100%',
        paddingInline: "var(--ds-space-050, 4px)",
        display: 'inline-flex',
        borderRadius: '3px',
        blockSize: 'min-content',
        position: 'static',
        overflow: 'hidden',
        boxSizing: 'border-box',
        appearance: 'none',
        border: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="status"] .lozenge-text': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '11px',
        fontStyle: 'normal',
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '16px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        maxWidth: `calc(200px - ${"var(--ds-space-100, 8px)"})`
    }
});
const $4ddd9aa5ac34f829$export$5393c24101671903 = ()=>(0, $3jLHL.css)`
	${$4ddd9aa5ac34f829$var$baseVanillaStatusStyles}
	${$4ddd9aa5ac34f829$var$getStatusColors()}
`;
const $4ddd9aa5ac34f829$export$79c8c9ad308bbe07 = (0, $3jLHL.css)`
	.${(0, $1zav4.TableSharedCssClassName).TABLE_CELL_WRAPPER},
		.${(0, $1zav4.TableSharedCssClassName).TABLE_HEADER_CELL_WRAPPER},
		[data-layout-section] {
		.${(0, $5UKg9.StatusSharedCssClassName).STATUS_CONTAINER} {
			max-width: 100%;
			line-height: 0;

			> span {
				width: 100%;
			}
		}
	}
	.${(0, $5UKg9.StatusSharedCssClassName).STATUS_CONTAINER} {
		> span {
			cursor: pointer;
			line-height: 0; /* Prevent responsive layouts increasing height of container. */
		}

		${$4ddd9aa5ac34f829$var$getVisualRefreshStatusStyles()}
	}

	.danger {
		.${(0, $5UKg9.StatusSharedCssClassName).STATUS_LOZENGE} > span {
			background-color: ${(0, $aFUXX.akEditorDeleteBackgroundWithOpacity)};
		}

		.${(0, $5UKg9.StatusSharedCssClassName).STATUS_CONTAINER}.${(0, $aFUXX.akEditorSelectedNodeClassName)}
			.${(0, $5UKg9.StatusSharedCssClassName).STATUS_LOZENGE}
			> span {
			box-shadow: 0 0 0 ${(0, $aFUXX.akEditorSelectedBorderSize)}px ${(0, $aFUXX.akEditorDeleteBorder)};
		}
	}
`;

});
parcelRegister("5UKg9", function(module, exports) {

$parcel$export(module.exports, "StatusSharedCssClassName", () => $351c6448366592ed$export$b18e58a1c082b710);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $351c6448366592ed$export$b18e58a1c082b710 = {
    STATUS_CONTAINER: 'statusView-content-wrap',
    STATUS_LOZENGE: 'status-lozenge-span'
};

});


parcelRegister("dR5Bd", function(module, exports) {

$parcel$export(module.exports, "taskDecisionStyles", () => $021ebed928b992e2$export$6083a263609cde43);
$parcel$export(module.exports, "vanillaTaskDecisionStyles", () => $021ebed928b992e2$export$7ac91fa205fa129a);
$parcel$export(module.exports, "vanillaTaskDecisionIconWithVisualRefresh", () => $021ebed928b992e2$export$eab9dc0cfe87f6c3);
$parcel$export(module.exports, "vanillaTaskDecisionIconWithoutVisualRefresh", () => $021ebed928b992e2$export$ac2a2eaab13bfe49);
$parcel$export(module.exports, "vanillaTaskItemStyles", () => $021ebed928b992e2$export$5d2a537111c20a83);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $7iisy = parcelRequire("7iisy");

var $aFUXX = parcelRequire("aFUXX");
var $ieXGd = parcelRequire("ieXGd");
var $b38UX = parcelRequire("b38UX");
const $021ebed928b992e2$export$6083a263609cde43 = (0, $3jLHL.css)`
	[data-decision-wrapper] {
		cursor: pointer;
	}

	.${(0, $aFUXX.akEditorSelectedNodeClassName)} > [data-decision-wrapper],
	ol[data-node-type='decisionList'].${(0, $aFUXX.akEditorSelectedNodeClassName)} {
		border-radius: 4px;
		${(0, $ieXGd.getSelectionStyles)([
    (0, $b38UX.SelectionStyle).BoxShadow,
    (0, $b38UX.SelectionStyle).Blanket
])}
	}

	.danger {
		.${(0, $7iisy.TaskDecisionSharedCssClassName).DECISION_CONTAINER}.${(0, $aFUXX.akEditorSelectedNodeClassName)} > div {
			box-shadow: 0 0 0 ${(0, $aFUXX.akEditorSelectedBorderSize)}px
				${`var(--ds-border-danger, ${(0, $aFUXX.akEditorDeleteBorder)})`};
			background-color: ${`var(--ds-blanket-danger, ${(0, $aFUXX.akEditorDeleteBackgroundWithOpacity)})`};
			&::after {
				content: none; /* reset the Blanket selection style */
			}
		}
	}
`;
const $021ebed928b992e2$export$7ac91fa205fa129a = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"]': {
        listStyleType: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper]': {
        display: 'flex',
        flexDirection: 'row',
        margin: `${"var(--ds-space-100, 8px)"} 0 0 0`,
        padding: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-150, 12px)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        backgroundColor: "var(--ds-background-neutral, #091E420F)",
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"]': {
        flex: '0 0 16px',
        height: '16px',
        width: '16px',
        margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"} 0 0`,
        color: "var(--ds-icon-subtle, #626F86)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"]:not(:has([data-empty]):not(:has([data-type-ahead]))) > [data-decision-wrapper] > [data-component="icon"]': {
        color: "var(--ds-icon-success, #22A06B)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span': {
        display: 'inline-block',
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- Mirroring icon styles
        lineHeight: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span > svg': {
        overflow: 'hidden',
        pointerEvents: 'none',
        color: 'currentColor',
        verticalAlign: 'bottom'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="placeholder"]': {
        margin: `0 0 0 calc(${"var(--ds-space-100, 8px)"} * 3.5)`,
        position: 'absolute',
        color: "var(--ds-text-subtlest, #626F86)",
        pointerEvents: 'none',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 50px)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"]:not(:has([data-empty]):not(:has([data-type-ahead]))) > [data-decision-wrapper] > [data-component="placeholder"]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="content"]': {
        margin: 0,
        wordWrap: 'break-word',
        minWidth: 0,
        flex: '1 1 auto'
    }
});
const $021ebed928b992e2$export$eab9dc0cfe87f6c3 = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span >  svg[data-icon-source="legacy"]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span': {
        boxSizing: 'border-box',
        paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
        paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)',
        '@media screen and (forced-colors: active)': {
            color: 'canvastext',
            filter: 'grayscale(1)'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span > svg': {
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)"
    }
});
const $021ebed928b992e2$export$ac2a2eaab13bfe49 = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span >  svg[data-icon-source="refreshed"]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span': {
        width: '32px',
        height: '32px',
        '@media screen and (forced-colors: active)': {
            filter: 'grayscale(1)',
            color: 'canvastext',
            fill: 'canvas'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span > svg': {
        maxWidth: '100%',
        maxHeight: '100%',
        fill: "var(--ds-surface, #FFFFFF)",
        width: '32px',
        height: '32px'
    }
});
const $021ebed928b992e2$export$5d2a537111c20a83 = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"]': {
        listStyle: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] [data-component="task-item-main"]': {
        display: 'flex',
        flexDirection: 'row',
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] [data-component="placeholder"]': {
        position: 'absolute',
        color: "var(--ds-text-subtlest, #626F86)",
        margin: `0 0 0 calc(${"var(--ds-space-100, 8px)"} * 3)`,
        pointerEvents: 'none',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 50px)',
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"]:has([data-empty]):not(:has([data-type-ahead])) [data-component="placeholder"]': {
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] [data-component="content"]': {
        margin: 0,
        wordWrap: 'break-word',
        minWidth: 0,
        flex: '1 1 auto'
    },
    // copied styles from packages/design-system/icon/src/components/icon-new.tsx
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"]': {
        display: 'inline-block',
        boxSizing: 'border-box',
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
        paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"] svg': {
        overflow: 'hidden',
        pointerEvents: 'none',
        color: 'currentColor',
        verticalAlign: 'bottom',
        width: "var(--ds-space-200, 16px)",
        height: "var(--ds-space-200, 16px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-checked-icon]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-unchecked-icon]': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-checked-icon]': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-unchecked-icon]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`[data-prosemirror-node-view-type="vanilla"][data-prosemirror-node-name="taskItem"] .${(0, $7iisy.TaskDecisionSharedCssClassName).TASK_CHECKBOX_CONTAINER}`]: {
        flex: '0 0 24px',
        width: '24px',
        height: '24px',
        position: 'relative',
        alignSelf: 'start',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "& > input[type='checkbox']": {
            width: '16px',
            height: '16px',
            zIndex: 1,
            cursor: 'pointer',
            outline: 'none',
            margin: 0,
            opacity: 0,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[disabled]': {
                cursor: 'default'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '+ span': {
                width: '24px',
                height: '24px',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '+ span > svg': {
                boxSizing: 'border-box',
                display: 'inline',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                maxWidth: 'unset',
                maxHeight: 'unset',
                position: 'absolute',
                overflow: 'hidden',
                color: "var(--ds-background-input, #FFFFFF)",
                transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'path:first-of-type': {
                    visibility: 'hidden'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border-input, #8590A2)",
                    strokeWidth: 1,
                    transition: 'stroke 0.2s ease-in-out'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:hover + span > svg': {
                color: "var(--ds-background-input-hovered, #F7F8F9)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border-input, #8590A2)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:checked:hover + span > svg': {
                color: "var(--ds-background-selected-bold-hovered, #0055CC)",
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-background-selected-bold-hovered, #0055CC)"
                }
            },
            '&:checked': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
                '+ span > svg': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'path:first-of-type': {
                        visibility: 'visible'
                    },
                    color: "var(--ds-background-selected-bold, #0C66E4)",
                    fill: "var(--ds-icon-inverse, #FFFFFF)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'rect:first-of-type': {
                        stroke: "var(--ds-background-selected-bold, #0C66E4)"
                    }
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:active + span > svg': {
                color: "var(--ds-background-input-pressed, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border, #091E4224)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:checked:active + span > svg': {
                color: "var(--ds-background-input-pressed, #FFFFFF)",
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border, #091E4224)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:disabled + span > svg, &:disabled:hover + span > svg, &:disabled:focus + span > svg, &:disabled:active + span > svg': {
                color: "var(--ds-background-disabled, #091E4208)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-background-disabled, #091E4208)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:disabled:checked + span > svg': {
                fill: "var(--ds-icon-disabled, #091E424F)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:focus + span::after': {
                position: 'absolute',
                width: "var(--ds-space-200, 16px)",
                height: "var(--ds-space-200, 16px)",
                border: `2px solid ${"var(--ds-border-focused, #388BFF)"}`,
                borderRadius: "var(--ds-space-050, 4px)",
                content: "''",
                display: 'block',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            }
        }
    }
});

});


parcelRegister("axOCf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad78489f7c19358a$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable react-hooks/rules-of-hooks */ /* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Requires manual remediation over time due to use of unsafe nested mixins */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");
var $ja596 = parcelRequire("ja596");

var $d7ZU3 = parcelRequire("d7ZU3");

var $h3X17 = parcelRequire("h3X17");

var $fhsiz = parcelRequire("fhsiz");
var $98HrB = parcelRequire("98HrB");

var $9WN1A = parcelRequire("9WN1A");

var $DoNsZ = parcelRequire("DoNsZ");

var $4AaC5 = parcelRequire("4AaC5");

var $kZBrC = parcelRequire("kZBrC");
var $5MaNT = parcelRequire("5MaNT");
var $7zsay = parcelRequire("7zsay");
var $7bDsi = parcelRequire("7bDsi");
var $iMS6j = parcelRequire("iMS6j");
var $cV5SN = parcelRequire("cV5SN");
var $87iYj = parcelRequire("87iYj");
var $diPla = parcelRequire("diPla");
var $4mSjx = parcelRequire("4mSjx");
var $3Khgq = parcelRequire("3Khgq");
var $7QdQz = parcelRequire("7QdQz");
var $cRffC = parcelRequire("cRffC");
var $0vvte = parcelRequire("0vvte");
var $7iisy = parcelRequire("7iisy");
var $4h2HM = parcelRequire("4h2HM");
var $2wkZs = parcelRequire("2wkZs");
var $3iemu = parcelRequire("3iemu");
parcelRequire("o46Yq");
var $4jPB7 = parcelRequire("4jPB7");
parcelRequire("9PfP2");
var $hAOTs = parcelRequire("hAOTs");
parcelRequire("agKS6");
var $gg4RV = parcelRequire("gg4RV");
parcelRequire("axrL7");
var $319kp = parcelRequire("319kp");
parcelRequire("c4XA1");
var $3teBi = parcelRequire("3teBi");

var $aFUXX = parcelRequire("aFUXX");
var $ieXGd = parcelRequire("ieXGd");
var $b38UX = parcelRequire("b38UX");

var $26eEE = parcelRequire("26eEE");

var $dh538 = parcelRequire("dh538");

var $iu6m9 = parcelRequire("iu6m9");

var $cOrQJ = parcelRequire("cOrQJ");

var $gYSj7 = parcelRequire("gYSj7");

var $1zjTz = parcelRequire("1zjTz");

var $jFND0 = parcelRequire("jFND0");

var $gSnRq = parcelRequire("gSnRq");

var $6dFlY = parcelRequire("6dFlY");

var $bD4Xf = parcelRequire("bD4Xf");

var $ftMAt = parcelRequire("ftMAt");

var $dR5Bd = parcelRequire("dR5Bd");

var $9OTqy = parcelRequire("9OTqy");

var $ejPu0 = parcelRequire("ejPu0");

var $aGf6a = parcelRequire("aGf6a");

var $6svai = parcelRequire("6svai");

var $cO7tu = parcelRequire("cO7tu");

var $432pP = parcelRequire("432pP");

var $i3P6T = parcelRequire("i3P6T");

var $jFNRW = parcelRequire("jFNRW");
const $ad78489f7c19358a$var$vanillaMentionsStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive': {
        display: 'inline',
        borderRadius: '20px',
        cursor: 'pointer',
        padding: '0 0.3em 2px 0.23em',
        fontWeight: "var(--ds-font-weight-regular, 400)",
        wordBreak: 'break-word',
        background: "var(--ds-background-neutral, #091E420F)",
        border: '1px solid transparent',
        color: "var(--ds-text-subtle, #44546F)",
        '&:hover': {
            background: "var(--ds-background-neutral-hovered, #091E4224)"
        },
        '&:active': {
            background: "var(--ds-background-neutral-pressed, #091E424F)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive.mention-restricted': {
        background: 'transparent',
        border: `1px solid ${"var(--ds-border-bold, #758195)"}`,
        color: "var(--ds-text, #172B4D)",
        '&:hover': {
            background: 'transparent'
        },
        '&:active': {
            background: 'transparent'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive.mention-self': {
        background: "var(--ds-background-brand-bold, #0C66E4)",
        border: '1px solid transparent',
        color: "var(--ds-text-inverse, #FFFFFF)",
        '&:hover': {
            background: "var(--ds-background-brand-bold-hovered, #0055CC)"
        },
        '&:active': {
            background: "var(--ds-background-brand-bold-pressed, #09326C)"
        }
    }
});
const $ad78489f7c19358a$var$vanillaSelectionStyles = (0, $3jLHL.css)`
	.danger {
		.editor-mention-primitive {
			box-shadow: 0 0 0 ${(0, $aFUXX.akEditorSelectedBorderSize)}px ${(0, $aFUXX.akEditorDeleteBorder)};
			background-color: ${`var(--ds-background-danger, ${(0, $aFUXX.akEditorDeleteBackgroundWithOpacity)})`};
		}
	}

	.${(0, $aFUXX.akEditorSelectedNodeClassName)} > .editor-mention-primitive,
	.${(0, $aFUXX.akEditorSelectedNodeClassName)} > .editor-mention-primitive.mention-self,
	.${(0, $aFUXX.akEditorSelectedNodeClassName)} > .editor-mention-primitive.mention-restricted {
		${(0, $ieXGd.getSelectionStyles)([
    (0, $b38UX.SelectionStyle).BoxShadow,
    (0, $b38UX.SelectionStyle).Background
])}
		/* need to specify dark text colour because personal mentions
		   (in dark blue) have white text by default */
		color: ${"var(--ds-text-subtle, #44546F)"}
	}
`;
const $ad78489f7c19358a$var$mentionsStyles = (0, $3jLHL.css)`
	.${(0, $9WN1A.MentionSharedCssClassName).MENTION_CONTAINER} {
		&.${(0, $aFUXX.akEditorSelectedNodeClassName)} [data-mention-id] > span {
			${(0, $ieXGd.getSelectionStyles)([
    (0, $b38UX.SelectionStyle).BoxShadow,
    (0, $b38UX.SelectionStyle).Background
])}

			/* need to specify dark text colour because personal mentions
		 (in dark blue) have white text by default */
	  color: ${"var(--ds-text-subtle, #44546F)"};
		}
	}

	.danger {
		.${(0, $9WN1A.MentionSharedCssClassName).MENTION_CONTAINER}.${(0, $aFUXX.akEditorSelectedNodeClassName)}
			> span
			> span
			> span {
			box-shadow: 0 0 0 ${(0, $aFUXX.akEditorSelectedBorderSize)}px ${(0, $aFUXX.akEditorDeleteBorder)};
			background-color: ${`var(--ds-background-danger, ${(0, $aFUXX.akEditorDeleteBackgroundWithOpacity)})`};
		}
		.${(0, $9WN1A.MentionSharedCssClassName).MENTION_CONTAINER} > span > span > span {
			background-color: ${"var(--ds-background-neutral, #091E420F)"};
			color: ${"var(--ds-text-subtle, #44546F)"};
		}
	}
`;
const $ad78489f7c19358a$var$listsStyles = (0, $3jLHL.css)`
	.ProseMirror {
		li {
			position: relative;

			> p:not(:first-child) {
				margin: ${"var(--ds-space-050, 4px)"} 0 0 0;
			}

			// In SSR the above rule will apply to all p tags because first-child would be a style tag.
			// The following rule resets the first p tag back to its original margin
			// defined in packages/editor/editor-common/src/styles/shared/paragraph.ts
			> style:first-child + p {
				margin-top: ${(0, $aFUXX.blockNodesVerticalMargin)};
			}
		}

		&:not([data-node-type='decisionList']) > li,
	// This prevents https://product-fabric.atlassian.net/browse/ED-20924
	&:not(.${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}) > li {
			${(0, $d7ZU3.browser).safari ? (0, $5MaNT.codeBlockInListSafariFix) : ''}
		}
	}
`;
const $ad78489f7c19358a$var$reactEmojiStyles = (0, $3jLHL.css)`
	.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_CONTAINER} {
		display: inline-block;

		.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_NODE} {
			cursor: pointer;

			&.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE} > span {
				/** needed for selection style to cover custom emoji image properly */
				display: flex;
			}
		}

		&.${(0, $aFUXX.akEditorSelectedNodeClassName)} {
			.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE} {
				border-radius: 2px;
				${(0, $ieXGd.getSelectionStyles)([
    (0, $b38UX.SelectionStyle).Blanket,
    (0, $b38UX.SelectionStyle).BoxShadow
])}
			}
		}
	}
`;
const $ad78489f7c19358a$var$emojiStyles = (0, $3jLHL.css)`
	[data-prosemirror-node-view-type='vanilla'] {
		.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_CONTAINER} {
			display: inline-block;
		}

		.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE} {
			background: no-repeat transparent;
			display: inline-block;
			height: ${(0, $fhsiz.defaultEmojiHeight)}px;
			max-height: ${(0, $fhsiz.defaultEmojiHeight)}px;
			cursor: pointer;
			vertical-align: middle;
			user-select: all;
		}

		&.${(0, $aFUXX.akEditorSelectedNodeClassName)} {
			.${(0, $98HrB.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $98HrB.EmojiSharedCssClassName).EMOJI_IMAGE} {
				border-radius: 2px;
				${(0, $ieXGd.getSelectionStyles)([
    (0, $b38UX.SelectionStyle).Blanket,
    (0, $b38UX.SelectionStyle).BoxShadow
])}
			}
		}
	}
`;
const $ad78489f7c19358a$export$d3bdc0d52bb6c2c8 = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror .placeholder-decoration': {
        color: "var(--ds-text-subtlest, #626F86)",
        width: '100%',
        pointerEvents: 'none',
        userSelect: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.placeholder-android': {
            pointerEvents: 'none',
            outline: 'none',
            userSelect: 'none',
            position: 'absolute'
        }
    }
});
const $ad78489f7c19358a$var$placeholderOverflowStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p:has(.placeholder-decoration-hide-overflow)': {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    }
});
const $ad78489f7c19358a$var$placeholderWrapStyles = (0, $3jLHL.css)({
    // As part of controls work, we add placeholder `Search` to quick insert command
    // This style is to prevent `/Search` being wrapped if it's triggered at the end of the line
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ProseMirror mark[data-type-ahead-query="true"]:has(.placeholder-decoration-wrap)': {
        whiteSpace: 'nowrap'
    }
});
const $ad78489f7c19358a$var$firstBlockNodeStyles = (0, $3jLHL.css)`
	.ProseMirror {
		> .${(0, $DoNsZ.PanelSharedCssClassName).prefix},
			> .${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER},
			> .${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER},
			> div[data-task-list-local-id],
		> div[data-layout-section],
		> .${(0, $iMS6j.expandClassNames).prefix} {
			&:first-child {
				margin-top: 0;
			}
		}

		> hr:first-of-type {
			margin-top: 0;
		}
	}
`;
const $ad78489f7c19358a$var$firstBlockNodeStylesNew = (0, $3jLHL.css)`
	.ProseMirror {
		> .${(0, $DoNsZ.PanelSharedCssClassName).prefix},
			> .${(0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER},
			> .${(0, $cV5SN.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER},
			> div[data-task-list-local-id],
		> div[data-layout-section],
		> .${(0, $iMS6j.expandClassNames).prefix} {
			&:first-child {
				margin-top: 0;
			}
		}

		> hr:first-child,
		> .ProseMirror-widget:first-child + hr {
			margin-top: 0;
		}
	}
`;
const $ad78489f7c19358a$export$42a58e6dfeaffebe = ()=>{
    if ((0, $dh538.fg)('platform_editor_element_dnd_nested_fix_patch_6')) return $ad78489f7c19358a$var$firstBlockNodeStylesNew;
    return $ad78489f7c19358a$var$firstBlockNodeStyles;
};
// The breakpoint for small devices is 1266px, copied from getBreakpoint in platform/packages/editor/editor-common/src/ui/WidthProvider/index.tsx
const $ad78489f7c19358a$var$akEditorBreakpointForSmallDevice = `1266px`;
// jest warning: JSDOM version (22) doesn't support the new @container CSS rule
const $ad78489f7c19358a$var$contentStyles = ()=>(0, $3jLHL.css)`
	--ak-editor--default-gutter-padding: ${0, $aFUXX.akEditorGutterPadding}px;
	/* 52 is from akEditorGutterPaddingDynamic via editor-shared-styles */
	--ak-editor--large-gutter-padding: ${(0, $aFUXX.akEditorGutterPaddingDynamic)()}px;
	--ak-editor--default-layout-width: ${0, $aFUXX.akEditorDefaultLayoutWidth}px;
	--ak-editor--full-width-layout-width: ${0, $aFUXX.akEditorFullWidthLayoutWidth}px;
	/* calculate editor line length, 100cqw is the editor container width */
	--ak-editor--line-length: min(
		calc(100cqw - var(--ak-editor--large-gutter-padding) * 2),
		var(--ak-editor--default-layout-width)
	);
	--ak-editor--breakout-wide-layout-width: ${0, $aFUXX.akEditorCalculatedWideLayoutWidthSmallViewport}px;
	--ak-editor--breakout-full-page-guttering-padding: calc(
		var(--ak-editor--large-gutter-padding) * 2 + var(--ak-editor--default-gutter-padding)
	);

	.fabric-editor--full-width-mode {
		--ak-editor--line-length: min(
			calc(100cqw - var(--ak-editor--large-gutter-padding) * 2),
			var(--ak-editor--full-width-layout-width)
		);
	}

	.ProseMirror {
		--ak-editor-max-container-width: calc(100cqw - var(--ak-editor--large-gutter-padding));
	}

	/* We can't allow nodes that are inside other nodes to bleed from the parent container */
	.ProseMirror > div[data-prosemirror-node-block] [data-prosemirror-node-block] {
		--ak-editor-max-container-width: 100%;
	}

	/* container editor-area is defined in platform/packages/editor/editor-core/src/ui/Appearance/FullPage/StyledComponents.ts */
	@container editor-area (width >= ${$ad78489f7c19358a$var$akEditorBreakpointForSmallDevice}) {
		.ProseMirror {
			--ak-editor--breakout-wide-layout-width: ${0, $aFUXX.akEditorCalculatedWideLayoutWidth}px;
		}
	}

	.ProseMirror {
		outline: none;
		font-size: var(--ak-editor-base-font-size);

		${0, $3iemu.whitespaceSharedStyles};

		${(0, $3Khgq.paragraphSharedStyles)()};

		${0, $4mSjx.listsSharedStyles};

		${0, $diPla.indentationSharedStyles};

		${0, $cRffC.shadowSharedStyle};

		${0, $gYSj7.InlineNodeViewSharedStyles};
	}

	${(0, $dh538.fg)('editor_request_to_edit_task') ? null : (0, $3jLHL.css)`
				.ProseMirror[contenteditable='false'] .taskItemView-content-wrap {
					pointer-events: none;
					opacity: 0.7;
				}
			`}

	.ProseMirror-hideselection *::selection {
		background: transparent;
	}

	.ProseMirror-hideselection *::-moz-selection {
		background: transparent;
	}

	/**
	 * This prosemirror css style: https://github.com/ProseMirror/prosemirror-view/blob/f37ebb29befdbde3cd194fe13fe17b78e743d2f2/style/prosemirror.css#L24
	 *
	 * 1. Merge and Release platform_editor_hide_cursor_when_pm_hideselection
	 * 2. Cleanup duplicated style from platform_editor_advanced_code_blocks
	 *    https://product-fabric.atlassian.net/browse/ED-26331
	 */
	${(0, $dh538.fg)('platform_editor_hide_cursor_when_pm_hideselection') ? (0, $3jLHL.css)`
				.ProseMirror-hideselection {
					caret-color: transparent;
				}
			` : null}

	/* This prosemirror css style: https://github.com/ProseMirror/prosemirror-view/blob/f37ebb29befdbde3cd194fe13fe17b78e743d2f2/style/prosemirror.css#L24 */
	${(0, $iu6m9.editorExperiment)('platform_editor_advanced_code_blocks', true) ? (0, $3jLHL.css)`
				.ProseMirror-hideselection {
					caret-color: transparent;
				}
			` : null}

	.ProseMirror-selectednode {
		outline: none;
	}

	.ProseMirror-selectednode:empty {
		outline: 2px solid ${"var(--ds-border-focused, #8cf)"};
	}

	.ProseMirror.ProseMirror-focused:has(.ProseMirror-mark-boundary-cursor) {
		caret-color: transparent;
	}
	.ProseMirror:not(.ProseMirror-focused) .ProseMirror-mark-boundary-cursor {
		display: none;
	}

	${0, $319kp.placeholderTextStyles}

	${$ad78489f7c19358a$export$d3bdc0d52bb6c2c8}

	${(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? $ad78489f7c19358a$var$placeholderOverflowStyles : null}

	${(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_quick_insert_placeholder') ? $ad78489f7c19358a$var$placeholderWrapStyles : null}

  ${(0, $1zjTz.codeBlockStyles)()}

  ${(0, $4jPB7.blocktypeStyles)()}

  ${(0, $7zsay.codeMarkSharedStyles)()}

  ${0, $4h2HM.textColorStyles}

  ${0, $aGf6a.backgroundColorStyles}

  ${$ad78489f7c19358a$var$listsStyles}

  ${0, $jFNRW.ruleStyles}

  ${0, $i3P6T.mediaStyles}

  ${(0, $dh538.fg)('confluence_team_presence_scroll_to_pointer') ? (0, $h3X17.telepointerStyle) : (0, $h3X17.telepointerStyleWithInitialOnly)}
  ${0, $4AaC5.gapCursorStyles};

	${(0, $bD4Xf.panelStyles)()}

	${$ad78489f7c19358a$var$mentionsStyles}

  ${(0, $iu6m9.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && $ad78489f7c19358a$var$vanillaMentionsStyles}

  ${(0, $iu6m9.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && $ad78489f7c19358a$var$vanillaSelectionStyles}

  ${(0, $iu6m9.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) ? $ad78489f7c19358a$var$emojiStyles : $ad78489f7c19358a$var$reactEmojiStyles}

  ${$ad78489f7c19358a$var$emojiStyles}

  ${0, $7iisy.tasksAndDecisionsStyles}

  ${0, $87iYj.gridStyles}

  ${0, $kZBrC.blockMarksSharedStyles}

  ${0, $7bDsi.dateSharedStyle}

  ${0, $6dFlY.extensionStyles}

  ${(0, $gSnRq.expandStyles)()}

  ${0, $hAOTs.findReplaceStyles}

  ${0, $gg4RV.textHighlightStyle}

  ${0, $dR5Bd.taskDecisionStyles}

  ${(0, $iu6m9.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && (0, $dR5Bd.vanillaTaskItemStyles)}

  ${(0, $iu6m9.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && (0, $dR5Bd.vanillaTaskDecisionStyles)}

  // Switch between the two icons based on the visual refresh feature gate
  ${(0, $iu6m9.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && (0, $dh538.fg)('platform-visual-refresh-icons') && (0, $dR5Bd.vanillaTaskDecisionIconWithVisualRefresh)}

  ${(0, $iu6m9.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: false
    }) && !(0, $dh538.fg)('platform-visual-refresh-icons') && (0, $dR5Bd.vanillaTaskDecisionIconWithoutVisualRefresh)}

  ${0, $ftMAt.statusStyles}

  ${(0, $iu6m9.editorExperiment)('platform_editor_vanilla_dom', true) ? (0, $ftMAt.vanillaStatusStyles)() : null}

  ${0, $ejPu0.annotationStyles}

  ${(0, $0vvte.smartCardStyles)()}

  ${(0, $dh538.fg)('platform-linking-visual-refresh-v1') ? (0, $cV5SN.getSmartCardSharedStyles)() : (0, $cV5SN.smartCardSharedStyles)}

  ${(0, $iu6m9.editorExperiment)('platform_editor_vanilla_dom', true) ? (0, $jFND0.dateVanillaStyles) : null}

	${0, $jFND0.dateStyles}

  ${0, $6svai.embedCardStyles}

  ${0, $2wkZs.unsupportedStyles}

  ${0, $7QdQz.resizerStyles}

  ${(0, $7QdQz.pragmaticResizerStyles)()}

  ${$ad78489f7c19358a$export$42a58e6dfeaffebe()}

  .panelView-content-wrap {
		box-sizing: border-box;
	}

	.mediaGroupView-content-wrap ul {
		padding: 0;
	}

	/** Needed to override any cleared floats, e.g. image wrapping */

	div.fabric-editor-block-mark[class^='fabric-editor-align'] {
		clear: none !important;
	}

	.fabric-editor-align-end {
		text-align: right;
	}

	.fabric-editor-align-start {
		text-align: left;
	}

	.fabric-editor-align-center {
		text-align: center;
	}

	// For FullPage only when inside a table
	// Related code all lives inside: packages/editor/editor-core/src/ui/Appearance/FullPage/StyledComponents.ts
	// In the "editorContentAreaContainerStyle" function
	.fabric-editor--full-width-mode {
		.pm-table-container {
			.code-block,
			.extension-container,
			.multiBodiedExtension--container {
				max-width: 100%;
			}
		}
	}

	.pm-table-header-content-wrap :not(.fabric-editor-alignment),
	.pm-table-header-content-wrap :not(p, .fabric-editor-block-mark) + div.fabric-editor-block-mark,
	.pm-table-cell-content-wrap :not(p, .fabric-editor-block-mark) + div.fabric-editor-block-mark {
		p:first-of-type {
			margin-top: 0;
		}
	}
	.pm-table-cell-content-wrap .mediaGroupView-content-wrap {
		clear: both;
	}

	.hyperlink-floating-toolbar {
		padding: 0;
	}

	/* Legacy Link icon in the Atlaskit package
	 is bigger than the others, new ADS icon does not have this issue
  */
	${!(0, $dh538.fg)('platform-visual-refresh-icons') ? (0, $3jLHL.css)`
				.hyperlink-open-link {
					min-width: 24px;
					svg {
						max-width: 18px;
					}
				}
			` : null}
`;
const $ad78489f7c19358a$var$CommentEditorMargin = 14;
// Originally copied from packages/editor/editor-core/src/ui/Appearance/Comment/Comment.tsx
const $ad78489f7c19358a$var$commentEditorStyles = (0, $3jLHL.css)({
    flexGrow: 1,
    overflowX: 'clip',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '24px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror': {
        margin: "var(--ds-space-150, 12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridParent': {
        marginLeft: "var(--ds-space-025, 2px)",
        marginRight: "var(--ds-space-025, 2px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `calc(100% + ${$ad78489f7c19358a$var$CommentEditorMargin - (0, $87iYj.GRID_GUTTER)}px)`
    },
    padding: "var(--ds-space-250, 20px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $3teBi.tableCommentEditorStyles));
// Originally copied from scrollStyles in packages/editor/editor-core/src/ui/Appearance/FullPage/StyledComponents.ts
const $ad78489f7c19358a$var$fullPageEditorStyles = (0, $3jLHL.css)({
    flexGrow: 1,
    height: '100%',
    overflowY: 'scroll',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    scrollBehavior: 'smooth'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $26eEE.scrollbarStyles));
const $ad78489f7c19358a$var$listLayoutShiftFix = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror ul, .ProseMirror ol': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '10px'
    }
});
/**
 * EditorContentStyles is a wrapper component that applies styles to its children
 * based on the provided feature flags, view mode, and other props.
 * It uses Emotion for styling and supports scrollable content.
 *
 * This will be used in near future to replace the current editor content styles from index.tsx
 */ const $ad78489f7c19358a$var$EditorContentContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef((props, ref)=>{
    const { className: className, children: children, viewMode: viewMode, isScrollable: isScrollable, appearance: appearance } = props;
    const theme = (0, $ja596.u)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const isFullPage = appearance === 'full-page' || appearance === 'full-width';
    const isComment = appearance === 'comment';
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        css: [
            $ad78489f7c19358a$var$contentStyles(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cO7tu.layoutBaseStyles)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $dh538.fg)('platform_editor_hyperlink_underline') ? (0, $432pP.linkStyles) : (0, $432pP.linkStylesOld),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9OTqy.aiPanelBaseStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            colorMode === 'dark' && (0, $9OTqy.aiPanelDarkStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            viewMode === 'view' && (0, $cO7tu.layoutViewStyles),
            isComment && $ad78489f7c19358a$var$commentEditorStyles,
            isFullPage && $ad78489f7c19358a$var$fullPageEditorStyles,
            (0, $dh538.fg)('platform_editor_ssr_fix_lists') && $ad78489f7c19358a$var$listLayoutShiftFix
        ],
        "data-editor-scroll-container": isScrollable ? 'true' : undefined,
        "data-testid": "editor-content-container",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--ak-editor-base-font-size': `${(0, $aFUXX.editorFontSize)({
                theme: theme
            })}px`
        }
    }, children);
});
var $ad78489f7c19358a$export$2e2bcd8739ae039 = $ad78489f7c19358a$var$EditorContentContainer;

});
parcelRegister("c4XA1", function(module, exports) {

$parcel$export(module.exports, "tableFullPageEditorStyles", () => (parcelRequire("3teBi")).tableFullPageEditorStyles);
$parcel$export(module.exports, "tableCommentEditorStyles", () => (parcelRequire("3teBi")).tableCommentEditorStyles);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $3teBi = parcelRequire("3teBi");

});
parcelRegister("3teBi", function(module, exports) {

$parcel$export(module.exports, "insertColumnButtonOffset", () => $93fa7bbbefe5a956$export$af45328890cf2a82);
$parcel$export(module.exports, "tableStyles", () => $93fa7bbbefe5a956$export$e938d6f191645a3e);
$parcel$export(module.exports, "tableFullPageEditorStyles", () => $93fa7bbbefe5a956$export$b0d19c9126eaec7a);
$parcel$export(module.exports, "tableCommentEditorStyles", () => $93fa7bbbefe5a956$export$61a2da566f69d1df);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $d7ZU3 = parcelRequire("d7ZU3");

var $1zav4 = parcelRequire("1zav4");

var $1j8OE = parcelRequire("1j8OE");

var $aFUXX = parcelRequire("aFUXX");
var $ieXGd = parcelRequire("ieXGd");
var $b38UX = parcelRequire("b38UX");

var $26eEE = parcelRequire("26eEE");

var $dh538 = parcelRequire("dh538");

var $6fnsQ = parcelRequire("6fnsQ");

var $iu6m9 = parcelRequire("iu6m9");

var $5p8Hs = parcelRequire("5p8Hs");

var $d5aTJ = parcelRequire("d5aTJ");

var $eoFXy = parcelRequire("eoFXy");

var $gvjT6 = parcelRequire("gvjT6");
const $93fa7bbbefe5a956$var$cornerControlHeight = (0, $eoFXy.tableToolbarSize) + 1;
const $93fa7bbbefe5a956$export$af45328890cf2a82 = (0, $eoFXy.tableInsertColumnButtonSize) / 2;
const $93fa7bbbefe5a956$export$cc4d06b9af7cea87 = 44;
const $93fa7bbbefe5a956$var$rangeSelectionStyles = `
.${(0, $d5aTJ.TableCssClassName).NODEVIEW_WRAPPER}.${(0, $aFUXX.akEditorSelectedNodeClassName)} table tbody tr {
  th,td {
    ${(0, $ieXGd.getSelectionStyles)([
    (0, $b38UX.SelectionStyle).Blanket,
    (0, $b38UX.SelectionStyle).Border
])}

    // The non-break space /00a0 in :after selector caused a table scroll issue when pressing Cmd+A to select table
    // This line is to override the content of :after selector from the shared getSelectionStyles
    &::after {
      content: '';
    }
  }
}
`;
const $93fa7bbbefe5a956$var$sentinelStyles = `.${(0, $d5aTJ.TableCssClassName).TABLE_CONTAINER} {
  > .${(0, $d5aTJ.TableCssClassName).TABLE_STICKY_SENTINEL_TOP}, > .${(0, $d5aTJ.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM} {
    position: absolute;
    width: 100%;
    height: 1px;
    margin-top: -1px;
    // need this to avoid sentinel being focused via keyboard
    // this still allows it to be detected by intersection observer
    visibility: hidden;
  }
  > .${(0, $d5aTJ.TableCssClassName).TABLE_STICKY_SENTINEL_TOP} {
    top: ${(0, $eoFXy.columnControlsDecorationHeight)}px;
  }
  > .${(0, $d5aTJ.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM} {
      bottom: ${(0, $eoFXy.tableScrollbarOffset) + (0, $eoFXy.stickyRowOffsetTop) + (0, $eoFXy.tablePadding) * 2 + 23}px;
  }
  &.${(0, $d5aTJ.TableCssClassName).WITH_CONTROLS} {
    > .${(0, $d5aTJ.TableCssClassName).TABLE_STICKY_SENTINEL_TOP} {
      top: 0px;
    }
    > .${(0, $d5aTJ.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM} {
      margin-bottom: ${(0, $eoFXy.columnControlsDecorationHeight)}px;
    }
  }
}`;
const $93fa7bbbefe5a956$var$stickyScrollbarSentinelStyles = `.${(0, $d5aTJ.TableCssClassName).TABLE_CONTAINER} {
 > .${(0, $d5aTJ.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
 > .${(0, $d5aTJ.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
    position: absolute;
    width: 100%;
    height: 1px;
    margin-top: -1px;
    // need this to avoid sentinel being focused via keyboard
    // this still allows it to be detected by intersection observer
    visibility: hidden;
  }
  > .${(0, $d5aTJ.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
    top: ${(0, $eoFXy.columnControlsDecorationHeight) + $93fa7bbbefe5a956$export$cc4d06b9af7cea87 * 3}px;
  }
  > .${(0, $d5aTJ.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM} {
    bottom: ${(0, $aFUXX.MAX_BROWSER_SCROLLBAR_HEIGHT)}px;
  }
}`;
const $93fa7bbbefe5a956$var$stickyScrollbarContainerStyles = `.${(0, $d5aTJ.TableCssClassName).TABLE_CONTAINER} {
  > .${(0, $d5aTJ.TableCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER} {
    width: 100%;
    display: none;
    overflow-x: auto;
    position: sticky;
    bottom: 0;
    z-index: 1;
  }
}`;
const $93fa7bbbefe5a956$var$stickyScrollbarStyles = `${$93fa7bbbefe5a956$var$stickyScrollbarContainerStyles} ${$93fa7bbbefe5a956$var$stickyScrollbarSentinelStyles}`;
const $93fa7bbbefe5a956$var$shadowSentinelStyles = `
  .${(0, $d5aTJ.TableCssClassName).TABLE_SHADOW_SENTINEL_LEFT},
  .${(0, $d5aTJ.TableCssClassName).TABLE_SHADOW_SENTINEL_RIGHT} {
    position: absolute;
    top: 0;
    height: 100%;
    width: 1px;
    visibility: hidden;
  }
  .${(0, $d5aTJ.TableCssClassName).TABLE_SHADOW_SENTINEL_LEFT} {
    left: 0;
  }
  .${(0, $d5aTJ.TableCssClassName).TABLE_SHADOW_SENTINEL_RIGHT} {
    right: 0;
  }
`;
const $93fa7bbbefe5a956$var$breakoutWidthStyling = ()=>{
    return (0, $3jLHL.css)`
		> *:not([data-mark-type='fragment'])
			.${(0, $d5aTJ.TableCssClassName).NODEVIEW_WRAPPER}
			.${(0, $d5aTJ.TableCssClassName).TABLE_CONTAINER} {
			margin-left: unset !important;
			width: 100% !important;
		}

		> [data-mark-type='fragment'] * .${(0, $d5aTJ.TableCssClassName).NODEVIEW_WRAPPER} .${(0, $d5aTJ.TableCssClassName).TABLE_CONTAINER} {
			margin-left: unset !important;
			width: 100% !important;
		}
	`;
};
const $93fa7bbbefe5a956$var$viewModeSortStyles = ()=>{
    return (0, $dh538.fg)('platform_editor_nested_tables_view_mode_sort') ? (0, $3jLHL.css)`
				/* new styles */
				th {
					.${0, $5p8Hs.SORTING_ICON_CLASS_NAME} {
						+ p {
							margin-top: 0 !important;
						}
					}

					> .${0, $5p8Hs.SORTING_ICON_CLASS_NAME} {
						&:has(.is-active) {
							.${0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME} {
								opacity: 1;
							}
						}
					}

					> .${0, $5p8Hs.SORTING_ICON_CLASS_NAME} {
						.${0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME} {
							opacity: 0;
							&:focus {
								opacity: 1;
							}
						}
					}

					&:hover:not(:has(.${(0, $d5aTJ.TableCssClassName).TABLE_CONTAINER}:hover)) {
						> .${0, $5p8Hs.SORTING_ICON_CLASS_NAME} {
							.${0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME} {
								opacity: 1;
							}
						}
					}
				}
			` : (0, $3jLHL.css)`
				/* old styles */
				th {
					.${0, $5p8Hs.SORTING_ICON_CLASS_NAME} {
						+ p {
							margin-top: 0 !important;
						}
					}

					&:has(.is-active) {
						.${0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME} {
							opacity: 1;
						}
					}

					.${0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME} {
						opacity: 0;
						&:focus {
							opacity: 1;
						}
					}

					&:hover {
						.${0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME} {
							opacity: 1;
						}
					}
				}
			`;
};
const $93fa7bbbefe5a956$var$tableBorderStyles = ()=>{
    return `border-color: ${0, $eoFXy.tableBorderDeleteColor}`;
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
const $93fa7bbbefe5a956$var$tableStickyHeaderColumnControlsDecorationsStyle = ()=>{
    return (0, $3jLHL.css)`
		.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY} .${(0, $d5aTJ.TableCssClassName).COLUMN_CONTROLS_DECORATIONS} {
			z-index: 0;
			left: -1px;
		}

		.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY} .${(0, $d5aTJ.TableCssClassName).COLUMN_CONTROLS_DECORATIONS}::after {
			border-left: 1px solid ${0, $eoFXy.tableBorderColor};
		}

		.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY} tr:first-of-type th.${(0, $d5aTJ.TableCssClassName).TABLE_HEADER_CELL} {
			&.${(0, $d5aTJ.TableCssClassName).COLUMN_SELECTED}, &.${(0, $d5aTJ.TableCssClassName).HOVERED_COLUMN} {
				.${(0, $d5aTJ.TableCssClassName).COLUMN_CONTROLS_DECORATIONS}::after {
					left: 0;
				}
			}
		}
	`;
};
const $93fa7bbbefe5a956$var$tableStickyHeaderFirefoxFixStyle = ()=>{
    /*
     This is MAGIC!
     This fixes a bug which occurs in firefox when the first row becomes sticky.
     see https://product-fabric.atlassian.net/browse/ED-19177
   */ if ((0, $d7ZU3.browser).gecko) return (0, $3jLHL.css)`
			.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY} > tbody::before {
				content: '';
			}
		`;
};
const $93fa7bbbefe5a956$export$9989b31b7900261c = (props)=>(0, $3jLHL.css)`
	${(0, $1zav4.tableSharedStyle)()};
	${(0, $gvjT6.columnControlsLineMarker)()};
	${(0, $gvjT6.hoveredDeleteButton)()};
	${(0, $gvjT6.hoveredCell)()};
	${0, $gvjT6.hoveredWarningCell};
	${(0, $gvjT6.insertLine)()};
	${(0, $gvjT6.resizeHandle)()};
	${$93fa7bbbefe5a956$var$rangeSelectionStyles};
	${$93fa7bbbefe5a956$var$viewModeSortStyles()};

	.${(0, $d5aTJ.TableCssClassName).LAST_ITEM_IN_CELL} {
		margin-bottom: 0;
	}

	.${(0, $d5aTJ.TableCssClassName).TABLE_NODE_WRAPPER} {
		td.${(0, $d5aTJ.TableCssClassName).TABLE_CELL}, th.${(0, $d5aTJ.TableCssClassName).TABLE_HEADER_CELL} {
			position: relative;
			overflow: visible;
		}

		td.${(0, $d5aTJ.TableCssClassName).TABLE_CELL} {
			background-color: ${0, $eoFXy.tableCellBackgroundColor};

			&::after {
				height: 100%;
				content: '';
				border-left: 1px solid ${0, $eoFXy.tableBorderColor};
				border-bottom: 1px solid ${0, $eoFXy.tableBorderColor};
				position: absolute;
				right: 0px;
				top: 0px;
				bottom: 0;
				width: 100%;
				display: inline-block;
				pointer-events: none;
			}
		}
	}

	.${(0, $d5aTJ.TableCssClassName).CONTROLS_FLOATING_BUTTON_COLUMN} {
		${(0, $gvjT6.insertColumnButtonWrapper)()}
	}

	.${(0, $d5aTJ.TableCssClassName).CONTROLS_FLOATING_BUTTON_ROW} {
		${(0, $gvjT6.insertRowButtonWrapper)()}
	}

	${(0, $gvjT6.dragInsertButtonWrapper)()}

	${(0, $gvjT6.dragCornerControlButton)()}

	/* Delete button */
	${(0, $gvjT6.DeleteButton)()}
	/* Ends Delete button */

	/* sticky styles */
	${(0, $dh538.fg)('platform_editor_nested_tables_sticky_header_bug') ? `
		${(0, $dh538.fg)('platform_editor_number_column_sticky_header_broken') ? `.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY} > .${props.isDragAndDropEnabled ? (0, $d5aTJ.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER : (0, $d5aTJ.TableCssClassName).ROW_CONTROLS_WRAPPER} .${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN} .${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN_BUTTON}:first-of-type {` : `.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY} > .${(0, $d5aTJ.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER} .${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN} .${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN_BUTTON}:first-of-type {`}
			margin-top: ${(0, $dh538.fg)('platform_editor_number_column_sticky_header_bug') ? (0, $eoFXy.stickyRowOffsetTop) : (0, $eoFXy.stickyRowOffsetTop) + 2}px;
			width: ${0, $aFUXX.akEditorTableNumberColumnWidth}px;

			position: fixed !important;
			z-index: ${0, $aFUXX.akEditorStickyHeaderZIndex} !important;
			box-shadow: 0px -${0, $eoFXy.stickyRowOffsetTop}px ${"var(--ds-surface, white)"};
			border-right: 0 none;
			/* top set by NumberColumn component */
		}
		` : `
    	.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY} .${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN} .${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN_BUTTON}:first-of-type {
			margin-top: ${(0, $dh538.fg)('platform_editor_number_column_sticky_header_bug') ? (0, $eoFXy.stickyRowOffsetTop) : (0, $eoFXy.stickyRowOffsetTop) + 2}px;
			width: ${0, $aFUXX.akEditorTableNumberColumnWidth}px;

			position: fixed !important;
			z-index: ${0, $aFUXX.akEditorStickyHeaderZIndex} !important;
			box-shadow: 0px -${0, $eoFXy.stickyRowOffsetTop}px ${"var(--ds-surface, white)"};
			border-right: 0 none;
			/* top set by NumberColumn component */
		}
		`}

	.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY} .${(0, $d5aTJ.TableCssClassName).CORNER_CONTROLS}.sticky {
		position: fixed !important;
		/* needs to be above row controls */
		z-index: ${0, $aFUXX.akEditorSmallZIndex} !important;
		background: ${"var(--ds-surface, white)"};

		width: ${0, $eoFXy.tableToolbarSize}px;
		height: ${0, $eoFXy.tableToolbarSize}px;
	}

	.${(0, $d5aTJ.TableCssClassName).CORNER_CONTROLS}.sticky .${(0, $d5aTJ.TableCssClassName).CONTROLS_CORNER_BUTTON} {
		border-bottom: 0px none;
		border-right: 0px none;

		height: ${0, $eoFXy.tableToolbarSize}px;
		width: ${0, $eoFXy.tableToolbarSize}px;
	}

	${$93fa7bbbefe5a956$var$tableStickyHeaderColumnControlsDecorationsStyle()}

	${$93fa7bbbefe5a956$var$tableStickyHeaderFirefoxFixStyle()}

    .${(0, $d5aTJ.TableCssClassName).TABLE_STICKY}
      .${(0, $d5aTJ.TableCssClassName).ROW_CONTROLS}
      .${(0, $d5aTJ.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP}.sticky {
		position: fixed !important;
		z-index: ${0, $aFUXX.akEditorStickyHeaderZIndex} !important;
		display: flex;
		border-left: ${0, $eoFXy.tableToolbarSize}px solid ${"var(--ds-surface, white)"};
		margin-left: -${0, $eoFXy.tableToolbarSize}px;
	}

	.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY} col:first-of-type {
		/* moving rows out of a table layout does weird things in Chrome */
		border-right: 1px solid ${"var(--ds-surface, green)"};
	}

	tr.sticky {
		padding-top: ${0, $eoFXy.stickyRowOffsetTop}px;
		position: fixed;
		display: grid;

		/* to keep it above cell selection but below date and other nodes popups that are inside sticky header */
		z-index: ${(0, $aFUXX.akEditorTableCellOnStickyHeaderZIndex) - 5};

		overflow-y: visible;
		overflow-x: hidden;

		grid-auto-flow: column;

		/* background for where controls apply */
		background: ${"var(--ds-surface, white)"};
		box-sizing: content-box;
		box-shadow: 0 6px 4px -4px ${`var(--ds-shadow-overflow-perimeter, ${0, $6fnsQ.N40A})`};
		margin-left: -1px;

		&.no-pointer-events {
			pointer-events: none;
		}
	}

	.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY} .${(0, $d5aTJ.TableCssClassName).TABLE_STICKY_SHADOW} {
		left: unset;
		position: fixed;
		/* needs to be above sticky header row and below date and other nodes popups that are inside sticky header */
		z-index: ${0, $aFUXX.akEditorTableCellOnStickyHeaderZIndex};
	}

	.${(0, $d5aTJ.TableCssClassName).WITH_CONTROLS}.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY} .${(0, $d5aTJ.TableCssClassName).TABLE_STICKY_SHADOW} {
		padding-bottom: ${0, $eoFXy.tableToolbarSize}px;
	}

	${(0, $dh538.fg)('nested_table_control_padding_with_css') ? `
		.tableView-content-wrap:has(.tableView-content-wrap):has(.${(0, $d5aTJ.TableCssClassName).NESTED_TABLE_WITH_CONTROLS}) {
			padding-left: unset;
		}

		.tableView-content-wrap:has(.${(0, $d5aTJ.TableCssClassName).NESTED_TABLE_WITH_CONTROLS}) {
			padding-left: 15px;
		}
		` : ''}

	tr.sticky th {
		border-bottom: ${0, $eoFXy.stickyHeaderBorderBottomWidth}px solid ${0, $eoFXy.tableBorderColor};
		margin-right: -1px;
	}

	.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY} tr.sticky > th:last-child {
		border-right-width: 1px;
	}

	/* add left edge for first cell */
	.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY} tr.sticky > th:first-of-type {
		margin-left: 0px;
	}

	/* add a little bit so the scroll lines up with the table */
	.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY} tr.sticky::after {
		content: ' ';
		width: ${$93fa7bbbefe5a956$export$af45328890cf2a82 + 1}px;
	}

	/* To fix jumpiness caused in Chrome Browsers for sticky headers */
	.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY} .sticky + tr {
		min-height: 0px;
	}

	/* move resize line a little in sticky bar */
	.${(0, $d5aTJ.TableCssClassName).TABLE_CONTAINER}.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY} {
		tr.sticky td.${(0, $d5aTJ.TableCssClassName).WITH_RESIZE_LINE}, tr.sticky th.${(0, $d5aTJ.TableCssClassName).WITH_RESIZE_LINE} {
			.${(0, $d5aTJ.TableCssClassName).RESIZE_HANDLE_DECORATION}::after {
				right: ${((0, $eoFXy.resizeHandlerAreaWidth) - (0, $eoFXy.resizeLineWidth)) / 2 + 1}px;
			}
		}

		/* when selected put it back to normal -- :not selector would be nicer */
		tr.sticky
			td.${(0, $d5aTJ.TableCssClassName).WITH_RESIZE_LINE}.${(0, $d5aTJ.TableCssClassName).SELECTED_CELL},
			tr.sticky
			th.${(0, $d5aTJ.TableCssClassName).WITH_RESIZE_LINE}.${(0, $d5aTJ.TableCssClassName).SELECTED_CELL} {
			.${(0, $d5aTJ.TableCssClassName).RESIZE_HANDLE_DECORATION}::after {
				right: ${((0, $eoFXy.resizeHandlerAreaWidth) - (0, $eoFXy.resizeLineWidth)) / 2}px;
			}
		}
	}

	tr.sticky .${(0, $d5aTJ.TableCssClassName).HOVERED_CELL}, tr.sticky .${(0, $d5aTJ.TableCssClassName).SELECTED_CELL} {
		z-index: 1;
	}

	.${(0, $d5aTJ.TableCssClassName).WITH_CONTROLS} tr.sticky {
		padding-top: ${0, $eoFXy.tableControlsSpacing}px;
	}

	${(0, $dh538.fg)('platform_editor_nested_tables_sticky_header_bug') ? `
		.${(0, $d5aTJ.TableCssClassName).WITH_CONTROLS}.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY} > .${(0, $d5aTJ.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER}
			.${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN}
			.${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN_BUTTON}:first-of-type {
			margin-top: ${(0, $dh538.fg)('platform_editor_number_column_sticky_header_bug') ? (0, $eoFXy.tableControlsSpacing) : (0, $eoFXy.tableControlsSpacing) + 2}px;
		}
		` : `
		.${(0, $d5aTJ.TableCssClassName).WITH_CONTROLS}.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY}
			.${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN}
			.${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN_BUTTON}:first-of-type {
			margin-top: ${(0, $dh538.fg)('platform_editor_number_column_sticky_header_bug') ? (0, $eoFXy.tableControlsSpacing) : (0, $eoFXy.tableControlsSpacing) + 2}px;
		}
		`}

	.${(0, $d5aTJ.TableCssClassName).CORNER_CONTROLS}.sticky {
		border-top: ${(0, $dh538.fg)('platform_editor_number_column_sticky_header_bug') ? (0, $eoFXy.tableControlsSpacing) - (0, $eoFXy.tableToolbarSize) : (0, $eoFXy.tableControlsSpacing) - (0, $eoFXy.tableToolbarSize) + 2}px
			solid ${"var(--ds-surface, white)"};
	}

	${$93fa7bbbefe5a956$var$sentinelStyles}
	${(0, $gvjT6.OverflowShadow)(props.featureFlags?.tableDragAndDrop)}
    ${$93fa7bbbefe5a956$var$stickyScrollbarStyles}

    .${(0, $d5aTJ.TableCssClassName).TABLE_STICKY} .${(0, $d5aTJ.TableCssClassName).TABLE_STICKY_SHADOW} {
		height: 0; /* stop overflow flash & set correct height in update-overflow-shadows.ts */
	}

	.less-padding {
		padding: 0 ${0, $eoFXy.tablePadding}px;

		.${(0, $d5aTJ.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER}, .${(0, $d5aTJ.TableCssClassName).ROW_CONTROLS_WRAPPER} {
			padding: 0 ${0, $eoFXy.tablePadding}px;

			/* https://product-fabric.atlassian.net/browse/ED-16386
			Fixes issue where the extra padding that is added here throws off the position
			of the rows control dot */
			&::after {
				right: 6px !important;
			}
		}

		.${(0, $d5aTJ.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER}.${(0, $d5aTJ.TableCssClassName).TABLE_CHROMELESS} {
			left: -4px;
		}

		.${(0, $d5aTJ.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER} {
			padding: 0 ${0, $eoFXy.tablePadding}px;
		}

		.${(0, $d5aTJ.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER}.${(0, $d5aTJ.TableCssClassName).TABLE_CHROMELESS} {
			left: -8px;
		}

		&.${(0, $d5aTJ.TableCssClassName).TABLE_CONTAINER}[data-number-column='true'] {
			padding-left: ${(0, $aFUXX.akEditorTableNumberColumnWidth) + (0, $eoFXy.tablePadding) - 1}px;
		}
		.${(0, $d5aTJ.TableCssClassName).TABLE_LEFT_SHADOW}, .${(0, $d5aTJ.TableCssClassName).TABLE_RIGHT_SHADOW} {
			width: ${0, $eoFXy.tableOverflowShadowWidth}px;
		}

		.${(0, $d5aTJ.TableCssClassName).TABLE_LEFT_SHADOW} {
			left: 6px;
		}
		.${(0, $d5aTJ.TableCssClassName).TABLE_LEFT_SHADOW}.${(0, $d5aTJ.TableCssClassName).TABLE_CHROMELESS} {
			left: 8px;
		}

		.${(0, $d5aTJ.TableCssClassName).TABLE_RIGHT_SHADOW} {
			left: calc(100% - 6px);
		}
		.${(0, $d5aTJ.TableCssClassName).TABLE_RIGHT_SHADOW}.${(0, $d5aTJ.TableCssClassName).TABLE_CHROMELESS} {
			left: calc(100% - 16px);
		}
	}

	> .${(0, $d5aTJ.TableCssClassName).NODEVIEW_WRAPPER} {
		/**
       * Prevent margins collapsing, aids with placing the gap-cursor correctly
       * @see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Box_Model/Mastering_margin_collapsing
       *
       * TODO: Enable this, many tests will fail!
       * border-top: 1px solid transparent;
       */
	}

	/* Breakout only works on top level unless wrapped in fragment mark */
	${$93fa7bbbefe5a956$var$breakoutWidthStyling()}

	${(0, $gvjT6.columnControlsDecoration)()};
	${(0, $gvjT6.rowControlsWrapperDotStyle)()};

	/* Corner controls */
	.${(0, $d5aTJ.TableCssClassName).CORNER_CONTROLS} {
		width: ${(0, $eoFXy.tableToolbarSize) + 1}px;
		height: ${$93fa7bbbefe5a956$var$cornerControlHeight}px;
		display: none;

		.${(0, $d5aTJ.TableCssClassName).CORNER_CONTROLS_INSERT_ROW_MARKER} {
			position: relative;

			${(0, $gvjT6.InsertMarker)(`
          left: -11px;
          top: 9px;
        `)};
		}
	}

	.${(0, $d5aTJ.TableCssClassName).CORNER_CONTROLS}.sticky {
		.${(0, $d5aTJ.TableCssClassName).CORNER_CONTROLS_INSERT_ROW_MARKER} {
			/* sticky row insert dot overlaps other row insert and messes things up */
			display: none !important;
		}
	}

	.${(0, $d5aTJ.TableCssClassName).CONTROLS_CORNER_BUTTON} {
		position: absolute;
		top: 0;
		width: ${(0, $eoFXy.tableToolbarSize) + 1}px;
		height: ${(0, $eoFXy.tableToolbarSize) + 1}px;
		border: 1px solid ${0, $eoFXy.tableBorderColor};
		border-radius: 0;
		border-top-left-radius: ${0, $eoFXy.tableBorderRadiusSize}px;
		background: ${0, $eoFXy.tableHeaderCellBackgroundColor};
		box-sizing: border-box;
		padding: 0;
		:focus {
			outline: none;
		}
	}
	.active .${(0, $d5aTJ.TableCssClassName).CONTROLS_CORNER_BUTTON} {
		border-color: ${0, $eoFXy.tableBorderSelectedColor};
		background: ${0, $eoFXy.tableToolbarSelectedColor};
	}

	.${(0, $d5aTJ.TableCssClassName).TABLE_CONTAINER}[data-number-column='true'] {
		.${(0, $d5aTJ.TableCssClassName).CORNER_CONTROLS}, .${(0, $d5aTJ.TableCssClassName).CONTROLS_CORNER_BUTTON} {
			width: ${(0, $aFUXX.akEditorTableToolbarSize) + (0, $aFUXX.akEditorTableNumberColumnWidth) + 1}px;
		}
		.${(0, $d5aTJ.TableCssClassName).ROW_CONTROLS} .${(0, $d5aTJ.TableCssClassName).CONTROLS_BUTTON} {
			border-right-width: 0;
		}
	}

	:not(.${(0, $d5aTJ.TableCssClassName).IS_RESIZING}) .${(0, $d5aTJ.TableCssClassName).CONTROLS_CORNER_BUTTON}:hover {
		border-color: ${0, $eoFXy.tableBorderSelectedColor};
		background: ${0, $eoFXy.tableToolbarSelectedColor};
		cursor: pointer;
	}

	:not(.${(0, $d5aTJ.TableCssClassName).IS_RESIZING})
		.${(0, $d5aTJ.TableCssClassName).CONTROLS_CORNER_BUTTON}.${(0, $d5aTJ.TableCssClassName).HOVERED_CELL_IN_DANGER} {
		border-color: ${0, $eoFXy.tableBorderDeleteColor};
		background: ${0, $eoFXy.tableToolbarDeleteColor};
	}

	/* Row controls */
	.${(0, $d5aTJ.TableCssClassName).ROW_CONTROLS} {
		width: ${0, $eoFXy.tableToolbarSize}px;
		box-sizing: border-box;
		display: none;
		position: relative;

		${(0, $gvjT6.InsertMarker)(`
        bottom: -1px;
        left: -11px;
      `)};

		.${(0, $d5aTJ.TableCssClassName).ROW_CONTROLS_INNER} {
			display: flex;
			flex-direction: column;
		}
		.${(0, $d5aTJ.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP}:last-child > button {
			border-bottom-left-radius: ${0, $eoFXy.tableBorderRadiusSize}px;
		}
		.${(0, $d5aTJ.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP} {
			position: relative;
			margin-top: -1px;
		}
		.${(0, $d5aTJ.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP}:hover,
			.${(0, $d5aTJ.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP}.active,
			.${(0, $d5aTJ.TableCssClassName).CONTROLS_BUTTON}:hover {
			z-index: ${0, $aFUXX.akEditorUnitZIndex};
		}

		${(0, $gvjT6.HeaderButton)(`
        border-bottom: 1px solid ${(0, $eoFXy.tableBorderColor)};
        border-right: 0px;
        border-radius: 0;
        height: 100%;
        width: ${(0, $eoFXy.tableToolbarSize)}px;

        .${(0, $d5aTJ.TableCssClassName).CONTROLS_BUTTON_OVERLAY} {
          position: absolute;
          width: 30px;
          height: 50%;
          right: 0;
          bottom: 0;
        }
        .${(0, $d5aTJ.TableCssClassName).CONTROLS_BUTTON_OVERLAY}:first-of-type {
          top: 0;
        }
      `)}
	}

	.${(0, $d5aTJ.TableCssClassName).DRAG_ROW_CONTROLS} {
		display: grid;
		align-items: center;
		position: absolute;
		z-index: ${(0, $dh538.fg)('platform_editor_table_column_selected_state_fix') ? (0, $eoFXy.rowControlsZIndex) + 4 : (0, $aFUXX.akEditorUnitZIndex)};

		.${(0, $d5aTJ.TableCssClassName).DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER} {
			position: absolute;
			align-self: end;
			height: 100%;
			width: 18px;
		}

		.${(0, $d5aTJ.TableCssClassName).DRAG_ROW_FLOATING_INSERT_DOT} {
			position: absolute;
			bottom: -3px;
			left: 2px;
			background-color: ${"var(--ds-background-accent-gray-subtler, #C1C7D0)"};
			height: 4px;
			width: 4px;
			border-radius: 50%;
			pointer-events: none;
		}
	}

	.${(0, $d5aTJ.TableCssClassName).DRAG_COLUMN_CONTROLS} {
		.${(0, $d5aTJ.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER} {
			height: 24px;
			position: absolute;
			top: ${"var(--ds-space-negative-150, -12px)"};
			z-index: ${0, $eoFXy.resizeHandlerZIndex};
		}

		.${(0, $d5aTJ.TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER} {
			position: absolute;
			height: 24px;
			width: 100%;
		}

		.${(0, $d5aTJ.TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT} {
			background-color: ${"var(--ds-background-accent-gray-subtler, #C1C7D0)"};
			height: 4px;
			width: 4px;
			border-radius: 50%;
			position: absolute;
			right: -2px;
		}
	}

	.${(0, $d5aTJ.TableCssClassName).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE} {
		background: none;
		border: none;
		outline: none;
		position: absolute;
		margin: 0;
		padding: 0;
		display: flex;
		align-items: center;
		cursor: pointer;

		:focus {
			outline: none;
		}
	}

	.${(0, $d5aTJ.TableCssClassName).DRAG_HANDLE_BUTTON_CONTAINER} {
		cursor: grab;
		pointer-events: auto;

		line-height: 0;
		padding: 0;
		border-radius: 6px;
		width: max-content;
		border: 2px solid ${`var(--ds-surface, ${0, $6fnsQ.N0})`};

		display: flex;
		justify-content: center;
		align-items: center;
		background: transparent;
		outline: none;

		&.placeholder {
			background-color: transparent;
			border: 2px solid transparent;
		}

		&.${(0, $d5aTJ.TableCssClassName).DRAG_HANDLE_DISABLED} {
			cursor: pointer;
			& svg {
				& > rect.${(0, $d5aTJ.TableCssClassName).DRAG_HANDLE_MINIMISED} {
					fill: ${"var(--ds-background-accent-gray-subtler, #DCDFE4)"};
				}
				& > rect {
					fill: ${"var(--ds-background-accent-gray-subtlest, #F4F5F7)"};
				}
				& > g > rect {
					fill: ${"var(--ds-icon-disabled, #BFDBF847)"};
				}
			}
		}

		&:not(.${(0, $d5aTJ.TableCssClassName).DRAG_HANDLE_DISABLED}) {
			& svg {
				rect {
					fill: ${"var(--ds-background-accent-gray-subtler, #DCDFE4)"};
				}
				g {
					fill: ${"var(--ds-icon-subtle, #626f86)"};
				}
			}

			&:hover {
				svg {
					rect {
						fill: ${"var(--ds-background-accent-blue-subtle, #579DFF)"};
					}
					g {
						fill: ${"var(--ds-icon-inverse, #FFF)"};
					}
				}
			}

			&:active {
				cursor: grabbing;
			}

			&.selected {
				:focus {
					outline: 2px solid ${"var(--ds-border-focused, #2684FF)"};
					outline-offset: 1px;
				}

				&:active {
					outline: none;
				}

				svg {
					rect {
						fill: ${"var(--ds-background-accent-blue-subtle, #579dff)"};
					}
					g {
						fill: ${"var(--ds-icon-inverse, #fff)"};
					}
				}
			}

			&.danger {
				svg {
					rect {
						fill: ${"var(--ds-background-accent-red-subtler-pressed, #F87462)"};
					}
					g {
						fill: ${"var(--ds-border-inverse, #FFF)"};
					}
				}
			}
		}
	}

	${(0, $gvjT6.floatingColumnControls)()}

	:not(.${(0, $d5aTJ.TableCssClassName).IS_RESIZING}) .${(0, $d5aTJ.TableCssClassName).ROW_CONTROLS} {
		${(0, $gvjT6.HeaderButtonHover)()}
		${(0, $gvjT6.HeaderButtonDanger)()}
	}

	/* Numbered column */
	.${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN} {
		position: relative;
		float: right;
		margin-left: ${0, $aFUXX.akEditorTableToolbarSize}px;
		top: ${((0, $dh538.fg)('platform_editor_number_column_sticky_header_broken') ? props.isDragAndDropEnabled : props.featureFlags?.tableDragAndDrop) || (0, $iu6m9.editorExperiment)('support_table_in_comment_jira', true) ? 0 : (0, $aFUXX.akEditorTableToolbarSize)}px;
		width: ${(0, $aFUXX.akEditorTableNumberColumnWidth) + 1}px;
		box-sizing: border-box;
	}

	.${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN_BUTTON} {
		border: 1px solid ${0, $eoFXy.tableBorderColor};
		box-sizing: border-box;
		margin-top: -1px;
		padding-bottom: 2px;
		padding: 10px 2px;
		text-align: center;
		font-size: ${(0, $aFUXX.relativeFontSizeToBase16)(14)};
		background-color: ${0, $eoFXy.tableHeaderCellBackgroundColor};
		color: ${0, $eoFXy.tableTextColor};
		border-color: ${0, $eoFXy.tableBorderColor};

		:first-child:not(style),
		style:first-child + * {
			margin-top: 0;
		}
		:last-child {
			border-bottom: 1px solid ${0, $eoFXy.tableBorderColor};
		}
	}

	/* add a background above the first numbered column cell when sticky header is engaged
	which hides the table when scrolling */
	${(0, $dh538.fg)('platform_editor_nested_tables_sticky_header_bug') ? `
		${(0, $dh538.fg)('platform_editor_number_column_sticky_header_broken') ? `.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY} > .${props.isDragAndDropEnabled ? (0, $d5aTJ.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER : (0, $d5aTJ.TableCssClassName).ROW_CONTROLS_WRAPPER} {
				.${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED}:first-of-type::after {` : `.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY} > .${(0, $d5aTJ.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER} {
				.${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED}:first-of-type::after {`}
				content: '';
				display: block;
				height: 33px;
				width: 100%;
				background-color: ${"var(--ds-surface, white)"};
				position: absolute;

				/* the extra pixel is accounting for borders */
				top: -34px;
				left: -1px;
			}
		}
		` : `
		.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY} {
			.${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED}:first-of-type::after {
				content: '';
				display: block;
				height: 33px;
				width: 100%;
				background-color: ${"var(--ds-surface, white)"};
				position: absolute;

				/* the extra pixel is accounting for borders */
				top: -34px;
				left: -1px;
			}
		}
		`}

	.${(0, $d5aTJ.TableCssClassName).WITH_CONTROLS} {
		.${(0, $d5aTJ.TableCssClassName).CORNER_CONTROLS}, .${(0, $d5aTJ.TableCssClassName).ROW_CONTROLS} {
			display: block;
		}
		.${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN} {
			padding-left: 0px;

			.${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN_BUTTON} {
				border-left: 0 none;
			}

			.${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN_BUTTON}.active {
				border-bottom: 1px solid ${0, $eoFXy.tableBorderSelectedColor};
				border-color: ${0, $eoFXy.tableBorderSelectedColor};
				background-color: ${0, $eoFXy.tableToolbarSelectedColor};
				position: relative;
				z-index: ${0, $aFUXX.akEditorUnitZIndex};
				color: ${`var(--ds-text-selected, ${0, $6fnsQ.N0})`};
			}
		}

		/* nested tables should be ignored when we apply border-left: 0 to the parent table */
		.${(0, $d5aTJ.TableCssClassName).TABLE_CONTAINER} {
			.${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN_BUTTON} {
				border-left: 1px solid ${0, $eoFXy.tableBorderColor};
			}
		}
	}
	:not(.${(0, $d5aTJ.TableCssClassName).IS_RESIZING}) .${(0, $d5aTJ.TableCssClassName).WITH_CONTROLS} {
		.${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN_BUTTON}:not(.${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED}) {
			cursor: pointer;
		}
		.${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN_BUTTON}:not(.${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED}):hover {
			border-bottom: 1px solid ${0, $eoFXy.tableBorderSelectedColor};
			border-color: ${0, $eoFXy.tableBorderSelectedColor};
			background-color: ${0, $eoFXy.tableToolbarSelectedColor};
			position: relative;
			z-index: ${0, $aFUXX.akEditorUnitZIndex};
			color: ${`var(--ds-text-selected, ${0, $6fnsQ.N0})`};
		}
		.${(0, $d5aTJ.TableCssClassName).NUMBERED_COLUMN_BUTTON}.${(0, $d5aTJ.TableCssClassName).HOVERED_CELL_IN_DANGER} {
			background-color: ${0, $eoFXy.tableToolbarDeleteColor};
			border: 1px solid ${0, $eoFXy.tableBorderDeleteColor};
			border-left: 0;
			color: ${`var(--ds-text-danger, ${0, $6fnsQ.R500})`};
			position: relative;
			z-index: ${0, $aFUXX.akEditorUnitZIndex};
		}
	}

	/* Table */
	.${(0, $d5aTJ.TableCssClassName).TABLE_NODE_WRAPPER} > table {
		table-layout: fixed;
		white-space: normal;
		border-top: none;
		/* 1px border width offset added here to prevent unwanted overflow and scolling - ED-16212 */
		margin-right: -1px;
		/* Allows better positioning for the shadow sentinels - ED-16668 */
		position: relative;

		> tbody > tr {
			white-space: pre-wrap;
		}

		.${(0, $d5aTJ.TableCssClassName).COLUMN_CONTROLS_DECORATIONS} + * {
			margin-top: 0;
		}

		/*
       * Headings have a top margin by default, but we don't want this on the
       * first heading within table header cells.
       *
       * This specifically sets margin-top for the first heading within a header
       * cell when center/right aligned.
       */
		th.${(0, $d5aTJ.TableCssClassName).TABLE_HEADER_CELL} > .fabric-editor-block-mark {
			> h1:first-of-type,
			> h2:first-of-type,
			> h3:first-of-type,
			> h4:first-of-type,
			> h5:first-of-type,
			> h6:first-of-type {
				margin-top: 0;
			}
		}

		.${(0, $d5aTJ.TableCssClassName).SELECTED_CELL}, .${(0, $d5aTJ.TableCssClassName).HOVERED_CELL_IN_DANGER} {
			position: relative;
		}
		/* Give selected cells a blue overlay */
		.${(0, $d5aTJ.TableCssClassName).SELECTED_CELL}::after, .${(0, $d5aTJ.TableCssClassName).HOVERED_CELL_IN_DANGER}::after {
			z-index: ${0, $aFUXX.akEditorSmallZIndex};
			position: absolute;
			content: '';
			left: 0;
			right: 0;
			top: 0;
			bottom: 0;
			width: 100%;
			pointer-events: none;
		}
		.${(0, $d5aTJ.TableCssClassName).SELECTED_CELL} {
			border: 1px solid ${0, $eoFXy.tableBorderSelectedColor};
		}
		.${(0, $d5aTJ.TableCssClassName).SELECTED_CELL}::after {
			background: ${0, $eoFXy.tableCellSelectedColor};
			z-index: ${0, $aFUXX.akEditorSmallZIndex};
		}
		th.${(0, $d5aTJ.TableCssClassName).HOVERED_CELL_IN_DANGER}::after, td.${(0, $d5aTJ.TableCssClassName).HOVERED_CELL_IN_DANGER}::after {
			background: ${0, $eoFXy.tableCellDeleteColor};
			z-index: ${(0, $aFUXX.akEditorUnitZIndex) * 100};
		}
		td.${(0, $d5aTJ.TableCssClassName).HOVERED_CELL},
			td.${(0, $d5aTJ.TableCssClassName).SELECTED_CELL},
			th.${(0, $d5aTJ.TableCssClassName).TABLE_HEADER_CELL}.${(0, $d5aTJ.TableCssClassName).SELECTED_CELL},
			th.${(0, $d5aTJ.TableCssClassName).TABLE_HEADER_CELL}.${(0, $d5aTJ.TableCssClassName).HOVERED_CELL} {
			&::after {
				height: 100%;
				width: 100%;
				border: 1px solid ${0, $eoFXy.tableBorderSelectedColor};
				content: '';
				position: absolute;
				left: -1px;
				top: -1px;
				bottom: 0;
				z-index: ${0, $aFUXX.akEditorSmallZIndex};
				display: inline-block;
				pointer-events: none;
			}
			&.${(0, $d5aTJ.TableCssClassName).HOVERED_CELL_IN_DANGER}::after {
				${$93fa7bbbefe5a956$var$tableBorderStyles()};
				z-index: ${(0, $aFUXX.akEditorUnitZIndex) * 100};
			}

			&.${(0, $d5aTJ.TableCssClassName).HOVERED_NO_HIGHLIGHT}.${(0, $d5aTJ.TableCssClassName).HOVERED_CELL_IN_DANGER}::after {
				${$93fa7bbbefe5a956$var$tableBorderStyles()};
				z-index: ${(0, $aFUXX.akEditorUnitZIndex) * 100};
			}
		}
	}

	/* override for DnD controls */
	.${(0, $d5aTJ.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER} {
		position: absolute;
		margin-top: ${0, $1zav4.tableMarginTop}px;
		left: -${(0, $eoFXy.tableToolbarSize) + 1}px;
		${(0, $dh538.fg)('platform_editor_table_column_selected_state_fix') ? '' : `z-index: ${(0, $eoFXy.rowControlsZIndex) + 4}`}
	}

	.${(0, $d5aTJ.TableCssClassName).ROW_CONTROLS_WRAPPER} {
		position: absolute;
		/* this is to fix the misalignment of the numbered column in live page view mode */
		${props.isDragAndDropEnabled && (0, $dh538.fg)('platform_editor_numbered_column_misalignment') ? `
			margin-top: ${0, $1zav4.tableMarginTop}px;
			top: 0;
			left: -${(0, $eoFXy.tableToolbarSize) + 1}px;
		` : `
			/* top of corner control is table margin top - corner control height + 1 pixel of table border. */
			top: ${(0, $1zav4.tableMarginTop) - $93fa7bbbefe5a956$var$cornerControlHeight + 1}px;
			margin-top: 0;
			left: -${0, $eoFXy.tableToolbarSize}px;
		`}
	}

	.${(0, $d5aTJ.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER}.${(0, $d5aTJ.TableCssClassName).TABLE_LEFT_SHADOW},
		.${(0, $d5aTJ.TableCssClassName).ROW_CONTROLS_WRAPPER}.${(0, $d5aTJ.TableCssClassName).TABLE_LEFT_SHADOW} {
		z-index: ${0, $aFUXX.akEditorUnitZIndex};
	}

	.${(0, $d5aTJ.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER} {
		position: absolute;
		top: ${0, $1zav4.tableMarginTop}px;
	}

	.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY} .${(0, $d5aTJ.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER} {
		position: fixed;
		/* higher zIndex than sticky header which is akEditorTableCellOnStickyHeaderZIndex - 5 */
		z-index: ${(0, $aFUXX.akEditorTableCellOnStickyHeaderZIndex) - 4};
	}

	/* nested tables */
	${(0, $dh538.fg)('platform_editor_nested_table_drag_controls') ? `
		.${(0, $d5aTJ.TableCssClassName).TABLE_CONTAINER} {
			.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY} .${(0, $d5aTJ.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER} {
				position: absolute;
				z-index: ${0, $aFUXX.akEditorUnitZIndex};
			}
		}
		` : ''}

	.${(0, $d5aTJ.TableCssClassName).TABLE_NODE_WRAPPER} {
		padding-bottom: 0px;
		/* fixes gap cursor height */
		overflow: auto;
		overflow-y: hidden;
		position: relative;
	}
`;
const $93fa7bbbefe5a956$export$e938d6f191645a3e = (props)=>(0, $3jLHL.css)`
	.ProseMirror {
		${$93fa7bbbefe5a956$export$9989b31b7900261c(props)}
	}

	.ProseMirror.${(0, $d5aTJ.TableCssClassName).IS_RESIZING} {
		.${(0, $d5aTJ.TableCssClassName).TABLE_NODE_WRAPPER} {
			overflow-x: auto;
			${0, $26eEE.scrollbarStyles};
		}
	}

	.ProseMirror.${(0, $d5aTJ.TableCssClassName).RESIZE_CURSOR} {
		cursor: col-resize;
	}

	${$93fa7bbbefe5a956$var$shadowSentinelStyles}
`;
const $93fa7bbbefe5a956$export$b0d19c9126eaec7a = (0, $3jLHL.css)`
	.ProseMirror .${(0, $d5aTJ.TableCssClassName).TABLE_NODE_WRAPPER} > table {
		margin-left: 0;
		/* 1px border width offset added here to prevent unwanted overflow and scolling - ED-16212 */
		margin-right: -1px;
		width: 100%;
	}
`;
const $93fa7bbbefe5a956$export$61a2da566f69d1df = (0, $3jLHL.css)`
	.ProseMirror .${(0, $d5aTJ.TableCssClassName).TABLE_NODE_WRAPPER} > table {
		margin-left: 0;
		margin-right: 0;
		${(0, $26eEE.scrollbarStyles)};
	}
`;

});
parcelRegister("5p8Hs", function(module, exports) {

$parcel$export(module.exports, "SORTING_ICON_CLASS_NAME", () => $ef6a076f3671a2c9$export$b61cb5d3425147f);
$parcel$export(module.exports, "IS_DISABLED_CLASS_NAME", () => $ef6a076f3671a2c9$export$fb5c0ba8f0806db1);
$parcel$export(module.exports, "SORT_INDEX_DATA_ATTRIBUTE", () => $ef6a076f3671a2c9$export$665a01df2c44393a);
const $ef6a076f3671a2c9$export$b61cb5d3425147f = 'view-mode-sorting-icon';
const $ef6a076f3671a2c9$export$fb5c0ba8f0806db1 = 'is-disabled';
const $ef6a076f3671a2c9$export$665a01df2c44393a = 'data-sort-index';

});

parcelRegister("gvjT6", function(module, exports) {

$parcel$export(module.exports, "InsertMarker", () => $a1b9a7d0f0cb60f0$export$22ce45ffbca2b768);
$parcel$export(module.exports, "HeaderButton", () => $a1b9a7d0f0cb60f0$export$c7c73467b57835d);
$parcel$export(module.exports, "HeaderButtonHover", () => $a1b9a7d0f0cb60f0$export$eb5435fbd56e8d4);
$parcel$export(module.exports, "HeaderButtonDanger", () => $a1b9a7d0f0cb60f0$export$7f243984d41e6570);
$parcel$export(module.exports, "dragInsertButtonWrapper", () => $a1b9a7d0f0cb60f0$export$cfa9a9cdd25b9d6e);
$parcel$export(module.exports, "dragCornerControlButton", () => $a1b9a7d0f0cb60f0$export$6134f9ac8c9f161f);
$parcel$export(module.exports, "insertColumnButtonWrapper", () => $a1b9a7d0f0cb60f0$export$d9daf73b486785b9);
$parcel$export(module.exports, "insertRowButtonWrapper", () => $a1b9a7d0f0cb60f0$export$595c9c01d7c39885);
$parcel$export(module.exports, "columnControlsLineMarker", () => $a1b9a7d0f0cb60f0$export$6114ba9f95ca48dc);
$parcel$export(module.exports, "DeleteButton", () => $a1b9a7d0f0cb60f0$export$d6f68d0fe29f8050);
$parcel$export(module.exports, "OverflowShadow", () => $a1b9a7d0f0cb60f0$export$f802e22253ad2b2c);
$parcel$export(module.exports, "floatingColumnControls", () => $a1b9a7d0f0cb60f0$export$125caa90718a4ea9);
$parcel$export(module.exports, "rowControlsWrapperDotStyle", () => $a1b9a7d0f0cb60f0$export$a2258906ae78ec82);
$parcel$export(module.exports, "columnControlsDecoration", () => $a1b9a7d0f0cb60f0$export$8c8180e74f25db6a);
$parcel$export(module.exports, "hoveredDeleteButton", () => $a1b9a7d0f0cb60f0$export$4d63bf225990ad34);
$parcel$export(module.exports, "hoveredCell", () => $a1b9a7d0f0cb60f0$export$1c46f5412a5a3ae0);
$parcel$export(module.exports, "hoveredWarningCell", () => $a1b9a7d0f0cb60f0$export$40edb32b62e4fb85);
$parcel$export(module.exports, "resizeHandle", () => $a1b9a7d0f0cb60f0$export$8e36b812ea421d73);
$parcel$export(module.exports, "insertLine", () => $a1b9a7d0f0cb60f0$export$b9932a52fb1c7aad);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- needs mahual remediation */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $1zav4 = parcelRequire("1zav4");

var $aFUXX = parcelRequire("aFUXX");

var $6fnsQ = parcelRequire("6fnsQ");

var $d5aTJ = parcelRequire("d5aTJ");

var $eoFXy = parcelRequire("eoFXy");
const $a1b9a7d0f0cb60f0$var$InsertLine = (cssString)=>(0, $3jLHL.css)`
	.${(0, $d5aTJ.TableCssClassName).CONTROLS_INSERT_LINE} {
		background: ${0, $eoFXy.tableBorderSelectedColor};
		display: none;
		position: absolute;
		z-index: ${0, $aFUXX.akEditorUnitZIndex};
		${cssString}
	}
`;
const $a1b9a7d0f0cb60f0$var$Marker = ()=>(0, $3jLHL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $eoFXy.tableBorderColor),
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $eoFXy.lineMarkerSize)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $eoFXy.lineMarkerSize)}px`,
        borderRadius: '50%',
        pointerEvents: 'none'
    });
const $a1b9a7d0f0cb60f0$export$22ce45ffbca2b768 = (cssString)=>(0, $3jLHL.css)`
	.${(0, $d5aTJ.TableCssClassName).CONTROLS_INSERT_MARKER} {
		${$a1b9a7d0f0cb60f0$var$Marker()};
		${cssString}
	}
`;
const $a1b9a7d0f0cb60f0$var$Button = (cssString)=>(0, $3jLHL.css)`
	border-radius: ${"var(--ds-border-radius, 3px)"};
	border-width: 0px;
	display: inline-flex;
	max-width: 100%;
	text-align: center;
	margin: 0px;
	padding: 0px;
	text-decoration: none;
	transition:
		background 0.1s ease-out 0s,
		box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;
	outline: none !important;
	cursor: none;

	> .${(0, $d5aTJ.TableCssClassName).CONTROLS_BUTTON_ICON} {
		display: inline-flex;
		max-height: 100%;
		max-width: 100%;
	}
	${cssString}
`;
const $a1b9a7d0f0cb60f0$export$c7c73467b57835d = (cssString)=>(0, $3jLHL.css)`
	.${(0, $d5aTJ.TableCssClassName).CONTROLS_BUTTON} {
		background: ${0, $eoFXy.tableHeaderCellBackgroundColor};
		border: 1px solid ${0, $eoFXy.tableBorderColor};
		display: block;
		box-sizing: border-box;
		padding: 0;

		:focus {
			outline: none;
		}
		${cssString}
	}

	.${(0, $d5aTJ.TableCssClassName).ROW_CONTROLS_BUTTON}::after {
		content: ' ';
		background-color: transparent;
		left: -15px;
		top: 0;
		position: absolute;
		width: 15px;
		height: 100%;
		z-index: 1;
	}

	.active .${(0, $d5aTJ.TableCssClassName).CONTROLS_BUTTON} {
		color: ${`var(--ds-icon-inverse, ${0, $6fnsQ.N0})`};
		background-color: ${0, $eoFXy.tableToolbarSelectedColor};
		border-color: ${0, $eoFXy.tableBorderSelectedColor};
	}
`;
const $a1b9a7d0f0cb60f0$export$eb5435fbd56e8d4 = ()=>(0, $3jLHL.css)`
	.${(0, $d5aTJ.TableCssClassName).CONTROLS_BUTTON}:hover {
		color: ${`var(--ds-icon-inverse, ${0, $6fnsQ.N0})`};
		background-color: ${0, $eoFXy.tableToolbarSelectedColor};
		border-color: ${0, $eoFXy.tableBorderSelectedColor};
		cursor: pointer;
	}
`;
const $a1b9a7d0f0cb60f0$export$7f243984d41e6570 = ()=>(0, $3jLHL.css)`
	.${(0, $d5aTJ.TableCssClassName).HOVERED_CELL_IN_DANGER} .${(0, $d5aTJ.TableCssClassName).CONTROLS_BUTTON} {
		background-color: ${0, $eoFXy.tableToolbarDeleteColor};
		border-color: ${0, $eoFXy.tableBorderDeleteColor};
		position: relative;
		z-index: ${0, $aFUXX.akEditorUnitZIndex};
	}
`;
const $a1b9a7d0f0cb60f0$var$InsertButton = ()=>(0, $3jLHL.css)`
	.${(0, $d5aTJ.TableCssClassName).CONTROLS_INSERT_BUTTON_INNER} {
		position: absolute;
		z-index: ${(0, $aFUXX.akEditorUnitZIndex) + 10};
		bottom: 0;
	}
	.${(0, $d5aTJ.TableCssClassName).CONTROLS_INSERT_BUTTON_INNER}, .${(0, $d5aTJ.TableCssClassName).CONTROLS_INSERT_BUTTON} {
		height: ${0, $eoFXy.tableInsertColumnButtonSize}px;
		width: ${0, $eoFXy.tableInsertColumnButtonSize}px;
	}
	.${(0, $d5aTJ.TableCssClassName).CONTROLS_INSERT_BUTTON} {
		${$a1b9a7d0f0cb60f0$var$Button(`
      background: ${"var(--ds-surface-overlay, white)"};
      box-shadow: ${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $6fnsQ.N60A)}, 0 0 1px ${(0, $6fnsQ.N60A)}`})`};
      color: ${`var(--ds-icon, ${(0, $6fnsQ.N300)})`};
    `)}
	}
	.${(0, $d5aTJ.TableCssClassName).CONTROLS_INSERT_LINE} {
		display: none;
	}
	&:hover .${(0, $d5aTJ.TableCssClassName).CONTROLS_INSERT_LINE} {
		display: flex;
	}
`;
const $a1b9a7d0f0cb60f0$var$InsertButtonHover = ()=>(0, $3jLHL.css)`
	.${(0, $d5aTJ.TableCssClassName).CONTROLS_INSERT_BUTTON}:hover {
		background: ${`var(--ds-background-brand-bold, ${0, $6fnsQ.B300})`};
		color: ${"var(--ds-icon-inverse, white)"};
		cursor: pointer;
	}
`;
const $a1b9a7d0f0cb60f0$export$cfa9a9cdd25b9d6e = ()=>(0, $3jLHL.css)`
	.${(0, $d5aTJ.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER} {
		position: absolute;
		z-index: ${(0, $aFUXX.akEditorUnitZIndex) + 10};
	}

	.${(0, $d5aTJ.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN} {
		bottom: -3px;
		left: 2px;
	}

	.${(0, $d5aTJ.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW} {
		left: -3px;
		bottom: -2px;
	}
	.${(0, $d5aTJ.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS} {
		left: 6px;
		bottom: -2px;
	}

	.${(0, $d5aTJ.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON} {
		${$a1b9a7d0f0cb60f0$var$Button(`
    background: ${"var(--ds-surface-overlay, white)"};
    color: ${`var(--ds-icon, ${(0, $6fnsQ.N300)})`};
    border: 1px solid ${"var(--ds-background-accent-gray-subtler, #C1C7D0)"};
    border-radius: 50%;
    height: ${(0, $eoFXy.dragTableInsertColumnButtonSize)}px;
    width: ${(0, $eoFXy.dragTableInsertColumnButtonSize)}px;
  `)}
	}

	.${(0, $d5aTJ.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON}:hover {
		background: ${`var(--ds-background-brand-bold, ${0, $6fnsQ.B300})`};
		border: 1px solid ${`var(--ds-background-brand-bold, ${0, $6fnsQ.B300})`};
		color: ${"var(--ds-icon-inverse, white)"};
		cursor: pointer;
	}
`;
const $a1b9a7d0f0cb60f0$export$6134f9ac8c9f161f = ()=>(0, $3jLHL.css)`
	.${(0, $d5aTJ.TableCssClassName).DRAG_CORNER_BUTTON} {
		width: 15px;
		height: 15px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		top: -17px;
		left: -5px;
		background-color: transparent;
		border: none;
		padding: 0;
		outline: none;
		z-index: ${(0, $aFUXX.akEditorUnitZIndex) * 99};

		&.active .${(0, $d5aTJ.TableCssClassName).DRAG_CORNER_BUTTON_INNER} {
			background-color: ${"var(--ds-border-selected, #0C66E4)"};
			width: 10px;
			height: 10px;
			border-width: 2px;
			border-radius: 4px;

			top: 3px;
			left: 2px;
		}

		&:hover {
			cursor: pointer;

			.${(0, $d5aTJ.TableCssClassName).DRAG_CORNER_BUTTON_INNER} {
				width: 10px;
				height: 10px;
				border-radius: 4px;
				top: 3px;
				left: 2px;
			}
		}
	}

	.${(0, $d5aTJ.TableCssClassName).DRAG_CORNER_BUTTON_INNER} {
		border: 1px solid ${"var(--ds-border-inverse, #FFF)"};
		background-color: ${"var(--ds-background-accent-gray-subtler, #DCDFE4)"};
		border-radius: 2px;
		width: 5px;
		height: 5px;
		position: relative;
	}
`;
const $a1b9a7d0f0cb60f0$export$d9daf73b486785b9 = ()=>(0, $3jLHL.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1b9a7d0f0cb60f0$var$InsertButton(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1b9a7d0f0cb60f0$var$InsertButtonHover(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1b9a7d0f0cb60f0$var$InsertLine(`
    width: 2px;
    left: 9px;
  `));
const $a1b9a7d0f0cb60f0$export$595c9c01d7c39885 = ()=>(0, $3jLHL.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1b9a7d0f0cb60f0$var$InsertButton(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1b9a7d0f0cb60f0$var$InsertButtonHover(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1b9a7d0f0cb60f0$var$InsertLine(`
    height: 2px;
    top: -11px;
	${''}
    left: ${(0, $eoFXy.tableInsertColumnButtonSize) - 1}px;
  `));
const $a1b9a7d0f0cb60f0$export$6114ba9f95ca48dc = ()=>(0, $3jLHL.css)`
	.${(0, $d5aTJ.TableCssClassName).TABLE_CONTAINER}.${(0, $d5aTJ.TableCssClassName).WITH_CONTROLS} table tr:first-of-type td,
	.${(0, $d5aTJ.TableCssClassName).TABLE_CONTAINER}.${(0, $d5aTJ.TableCssClassName).WITH_CONTROLS} table tr:first-of-type th {
		position: relative;
	}
`;
const $a1b9a7d0f0cb60f0$export$d6f68d0fe29f8050 = ()=>(0, $3jLHL.css)`
	.${(0, $d5aTJ.TableCssClassName).CONTROLS_DELETE_BUTTON_WRAP}, .${(0, $d5aTJ.TableCssClassName).CONTROLS_DELETE_BUTTON} {
		height: ${0, $eoFXy.tableDeleteButtonSize}px;
		width: ${0, $eoFXy.tableDeleteButtonSize}px;
	}
	.${(0, $d5aTJ.TableCssClassName).CONTROLS_DELETE_BUTTON_WRAP} {
		.${(0, $d5aTJ.TableCssClassName).CONTROLS_DELETE_BUTTON} {
			${$a1b9a7d0f0cb60f0$var$Button(`
        background: ${(0, $eoFXy.tableCellSelectedDeleteIconBackground)};
        color: ${(0, $eoFXy.tableCellSelectedDeleteIconColor)};
      `)}
		}
	}

	.${(0, $d5aTJ.TableCssClassName).CONTROLS_DELETE_BUTTON}:hover {
		background: ${0, $eoFXy.tableCellHoverDeleteIconBackground};
		color: ${0, $eoFXy.tableCellHoverDeleteIconColor};
		cursor: pointer;
	}
`;
const $a1b9a7d0f0cb60f0$export$f802e22253ad2b2c = (isDragAndDropEnabled)=>(0, $3jLHL.css)`
	.${(0, $d5aTJ.TableCssClassName).TABLE_RIGHT_SHADOW}, .${(0, $d5aTJ.TableCssClassName).TABLE_LEFT_SHADOW} {
		display: block;
		height: calc(100% - ${0, $1zav4.tableMarginTop}px);
		position: absolute;
		pointer-events: none;
		top: ${0, $1zav4.tableMarginTop}px;
		z-index: ${0, $aFUXX.akEditorShadowZIndex};
		width: ${0, $eoFXy.tableOverflowShadowWidthWide}px;
	}
	.${(0, $d5aTJ.TableCssClassName).TABLE_LEFT_SHADOW} {
		background: linear-gradient(
				to left,
				transparent 0,
				${`var(--ds-shadow-overflow-spread, ${0, $6fnsQ.N40A})`} 140%
			),
			linear-gradient(
				to right,
				${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px,
				transparent 1px
			);
		left: 0px;
	}
	.${(0, $d5aTJ.TableCssClassName).TABLE_CONTAINER}[data-number-column='true'] > :not(.${(0, $d5aTJ.TableCssClassName).TABLE_STICKY_SHADOW}).${(0, $d5aTJ.TableCssClassName).TABLE_LEFT_SHADOW} {
		left: ${(0, $aFUXX.akEditorTableNumberColumnWidth) - 1}px;
	}
	.${(0, $d5aTJ.TableCssClassName).TABLE_RIGHT_SHADOW} {
		background: linear-gradient(
				to right,
				transparent 0,
				${`var(--ds-shadow-overflow-spread, ${0, $6fnsQ.N40A})`} 140%
			),
			linear-gradient(
				to left,
				${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px,
				transparent 1px
			);
		left: calc(100% - ${0, $eoFXy.tableOverflowShadowWidthWide}px);
	}
	.${(0, $d5aTJ.TableCssClassName).WITH_CONTROLS} {
		${$a1b9a7d0f0cb60f0$var$overflowShadowWidhoutDnD(isDragAndDropEnabled)}
		.${(0, $d5aTJ.TableCssClassName).TABLE_LEFT_SHADOW} {
			border-left: 1px solid ${0, $eoFXy.tableBorderColor};
		}
	}
`;
const $a1b9a7d0f0cb60f0$var$overflowShadowWidhoutDnD = (isDragAndDropEnabled)=>{
    if (!isDragAndDropEnabled) return (0, $3jLHL.css)`
			.${(0, $d5aTJ.TableCssClassName).TABLE_RIGHT_SHADOW}, .${(0, $d5aTJ.TableCssClassName).TABLE_LEFT_SHADOW} {
				height: calc(100% - ${0, $1zav4.tableMarginTopWithControl}px);
				top: ${0, $1zav4.tableMarginTopWithControl}px;
			}
		`;
};
const $a1b9a7d0f0cb60f0$var$columnHeaderButton = (cssString)=>{
    return (0, $3jLHL.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: (0, $eoFXy.tableHeaderCellBackgroundColor),
        display: 'block',
        boxSizing: 'border-box',
        padding: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':focus': {
            outline: 'none'
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    cssString);
};
const $a1b9a7d0f0cb60f0$var$columnHeaderButtonSelected = ()=>(0, $3jLHL.css)({
        color: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $eoFXy.tableToolbarSelectedColor),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderColor: (0, $eoFXy.tableBorderSelectedColor),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $eoFXy.columnControlsSelectedZIndex)
    });
const $a1b9a7d0f0cb60f0$var$getFloatingDotOverrides = ()=>{
    return (0, $3jLHL.css)`
		tr
			th:last-child
			.${(0, $d5aTJ.TableCssClassName).COLUMN_CONTROLS_DECORATIONS}::before,
			tr
			td:last-child
			.${(0, $d5aTJ.TableCssClassName).COLUMN_CONTROLS_DECORATIONS}::before {
			content: '';
			background-color: ${0, $eoFXy.tableBorderColor};
			position: absolute;
			height: ${0, $eoFXy.lineMarkerSize}px;
			width: ${0, $eoFXy.lineMarkerSize}px;
			border-radius: 50%;
			pointer-events: none;
			top: ${"var(--ds-space-025, 2px)"};
			right: 0px;
		}
	`;
};
const $a1b9a7d0f0cb60f0$export$125caa90718a4ea9 = ()=>{
    return (0, $3jLHL.css)`
		.${(0, $d5aTJ.TableCssClassName).DRAG_COLUMN_DROP_TARGET_CONTROLS} {
			box-sizing: border-box;
			position: absolute;
			top: 0;

			.${(0, $d5aTJ.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER} {
				display: flex;
				flex-direction: row;
			}
		}

		.${(0, $d5aTJ.TableCssClassName).DRAG_COLUMN_CONTROLS} {
			box-sizing: border-box;

			.${(0, $d5aTJ.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER} {
				display: grid;
				justify-items: center;
			}
		}
	`;
};
const $a1b9a7d0f0cb60f0$export$a2258906ae78ec82 = ()=>{
    return (0, $3jLHL.css)`
		/* override for DnD controls */
		div.${(0, $d5aTJ.TableCssClassName).WITH_CONTROLS}>.${(0, $d5aTJ.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER}::after {
			display: none;
		}

		div.${(0, $d5aTJ.TableCssClassName).WITH_CONTROLS}>.${(0, $d5aTJ.TableCssClassName).ROW_CONTROLS_WRAPPER}::after {
			content: ' ';
			background-color: ${0, $eoFXy.tableBorderColor};
			position: absolute;
			height: ${0, $eoFXy.lineMarkerSize}px;
			width: ${0, $eoFXy.lineMarkerSize}px;
			border-radius: 50%;
			pointer-events: none;
			top: -${(0, $eoFXy.tableToolbarSize) + (0, $1zav4.tableCellBorderWidth)}px;
			right: -1px;
		}
	`;
};
const $a1b9a7d0f0cb60f0$export$8c8180e74f25db6a = ()=>{
    return (0, $3jLHL.css)`
		.${(0, $d5aTJ.TableCssClassName).COLUMN_CONTROLS_DECORATIONS} {
			display: none;
			cursor: pointer;
			position: absolute;
			width: 100%;
			left: 0;
			top: -${(0, $eoFXy.columnControlsDecorationHeight) + (0, $1zav4.tableCellBorderWidth)}px;
			height: ${0, $eoFXy.columnControlsDecorationHeight}px;
			/* floating dot for adding column button */
			&::before {
				content: ' ';
				background-color: ${0, $eoFXy.tableBorderColor};
				position: absolute;
				height: ${0, $eoFXy.lineMarkerSize}px;
				width: ${0, $eoFXy.lineMarkerSize}px;
				border-radius: 50%;
				pointer-events: none;
				top: 2px;
				right: ${"var(--ds-space-negative-025, -2px)"};
			}

			&::after {
				content: ' ';

				${$a1b9a7d0f0cb60f0$var$columnHeaderButton(`
        border-right: ${(0, $1zav4.tableCellBorderWidth)}px solid ${(0, $eoFXy.tableBorderColor)};
        border-top: ${(0, $1zav4.tableCellBorderWidth)}px solid ${(0, $eoFXy.tableBorderColor)};
        border-bottom: ${(0, $1zav4.tableCellBorderWidth)}px solid ${(0, $eoFXy.tableBorderColor)};
        box-sizing: content-box;
        height: ${(0, $eoFXy.tableToolbarSize) - 1}px;
        width: 100%;
        position: absolute;
        top: ${(0, $eoFXy.columnControlsDecorationHeight) - (0, $eoFXy.tableToolbarSize)}px;
        left: 0px;
        z-index: ${(0, $eoFXy.columnControlsZIndex)};
      `)}
			}
		}

		/* floating dot for adding column button - overriding style on last column to avoid scroll */
		${$a1b9a7d0f0cb60f0$var$getFloatingDotOverrides()}

		.${(0, $d5aTJ.TableCssClassName).WITH_CONTROLS} .${(0, $d5aTJ.TableCssClassName).COLUMN_CONTROLS_DECORATIONS} {
			display: block;
		}

		table
			tr:first-of-type
			td.${(0, $d5aTJ.TableCssClassName).TABLE_CELL},table
			tr:first-of-type
			th.${(0, $d5aTJ.TableCssClassName).TABLE_HEADER_CELL} {
			&.${(0, $d5aTJ.TableCssClassName).COLUMN_SELECTED}, &.${(0, $d5aTJ.TableCssClassName).HOVERED_TABLE} {
				.${(0, $d5aTJ.TableCssClassName).COLUMN_CONTROLS_DECORATIONS}::after {
					${$a1b9a7d0f0cb60f0$var$columnHeaderButtonSelected()};
				}

				&.${(0, $d5aTJ.TableCssClassName).HOVERED_CELL_IN_DANGER} .${(0, $d5aTJ.TableCssClassName).COLUMN_CONTROLS_DECORATIONS}::after {
					background-color: ${0, $eoFXy.tableToolbarDeleteColor};
					border-color: ${0, $eoFXy.tableBorderDeleteColor};
					z-index: ${(0, $aFUXX.akEditorUnitZIndex) * 100};
				}
			}
		}

		table
			tr:first-of-type
			td.${(0, $d5aTJ.TableCssClassName).TABLE_CELL},table
			tr:first-of-type
			th.${(0, $d5aTJ.TableCssClassName).TABLE_HEADER_CELL} {
			&.${(0, $d5aTJ.TableCssClassName).COLUMN_SELECTED}, &.${(0, $d5aTJ.TableCssClassName).HOVERED_COLUMN} {
				.${(0, $d5aTJ.TableCssClassName).COLUMN_CONTROLS_DECORATIONS}::after {
					${$a1b9a7d0f0cb60f0$var$columnHeaderButtonSelected()};
					border-left: ${0, $1zav4.tableCellBorderWidth}px solid ${0, $eoFXy.tableBorderSelectedColor};
					left: -${0, $1zav4.tableCellBorderWidth}px;
				}
			}
		}

		table
			tr:first-of-type
			td.${(0, $d5aTJ.TableCssClassName).TABLE_CELL},
			table
			tr:first-of-type
			th.${(0, $d5aTJ.TableCssClassName).TABLE_HEADER_CELL} {
			&.${(0, $d5aTJ.TableCssClassName).HOVERED_COLUMN} {
				.${(0, $d5aTJ.TableCssClassName).COLUMN_CONTROLS_DECORATIONS}::after {
					${$a1b9a7d0f0cb60f0$var$columnHeaderButtonSelected()};
				}

				&.${(0, $d5aTJ.TableCssClassName).HOVERED_CELL_IN_DANGER} .${(0, $d5aTJ.TableCssClassName).COLUMN_CONTROLS_DECORATIONS}::after {
					background-color: ${0, $eoFXy.tableToolbarDeleteColor};
					border-color: ${0, $eoFXy.tableBorderDeleteColor};
					border-left: ${0, $1zav4.tableCellBorderWidth}px solid ${0, $eoFXy.tableBorderDeleteColor};
					left: -${0, $1zav4.tableCellBorderWidth}px;
					z-index: ${(0, $aFUXX.akEditorUnitZIndex) * 100};
				}
			}
		}

		.${(0, $d5aTJ.TableCssClassName).TABLE_SELECTED}
			table
			tr:first-of-type
			td.${(0, $d5aTJ.TableCssClassName).TABLE_CELL},
			.${(0, $d5aTJ.TableCssClassName).TABLE_SELECTED}
			table
			tr:first-of-type
			th.${(0, $d5aTJ.TableCssClassName).TABLE_HEADER_CELL} {
			.${(0, $d5aTJ.TableCssClassName).COLUMN_CONTROLS_DECORATIONS}::after {
				${$a1b9a7d0f0cb60f0$var$columnHeaderButtonSelected()};
			}
		}
	`;
};
const $a1b9a7d0f0cb60f0$export$4d63bf225990ad34 = ()=>(0, $3jLHL.css)`
	.${(0, $d5aTJ.TableCssClassName).TABLE_CONTAINER}.${(0, $d5aTJ.TableCssClassName).HOVERED_DELETE_BUTTON} {
		.${(0, $d5aTJ.TableCssClassName).SELECTED_CELL}, .${(0, $d5aTJ.TableCssClassName).COLUMN_SELECTED}, .${(0, $d5aTJ.TableCssClassName).HOVERED_CELL} {
			border: 1px solid ${0, $eoFXy.tableBorderDeleteColor};
		}
		.${(0, $d5aTJ.TableCssClassName).SELECTED_CELL}::after {
			background: ${0, $eoFXy.tableCellDeleteColor};
		}

		.${(0, $d5aTJ.TableCssClassName).TABLE_NODE_WRAPPER} > table {
			td.${(0, $d5aTJ.TableCssClassName).HOVERED_NO_HIGHLIGHT}::after {
				background: ${0, $eoFXy.tableCellDeleteColor};
				border: 1px solid ${0, $eoFXy.tableBorderDeleteColor};
			}
			th.${(0, $d5aTJ.TableCssClassName).HOVERED_NO_HIGHLIGHT} {
				background-color: unset;
			}
			th.${(0, $d5aTJ.TableCssClassName).HOVERED_NO_HIGHLIGHT}::after {
				background: ${0, $eoFXy.tableCellDeleteColor};
				border: 1px solid ${0, $eoFXy.tableBorderDeleteColor};
			}
		}
	}
`;
const $a1b9a7d0f0cb60f0$export$1c46f5412a5a3ae0 = ()=>(0, $3jLHL.css)`
	:not(.${(0, $d5aTJ.TableCssClassName).IS_RESIZING})
		.${(0, $d5aTJ.TableCssClassName).TABLE_CONTAINER}:not(.${(0, $d5aTJ.TableCssClassName).HOVERED_DELETE_BUTTON}) {
		.${(0, $d5aTJ.TableCssClassName).HOVERED_CELL} {
			position: relative;
			border: 1px solid ${0, $eoFXy.tableBorderSelectedColor};
		}
		.${(0, $d5aTJ.TableCssClassName).HOVERED_CELL}.${(0, $d5aTJ.TableCssClassName).HOVERED_NO_HIGHLIGHT} {
			position: relative;
			border: 1px solid ${0, $eoFXy.tableBorderColor};
		}
	}
`;
const $a1b9a7d0f0cb60f0$export$40edb32b62e4fb85 = (0, $3jLHL.css)`
	:not(.${(0, $d5aTJ.TableCssClassName).IS_RESIZING})
		.${(0, $d5aTJ.TableCssClassName).TABLE_CONTAINER}:not(.${(0, $d5aTJ.TableCssClassName).HOVERED_DELETE_BUTTON}) {
		td.${(0, $d5aTJ.TableCssClassName).HOVERED_CELL_WARNING} {
			background-color: ${`var(--ds-background-warning, ${(0, $6fnsQ.Y50)})`} !important; /* We need to override the background-color added to the cell */
			border: 1px solid ${`var(--ds-border-warning, ${(0, $6fnsQ.Y200)})`};
		}
	}
`;
// Explicit pixel values required here to ensure correct positioning and sizes of column resize handle
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
const $a1b9a7d0f0cb60f0$var$resizeLineStyles = ()=>{
    return (0, $3jLHL.css)`
		th.${(0, $d5aTJ.TableCssClassName).WITH_DRAG_RESIZE_LINE}::before, td.${(0, $d5aTJ.TableCssClassName).WITH_DRAG_RESIZE_LINE}::before {
			content: ' ';
			position: absolute;
			left: ${"var(--ds-space-negative-025, -2px)"};
			top: -1px;
			width: ${0, $eoFXy.resizeLineWidth}px;
			height: calc(100% + 2px);
			background-color: ${0, $eoFXy.tableBorderSelectedColor};
			z-index: ${(0, $eoFXy.columnControlsZIndex) * 2};
		}

		th.${(0, $d5aTJ.TableCssClassName).WITH_DRAG_RESIZE_LINE_LAST_COLUMN}::before,
			td.${(0, $d5aTJ.TableCssClassName).WITH_DRAG_RESIZE_LINE_LAST_COLUMN}::before {
			content: ' ';
			position: absolute;
			right: -1px;
			top: -1px;
			width: ${0, $eoFXy.resizeLineWidth}px;
			height: calc(100% + 2px);
			background-color: ${0, $eoFXy.tableBorderSelectedColor};
			z-index: ${(0, $eoFXy.columnControlsZIndex) * 2};
		}

		/* Styles when drag and drop is disabled - will be removed */
		td.${(0, $d5aTJ.TableCssClassName).WITH_RESIZE_LINE}::before {
			content: ' ';
			position: absolute;
			left: ${"var(--ds-space-negative-025, -2px)"};
			top: -1px;
			width: ${0, $eoFXy.resizeLineWidth}px;
			height: calc(100% + 2px);
			background-color: ${0, $eoFXy.tableBorderSelectedColor};
			z-index: ${(0, $eoFXy.columnControlsZIndex) * 2};
		}

		th.${(0, $d5aTJ.TableCssClassName).WITH_RESIZE_LINE}::before {
			content: ' ';
			left: ${"var(--ds-space-negative-025, -2px)"};
			position: absolute;
			width: ${0, $eoFXy.resizeLineWidth}px;
			height: calc(100% + ${(0, $eoFXy.tableToolbarSize) + (0, $1zav4.tableCellBorderWidth)}px);
			background-color: ${0, $eoFXy.tableBorderSelectedColor};
			z-index: ${(0, $eoFXy.columnControlsZIndex) * 2};
			top: -${(0, $eoFXy.tableToolbarSize) + (0, $1zav4.tableCellBorderWidth)}px;
		}

		td.${(0, $d5aTJ.TableCssClassName).WITH_RESIZE_LINE_LAST_COLUMN}::before {
			content: ' ';
			position: absolute;
			right: -1px;
			top: -1px;
			width: ${0, $eoFXy.resizeLineWidth}px;
			height: calc(100% + 2px);
			background-color: ${0, $eoFXy.tableBorderSelectedColor};
			z-index: ${(0, $eoFXy.columnControlsZIndex) * 2};
		}

		th.${(0, $d5aTJ.TableCssClassName).WITH_RESIZE_LINE_LAST_COLUMN}::before {
			content: ' ';
			right: -1px;
			position: absolute;
			width: ${0, $eoFXy.resizeLineWidth}px;
			height: calc(100% + ${(0, $eoFXy.tableToolbarSize) + (0, $1zav4.tableCellBorderWidth)}px);
			background-color: ${0, $eoFXy.tableBorderSelectedColor};
			z-index: ${(0, $eoFXy.columnControlsZIndex) * 2};
			top: -${(0, $eoFXy.tableToolbarSize) + (0, $1zav4.tableCellBorderWidth)}px;
		}
	`;
};
const $a1b9a7d0f0cb60f0$export$8e36b812ea421d73 = ()=>(0, $3jLHL.css)`
	.${(0, $d5aTJ.TableCssClassName).TABLE_CONTAINER} {
		.${(0, $d5aTJ.TableCssClassName).RESIZE_HANDLE_DECORATION} {
			background-color: transparent;
			position: absolute;
			width: ${0, $eoFXy.resizeHandlerAreaWidth}px;
			height: 100%;
			top: 0;
			right: -${(0, $eoFXy.resizeHandlerAreaWidth) / 2}px;
			cursor: col-resize;
			z-index: ${0, $eoFXy.resizeHandlerZIndex};
		}

		tr
			th:last-child
			.${(0, $d5aTJ.TableCssClassName).RESIZE_HANDLE_DECORATION},
			tr
			td:last-child
			.${(0, $d5aTJ.TableCssClassName).RESIZE_HANDLE_DECORATION} {
			background-color: transparent;
			position: absolute;
			width: ${(0, $eoFXy.resizeHandlerAreaWidth) / 2}px;
			height: 100%;
			top: 0;
			right: 0;
			cursor: col-resize;
			z-index: ${0, $eoFXy.resizeHandlerZIndex};
		}

		${$a1b9a7d0f0cb60f0$var$resizeLineStyles()}

		table
      tr:first-of-type
      th.${(0, $d5aTJ.TableCssClassName).WITH_DRAG_RESIZE_LINE}
      .${(0, $d5aTJ.TableCssClassName).RESIZE_HANDLE_DECORATION}::after,
      table
      tr:first-of-type
      td.${(0, $d5aTJ.TableCssClassName).WITH_DRAG_RESIZE_LINE}
      .${(0, $d5aTJ.TableCssClassName).RESIZE_HANDLE_DECORATION}::after,
	  /* Styles when drag and drop is disabled - will be removed */
		table
      tr:first-of-type
      th.${(0, $d5aTJ.TableCssClassName).WITH_RESIZE_LINE}
      .${(0, $d5aTJ.TableCssClassName).RESIZE_HANDLE_DECORATION}::after,
      table
      tr:first-of-type
      td.${(0, $d5aTJ.TableCssClassName).WITH_RESIZE_LINE}
      .${(0, $d5aTJ.TableCssClassName).RESIZE_HANDLE_DECORATION}::after {
			top: -${(0, $eoFXy.tableToolbarSize) + (0, $1zav4.tableCellBorderWidth)}px;
			height: calc(100% + ${(0, $eoFXy.tableToolbarSize) + (0, $1zav4.tableCellBorderWidth)}px);
		}
	}
`;
// Drag and Drop: drop target insert line
const $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles = (0, $3jLHL.css)({
    content: "' '",
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `calc(100% + ${(0, $1zav4.tableCellBorderWidth) * 2}px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $eoFXy.insertLineWidth)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $eoFXy.columnControlsZIndex) * 2
});
const $a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles = (0, $3jLHL.css)({
    content: "' '",
    position: 'absolute',
    left: "var(--ds-space-negative-025, -2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $eoFXy.insertLineWidth)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `calc(100% + ${(0, $1zav4.tableCellBorderWidth) * 2}px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $eoFXy.columnControlsZIndex) * 2
});
const $a1b9a7d0f0cb60f0$var$insertLineActiveColor = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: (0, $eoFXy.tableBorderSelectedColor)
});
const $a1b9a7d0f0cb60f0$var$insertLineInactiveColor = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-background-accent-gray-subtler, ${(0, $aFUXX.akEditorTableBorder)})`
});
const $a1b9a7d0f0cb60f0$export$b9932a52fb1c7aad = ()=>(0, $3jLHL.css)`
	.${(0, $d5aTJ.TableCssClassName).TABLE_CONTAINER} {
		td.${(0, $d5aTJ.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE}::before {
			${$a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles}
			left: -1px;
			top: -1px;
			${$a1b9a7d0f0cb60f0$var$insertLineActiveColor}
		}

		td.${(0, $d5aTJ.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE}::before {
			${$a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles}
			left: -1px;
			top: -1px;
			${$a1b9a7d0f0cb60f0$var$insertLineInactiveColor}
		}

		th.${(0, $d5aTJ.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE}::before {
			${$a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles}
			left: -1px;
			top: -${0, $1zav4.tableCellBorderWidth}px;
			${$a1b9a7d0f0cb60f0$var$insertLineActiveColor}
		}

		th.${(0, $d5aTJ.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE}::before {
			${$a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles}
			left: -1px;
			top: -${0, $1zav4.tableCellBorderWidth}px;
			${$a1b9a7d0f0cb60f0$var$insertLineInactiveColor}
		}

		td.${(0, $d5aTJ.TableCssClassName).WITH_COLUMN_INSERT_LINE}::before {
			${$a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles}
			left: ${"var(--ds-space-negative-025, -2px)"};
			top: -1px;
			${$a1b9a7d0f0cb60f0$var$insertLineActiveColor}
		}

		td.${(0, $d5aTJ.TableCssClassName).WITH_COLUMN_INSERT_LINE_INACTIVE}::before {
			${$a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles}
			left: ${"var(--ds-space-negative-025, -2px)"};
			top: -1px;
			${$a1b9a7d0f0cb60f0$var$insertLineInactiveColor}
		}

		th.${(0, $d5aTJ.TableCssClassName).WITH_COLUMN_INSERT_LINE}::before {
			${$a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles}
			left: ${"var(--ds-space-negative-025, -2px)"};
			top: -${0, $1zav4.tableCellBorderWidth}px;
			${$a1b9a7d0f0cb60f0$var$insertLineActiveColor}
		}

		th.${(0, $d5aTJ.TableCssClassName).WITH_COLUMN_INSERT_LINE_INACTIVE}::before {
			${$a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles}
			left: ${"var(--ds-space-negative-025, -2px)"};
			top: -${0, $1zav4.tableCellBorderWidth}px;
			${$a1b9a7d0f0cb60f0$var$insertLineInactiveColor}
		}

		td.${(0, $d5aTJ.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE}::before {
			${$a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles}
			right: -1px;
			top: -1px;
			${$a1b9a7d0f0cb60f0$var$insertLineActiveColor}
		}

		td.${(0, $d5aTJ.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE}::before {
			${$a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles}
			right: -1px;
			top: -1px;
			${$a1b9a7d0f0cb60f0$var$insertLineInactiveColor}
		}

		th.${(0, $d5aTJ.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE}::before {
			${$a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles}
			right: -1px;
			top: -${0, $1zav4.tableCellBorderWidth}px;
			${$a1b9a7d0f0cb60f0$var$insertLineActiveColor}
		}

		th.${(0, $d5aTJ.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE}::before {
			${$a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles}
			right: -1px;
			top: -${0, $1zav4.tableCellBorderWidth}px;
			${$a1b9a7d0f0cb60f0$var$insertLineInactiveColor}
		}

		td.${(0, $d5aTJ.TableCssClassName).WITH_ROW_INSERT_LINE}::before {
			${$a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles}
			top: -1px;
			${$a1b9a7d0f0cb60f0$var$insertLineActiveColor}
		}

		td.${(0, $d5aTJ.TableCssClassName).WITH_ROW_INSERT_LINE_INACTIVE}::before {
			${$a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles}
			top: -1px;
			${$a1b9a7d0f0cb60f0$var$insertLineInactiveColor}
		}

		th.${(0, $d5aTJ.TableCssClassName).WITH_ROW_INSERT_LINE}::before {
			${$a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles}
			top: -1px;
			${$a1b9a7d0f0cb60f0$var$insertLineActiveColor}
		}

		th.${(0, $d5aTJ.TableCssClassName).WITH_ROW_INSERT_LINE_INACTIVE}::before {
			${$a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles}
			top: -1px;
			${$a1b9a7d0f0cb60f0$var$insertLineInactiveColor}
		}

		td.${(0, $d5aTJ.TableCssClassName).WITH_LAST_ROW_INSERT_LINE}::before {
			${$a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles}
			bottom: 0;
			${$a1b9a7d0f0cb60f0$var$insertLineActiveColor}
		}

		td.${(0, $d5aTJ.TableCssClassName).WITH_LAST_ROW_INSERT_LINE_INACTIVE}::before {
			${$a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles}
			bottom: 0;
			${$a1b9a7d0f0cb60f0$var$insertLineInactiveColor}
		}

		th.${(0, $d5aTJ.TableCssClassName).WITH_LAST_ROW_INSERT_LINE}::before {
			${$a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles}
			bottom: 0;
			${$a1b9a7d0f0cb60f0$var$insertLineActiveColor}
		}

		th.${(0, $d5aTJ.TableCssClassName).WITH_LAST_ROW_INSERT_LINE_INACTIVE}::before {
			${$a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles}
			bottom: 0;
			${$a1b9a7d0f0cb60f0$var$insertLineInactiveColor}
		}
	}
`;

});



parcelRegister("9OTqy", function(module, exports) {

$parcel$export(module.exports, "aiPanelBaseStyles", () => $2d63371b8a9e6d91$export$7d2a5652980d3808);
$parcel$export(module.exports, "aiPanelDarkStyles", () => $2d63371b8a9e6d91$export$9a2d17c0df63f635);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $3jLHL = parcelRequire("3jLHL");
/**
 * aiPanelStyles
 * was imported from packages/editor/editor-core/src/ui/ContentStyles/ai-panels.ts
 */ const $2d63371b8a9e6d91$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $2d63371b8a9e6d91$var$rotationAnimation = (0, $3jLHL.keyframes)({
    '0%': {
        '--panel-gradient-angle': '0deg',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$2d63371b8a9e6d91$var$isFirefox ? {
            backgroundPosition: '100%'
        } : {}
    },
    '100%': {
        '--panel-gradient-angle': '360deg',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$2d63371b8a9e6d91$var$isFirefox ? {
            backgroundPosition: '-100%'
        } : {}
    }
});
const $2d63371b8a9e6d91$var$aiPrismColor = {
    ['prism.border.step.1']: {
        light: '#0065FF',
        dark: '#0065FF80'
    },
    ['prism.border.step.2']: {
        light: '#0469FF',
        dark: '#0469FF80'
    },
    ['prism.border.step.3']: {
        light: '#BF63F3',
        dark: '#BF63F380'
    },
    ['prism.border.step.4']: {
        light: '#FFA900',
        dark: '#FFA90080'
    }
};
const $2d63371b8a9e6d91$var$prismBorderAnimationStyles = (0, $3jLHL.css)({
    '&::before, &::after': {
        animationName: $2d63371b8a9e6d91$var$rotationAnimation,
        animationDuration: '2s',
        animationTimingFunction: 'linear',
        animationIterationCount: 'infinite',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$2d63371b8a9e6d91$var$isFirefox ? {
            animationDirection: 'normal',
            animationDuration: '1s'
        } : {},
        '@media (prefers-reduced-motion)': {
            animation: 'none'
        }
    }
});
const $2d63371b8a9e6d91$var$prismBorderBaseStyles = (0, $3jLHL.css)({
    content: "''",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: -1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `calc(100% + 2px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `calc(100% + 2px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: `-1px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    left: `-1px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `calc(${"var(--ds-border-radius-100, 3px)"} + 1px)`,
    transform: 'translate3d(0, 0, 0)',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    ...$2d63371b8a9e6d91$var$isFirefox ? {
        background: `linear-gradient(90deg,
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.1']['light']} 0%,
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.2']['light']} 12%,
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.3']['light']} 24%,
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.4']['light']} 48%,
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.3']['light']} 64%,
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.2']['light']} 80%,
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.1']['light']} 100%
							)`,
        backgroundSize: '200%'
    } : {
        background: `conic-gradient(
								from var(--panel-gradient-angle, 270deg),
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.1']['light']} 0%,
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.2']['light']} 20%,
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.3']['light']} 50%,
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.4']['light']} 56%,
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.1']['light']} 100%
							)`
    }
});
const $2d63371b8a9e6d91$var$prismBorderDarkStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    ...$2d63371b8a9e6d91$var$isFirefox ? {
        background: `linear-gradient(90deg,
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.1']['dark']} 0%,
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.2']['dark']} 12%,
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.3']['dark']} 24%,
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.4']['dark']} 48%,
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.3']['dark']} 64%,
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.2']['dark']} 80%,
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.1']['dark']} 100%
							)`,
        backgroundSize: '200%'
    } : {
        background: `conic-gradient(
								from var(--panel-gradient-angle, 270deg),
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.1']['dark']} 0%,
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.2']['dark']} 20%,
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.3']['dark']} 50%,
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.4']['dark']} 56%,
								${$2d63371b8a9e6d91$var$aiPrismColor['prism.border.step.1']['dark']} 100%
							)`
    }
});
const $2d63371b8a9e6d91$var$prismBorderHoverStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: "var(--ds-border-input, #8590A2)"
});
const $2d63371b8a9e6d91$export$7d2a5652980d3808 = (0, $3jLHL.css)`
	@property --panel-gradient-angle {
		syntax: '<angle>';
		initial-value: 270deg;
		inherits: false;
	}

	div[extensionType='com.atlassian.ai-blocks'] {
		/* This hides the label for the extension */
		.extension-label {
			display: none;
		}

		/* This styles the ai panel correctly when its just sitting on the page and there
		is no user interaction */
		.extension-container {
			position: relative;
			box-shadow: none;
			overflow: unset;
			background-color: ${"var(--ds-surface, #FFFFFF)"} !important;
			&::before,
			&::after {
				${$2d63371b8a9e6d91$var$prismBorderBaseStyles}
			}
			&.with-hover-border {
				&::before,
				&::after {
					${$2d63371b8a9e6d91$var$prismBorderHoverStyles}
				}
			}
			& .with-margin-styles {
				background-color: ${"var(--ds-surface, #FFFFFF)"} !important;
				border-radius: ${"var(--ds-border-radius-100, 3px)"};
			}
		}
	}

	/* This styles the ai panel correctly when its streaming */
	div[extensionType='com.atlassian.ai-blocks']:has(.streaming) {
		.extension-container {
			box-shadow: none;
			overflow: unset;
			${$2d63371b8a9e6d91$var$prismBorderAnimationStyles}
			&::before,
			&::after {
				${$2d63371b8a9e6d91$var$prismBorderBaseStyles}
			}
		}
	}

	/* This styles the ai panel correctly when a user is hovering over the delete button in the floating panel */
	div[extensionType='com.atlassian.ai-blocks'].danger {
		.extension-container {
			box-shadow: 0 0 0 1px ${"var(--ds-border-danger, #E2483D)"};
		}
	}

	/* This removes the margin from the action list when inside an ai panel */
	div[extensiontype='com.atlassian.ai-blocks'][extensionkey='ai-action-items-block:aiActionItemsBodiedExtension'] {
		div[data-node-type='actionList'] {
			margin: 0 !important;
		}
	}
`;
const $2d63371b8a9e6d91$export$9a2d17c0df63f635 = (0, $3jLHL.css)`
	div[extensionType='com.atlassian.ai-blocks'] {
		.extension-container {
			&::before,
			&::after {
				${$2d63371b8a9e6d91$var$prismBorderDarkStyles}
			}
		}
	}

	/* This styles the ai panel correctly when its streaming */
	div[extensionType='com.atlassian.ai-blocks']:has(.streaming) {
		.extension-container {
			&::before,
			&::after {
				${$2d63371b8a9e6d91$var$prismBorderDarkStyles}
			}
		}
	}
`;

});

parcelRegister("ejPu0", function(module, exports) {

$parcel$export(module.exports, "annotationStyles", () => $e744a1f22573fa53$export$65cde0a0b7e7c1c1);

var $3jLHL = parcelRequire("3jLHL");

var $6ESsx = parcelRequire("6ESsx");
const $e744a1f22573fa53$export$65cde0a0b7e7c1c1 = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $6ESsx.AnnotationSharedClassNames).blur}, .${(0, $6ESsx.AnnotationSharedClassNames).focus}, .${(0, $6ESsx.AnnotationSharedClassNames).draft}, .${(0, $6ESsx.AnnotationSharedClassNames).hover}`]: {
            borderBottom: '2px solid transparent',
            cursor: 'pointer',
            padding: '1px 0 2px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has(.card), &:has([data-inline-card])': {
                padding: '5px 0 3px 0'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has(.date-lozenger-container)': {
                paddingTop: "var(--ds-space-025, 2px)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $6ESsx.AnnotationSharedClassNames).focus}`]: {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $6ESsx.AnnotationSharedClassNames).draft}`]: {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)",
            cursor: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $6ESsx.AnnotationSharedClassNames).blur}`]: {
            background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $6ESsx.AnnotationSharedClassNames).hover}`]: {
            background: "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
        }
    }
});

});

parcelRegister("aGf6a", function(module, exports) {

$parcel$export(module.exports, "backgroundColorStyles", () => $680457c62c4e856c$export$e4cca17cf56e99d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");
const $680457c62c4e856c$export$e4cca17cf56e99d = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-background-color-mark': {
        backgroundColor: 'var(--custom-palette-color, inherit)',
        borderRadius: 2,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingTop: 1,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingBottom: 2,
        boxDecorationBreak: 'clone'
    },
    // Don't show text highlight styling when there is a hyperlink
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    'a .fabric-background-color-mark': {
        backgroundColor: 'unset'
    },
    // Don't show text highlight styling when there is an inline comment
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-background-color-mark .ak-editor-annotation': {
        backgroundColor: 'unset'
    }
});

});

parcelRegister("6svai", function(module, exports) {

$parcel$export(module.exports, "embedCardStyles", () => $92bd659d1ad36350$export$5a1f57c6600b90f1);

var $3jLHL = parcelRequire("3jLHL");
const $92bd659d1ad36350$export$5a1f57c6600b90f1 = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        ".embedCardView-content-wrap[layout^='wrap-']": {
            maxWidth: '100%',
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            zIndex: 2
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        ".embedCardView-content-wrap[layout='wrap-left']": {
            float: 'left'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        ".embedCardView-content-wrap[layout='wrap-right']": {
            float: 'right'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        ".embedCardView-content-wrap[layout='wrap-right'] + .embedCardView-content-wrap[layout='wrap-left']": {
            clear: 'both'
        }
    }
});

});

parcelRegister("cO7tu", function(module, exports) {

$parcel$export(module.exports, "layoutBaseStyles", () => $07d5bf3f0b10fce1$export$ce383b8d82e44bf5);
$parcel$export(module.exports, "layoutViewStyles", () => $07d5bf3f0b10fce1$export$912935b267e01be9);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $3jLHL = parcelRequire("3jLHL");

var $boKri = parcelRequire("boKri");
parcelRequire("jK0dl");
var $d5aTJ = parcelRequire("d5aTJ");
parcelRequire("eJQfi");
var $eoFXy = parcelRequire("eoFXy");

var $aFUXX = parcelRequire("aFUXX");
var $ieXGd = parcelRequire("ieXGd");
var $b38UX = parcelRequire("b38UX");

var $dh538 = parcelRequire("dh538");

var $iu6m9 = parcelRequire("iu6m9");
const $07d5bf3f0b10fce1$var$columnLayoutSharedStyle = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $aFUXX.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $07d5bf3f0b10fce1$var$columnLayoutResponsiveSharedStyle = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-layout-section]': {
        display: 'flex',
        flexDirection: 'row',
        gap: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.layout-section-container': {
        containerType: 'inline-size',
        containerName: 'layout-area'
    }
});
const $07d5bf3f0b10fce1$var$firstNodeWithNotMarginTop = ()=>(0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $3jLHL.css)`
				> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)) {
					margin-top: 0;
				}
			` : // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $3jLHL.css)`
				> :not(style):first-child,
				> style:first-child + * {
					margin-top: 0;
				}

				> .ProseMirror-gapcursor:first-child + *,
				> style:first-child + .ProseMirror-gapcursor + * {
					margin-top: 0;
				}

				> .ProseMirror-gapcursor:first-child + span + * {
					margin-top: 0;
				}
			`;
const $07d5bf3f0b10fce1$var$layoutColumnStyles = ()=>(0, $iu6m9.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $3jLHL.css)`
				> [data-layout-column] {
					margin: 0 ${(0, $boKri.LAYOUT_SECTION_MARGIN) / 2}px;
				}

				> [data-layout-column]:first-of-type {
					margin-left: 0;
				}

				> [data-layout-column]:last-of-type {
					margin-right: 0;
				}

				@media screen and (max-width: ${0, $aFUXX.gridMediumMaxWidth}px) {
					[data-layout-column] + [data-layout-column] {
						margin: 0;
					}
				}

				> [data-layout-column].${0, $aFUXX.akEditorSelectedNodeClassName}:not(.danger) {
					${(0, $ieXGd.getSelectionStyles)([
        (0, $b38UX.SelectionStyle).Blanket
    ])};
					/* layout column selection shorter after layout border has been removed */
					::before {
						width: calc(100% - 8px);
						left: 4px;
						border-radius: ${"var(--ds-border-radius, 3px)"};
					}
				}
			` : // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $3jLHL.css)`
				[data-layout-column] + [data-layout-column] {
					margin-left: ${0, $boKri.LAYOUT_SECTION_MARGIN}px;
				}

				@media screen and (max-width: ${0, $aFUXX.gridMediumMaxWidth}px) {
					[data-layout-column] + [data-layout-column] {
						margin-left: 0;
					}
				}
			`;
const $07d5bf3f0b10fce1$var$layoutSectionStyles = ()=>(0, $iu6m9.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $3jLHL.css)`
				${$07d5bf3f0b10fce1$var$columnLayoutResponsiveSharedStyle};
				.layout-section-container [data-layout-section] {
					> .ProseMirror-widget {
						flex: none;
						display: contents !important;

						&[data-blocks-drag-handle-container] div {
							display: contents !important;
						}

						&[data-blocks-drop-target-container] {
							display: block !important;
							margin: ${"var(--ds-space-negative-050, -4px)"};

							[data-drop-target-for-element] {
								position: absolute;
							}
						}

						& + [data-layout-column] {
							margin: 0;
						}
					}

					> [data-layout-column] {
						margin: 0;
					}
				}
			` : // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $3jLHL.css)`
				${$07d5bf3f0b10fce1$var$columnLayoutSharedStyle}
			`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $07d5bf3f0b10fce1$var$layoutBorderBaseStyles = (0, $3jLHL.css)`
	/* TODO: Remove the border styles below once design tokens have been enabled and fallbacks are no longer triggered.
	This is because the default state already uses the same token and, as such, the hover style won't change anything.
	https://product-fabric.atlassian.net/browse/DSP-4441 */
	/* Shows the border when cursor is inside a layout */
	&.selected [data-layout-column],
	&:hover [data-layout-column] {
		border: ${(0, $aFUXX.akEditorSelectedBorderSize)}px solid ${"var(--ds-border, #091E4224)"};
	}

	&.selected.danger [data-layout-column] {
		background-color: ${`var(--ds-background-danger, ${(0, $aFUXX.akEditorDeleteBackground)})`};
		border-color: ${`var(--ds-border-danger, ${(0, $aFUXX.akEditorDeleteBorder)})`};
	}

	&.${(0, $aFUXX.akEditorSelectedNodeClassName)}:not(.danger) {
		[data-layout-column] {
			${(0, $ieXGd.getSelectionStyles)([
    (0, $b38UX.SelectionStyle).Border,
    (0, $b38UX.SelectionStyle).Blanket
])}
			::after {
				background-color: transparent;
			}
		}
	}
`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $07d5bf3f0b10fce1$var$layoutBorderViewStyles = (0, $3jLHL.css)`
	&.selected [data-layout-column],
	&:hover [data-layout-column] {
		border: 0;
	}
`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $07d5bf3f0b10fce1$var$columnSeparatorBaseStyles = (0, $3jLHL.css)`
	[data-layout-content]::before {
		content: '';
		border-left: ${(0, $aFUXX.akEditorSelectedBorderSize)}px solid ${"var(--ds-border, #091E4224)"};
		position: absolute;
		height: calc(100% - 24px);
		margin-left: -25px;
	}
`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $07d5bf3f0b10fce1$var$columnSeparatorViewStyles = (0, $3jLHL.css)`
	[data-layout-content]::before {
		border-left: 0;
	}
`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $07d5bf3f0b10fce1$var$rowSeparatorBaseStyles = (0, $3jLHL.css)`
	[data-layout-content]::before {
		content: '';
		border-top: ${(0, $aFUXX.akEditorSelectedBorderSize)}px solid ${"var(--ds-border, #091E4224)"};
		position: absolute;
		width: calc(100% - 32px);
		margin-top: -13px;

		/* clear styles for column separator */
		border-left: unset;
		margin-left: unset;
		height: unset;
	}
`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $07d5bf3f0b10fce1$var$rowSeparatorViewStyles = (0, $3jLHL.css)`
	[data-layout-content]::before {
		border-top: 0;
	}
`;
// jest warning: JSDOM version (22) doesn't support the new @container CSS rule
const $07d5bf3f0b10fce1$var$layoutWithSeparatorBorderResponsiveBaseStyles = (breakpoint)=>(0, $3jLHL.css)`
	&.selected,
	&:hover,
	&.selected.danger,
	&.${0, $aFUXX.akEditorSelectedNodeClassName}:not(.danger) {
		[data-layout-column]:not(:first-of-type) {
			@container editor-area (max-width:${breakpoint}px) {
				${$07d5bf3f0b10fce1$var$rowSeparatorBaseStyles}
			}
		}
	}
`;
// jest warning: JSDOM version (22) doesn't support the new @container CSS rule
const $07d5bf3f0b10fce1$var$layoutWithSeparatorBorderResponsiveViewStyles = (breakpoint)=>(0, $3jLHL.css)`
	&.selected,
	&:hover,
	&.selected.danger,
	&.${0, $aFUXX.akEditorSelectedNodeClassName}:not(.danger) {
		[data-layout-column]:not(:first-of-type) {
			@container editor-area (max-width:${breakpoint}px) {
				${$07d5bf3f0b10fce1$var$rowSeparatorViewStyles}
			}
		}
	}
`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $07d5bf3f0b10fce1$var$layoutWithSeparatorBorderBaseStyles = (0, $3jLHL.css)`
	&.selected [data-layout-column]:not(:first-of-type),
	[data-empty-layout='true'] [data-layout-column]:not(:first-of-type),
	&:hover [data-layout-column]:not(:first-of-type) {
		${$07d5bf3f0b10fce1$var$columnSeparatorBaseStyles}
	}

	&.selected.danger [data-layout-section] {
		background-color: ${`var(--ds-background-danger, ${(0, $aFUXX.akEditorDeleteBackground)})`};

		box-shadow: 0 0 0 ${(0, $aFUXX.akEditorSelectedBorderSize)}px ${(0, $aFUXX.akEditorDeleteBorder)};
		border-radius: 4px;
		[data-layout-column]:not(:first-of-type) {
			${$07d5bf3f0b10fce1$var$columnSeparatorBaseStyles}
		}
	}

	&.${(0, $aFUXX.akEditorSelectedNodeClassName)}:not(.danger) [data-layout-section] {
		box-shadow: 0 0 0 ${(0, $aFUXX.akEditorSelectedBorderSize)}px ${"var(--ds-border-selected, #0C66E4)"};
		border-radius: 4px;
		background-color: ${"var(--ds-background-selected, #E9F2FF)"};
		[data-layout-column] {
			${(0, $ieXGd.getSelectionStyles)([
    (0, $b38UX.SelectionStyle).Blanket
])}
			border: 0px;
			::before {
				background-color: transparent;
			}
		}
		[data-layout-column]:not(:first-of-type) {
			${$07d5bf3f0b10fce1$var$columnSeparatorBaseStyles}
		}
	}
`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $07d5bf3f0b10fce1$var$layoutWithSeparatorBorderViewStyles = (0, $3jLHL.css)`
	&.selected [data-layout-column]:not(:first-of-type),
	[data-empty-layout='true'] [data-layout-column]:not(:first-of-type),
	&:hover [data-layout-column]:not(:first-of-type) {
		${$07d5bf3f0b10fce1$var$columnSeparatorViewStyles}
	}

	&.selected.danger [data-layout-section] {
		box-shadow: 0 0 0 0 ${(0, $aFUXX.akEditorDeleteBorder)};
		[data-layout-column]:not(:first-of-type) {
			${$07d5bf3f0b10fce1$var$columnSeparatorViewStyles}
		}
	}

	&.${(0, $aFUXX.akEditorSelectedNodeClassName)}:not(.danger) [data-layout-section] {
		box-shadow: 0 0 0 0 ${"var(--ds-border-selected, #0C66E4)"};
		[data-layout-column]:not(:first-of-type) {
			${$07d5bf3f0b10fce1$var$columnSeparatorViewStyles}
		}
	}
`;
// jest warning: JSDOM version (22) doesn't support the new @container CSS rule
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $07d5bf3f0b10fce1$var$layoutResponsiveBaseStyles = (0, $3jLHL.css)`
	/* chosen breakpoints in container queries are to make sure layout responsiveness in editor aligns with renderer */
	/* not resized layout in full-width editor */
	.fabric-editor--full-width-mode .ProseMirror {
		> .layoutSectionView-content-wrap {
			[data-layout-section] {
				@container editor-area (max-width:724px) {
					flex-direction: column;
				}
			}

			${$07d5bf3f0b10fce1$var$layoutWithSeparatorBorderResponsiveBaseStyles(724)}
		}
	}

	/* not resized layout in fixed-width editor */
	.ak-editor-content-area:not(.fabric-editor--full-width-mode) .ProseMirror {
		> .layoutSectionView-content-wrap {
			[data-layout-section] {
				@container editor-area (max-width:788px) {
					flex-direction: column;
				}
			}

			${$07d5bf3f0b10fce1$var$layoutWithSeparatorBorderResponsiveBaseStyles(788)}
		}
	}

	/* resized layout in full/fixed-width editor */
	.ProseMirror .fabric-editor-breakout-mark {
		.layoutSectionView-content-wrap {
			[data-layout-section] {
				@container editor-area (max-width:820px) {
					flex-direction: column;
				}
			}

			${$07d5bf3f0b10fce1$var$layoutWithSeparatorBorderResponsiveBaseStyles(820)}
		}
	}
`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $07d5bf3f0b10fce1$var$layoutResponsiveViewStyles = (0, $3jLHL.css)`
	/* chosen breakpoints in container queries are to make sure layout responsiveness in editor aligns with renderer */
	/* not resized layout in full-width editor */
	.fabric-editor--full-width-mode .ProseMirror {
		> .layoutSectionView-content-wrap {
			${$07d5bf3f0b10fce1$var$layoutWithSeparatorBorderResponsiveViewStyles(724)}
		}
	}

	/* not resized layout in fixed-width editor */
	.ak-editor-content-area:not(.fabric-editor--full-width-mode) .ProseMirror {
		> .layoutSectionView-content-wrap {
			${$07d5bf3f0b10fce1$var$layoutWithSeparatorBorderResponsiveViewStyles(788)}
		}
	}

	/* resized layout in full/fixed-width editor */
	.ProseMirror .fabric-editor-breakout-mark {
		.layoutSectionView-content-wrap {
			${$07d5bf3f0b10fce1$var$layoutWithSeparatorBorderResponsiveViewStyles(820)}
		}
	}
`;
const $07d5bf3f0b10fce1$export$ce383b8d82e44bf5 = ()=>(0, $3jLHL.css)`
	.ProseMirror {
		${$07d5bf3f0b10fce1$var$layoutSectionStyles()}
		[data-layout-section] {
			/* Ignored via go/ees007
			TODO: Migrate away from gridSize
			Recommendation: Replace directly with 7px */
			margin: ${"var(--ds-space-100, 8px)"} -${(0, $aFUXX.akLayoutGutterOffset) + ((0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? 8 : 0)}px 0;
			transition: border-color 0.3s ${0, $aFUXX.akEditorSwoopCubicBezier};
			cursor: pointer;

			/* Inner cursor located 26px from left */
			[data-layout-column] {
				flex: 1;
				position: relative;

				min-width: 0;
				/* disable 4 borders when in view mode and advanced layouts is on */
				border: ${(0, $iu6m9.editorExperiment)('advanced_layouts', true) ? 0 : (0, $aFUXX.akEditorSelectedBorderSize)}px
					solid ${"var(--ds-border, #091E4224)"};
				border-radius: 4px;
				padding: ${0, $boKri.LAYOUT_COLUMN_PADDING}px
					${(0, $boKri.LAYOUT_COLUMN_PADDING) + ((0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') ? 8 : 0)}px;
				box-sizing: border-box;

				> div {
					${$07d5bf3f0b10fce1$var$firstNodeWithNotMarginTop()}

					> .embedCardView-content-wrap:first-of-type .rich-media-item {
						margin-top: 0;
					}

					> .mediaSingleView-content-wrap:first-of-type .rich-media-item {
						margin-top: 0;
					}

					> .ProseMirror-gapcursor.-right:first-child
						+ .mediaSingleView-content-wrap
						.rich-media-item,
					> style:first-child
						+ .ProseMirror-gapcursor.-right
						+ .mediaSingleView-content-wrap
						.rich-media-item,
					> .ProseMirror-gapcursor.-right:first-of-type
						+ .embedCardView-content-wrap
						.rich-media-item {
						margin-top: 0;
					}

					> .ProseMirror-gapcursor:first-child
						+ span
						+ .mediaSingleView-content-wrap
						.rich-media-item,
					> style:first-child
						+ .ProseMirror-gapcursor
						+ span
						+ .mediaSingleView-content-wrap
						.rich-media-item {
						margin-top: 0;
					}

					/* Prevent first DecisionWrapper's margin-top: 8px from shifting decisions down
			 and shrinking layout's node selectable area (leniency margin) */
					> [data-node-type='decisionList'] {
						li:first-of-type [data-decision-wrapper] {
							margin-top: 0;
						}
					}
				}

				/* Make the 'content' fill the entire height of the layout column to allow click
		   handler of layout section nodeview to target only data-layout-column */
				[data-layout-content] {
					height: 100%;
					cursor: text;
					.mediaGroupView-content-wrap {
						clear: both;
					}
				}
			}

			${$07d5bf3f0b10fce1$var$layoutColumnStyles()}
		}

		/* styles to support borders for layout */
		[data-layout-section],
		.layoutSectionView-content-wrap {
			${(0, $iu6m9.editorExperiment)('advanced_layouts', true) ? $07d5bf3f0b10fce1$var$layoutWithSeparatorBorderBaseStyles : $07d5bf3f0b10fce1$var$layoutBorderBaseStyles}
		}
	}

	${(0, $iu6m9.editorExperiment)('advanced_layouts', true) && $07d5bf3f0b10fce1$var$layoutResponsiveBaseStyles}

	/* hide separator when element is dragging on top of a layout column */
	[data-blocks-drop-target-container] ~ [data-layout-column] > [data-layout-content]::before {
		display: none;
	}

	.fabric-editor--full-width-mode .ProseMirror {
		[data-layout-section] {
			.${(0, $d5aTJ.TableCssClassName).TABLE_CONTAINER} {
				margin: 0 ${0, $eoFXy.tableMarginFullWidthMode}px;
			}
		}
	}

	${(0, $iu6m9.editorExperiment)('advanced_layouts', false) && (0, $dh538.fg)('platform_editor_nested_dnd_styles_changes') && `.ak-editor-content-area.appearance-full-page .ProseMirror [data-layout-section] {
				margin: ${"var(--ds-space-100, 8px)"} -${(0, $aFUXX.akLayoutGutterOffset) + 8}px 0;
				}`}
`;
const $07d5bf3f0b10fce1$export$912935b267e01be9 = (0, $3jLHL.css)`
	.ProseMirror {
		[data-layout-section] {
			cursor: default;
			[data-layout-column] {
				border: 0;
			}
		}
		[data-layout-section],
		.layoutSectionView-content-wrap {
			${(0, $iu6m9.editorExperiment)('advanced_layouts', true) ? $07d5bf3f0b10fce1$var$layoutWithSeparatorBorderViewStyles : $07d5bf3f0b10fce1$var$layoutBorderViewStyles}
		}
	}

	${(0, $iu6m9.editorExperiment)('advanced_layouts', true) && $07d5bf3f0b10fce1$var$layoutResponsiveViewStyles}
`;

});

parcelRegister("432pP", function(module, exports) {

$parcel$export(module.exports, "linkStyles", () => $9be63d8bc680ee45$export$4ea5976125a01ffa);
$parcel$export(module.exports, "linkStylesOld", () => $9be63d8bc680ee45$export$d9d1ccc645b021);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $3jLHL = parcelRequire("3jLHL");
const $9be63d8bc680ee45$export$4ea5976125a01ffa = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror a.blockLink': {
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror a[data-prosemirror-mark-name="link"]': {
        textDecoration: 'underline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror a[data-prosemirror-mark-name="link"]:hover': {
        textDecoration: 'none'
    }
});
const $9be63d8bc680ee45$export$d9d1ccc645b021 = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror a.blockLink': {
        display: 'block'
    }
});

});

parcelRegister("i3P6T", function(module, exports) {

$parcel$export(module.exports, "mediaStyles", () => $8b8a9e34027bcb70$export$abd2efc27ac7e809);

var $3jLHL = parcelRequire("3jLHL");

var $fhm10 = parcelRequire("fhm10");

var $ag6aQ = parcelRequire("ag6aQ");
var $gnMzP = parcelRequire("gnMzP");

var $aFUXX = parcelRequire("aFUXX");

var $jTudT = parcelRequire("jTudT");
var $cDSVG = parcelRequire("cDSVG");
var $8jrlU = parcelRequire("8jrlU");
const $8b8a9e34027bcb70$var$wrappedMediaBreakoutPoint = 410;
/**
 * Reference Heights
 *
 * These heights enforce consistent sizes with media inline nodes due to
 * inconsistencies with center aligned inline nodes and text.
 *
 * There is conversation about refactoring media inline nodes to conform to
 * aligning correctly with the surrounding text.
 *
 * These constants originally came from `headingSizes` from the `theme` package
 * and have been copied here to remove this package.
 */ const $8b8a9e34027bcb70$var$referenceHeights = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};
const $8b8a9e34027bcb70$var$inlineImageSelector = `> .mediaInlineView-content-wrap > .${(0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME)}, > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${(0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME)}, > .${(0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME)}, > :is(a, span[data-mark-type='border']) .${(0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME)}`;
const $8b8a9e34027bcb70$export$abd2efc27ac7e809 = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`li .${0, $gnMzP.richMediaClassName}`]: {
            margin: 0
        },
        // Hack for chrome to fix media single position inside a list when media is the first child
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
            content: "''",
            display: 'block',
            height: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ua-firefox': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.mediaSingleView-content-wrap': {
                userSelect: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.captionView-content-wrap': {
                userSelect: 'text'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout^='wrap-']": {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
            zIndex: (0, $aFUXX.akEditorWrappedNodeZIndex),
            maxWidth: '100%',
            /* overwrite default Prosemirror setting making it clear: both */ clear: 'inherit'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='center']": {
            clear: 'both'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`table .${0, $gnMzP.richMediaClassName}`]: {
            marginTop: "var(--ds-space-150, 12px)",
            marginBottom: "var(--ds-space-150, 12px)",
            clear: 'both',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
                clear: 'none',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                '&:first-child': {
                    marginTop: "var(--ds-space-150, 12px)"
                }
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`.${0, $gnMzP.richMediaClassName}.image-wrap-right + .${0, $gnMzP.richMediaClassName}.image-wrap-left`]: {
            clear: 'both'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`.${0, $gnMzP.richMediaClassName}.image-wrap-left + .${0, $gnMzP.richMediaClassName}.image-wrap-right, .${0, $gnMzP.richMediaClassName}.image-wrap-right + .${0, $gnMzP.richMediaClassName}.image-wrap-left, .${0, $gnMzP.richMediaClassName}.image-wrap-left + .${0, $gnMzP.richMediaClassName}.image-wrap-left, .${0, $gnMzP.richMediaClassName}.image-wrap-right + .${0, $gnMzP.richMediaClassName}.image-wrap-right`]: {
            marginRight: 0,
            marginLeft: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media all and (max-width: ${$8b8a9e34027bcb70$var$wrappedMediaBreakoutPoint}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
                float: 'none',
                overflow: 'auto',
                margin: `${"var(--ds-space-150, 12px)"} 0`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`& [layout='full-width'] .${0, $gnMzP.richMediaClassName}, & [layout='wide'] .${0, $gnMzP.richMediaClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '50%',
            transform: 'translateX(-50%)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".media-extended-resize-experience[layout^='wrap-']": {
            // override 'overflow: auto' when viewport <= 410 set by mediaSingleSharedStyle
            // to prevent scroll bar
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            overflow: 'visible !important'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& [layout^='wrap-'] + [layout^='wrap-']": {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "& + p, & + div[class^='fabric-editor-align'], & + ul, & + ol, & + h1, & + h2, & + h3, & + h4, & + h5, & + h6": {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles,@atlaskit/ui-styling-standard/no-unsafe-values
                clear: 'both !important'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${0, $gnMzP.richMediaClassName}`]: {
                marginLeft: 0,
                marginRight: 0
            }
        },
        // Shifting the mediaInline image component (renders image) to align nicely with
        // mediaInline (renders text) is a bit of a testing ground. This numbers represent
        // shift in top and bottom and size adjustments to make up for lack of 1to1 size
        //  mapping
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $fhm10.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height: $8b8a9e34027bcb70$var$referenceHeights['p'],
            transform: 'translateY(-2px)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h1: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h1,
                transform: `translateY(-3px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h2: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h2,
                transform: `translateY(-3px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h3: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h3,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h4: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h4,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h5: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h5,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h6: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$8b8a9e34027bcb70$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $8b8a9e34027bcb70$var$referenceHeights.h6,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='wrap-left']": {
            float: 'left'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='wrap-right']": {
            float: 'right'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='wrap-right'] + .mediaSingleView-content-wrap[layout='wrap-left']": {
            clear: 'both'
        },
        // Larger margins for resize handlers when at depth 0 of the document
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > .mediaSingleView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-right': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                marginRight: `-${(0, $aFUXX.akEditorMediaResizeHandlerPaddingWide)}px`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-left': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                marginLeft: `-${(0, $aFUXX.akEditorMediaResizeHandlerPaddingWide)}px`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $ag6aQ.ClassNames).FLOATING_TOOLBAR_COMPONENT}`]: {
        padding: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-right, .richMedia-resize-handle-left': {
        display: 'flex',
        flexDirection: 'column',
        /* vertical align */ justifyContent: 'center'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-right': {
        alignItems: 'flex-end',
        paddingRight: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        marginRight: `-${(0, $aFUXX.akEditorMediaResizeHandlerPadding)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-left': {
        alignItems: 'flex-start',
        paddingLeft: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        marginLeft: `-${(0, $aFUXX.akEditorMediaResizeHandlerPadding)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
        content: "' '",
        display: 'flex',
        width: 3,
        height: 64,
        borderRadius: 6
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${0, $gnMzP.richMediaClassName}:hover .richMedia-resize-handle-left::after, .${0, $gnMzP.richMediaClassName}:hover .richMedia-resize-handle-right::after`]: {
        background: "var(--ds-border, #091E4224)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${0, $aFUXX.akEditorSelectedNodeClassName} .richMedia-resize-handle-right::after, .${0, $aFUXX.akEditorSelectedNodeClassName} .richMedia-resize-handle-left::after, .${0, $gnMzP.richMediaClassName} .richMedia-resize-handle-right:hover::after, .${0, $gnMzP.richMediaClassName} .richMedia-resize-handle-left:hover::after, .${0, $gnMzP.richMediaClassName}.is-resizing .richMedia-resize-handle-right::after, .${0, $gnMzP.richMediaClassName}.is-resizing .richMedia-resize-handle-left::after`]: {
        background: "var(--ds-border-focused, #388BFF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.__resizable_base__': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        left: 'unset !important',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'auto !important',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        height: 'auto !important'
    },
    // Danger when top level node for smart cards / inline links
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger > div > div > .media-card-frame, .danger > span > a': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        boxShadow: `0px 0px 0px ${(0, $aFUXX.akEditorSelectedBorderBoldSize)}px, ${"var(--ds-border-danger, #E2483D)"}`,
        transition: 'background-color 0s, box-shadow 0s'
    },
    // Danger when nested node or common
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // Media single
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $jTudT.fileCardImageViewSelector}::after`]: {
            border: `1px solid ${"var(--ds-border-danger, #E2483D)"}`
        },
        // Media single video player
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $cDSVG.inlinePlayerClassName}::after`]: {
            border: `1px solid ${"var(--ds-border-danger, #E2483D)"}`
        },
        // New file experience
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $8jrlU.newFileExperienceClassName}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`
        },
        // Media resize legacy handlers
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            background: `${"var(--ds-icon-danger, #C9372C)"} !important`
        },
        // Media resize new handlers
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.resizer-handle-thumb': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            background: `${"var(--ds-icon-danger, #C9372C)"} !important`
        },
        // Smart cards
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div div .media-card-frame, .inlineCardView-content-wrap > span > a': {
            backgroundColor: `${"var(--ds-blanket-danger, #EF5C4814)"}`,
            transition: `background-color 0s`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div div .media-card-frame::after': {
            boxShadow: 'none'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.warning': {
        // Media single
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $jTudT.fileCardImageViewSelector}::after`]: {
            border: `1px solid ${"var(--ds-border-warning, #E56910)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $cDSVG.inlinePlayerClassName}::after`]: {
            border: `1px solid ${"var(--ds-border-warning, #E56910)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $gnMzP.richMediaClassName} .${0, $8jrlU.newFileExperienceClassName}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            boxShadow: `0 0 0 1px ${"var(--ds-border-warning, #E56910)"} !important`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.resizer-handle-thumb': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            background: `${"var(--ds-icon-warning, #E56910)"} !important`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.media-filmstrip-list-item': {
        cursor: 'pointer'
    },
    // When clicking drag handle, mediaGroup node will be selected. Hence we need to apply selected style to each media node
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.mediaGroupView-content-wrap.${0, $aFUXX.akEditorSelectedNodeClassName} #newFileExperienceWrapper`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        boxShadow: (0, $aFUXX.akEditorSelectedBoxShadow)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-no-interaction #newFileExperienceWrapper': {
        boxShadow: 'none'
    }
});

});

parcelRegister("jFNRW", function(module, exports) {

$parcel$export(module.exports, "ruleStyles", () => $0e823357fa8df654$export$2413e968422424ec);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $3jLHL = parcelRequire("3jLHL");

var $aFUXX = parcelRequire("aFUXX");
const $0e823357fa8df654$export$2413e968422424ec = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror hr': {
        border: 'none',
        backgroundColor: "var(--ds-border, #091E4224)",
        height: '2px',
        borderRadius: '1px',
        cursor: 'pointer',
        padding: `${"var(--ds-space-050, 4px)"} 0`,
        margin: `${"var(--ds-space-300, 24px)"} 0`,
        backgroundClip: 'content-box'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror hr.${0, $aFUXX.akEditorSelectedNodeClassName}`]: {
        outline: 'none',
        backgroundColor: "var(--ds-border-selected, #0C66E4)"
    }
});

});


parcelRegister("3ae8F", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a2d94567ed6726c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $atveb = parcelRequire("atveb");

var $d925B = parcelRequire("d925B");

var $98MB9 = parcelRequire("98MB9");

var $3Zxyk = parcelRequire("3Zxyk");
const $4a2d94567ed6726c$var$pluginsComponentsWrapper = (0, $3jLHL.css)({
    display: 'flex'
});
const $4a2d94567ed6726c$var$PluginSlot = ({ items: items, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: appearance, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, containerElement: containerElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, wrapperElement: wrapperElement, pluginHooks: pluginHooks })=>{
    if (!items && !pluginHooks || !editorView) return null;
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $98MB9.ErrorBoundary), {
        component: (0, $d925B.ACTION_SUBJECT).PLUGIN_SLOT,
        fallbackComponent: null
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3Zxyk.MountPluginHooks), {
        editorView: editorView,
        pluginHooks: pluginHooks,
        containerElement: containerElement
    }), /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $4a2d94567ed6726c$var$pluginsComponentsWrapper
    }, items?.map((component, key)=>{
        const props = {
            key: key
        };
        const element = component({
            editorView: editorView,
            editorActions: editorActions,
            eventDispatcher: eventDispatcher,
            providerFactory: providerFactory,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            appearance: appearance,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            containerElement: containerElement,
            disabled: disabled,
            wrapperElement: wrapperElement
        });
        return element && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).cloneElement(element, props);
    })));
};
const $4a2d94567ed6726c$var$PluginSlotComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo($4a2d94567ed6726c$var$PluginSlot, (0, (/*@__PURE__*/$parcel$interopDefault($atveb))));
$4a2d94567ed6726c$var$PluginSlotComponent.displayName = 'PluginSlot';
var $4a2d94567ed6726c$export$2e2bcd8739ae039 = $4a2d94567ed6726c$var$PluginSlotComponent;

});
parcelRegister("98MB9", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $ea497c7b8855fd08$export$e926676385687eaf);

var $gwFzn = parcelRequire("gwFzn");

var $d925B = parcelRequire("d925B");

var $hWRJP = parcelRequire("hWRJP");
class $ea497c7b8855fd08$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).EDITOR_CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                errorInfo: errorInfo,
                errorRethrown: !this.hasFallback()
            }
        });
        (0, $hWRJP.logException)(error, {
            location: 'editor-core/ui'
        });
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        });
    }
    render() {
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            errorCaptured: false
        };
    }
}

});

parcelRegister("3Zxyk", function(module, exports) {

$parcel$export(module.exports, "MountPluginHooks", () => $e83111829c538b72$export$a9224552b63e3fe8);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
function $e83111829c538b72$var$MountPluginHook({ usePluginHook: usePluginHook, editorView: editorView, containerElement: containerElement }) {
    usePluginHook({
        editorView: editorView,
        containerElement: containerElement
    });
    return null;
}
function $e83111829c538b72$export$a9224552b63e3fe8({ pluginHooks: pluginHooks, editorView: editorView, containerElement: containerElement }) {
    if (!editorView) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: pluginHooks?.map((usePluginHook, key)=>/*#__PURE__*/ (0, $7UHDa.jsx)($e83111829c538b72$var$MountPluginHook, {
                usePluginHook: usePluginHook,
                editorView: editorView,
                containerElement: containerElement
            }, key))
    });
}

});


parcelRegister("uq7dM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b70de66aa381d38d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");
const $b70de66aa381d38d$var$pulseBackground = (0, $3jLHL.keyframes)({
    '50%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    }
});
const $b70de66aa381d38d$var$pulseBackgroundReverse = (0, $3jLHL.keyframes)({
    '0%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    },
    '50%': {
        backgroundColor: 'auto'
    },
    '100%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    }
});
const $b70de66aa381d38d$var$flashWrapper = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.-flash > div': {
        animationName: $b70de66aa381d38d$var$pulseBackgroundReverse,
        animationDuration: '0.25s',
        animationTimingFunction: 'ease-in-out'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > div': {
        animation: "'none'"
    }
});
const $b70de66aa381d38d$var$flashWrapperAnimated = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`${$b70de66aa381d38d$var$flashWrapper} & > div`]: {
        animationName: $b70de66aa381d38d$var$pulseBackground,
        animationDuration: '0.25s',
        animationTimingFunction: 'ease-in-out'
    }
});
class $b70de66aa381d38d$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { animate: animate, children: children } = this.props;
        this.toggle = animate && !this.toggle;
        return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
        /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            css: animate ? $b70de66aa381d38d$var$flashWrapperAnimated : $b70de66aa381d38d$var$flashWrapper,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: this.toggle ? '-flash' : ''
        }, children));
    }
    constructor(...args){
        super(...args);
        this.toggle = false;
    }
}

});


parcelRegister("5Gwdo", function(module, exports) {

$parcel$export(module.exports, "KeyDownHandlerContext", () => $75d74c57448b9b48$export$5455406531e3792c);
$parcel$export(module.exports, "ToolbarArrowKeyNavigationProvider", () => $75d74c57448b9b48$export$9837e395eba6f527);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $dK4ZR = parcelRequire("dK4ZR");

var $8aWkM = parcelRequire("8aWkM");

var $b0RMS = parcelRequire("b0RMS");

var $f9zLy = parcelRequire("f9zLy");
const $75d74c57448b9b48$export$5455406531e3792c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    handleArrowLeft: ()=>{},
    handleArrowRight: ()=>{},
    handleTab: ()=>{}
});
const $75d74c57448b9b48$var$centeredToolbarContainer = (0, $3jLHL.css)({
    display: 'flex',
    width: '100%',
    alignItems: 'center'
});
const $75d74c57448b9b48$export$9837e395eba6f527 = ({ children: children, editorView: editorView, childComponentSelector: childComponentSelector, handleEscape: handleEscape, disableArrowKeyNavigation: disableArrowKeyNavigation, isShortcutToFocusToolbar: isShortcutToFocusToolbar, editorAppearance: editorAppearance, useStickyToolbar: useStickyToolbar, intl: intl })=>{
    const wrapperRef = (0, $gwFzn.useRef)(null);
    const selectedItemIndex = (0, $gwFzn.useRef)(0);
    const incrementIndex = (0, $gwFzn.useCallback)((list)=>{
        let index = 0;
        if (document.activeElement) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            index = list.indexOf(document.activeElement);
            index = (index + 1) % list.length;
        }
        selectedItemIndex.current = index;
    }, []);
    const decrementIndex = (0, $gwFzn.useCallback)((list)=>{
        let index = 0;
        if (document.activeElement) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            index = list.indexOf(document.activeElement);
            index = (list.length + index - 1) % list.length;
        }
        selectedItemIndex.current = index;
    }, []);
    const handleArrowRight = ()=>{
        const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
        incrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    };
    const handleArrowLeft = ()=>{
        const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
        decrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    };
    const handleTab = ()=>{
        const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    };
    const handleTabLocal = ()=>{
        const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
        filteredFocusableElements.forEach((element)=>{
            element.setAttribute('tabindex', '-1');
        });
        filteredFocusableElements[selectedItemIndex.current].setAttribute('tabindex', '0');
    };
    const focusAndScrollToElement = (element, scrollToElement = true)=>{
        if (scrollToElement) element?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });
        element.focus();
    };
    const submenuKeydownHandleContext = {
        handleArrowLeft: handleArrowLeft,
        handleArrowRight: handleArrowRight,
        handleTab: handleTab
    };
    (0, $gwFzn.useLayoutEffect)(()=>{
        if (!wrapperRef.current || disableArrowKeyNavigation) return;
        const { current: element } = wrapperRef;
        /**
     * To handle the key events on the list
     * @param event
     */ const handleKeyDown = (event)=>{
            // To trap the focus inside the horizontal toolbar for left and right arrow keys
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            if (targetElement instanceof HTMLElement && document.querySelector('[data-role="droplistContent"], [data-test-id="color-picker-menu"], [data-emoji-picker-container="true"]')?.contains(targetElement) || targetElement instanceof HTMLElement && document.querySelector('[data-test-id="color-picker-menu"]')?.contains(targetElement) || event.key === 'ArrowUp' || event.key === 'ArrowDown' || disableArrowKeyNavigation) return;
            const menuWrapper = document.querySelector('.menu-key-handler-wrapper');
            if (menuWrapper) // if menu wrapper exists, then a menu is open and arrow keys will be handled by MenuArrowKeyNavigationProvider
            return;
            const elementBrowser = wrapperRef?.current?.querySelector(`#${(0, $dK4ZR.ELEMENT_BROWSER_ID)}`);
            if (elementBrowser) // if element browser is open, then arrow keys will be handled by MenuArrowKeyNavigationProvider
            return;
            const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
            if (!filteredFocusableElements || filteredFocusableElements?.length === 0) return;
            // If the target element is the media picker then navigation is handled by the media picker
            if (targetElement instanceof HTMLElement && targetElement.closest(`[aria-label="${intl.formatMessage((0, $b0RMS.mediaInsertMessages).mediaPickerPopupAriaLabel)}"]`)) return;
            if (targetElement instanceof HTMLElement && !wrapperRef.current?.contains(targetElement)) selectedItemIndex.current = -1;
            else selectedItemIndex.current = targetElement instanceof HTMLElement && filteredFocusableElements.indexOf(targetElement) > -1 ? filteredFocusableElements.indexOf(targetElement) : selectedItemIndex.current;
            // do not scroll to focused element for sticky toolbar when navigating with arrows to avoid unnesessary scroll jump
            const allowScrollToElement = !(editorAppearance === 'comment' && !!useStickyToolbar);
            switch(event.key){
                case 'ArrowRight':
                    incrementIndex(filteredFocusableElements);
                    focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                    event.preventDefault();
                    break;
                case 'ArrowLeft':
                    decrementIndex(filteredFocusableElements);
                    focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                    event.preventDefault();
                    break;
                case 'Tab':
                    handleTabLocal();
                    break;
                case 'Escape':
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleEscape(event);
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event)=>{
            // To focus the first element in the toolbar
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (isShortcutToFocusToolbar(event)) {
                const filteredFocusableElements = $75d74c57448b9b48$var$getFilteredFocusableElements(wrapperRef?.current);
                filteredFocusableElements[0]?.focus();
                filteredFocusableElements[0]?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        const editorViewDom = editorView?.dom;
        if (isShortcutToFocusToolbar) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        editorViewDom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
            if (isShortcutToFocusToolbar) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorViewDom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        selectedItemIndex,
        wrapperRef,
        editorView,
        disableArrowKeyNavigation,
        handleEscape,
        childComponentSelector,
        incrementIndex,
        decrementIndex,
        isShortcutToFocusToolbar,
        editorAppearance,
        useStickyToolbar,
        intl
    ]);
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: editorAppearance === 'comment' && $75d74c57448b9b48$var$centeredToolbarContainer,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: "toolbar",
        "aria-label": intl.formatMessage((0, $8aWkM.messages).toolbarLabel),
        "aria-controls": (0, $f9zLy.EDIT_AREA_ID)
    }, /*#__PURE__*/ (0, $3jLHL.jsx)($75d74c57448b9b48$export$5455406531e3792c.Provider, {
        value: submenuKeydownHandleContext
    }, children));
};
function $75d74c57448b9b48$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"], div[tabindex="0"]') || [];
    return Array.from(focusableModalElements);
}
function $75d74c57448b9b48$var$getFilteredFocusableElements(rootNode) {
    // The focusable elements from child components such as dropdown menus / popups are ignored
    return $75d74c57448b9b48$var$getFocusableElements(rootNode).filter((elm)=>{
        const style = window.getComputedStyle(elm);
        // ignore invisible element to avoid losing focus
        const isVisible = style.visibility !== 'hidden' && style.display !== 'none';
        return !elm.closest('[data-role="droplistContent"]') && !elm.closest('[data-emoji-picker-container="true"]') && !elm.closest('[data-test-id="color-picker-menu"]') && !elm.closest('.scroll-buttons') && isVisible;
    });
}

});
parcelRegister("dK4ZR", function(module, exports) {

$parcel$export(module.exports, "GRID_SIZE", () => $75f348dd52cc6fb8$export$bc90872e265d166e);
$parcel$export(module.exports, "DEVICE_BREAKPOINT_NUMBERS", () => $75f348dd52cc6fb8$export$1f1798e92fa75806);
$parcel$export(module.exports, "FLEX_ITEMS_CONTAINER_BREAKPOINT_NUMBERS", () => $75f348dd52cc6fb8$export$69bde1b03e8b5224);
$parcel$export(module.exports, "SIDEBAR_WIDTH", () => $75f348dd52cc6fb8$export$780035d9fe48eb32);
$parcel$export(module.exports, "SIDEBAR_HEADING_WRAPPER_HEIGHT", () => $75f348dd52cc6fb8$export$95b62a1773aa5ebe);
$parcel$export(module.exports, "INLINE_SIDEBAR_HEIGHT", () => $75f348dd52cc6fb8$export$51a2d6b2c009fbfd);
$parcel$export(module.exports, "SEARCH_ITEM_HEIGHT_WIDTH", () => $75f348dd52cc6fb8$export$df8bcac60101d466);
$parcel$export(module.exports, "SCROLLBAR_WIDTH", () => $75f348dd52cc6fb8$export$9a6bb2acef5e644a);
$parcel$export(module.exports, "ELEMENT_LIST_PADDING", () => $75f348dd52cc6fb8$export$3b8e93b2c0f295b0);
$parcel$export(module.exports, "ELEMENT_ITEM_HEIGHT", () => $75f348dd52cc6fb8$export$6d221f35db1b75aa);
$parcel$export(module.exports, "ELEMENT_ITEM_PADDING", () => $75f348dd52cc6fb8$export$ab53450bc5fd5b7d);
$parcel$export(module.exports, "ELEMENT_BROWSER_ID", () => $75f348dd52cc6fb8$export$6ee360fa4b93ee8e);
const $75f348dd52cc6fb8$export$bc90872e265d166e = 8;
const $75f348dd52cc6fb8$export$1f1798e92fa75806 = {
    small: $75f348dd52cc6fb8$export$bc90872e265d166e * 40,
    medium: $75f348dd52cc6fb8$export$bc90872e265d166e * 75,
    large: $75f348dd52cc6fb8$export$bc90872e265d166e * 128
};
const $75f348dd52cc6fb8$export$69bde1b03e8b5224 = {
    small: $75f348dd52cc6fb8$export$bc90872e265d166e * 50,
    medium: $75f348dd52cc6fb8$export$1f1798e92fa75806.medium,
    large: $75f348dd52cc6fb8$export$1f1798e92fa75806.large
};
const $75f348dd52cc6fb8$export$780035d9fe48eb32 = `${$75f348dd52cc6fb8$export$bc90872e265d166e * 25}px`;
const $75f348dd52cc6fb8$export$95b62a1773aa5ebe = `${$75f348dd52cc6fb8$export$bc90872e265d166e * 6}px`;
const $75f348dd52cc6fb8$export$387950d54d372827 = '12px';
const $75f348dd52cc6fb8$export$51a2d6b2c009fbfd = '54px';
const $75f348dd52cc6fb8$export$df8bcac60101d466 = '20px';
const $75f348dd52cc6fb8$export$9a6bb2acef5e644a = 15;
const $75f348dd52cc6fb8$export$3b8e93b2c0f295b0 = 2;
const $75f348dd52cc6fb8$export$6d221f35db1b75aa = 60;
const $75f348dd52cc6fb8$export$ab53450bc5fd5b7d = 10;
const $75f348dd52cc6fb8$export$6ee360fa4b93ee8e = 'editor-element-browser';

});

parcelRegister("f9zLy", function(module, exports) {

$parcel$export(module.exports, "EDIT_AREA_ID", () => $12841799d44c3fc4$export$b16ce0826b76e795);
const $12841799d44c3fc4$export$b16ce0826b76e795 = 'ak-editor-textarea';

});


parcelRegister("dhoHU", function(module, exports) {

$parcel$export(module.exports, "addParagraphAtEnd", () => $1d2e8dba41928471$export$fc18809329b5ff08);
$parcel$export(module.exports, "changeImageAlignment", () => $1d2e8dba41928471$export$774cc08dd90b6a6a);
$parcel$export(module.exports, "createToggleBlockMarkOnRange", () => $1d2e8dba41928471$export$1115c4cf51ae1924);
$parcel$export(module.exports, "createToggleInlineMarkOnRange", () => $1d2e8dba41928471$export$a10bb5a1a10022f6);
$parcel$export(module.exports, "toggleBlockMark", () => $1d2e8dba41928471$export$72d6145976985e8c);
$parcel$export(module.exports, "findCutBefore", () => $1d2e8dba41928471$export$ad1078cb3917e860);

var $7T7aA = parcelRequire("7T7aA");

var $7XFGZ = parcelRequire("7XFGZ");

var $afcIe = parcelRequire("afcIe");
function $1d2e8dba41928471$export$fc18809329b5ff08(tr) {
    const { doc: { type: { schema: { nodes: { paragraph: paragraph } } } }, doc: doc } = tr;
    if (doc.lastChild && !(doc.lastChild.type === paragraph && doc.lastChild.content.size === 0)) {
        if (paragraph) tr.insert(doc.content.size, paragraph.createAndFill());
    }
    tr.setSelection((0, $7T7aA.TextSelection).create(tr.doc, tr.doc.content.size - 1));
    tr.scrollIntoView();
}
function $1d2e8dba41928471$export$2864da03fd603a92() {
    return function(state, dispatch) {
        const { tr: tr } = state;
        $1d2e8dba41928471$export$fc18809329b5ff08(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $1d2e8dba41928471$export$774cc08dd90b6a6a = (align)=>(state, dispatch)=>{
        const { from: from, to: to } = state.selection;
        const tr = state.tr;
        state.doc.nodesBetween(from, to, (node, pos)=>{
            if (node.type === state.schema.nodes.mediaSingle) tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                layout: align === 'center' ? 'center' : `align-${align}`
            });
        });
        if (tr.docChanged && dispatch) {
            dispatch(tr.scrollIntoView());
            return true;
        }
        return false;
    };
const $1d2e8dba41928471$export$1115c4cf51ae1924 = (markType, getAttrs, allowedBlocks)=>(from, to, tr, state)=>{
        let markApplied = false;
        state.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (!node.type.isBlock) return false;
            if ((!allowedBlocks || (Array.isArray(allowedBlocks) ? allowedBlocks.indexOf(node.type) > -1 : allowedBlocks(state.schema, node, parent))) && parent?.type.allowsMarkType(markType)) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $1d2e8dba41928471$export$a10bb5a1a10022f6 = (markType, getAttrs)=>(from, to, tr, state)=>{
        let markApplied = false;
        state.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (parent?.type.allowsMarkType(markType)) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    tr.setSelection((0, $7T7aA.NodeSelection).create(tr.doc, state.selection.from));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $1d2e8dba41928471$export$72d6145976985e8c = (markType, getAttrs, allowedBlocks)=>(state, dispatch)=>{
        let markApplied = false;
        const tr = state.tr;
        const toggleBlockMarkOnRange = $1d2e8dba41928471$export$1115c4cf51ae1924(markType, getAttrs, allowedBlocks);
        if (state.selection instanceof (0, $7XFGZ.CellSelection)) state.selection.forEachCell((cell, pos)=>{
            markApplied = toggleBlockMarkOnRange(pos, pos + cell.nodeSize, tr, state);
        });
        else {
            const { from: from, to: to } = state.selection;
            markApplied = toggleBlockMarkOnRange(from, to, tr, state);
        }
        if (markApplied && tr.docChanged) {
            if (dispatch) dispatch(tr.scrollIntoView());
            return true;
        }
        return false;
    };
const $1d2e8dba41928471$export$59c0bf8874edecc7 = (state, dispatch)=>{
    const tr = state.tr;
    tr.replace(0, state.doc.nodeSize - 2);
    tr.setSelection((0, $7T7aA.Selection).atStart(tr.doc));
    if (dispatch) {
        dispatch(tr);
        return true;
    }
    return false;
};
function $1d2e8dba41928471$export$ad1078cb3917e860($pos) {
    // parent is non-isolating, so we can look across this boundary
    if (!$pos.parent.type.spec.isolating) // search up the tree from the pos's *parent*
    for(let i = $pos.depth - 1; i >= 0; i--){
        // starting from the inner most node's parent, find out
        // if we're not its first child
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $1d2e8dba41928471$export$c6a04dca1ed03a3c(level) {
    return function(state, dispatch) {
        const { selection: selection, schema: schema, tr: tr } = state;
        const ranges = selection instanceof (0, $7XFGZ.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            tr.setBlockType($from.pos, $to.pos, schema.nodes.heading, {
                level: level
            });
        });
        if (dispatch) dispatch(tr);
        return true;
    };
}

});
parcelRegister("afcIe", function(module, exports) {

$parcel$export(module.exports, "insertBlock", () => $fde5eb025de1bc5c$export$f51280337625031);

var $7T7aA = parcelRequire("7T7aA");

var $gWR1e = parcelRequire("gWR1e");
const $fde5eb025de1bc5c$export$f51280337625031 = (state, nodeType, start, end, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
attrs)=>{
    // To ensure that match is done after HardBreak.
    const { hardBreak: hardBreak, codeBlock: codeBlock, listItem: listItem } = state.schema.nodes;
    const $pos = state.doc.resolve(start);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if ($pos.nodeAfter.type !== hardBreak) return null;
    // To ensure no nesting is done. (unless we're inserting a codeBlock inside lists)
    if ($pos.depth > 1 && !(nodeType === codeBlock && (0, $gWR1e.hasParentNodeOfType)(listItem)(state.selection))) return null;
    // Split at the start of autoformatting and delete formatting characters.
    let tr = state.tr.delete(start, end).split(start);
    let currentNode = tr.doc.nodeAt(start + 1);
    // If node has more content split at the end of autoformatting.
    let nodeHasMoreContent = false;
    tr.doc.nodesBetween(start, start + currentNode.nodeSize, (node, pos)=>{
        if (!nodeHasMoreContent && node.type === hardBreak) {
            nodeHasMoreContent = true;
            tr = tr.split(pos + 1).delete(pos, pos + 1);
        }
    });
    if (nodeHasMoreContent) currentNode = tr.doc.nodeAt(start + 1);
    // Create new node and fill with content of current node.
    const { blockquote: blockquote, paragraph: paragraph } = state.schema.nodes;
    let content;
    let depth;
    if (nodeType === blockquote) {
        depth = 3;
        content = [
            paragraph.create({}, currentNode.content)
        ];
    } else {
        depth = 2;
        content = currentNode.content;
    }
    const newNode = nodeType.create(attrs, content);
    // Add new node.
    tr = tr.setSelection(new (0, $7T7aA.NodeSelection)(tr.doc.resolve(start + 1)))// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .replaceSelectionWith(newNode).setSelection(new (0, $7T7aA.TextSelection)(tr.doc.resolve(start + depth)));
    return tr;
};

});


parcelRegister("1zPzM", function(module, exports) {

$parcel$export(module.exports, "setSelectionTopLevelBlocks", () => $4bfd6331a10a8378$export$1b305efb24649ca5);
$parcel$export(module.exports, "setGapCursorAtPos", () => $4bfd6331a10a8378$export$44fdd7840a0a11f2);

var $7T7aA = parcelRequire("7T7aA");

var $adhil = parcelRequire("adhil");

var $1gpr6 = parcelRequire("1gpr6");
// This function captures clicks outside of the ProseMirror contentEditable area
// see also description of "handleClick" in gap-cursor pm-plugin
const $4bfd6331a10a8378$var$captureCursorCoords = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, tr)=>{
    const rect = editorRef.getBoundingClientRect();
    // capture clicks before the first block element
    if (event.clientY < rect.top) return {
        position: 0,
        side: (0, $adhil.Side).LEFT
    };
    if (rect.left > 0) {
        // calculate start position of a node that is vertically at the same level
        const coords = posAtCoords({
            left: rect.left,
            top: event.clientY
        });
        if (coords && coords.inside > -1) {
            const $from = tr.doc.resolve(coords.inside);
            const start = $from.before(1);
            const side = event.clientX < rect.left ? (0, $adhil.Side).LEFT : (0, $adhil.Side).RIGHT;
            let position;
            if (side === (0, $adhil.Side).LEFT) position = start;
            else {
                const node = tr.doc.nodeAt(start);
                if (node) position = start + node.nodeSize;
            }
            return {
                position: position,
                side: side
            };
        }
    }
    return null;
};
const $4bfd6331a10a8378$export$1b305efb24649ca5 = (tr, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, editorFocused)=>{
    const cursorCoords = $4bfd6331a10a8378$var$captureCursorCoords(event, editorRef, posAtCoords, tr);
    if (!cursorCoords) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const $pos = cursorCoords.position !== undefined ? tr.doc.resolve(cursorCoords.position) : null;
    if ($pos === null) return;
    const isGapCursorAllowed = cursorCoords.side === (0, $adhil.Side).LEFT ? (0, $1gpr6.isValidTargetNode)($pos.nodeAfter) : (0, $1gpr6.isValidTargetNode)($pos.nodeBefore);
    if (isGapCursorAllowed && (0, $adhil.GapCursorSelection).valid($pos)) {
        // this forces PM to re-render the decoration node if we change the side of the gap cursor, it doesn't do it by default
        if (tr.selection instanceof (0, $adhil.GapCursorSelection)) tr.setSelection((0, $7T7aA.Selection).near($pos));
        else tr.setSelection(new (0, $adhil.GapCursorSelection)($pos, cursorCoords.side));
    } else if (editorFocused === false) {
        const selectionTemp = (0, $7T7aA.Selection).findFrom($pos, cursorCoords.side === (0, $adhil.Side).LEFT ? 1 : -1, true);
        if (selectionTemp) tr.setSelection(selectionTemp);
    }
};
const $4bfd6331a10a8378$export$44fdd7840a0a11f2 = (position, side = (0, $adhil.Side).LEFT)=>(state, dispatch)=>{
        // @see ED-6231
        if (position > state.doc.content.size) return false;
        const $pos = state.doc.resolve(position);
        if ((0, $adhil.GapCursorSelection).valid($pos)) {
            if (dispatch) dispatch(state.tr.setSelection(new (0, $adhil.GapCursorSelection)($pos, side)));
            return true;
        }
        return false;
    };

});

parcelRegister("6cQbn", function(module, exports) {

$parcel$export(module.exports, "CommentEditorWithIntl", () => $9cfcad4a35f316a8$export$7b9f3a51cd0c1967);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $6qIXK = parcelRequire("6qIXK");

var $dBxQj = parcelRequire("dBxQj");

var $hArLp = parcelRequire("hArLp");

var $ccHMk = parcelRequire("ccHMk");

var $574ry = parcelRequire("574ry");
var $1Oo9w = parcelRequire("1Oo9w");

var $61p3e = parcelRequire("61p3e");

var $87iYj = parcelRequire("87iYj");

var $bWRlG = parcelRequire("bWRlG");

var $5Gwdo = parcelRequire("5Gwdo");

var $b3YrF = parcelRequire("b3YrF");
parcelRequire("c4XA1");
var $3teBi = parcelRequire("3teBi");

var $aFUXX = parcelRequire("aFUXX");

var $9JpPs = parcelRequire("9JpPs");

var $iu6m9 = parcelRequire("iu6m9");

var $kXpLO = parcelRequire("kXpLO");

var $45E6y = parcelRequire("45E6y");

var $761rI = parcelRequire("761rI");

var $axOCf = parcelRequire("axOCf");

var $3ae8F = parcelRequire("3ae8F");

var $1xxAs = parcelRequire("1xxAs");

var $uq7dM = parcelRequire("uq7dM");

var $7Ogr0 = parcelRequire("7Ogr0");
const $9cfcad4a35f316a8$var$CommentEditorMargin = 14;
const $9cfcad4a35f316a8$var$commentEditorStyles = (0, $3jLHL.css)({
    display: 'flex',
    flexDirection: 'column',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.less-margin .ProseMirror': {
        margin: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
    },
    minWidth: '272px',
    height: 'auto',
    backgroundColor: "var(--ds-background-input, white)",
    border: `1px solid ${"var(--ds-border-input, #8590A2)"}`,
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-border-radius, 3px)",
    maxWidth: 'inherit',
    wordWrap: 'break-word'
});
const $9cfcad4a35f316a8$var$ContentArea = (0, $761rI.createEditorContentStyle)((0, $3jLHL.css)({
    flexGrow: 1,
    overflowX: 'clip',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '24px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror': {
        margin: "var(--ds-space-150, 12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridParent': {
        marginLeft: "var(--ds-space-025, 2px)",
        marginRight: "var(--ds-space-025, 2px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `calc(100% + ${$9cfcad4a35f316a8$var$CommentEditorMargin - (0, $87iYj.GRID_GUTTER)}px)`
    },
    padding: "var(--ds-space-250, 20px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $3teBi.tableCommentEditorStyles)));
$9cfcad4a35f316a8$var$ContentArea.displayName = 'ContentArea';
const $9cfcad4a35f316a8$var$secondaryToolbarStyles = (0, $3jLHL.css)({
    boxSizing: 'border-box',
    justifyContent: 'flex-end',
    alignItems: 'center',
    display: 'flex',
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-025, 2px)"}`
});
const $9cfcad4a35f316a8$var$appearance = 'comment';
const $9cfcad4a35f316a8$var$EditorContainer = (0, $9JpPs.componentWithCondition)(()=>(0, $iu6m9.editorExperiment)('platform_editor_core_static_emotion', true, {
        exposure: true
    }), (0, $axOCf.default), $9cfcad4a35f316a8$var$ContentArea);
const $9cfcad4a35f316a8$var$useCommentEditorPluginsStates = (0, $574ry.sharedPluginStateHookMigratorFactory)((pluginInjectionApi)=>{
    return (0, $1Oo9w.useSharedPluginState)(pluginInjectionApi, [
        'maxContentSize',
        'primaryToolbar',
        'editorViewMode'
    ]);
}, (pluginInjectionApi)=>{
    const maxContentSizeReached = (0, $b3YrF.useSharedPluginStateSelector)(pluginInjectionApi, 'maxContentSize.maxContentSizeReached');
    const primaryToolbarComponents = (0, $b3YrF.useSharedPluginStateSelector)(pluginInjectionApi, 'primaryToolbar.components');
    const editorViewMode = (0, $b3YrF.useSharedPluginStateSelector)(pluginInjectionApi, 'editorViewMode.mode');
    return {
        maxContentSizeState: maxContentSizeReached === undefined ? undefined : {
            maxContentSizeReached: maxContentSizeReached
        },
        primaryToolbarState: !primaryToolbarComponents ? undefined : {
            components: primaryToolbarComponents
        },
        editorViewModeState: !editorViewMode ? undefined : {
            mode: editorViewMode
        }
    };
});
const $9cfcad4a35f316a8$export$7b9f3a51cd0c1967 = (props)=>{
    const { editorAPI: editorAPI } = props;
    const { maxContentSizeState: maxContentSizeState, primaryToolbarState: primaryToolbarState, editorViewModeState: editorViewModeState } = $9cfcad4a35f316a8$var$useCommentEditorPluginsStates(editorAPI);
    const { mediaState: mediaState } = (0, $1Oo9w.useSharedPluginState)(editorAPI, [
        'media'
    ]);
    const intl = (0, $dBxQj.default)();
    const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, customPrimaryToolbarComponents: customPrimaryToolbarComponents, primaryToolbarComponents: primaryToolbarComponentsProp, customSecondaryToolbarComponents: customSecondaryToolbarComponents, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, maxHeight: maxHeight, minHeight: minHeight = 150, onSave: onSave, onCancel: onCancel, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, useStickyToolbar: useStickyToolbar, pluginHooks: pluginHooks, featureFlags: featureFlags, innerRef: innerRef } = props;
    const maxContentSizeReached = Boolean(maxContentSizeState?.maxContentSizeReached);
    const showSecondaryToolbar = !!onSave || !!onCancel || !!customSecondaryToolbarComponents;
    const containerElement = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef(null);
    // Wrapper container for toolbar and content area
    const wrapperElementRef = (0, $gwFzn.useMemo)(()=>innerRef || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createRef(), [
        innerRef
    ]);
    const [saveButtonDisabled, setSaveButtonDisabled] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (mediaState) mediaState.subscribeToUploadInProgressState(setSaveButtonDisabled);
        return ()=>mediaState?.unsubscribeFromUploadInProgressState(setSaveButtonDisabled);
    }, [
        mediaState
    ]);
    const handleSave = (0, $gwFzn.useCallback)(()=>{
        if (editorView && onSave) onSave(editorView);
    }, [
        editorView,
        onSave
    ]);
    const handleCancel = (0, $gwFzn.useCallback)(()=>{
        if (editorView && onCancel) onCancel(editorView);
    }, [
        editorView,
        onCancel
    ]);
    const isShortcutToFocusToolbar = (0, $gwFzn.useCallback)((event)=>{
        //Alt + F9 to reach first element in this main toolbar
        return event.altKey && (event.key === 'F9' || event.keyCode === 120);
    }, []);
    // When primary toolbar components is undefined, do not show two line editor toolbar
    const isTwoLineToolbarEnabled = !!customPrimaryToolbarComponents;
    const handleEscape = (0, $gwFzn.useCallback)((event)=>{
        if (!editorView?.hasFocus()) editorView?.focus();
        event.preventDefault();
        event.stopPropagation();
    }, [
        editorView
    ]);
    let primaryToolbarComponents = primaryToolbarComponentsProp;
    if (Array.isArray(primaryToolbarState?.components) && Array.isArray(primaryToolbarComponents)) primaryToolbarComponents = primaryToolbarState.components.concat(primaryToolbarComponents);
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $uq7dM.default), {
        animate: maxContentSizeReached
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $bWRlG.WidthProvider), null, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: [
            $9cfcad4a35f316a8$var$commentEditorStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $3jLHL.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                minHeight: `${minHeight}px`
            })
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "akEditor",
        ref: wrapperElementRef
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $7Ogr0.MainToolbar), {
        useStickyToolbar: useStickyToolbar,
        twoLineEditorToolbar: isTwoLineToolbarEnabled
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $5Gwdo.ToolbarArrowKeyNavigationProvider), {
        editorView: editorView,
        childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
        isShortcutToFocusToolbar: isShortcutToFocusToolbar,
        handleEscape: handleEscape,
        editorAppearance: $9cfcad4a35f316a8$var$appearance,
        useStickyToolbar: useStickyToolbar,
        intl: intl
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $1xxAs.ToolbarWithSizeDetector), {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: editorView,
        editorActions: editorActions,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        eventDispatcher: eventDispatcher,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        providerFactory: providerFactory,
        appearance: $9cfcad4a35f316a8$var$appearance,
        items: primaryToolbarComponents,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        disabled: !!disabled,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        containerElement: containerElement.current,
        twoLineEditorToolbar: isTwoLineToolbarEnabled
    }), /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: (0, $7Ogr0.mainToolbarCustomComponentsSlotStyle)(isTwoLineToolbarEnabled)
    }, customPrimaryToolbarComponents))), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $kXpLO.default), {
        editorView: editorView,
        editorDisabled: disabled
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $bWRlG.WidthConsumer), null, ({ width: width })=>{
        return /*#__PURE__*/ (0, $3jLHL.jsx)($9cfcad4a35f316a8$var$EditorContainer, {
            ref: containerElement,
            css: maxHeight ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $3jLHL.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                maxHeight: `${maxHeight}px`,
                // When maxHeight is set, content area should have overflow-y explicitly set as auto
                // As we have overflow-x: clip for the content area, and when maxHeight prop is set, overflow-y will be computed as visible by default.
                // This will cause the content area to have content overflowing the container
                // so need to set overflow-y as auto to make sure the content area is scrollable
                overflowY: 'auto'
            }) : null,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($6qIXK)))('ak-editor-content-area', {
                'less-margin': width < (0, $aFUXX.akEditorMobileBreakoutPoint)
            }),
            featureFlags: featureFlags,
            viewMode: editorViewModeState?.mode,
            appearance: $9cfcad4a35f316a8$var$appearance
        }, customContentComponents && 'before' in customContentComponents ? (0, $45E6y.contentComponentClickWrapper)(customContentComponents.before) : (0, $45E6y.contentComponentClickWrapper)(customContentComponents), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3ae8F.default), {
            editorView: editorView,
            editorActions: editorActions,
            eventDispatcher: eventDispatcher,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            providerFactory: providerFactory,
            appearance: $9cfcad4a35f316a8$var$appearance,
            items: contentComponents,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            containerElement: containerElement.current,
            disabled: !!disabled,
            wrapperElement: wrapperElementRef.current,
            pluginHooks: pluginHooks
        }), editorDOMElement, customContentComponents && 'after' in customContentComponents ? (0, $45E6y.contentComponentClickWrapper)(customContentComponents.after) : null);
    }))), showSecondaryToolbar && /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $9cfcad4a35f316a8$var$secondaryToolbarStyles,
        "data-testid": "ak-editor-secondary-toolbar"
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $hArLp.default), null, !!onSave && /*#__PURE__*/ (0, $3jLHL.jsx)((0, $ccHMk.default), {
        appearance: "primary",
        onClick: handleSave,
        testId: "comment-save-button",
        isDisabled: disabled || saveButtonDisabled,
        interactionName: "editor-comment-save-button"
    }, intl.formatMessage((0, $61p3e.default).saveButton)), !!onCancel && /*#__PURE__*/ (0, $3jLHL.jsx)((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: handleCancel,
        isDisabled: disabled,
        interactionName: "editor-comment-cancel-button"
    }, intl.formatMessage((0, $61p3e.default).cancelButton))), /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        style: {
            flexGrow: 1
        }
    }), customSecondaryToolbarComponents)));
};
$9cfcad4a35f316a8$export$7b9f3a51cd0c1967.displayName = 'CommentEditorAppearance';

});
parcelRegister("kXpLO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d312f85c475dacb6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $1NnoA = parcelRequire("1NnoA");
const $d312f85c475dacb6$var$clickWrapper = (0, $3jLHL.css)({
    flexGrow: 1,
    height: '100%'
});
const $d312f85c475dacb6$export$68468c5dbde37b99 = ({ editorView: editorView, editorDisabled: editorDisabled, children: children })=>{
    const handleMouseDown = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useCallback((event)=>{
        if (!editorView) return;
        if (!editorDisabled) (0, $1NnoA.clickAreaClickHandler)(editorView, event);
    }, [
        editorView,
        editorDisabled
    ]);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        "data-editor-click-wrapper": true,
        "data-testid": "click-wrapper",
        css: $d312f85c475dacb6$var$clickWrapper,
        onMouseDown: handleMouseDown
    }, children));
};
var $d312f85c475dacb6$export$2e2bcd8739ae039 = $d312f85c475dacb6$export$68468c5dbde37b99;

});
parcelRegister("1NnoA", function(module, exports) {

$parcel$export(module.exports, "clickAreaClickHandler", () => $fdee4aa7754cfd6c$export$28b64e3e5a38e8a2);

var $h3X17 = parcelRequire("h3X17");

var $dhoHU = parcelRequire("dhoHU");

var $1zPzM = parcelRequire("1zPzM");

var $4vlwG = parcelRequire("4vlwG");

var $dh538 = parcelRequire("dh538");

var $45E6y = parcelRequire("45E6y");
// we ignore all of the clicks made inside <div class="ak-editor-content-area" /> (but not clicks on the node itself)
const $fdee4aa7754cfd6c$var$insideContentArea = (ref)=>{
    while(ref){
        if (ref.classList && ref.classList.contains('ak-editor-content-area')) return true;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        ref = ref.parentNode;
    }
    return false;
};
const $fdee4aa7754cfd6c$var$insideProseMirrorEditableArea = (ref)=>{
    return Boolean(ref?.closest('.ProseMirror'));
};
const $fdee4aa7754cfd6c$export$79ba7abfc5f47a65 = (target)=>{
    const modalDialog = target?.closest('[role=dialog]');
    if (modalDialog) // return false if not an editor inside modal, otherwise return true
    return !!modalDialog?.querySelector('.akEditor');
    // no modal present so we can return true
    return true;
};
const $fdee4aa7754cfd6c$export$28b64e3e5a38e8a2 = (view, event)=>{
    const isEditorFocused = !!view?.hasFocus?.();
    if (!(event.target instanceof HTMLElement)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const isTargetContentArea = target?.classList.contains('ak-editor-content-area');
    const isTargetChildOfContentArea = $fdee4aa7754cfd6c$var$insideContentArea(target?.parentNode instanceof HTMLElement ? target?.parentNode : null);
    const isTargetInsideEditableArea = $fdee4aa7754cfd6c$var$insideProseMirrorEditableArea(target);
    // Any click inside ProseMirror should be managed by ProseMirror
    if (isTargetInsideEditableArea) return false;
    const isEventComingFromContentArea = Boolean(event.currentTarget.querySelector('.ak-editor-content-area'));
    // @see https://product-fabric.atlassian.net/browse/ED-4287
    // click event gets triggered twice on a checkbox (on <label> first and then on <input>)
    // by the time it gets triggered on input, PM already re-renders nodeView and detaches it from DOM
    // which doesn't pass the check !contentArea.contains(event.target)
    const isInputClicked = target?.nodeName === 'INPUT';
    // @see ED-5126
    const isPopupClicked = !!(0, $4vlwG.closestElement)(target, '[data-editor-popup]');
    // Fixes issue when using a textarea for editor title in full page editor doesn't let user focus it.
    const isTextAreaClicked = target?.nodeName === 'TEXTAREA';
    const isBreadcrumbClicked = !!(0, $4vlwG.closestElement)(target, 'nav[aria-label="Breadcrumbs"]');
    const selection = window.getSelection();
    const isEditorPopupTextSelected = selection?.type === 'Range' && // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    (0, $4vlwG.closestElement)(selection?.anchorNode, '[data-editor-popup]');
    // For clicks directly on the content component -- they should not be ignored
    const isContentComponent = (0, $dh538.fg)('platform_editor_keep_focus_on_content_comp_clicks') ? target?.parentElement?.closest(`[${(0, $45E6y.ignoreAttribute)}]`) : !!(0, $4vlwG.closestElement)(target, `[${(0, $45E6y.ignoreAttribute)}]`) || target?.getAttribute((0, $45E6y.ignoreAttribute)) === 'true';
    // This is a super workaround to find when events are coming from Confluence InlineComment modal
    // We don't own those components, so we can't change them
    const isEventComingFromInlineCommentPopup = Boolean((0, $4vlwG.closestElement)(event.currentTarget, 'div[offset]')) || Boolean((0, $4vlwG.closestElement)(target, 'div[offset]'));
    const isButtonClicked = Boolean((0, $4vlwG.closestElement)(event.currentTarget, 'button')) || Boolean((0, $4vlwG.closestElement)(target, 'button')) || event.currentTarget?.nodeName === 'BUTTON' || target?.nodeName === 'BUTTON';
    const isTargetInsideContentArea = Boolean(isTargetChildOfContentArea);
    const isBetweenContentAreaAndEditableContent = isTargetInsideContentArea && !isTargetInsideEditableArea;
    // Column Picker dropdown in Datasources table
    const isDatasourcePopupClicked = !!target?.closest('#column-picker-popup');
    const edgeCaseScenario1 = (isBetweenContentAreaAndEditableContent || !isEventComingFromContentArea) && !isEditorFocused;
    const edgeCaseScenario2 = !isTargetInsideContentArea && isEditorFocused;
    const edgeCaseScenario3 = isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
    const edgeCaseScenario4 = isEventComingFromContentArea && !isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
    const edgeCases = edgeCaseScenario1 || edgeCaseScenario2 || edgeCaseScenario3 || edgeCaseScenario4;
    const isClickOutsideEditor = edgeCases && !isDatasourcePopupClicked && !isEventComingFromInlineCommentPopup && !isButtonClicked && !isInputClicked && !isTextAreaClicked && !isPopupClicked && !isBreadcrumbClicked && !isEditorPopupTextSelected && !isContentComponent && $fdee4aa7754cfd6c$export$79ba7abfc5f47a65(target);
    // click was within editor container and focus should be brought to input
    if (isClickOutsideEditor && view) $fdee4aa7754cfd6c$export$c5a7a653c4681bfd(view, event);
};
const $fdee4aa7754cfd6c$export$c5a7a653c4681bfd = (view, event)=>{
    const { dispatch: dispatch, dom: dom, state: state } = view;
    const { tr: tr } = state;
    const isEditorFocused = !!view?.hasFocus?.();
    const isBottomAreaClicked = event.clientY > dom.getBoundingClientRect().bottom;
    if (isBottomAreaClicked) {
        tr.setMeta('outsideProsemirrorEditorClicked', true);
        (0, $dhoHU.addParagraphAtEnd)(tr);
    }
    (0, $1zPzM.setSelectionTopLevelBlocks)(tr, event, // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    dom, view.posAtCoords.bind(view), isEditorFocused);
    (0, $h3X17.tintDirtyTransaction)(tr);
    if (!tr.docChanged && !tr.selectionSet) return;
    if (dispatch) dispatch(tr);
    view.focus();
    event.preventDefault();
};

});
parcelRegister("45E6y", function(module, exports) {

$parcel$export(module.exports, "ignoreAttribute", () => $938cf1eec2ff4dc1$export$72d101e93c081651);
$parcel$export(module.exports, "contentComponentClickWrapper", () => $938cf1eec2ff4dc1$export$57a965c23051130d);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $938cf1eec2ff4dc1$export$72d101e93c081651 = 'data-editor-content-component';
const $938cf1eec2ff4dc1$export$57a965c23051130d = (reactComponents)=>{
    if (!(0, $dh538.fg)('platform_editor_content_component_ignore_click')) return reactComponents;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "data-editor-content-component": 'true',
        children: reactComponents
    });
};

});



parcelRegister("1xxAs", function(module, exports) {

$parcel$export(module.exports, "ToolbarWithSizeDetector", () => $4b0c8fc583dabeb9$export$6bb21858343ac39d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $eTj7Y = parcelRequire("eTj7Y");

var $zMjD6 = parcelRequire("zMjD6");

var $aFUXX = parcelRequire("aFUXX");

var $4JDbp = parcelRequire("4JDbp");

var $geLSP = parcelRequire("geLSP");

var $khPmN = parcelRequire("khPmN");

var $eUp7e = parcelRequire("eUp7e");

var $hoXJd = parcelRequire("hoXJd");
const $4b0c8fc583dabeb9$var$toolbar = (0, $3jLHL.css)({
    width: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $aFUXX.akEditorMobileMaxWidth}px)`]: {
        gridColumn: '1 / 2',
        gridRow: 2,
        width: 'calc(100% - 30px)',
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $4b0c8fc583dabeb9$export$6bb21858343ac39d = (props)=>{
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef(null);
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState(undefined);
    const elementWidth = (0, $khPmN.useElementWidth)(ref, {
        skip: typeof width !== 'undefined'
    });
    const defaultToolbarSize = (0, $eTj7Y.isSSR)() && (0, $geLSP.isFullPage)(props.appearance) ? (0, $zMjD6.ToolbarSize).XXL : undefined;
    const toolbarSize = typeof width === 'undefined' && typeof elementWidth === 'undefined' ? defaultToolbarSize : // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hoXJd.widthToToolbarSize)(width || elementWidth, props.appearance);
    const toolbarStyle = (0, $gwFzn.useMemo)(()=>{
        const toolbarWidth = (0, $geLSP.isFullPage)(props.appearance) && props.twoLineEditorToolbar ? (0, $zMjD6.ToolbarSize).S : (0, $zMjD6.ToolbarSize).M;
        const toolbarMinWidth = (0, $hoXJd.toolbarSizeToWidth)(toolbarWidth, props.appearance);
        const minWidth = `min-width: ${props.hasMinWidth ? toolbarMinWidth : '254'}px`;
        return [
            $4b0c8fc583dabeb9$var$toolbar,
            minWidth
        ];
    }, [
        props.appearance,
        props.hasMinWidth,
        props.twoLineEditorToolbar
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: toolbarStyle
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4JDbp.WidthObserver), {
        setWidth: setWidth
    }), props.editorView && toolbarSize ? // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $3jLHL.jsx)((0, $eUp7e.Toolbar), {
        ...props,
        toolbarSize: toolbarSize
    }) : /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ref: ref
    })));
};

});
parcelRegister("khPmN", function(module, exports) {

$parcel$export(module.exports, "useElementWidth", () => $3aec2ffe9f521610$export$1217913212f99c7);

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $3aec2ffe9f521610$export$1217913212f99c7 = (ref, { skip: skip })=>{
    const [elementWidth, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState(undefined);
    (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useEffect(()=>{
        if (!skip && ref.current && !(0, $dh538.fg)('platform_editor_prevent_toolbar_width_reflow')) setWidth(Math.round(ref.current.getBoundingClientRect().width));
    }, [
        skip,
        setWidth,
        ref
    ]);
    return elementWidth;
};

});

parcelRegister("eUp7e", function(module, exports) {

$parcel$export(module.exports, "Toolbar", () => $ba8f28fe8c9d2747$export$4c260019440d418f);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $zMjD6 = parcelRequire("zMjD6");

var $jlXEe = parcelRequire("jlXEe");
const $ba8f28fe8c9d2747$export$4c260019440d418f = (props)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jlXEe.ToolbarInner), {
        items: props.items,
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        toolbarSize: props.toolbarSize,
        isToolbarReducedSpacing: props.toolbarSize < (0, $zMjD6.ToolbarSize).XXL,
        containerElement: props.containerElement
    });
};

});
parcelRegister("jlXEe", function(module, exports) {

$parcel$export(module.exports, "ToolbarInner", () => $85ca23d15eecf4ef$export$7c77e89663c6a665);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $atveb = parcelRequire("atveb");

var $eTj7Y = parcelRequire("eTj7Y");

var $aFUXX = parcelRequire("aFUXX");
const $85ca23d15eecf4ef$var$toolbarComponentsWrapper = (0, $3jLHL.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $aFUXX.akEditorMobileMaxWidth}px)`]: {
        justifyContent: 'space-between'
    }
});
class $85ca23d15eecf4ef$export$7c77e89663c6a665 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($atveb)))(nextProps, this.props);
    }
    render() {
        const { appearance: appearance, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, items: items, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, containerElement: containerElement } = this.props;
        if (!items || !items.length) return null;
        if ((0, $eTj7Y.isSSR)()) // Toolbar in SSR environment is showing collapsed state, which caused layout shift after hydrating to SPA.
        // Hiding toolbar in SSR until the dependency of screen width is resolved in SSR environment.
        return null;
        return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            css: $85ca23d15eecf4ef$var$toolbarComponentsWrapper,
            "data-vc": "toolbar-inner"
        }, items.map((component, key)=>{
            const element = component({
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                providerFactory: providerFactory,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                appearance: appearance,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                disabled: disabled,
                toolbarSize: toolbarSize,
                isToolbarReducedSpacing: isToolbarReducedSpacing,
                containerElement: containerElement,
                isLastItem: key === items.length - 1,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                wrapperElement: null
            });
            return element && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).cloneElement(element, {
                key: key
            });
        }));
    }
}

});


parcelRegister("hoXJd", function(module, exports) {

$parcel$export(module.exports, "toolbarSizeToWidth", () => $bd42a2364528a44b$export$df8e48f984163082);
$parcel$export(module.exports, "widthToToolbarSize", () => $bd42a2364528a44b$export$886398ab6922a80f);

var $zMjD6 = parcelRequire("zMjD6");

var $dh538 = parcelRequire("dh538");

var $geLSP = parcelRequire("geLSP");
// Toolbar sizes for full page editor a little bit different, because it has more buttons e.g. actions button...
const $bd42a2364528a44b$var$toolbarSizesFullPageNext = [
    {
        width: (0, $zMjD6.ToolbarWidthsFullPageNext).XXL,
        size: (0, $zMjD6.ToolbarSize).XXL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPageNext).XL,
        size: (0, $zMjD6.ToolbarSize).XL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPageNext).L,
        size: (0, $zMjD6.ToolbarSize).L
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPageNext).M,
        size: (0, $zMjD6.ToolbarSize).M
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPageNext).S,
        size: (0, $zMjD6.ToolbarSize).S
    }
];
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of toolbarSizesFullPageNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ const $bd42a2364528a44b$var$toolbarSizesFullPage = [
    {
        width: (0, $zMjD6.ToolbarWidthsFullPage).XXL,
        size: (0, $zMjD6.ToolbarSize).XXL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPage).XL,
        size: (0, $zMjD6.ToolbarSize).XL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPage).L,
        size: (0, $zMjD6.ToolbarSize).L
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPage).M,
        size: (0, $zMjD6.ToolbarSize).M
    },
    {
        width: (0, $zMjD6.ToolbarWidthsFullPage).S,
        size: (0, $zMjD6.ToolbarSize).S
    }
];
const $bd42a2364528a44b$var$toolbarSizesNext = [
    {
        width: (0, $zMjD6.ToolbarWidthsNext).XXL,
        size: (0, $zMjD6.ToolbarSize).XXL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsNext).XL,
        size: (0, $zMjD6.ToolbarSize).XL
    },
    {
        width: (0, $zMjD6.ToolbarWidthsNext).L,
        size: (0, $zMjD6.ToolbarSize).L
    },
    {
        width: (0, $zMjD6.ToolbarWidthsNext).M,
        size: (0, $zMjD6.ToolbarSize).M
    },
    {
        width: (0, $zMjD6.ToolbarWidthsNext).S,
        size: (0, $zMjD6.ToolbarSize).S
    }
];
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of toolbarSizesNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ const $bd42a2364528a44b$var$toolbarSizes = [
    {
        width: (0, $zMjD6.ToolbarWidths).XXL,
        size: (0, $zMjD6.ToolbarSize).XXL
    },
    {
        width: (0, $zMjD6.ToolbarWidths).XL,
        size: (0, $zMjD6.ToolbarSize).XL
    },
    {
        width: (0, $zMjD6.ToolbarWidths).L,
        size: (0, $zMjD6.ToolbarSize).L
    },
    {
        width: (0, $zMjD6.ToolbarWidths).M,
        size: (0, $zMjD6.ToolbarSize).M
    },
    {
        width: (0, $zMjD6.ToolbarWidths).S,
        size: (0, $zMjD6.ToolbarSize).S
    }
];
const $bd42a2364528a44b$var$toolbarSizesForAppearance = (appearance)=>(0, $geLSP.isFullPage)(appearance) ? (0, $dh538.fg)('platform_editor_toolbar_responsive_fixes') ? $bd42a2364528a44b$var$toolbarSizesFullPageNext : $bd42a2364528a44b$var$toolbarSizesFullPage : (0, $dh538.fg)('platform_editor_toolbar_responsive_fixes') ? $bd42a2364528a44b$var$toolbarSizesNext : $bd42a2364528a44b$var$toolbarSizes;
const $bd42a2364528a44b$export$df8e48f984163082 = (toolbarSize, appearance)=>{
    return ($bd42a2364528a44b$var$toolbarSizesForAppearance(appearance).find(({ size: size })=>toolbarSize === size) || {
        width: (0, $zMjD6.ToolbarWidths).S
    }).width;
};
const $bd42a2364528a44b$export$886398ab6922a80f = (toolbarWidth, appearance)=>{
    return ($bd42a2364528a44b$var$toolbarSizesForAppearance(appearance).find(({ width: width })=>toolbarWidth > width) || {
        size: (0, $zMjD6.ToolbarSize).XXXS
    }).size;
};

});


parcelRegister("7Ogr0", function(module, exports) {

$parcel$export(module.exports, "MainToolbar", () => $e32357fdc808702d$export$f7e5e5a2fbd99270);
$parcel$export(module.exports, "mainToolbarCustomComponentsSlotStyle", () => $e32357fdc808702d$export$a9324f11be65944);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $aFUXX = parcelRequire("aFUXX");

var $dh538 = parcelRequire("dh538");
const $e32357fdc808702d$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 490;
/* eslint-disable @atlaskit/platform/ensure-feature-flag-registration */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
const $e32357fdc808702d$var$mainToolbarWrapperStyle = (isTwoLineEditorToolbar = false)=>(0, $3jLHL.css)`
	position: relative;
	align-items: center;
	padding: ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} 0;
	display: flex;
	height: auto;
	background-color: ${"var(--ds-surface, white)"};
	box-shadow: none;
	padding-left: ${"var(--ds-space-250, 20px)"};

	& > div {
		> :first-child:not(style),
		> style:first-child + * {
			margin-left: 0;
		}
		${isTwoLineEditorToolbar && `
        @media (max-width: ${$e32357fdc808702d$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px) {
          flex-direction: column-reverse;
          align-items: end;
          display: flex;
          justify-content: flex-end;
        }

        /* make this more explicit for a toolbar */
        > *:nth-child(1) {
          @media (max-width: ${$e32357fdc808702d$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px) {
            > div:nth-child(2) {
              justify-content: flex-end;
              display: flex;
            }
          }
        }
    `}
	}

	.block-type-btn {
		padding-left: 0;
	}

	${(0, $dh538.fg)('platform-visual-refresh-icons') && 'span svg { max-width: 100%; }'}
`;
/* eslint-enable @atlaskit/platform/ensure-feature-flag-registration */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $e32357fdc808702d$var$stickyToolbarWrapperStyle = (0, $3jLHL.css)`
	/* stylelint-disable declaration-block-no-duplicate-properties */
	position: relative;
	position: sticky;
	/* stylelint-enable declaration-block-no-duplicate-properties */
	padding-bottom: ${"var(--ds-space-100, 8px)"};
	z-index: ${(0, $aFUXX.akEditorMenuZIndex)};
	transition: box-shadow ease-in-out 0.2s;
	&.show-keyline {
		box-shadow: 0 ${(0, $aFUXX.akEditorToolbarKeylineHeight)}px 0 0
			${"var(--ds-background-accent-gray-subtlest, #F1F2F4)"};
	}
`;
const $e32357fdc808702d$var$StickyToolbar = (props)=>{
    const [top, setTop] = (0, $gwFzn.useState)(0);
    // ED-15802: if externalToolbarRef is passed in, set top to externalToolbarRef?.current?.clientHeight
    // else if offsetTop is a number set top to offsetTop
    // otherwise top is 0 as initial state
    (0, $gwFzn.useEffect)(()=>{
        if (props.externalToolbarRef?.current?.clientHeight) setTop(props.externalToolbarRef.current.clientHeight);
        else setTop(props.offsetTop || 0);
    }, [
        props.externalToolbarRef,
        props.offsetTop
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $e32357fdc808702d$var$mainToolbarWrapperStyle(props.twoLineEditorToolbar),
            $e32357fdc808702d$var$stickyToolbarWrapperStyle
        ],
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        style: {
            top: `${top}px`
        },
        "data-testid": "ak-editor-main-toolbar",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: 'show-keyline'
    }, props.children));
};
const $e32357fdc808702d$var$FixedToolbar = (props)=>// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: $e32357fdc808702d$var$mainToolbarWrapperStyle(props.twoLineEditorToolbar),
        "data-testid": "ak-editor-main-toolbar"
    }, props.children);
/**
 * ED-15802: Scenarios when a sticky bar is used:
 * 1. useStickyToolbar is true
 * 2. useStickyToolbar is a DOM element
 * 3. useStickyToolbar is an object and has offsetTop key;
 */ const $e32357fdc808702d$var$getStickyParameters = (configuration)=>{
    // const isUsingStickyOffset, isHTMLElement is used so TS can properly infer types.
    const isHTMLElement = typeof configuration === 'object' && !('offsetTop' in configuration);
    const isUsingStickyOffset = typeof configuration === 'object' && 'offsetTop' in configuration;
    if (typeof configuration !== 'object') return {
        externalToolbarRef: undefined,
        offsetTop: undefined
    };
    if (isUsingStickyOffset) return {
        offsetTop: configuration.offsetTop
    };
    if (isHTMLElement) return {
        externalToolbarRef: configuration
    };
};
const $e32357fdc808702d$export$f7e5e5a2fbd99270 = ({ useStickyToolbar: useStickyToolbar, twoLineEditorToolbar: twoLineEditorToolbar, children: children })=>{
    if (useStickyToolbar) return /*#__PURE__*/ (0, $3jLHL.jsx)($e32357fdc808702d$var$StickyToolbar, {
        ...$e32357fdc808702d$var$getStickyParameters(useStickyToolbar),
        twoLineEditorToolbar: twoLineEditorToolbar
    }, children);
    return /*#__PURE__*/ (0, $3jLHL.jsx)($e32357fdc808702d$var$FixedToolbar, {
        twoLineEditorToolbar: twoLineEditorToolbar
    }, children);
};
const $e32357fdc808702d$export$a9324f11be65944 = (isTwoLineEditorToolbar = false)=>// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $3jLHL.css)`
		display: flex;
		justify-content: flex-end;
		align-items: center;
		flex-grow: 1;
		padding-right: ${"var(--ds-space-250, 20px)"};
		> div {
			display: flex;
			flex-shrink: 0;
		}
		${isTwoLineEditorToolbar && `
    @media (max-width: ${$e32357fdc808702d$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px) {
      {
        padding-right: 0;
      }
    }
  `}
	`;

});


parcelRegister("am4ic", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8b6bac237a0c461904e6a964e56f26f8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $789f49dd01395bf7$var$_react = $789f49dd01395bf7$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $789f49dd01395bf7$var$_quotationMark = $789f49dd01395bf7$var$_interopRequireDefault((parcelRequire("9RVmI")));

var $789f49dd01395bf7$var$_quote = $789f49dd01395bf7$var$_interopRequireDefault((parcelRequire("h0sHG")));
function $789f49dd01395bf7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for QuotationMarkIcon.
 * This component is QuotationMarkIcon, with `UNSAFE_fallbackIcon` set to "QuoteIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $789f49dd01395bf7$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $789f49dd01395bf7$var$_react.default.createElement($789f49dd01395bf7$var$_quotationMark.default, Object.assign({
        LEGACY_fallbackIcon: $789f49dd01395bf7$var$_quote.default
    }, props));
$789f49dd01395bf7$var$QuotationMarkIcon.Name = 'QuotationMarkIconMigration';
var $789f49dd01395bf7$var$_default = module.exports.default = $789f49dd01395bf7$var$QuotationMarkIcon;

});


//# sourceMappingURL=panel.29f4e0ab.js.map
